import "./index.css";
// src/aipo/GetOffer/GetOffer.tsx
import React4, { useState as useState3, useEffect as useEffect8, useRef } from "react";
import Wizard from "@amzn/awsui-components-react/polaris/wizard";
import SpaceBetween8 from "@amzn/awsui-components-react/polaris/space-between";

// src/aipo/GetOffer/components/UnitsStep/UnitsStep.tsx
import { useMemo, useCallback, useState, useEffect } from "react";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import Button from "@amzn/awsui-components-react/polaris/button";
import Alert from "@amzn/awsui-components-react/polaris/alert";
import ExpandableSection from "@amzn/awsui-components-react/polaris/expandable-section";
import TextContent from "@amzn/awsui-components-react/polaris/text-content";
import Header from "@amzn/awsui-components-react/polaris/header";
import Container from "@amzn/awsui-components-react/polaris/container";
import Input from "@amzn/awsui-components-react/polaris/input";
import Link from "@amzn/awsui-components-react/polaris/link";
import Popover from "@amzn/awsui-components-react/polaris/popover";
import { ManagedTable } from "@amzn/awsmp-max-ux-patterns/ManagedTable";

// src/aipo/GetOffer/assets/human-robot-success.svg
var human_robot_success_default = 'data:image/svg+xml,<svg width="200" height="130" viewBox="0 0 200 130" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g clip-path="url(%23clip0_3022_49078)">%0A<g clip-path="url(%23clip1_3022_49078)">%0A<path d="M90.9358 45.1269L90.3938 46.389L105.743 52.9421L106.285 51.68C105.667 49.5004 103.537 47.5241 98.8337 45.9499C94.1307 44.3757 91.7235 44.5686 90.9358 45.1269Z" fill="%230F141A" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M94.0006 46.5281L92.9466 47.824C91.8926 49.1199 91.5855 50.8996 92.2275 52.444C92.9938 54.2944 94.1883 55.7914 96.6228 56.1577C100.167 56.6879 102.475 55.2366 103.612 51.4531C104.001 50.1542 104.154 48.8023 104.149 47.4482L104.138 44.2573C103.976 42.294 103.045 40.1745 102.56 39.0213L102.088 34.6475L101.657 29.0755C101.515 28.3076 101.218 27.3664 100.298 27.4086C99.4061 27.5145 99.5642 27.616 99.5726 28.2856L99.4504 26.8787C99.2732 26.0507 99.0488 25.158 97.9939 25.1077C97.0259 25.2564 97.4688 26.2479 97.5086 27.1408L97.2842 25.6412C97.0764 24.689 96.5761 24.0972 95.6308 24.2218C94.8661 24.4237 94.7819 25.0438 94.7819 25.0438C94.7819 25.0438 94.8905 25.5416 94.7523 25.5072C94.0339 25.3381 93.2762 25.7076 92.9998 26.3976C92.7671 26.9926 92.6903 27.6948 92.6801 28.1592L91.9566 37.0722C91.9809 37.8866 92.1099 38.2142 92.2948 39.0057C92.798 41.2083 93.8411 45.7729 94.0041 46.5361L94.0006 46.5281Z" fill="%23B78159" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M98.4849 36.3764L97.5199 27.2969Z" fill="%23B78159"/>%0A<path d="M98.4849 36.3764L97.5199 27.2969" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M99.5967 28.3413L100.24 37.2817" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M96.0412 37.7682L95.6902 26.9501C95.6902 26.9501 95.742 25.7895 94.9627 25.5569" fill="%23B78159"/>%0A<path d="M96.0412 37.7682L95.6902 26.9501C95.6902 26.9501 95.742 25.7895 94.9627 25.5569" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M104.136 44.5141L103.931 43.101C103.731 41.7232 103.057 40.3969 102.142 39.28C101.522 38.5226 100.739 37.9124 99.8678 37.4592L99.0781 37.051L97.2895 33.7183C96.6774 32.6539 95.5613 32.2036 94.2215 32.6289C93.7393 32.7831 93.3709 33.2194 93.3564 33.7283C93.3532 33.9051 93.3842 34.0954 93.4926 34.2566L95.8971 38.6947C96.4317 39.6034 96.9317 41.6794 96.9031 41.6682" fill="%23B78159"/>%0A<path d="M104.136 44.5141L103.931 43.101C103.731 41.7232 103.057 40.3969 102.142 39.28C101.522 38.5226 100.739 37.9124 99.8678 37.4592L99.0781 37.051L97.2895 33.7183C96.6774 32.6539 95.5613 32.2036 94.2215 32.6289C93.7393 32.7831 93.3709 33.2194 93.3564 33.7283C93.3532 33.9051 93.3842 34.0954 93.4926 34.2566L95.8971 38.6947C96.4317 39.6034 96.9317 41.6794 96.9031 41.6682" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M53.4941 67.8646C53.4522 67.8616 49.0739 67.2763 49.0739 67.2763L60.3111 86.0135L80.077 88.1639C80.7505 88.2576 81.424 88.306 82.0944 88.306C86.9164 88.306 90.8212 86.9738 92.935 83.7995C94.8799 80.8787 104.088 56.8602 105.546 53.0426C105.66 52.7458 105.516 52.4296 105.227 52.2981L91.5649 46.0814C91.256 45.9409 90.8921 46.0833 90.7607 46.3962L80.5705 70.6551L53.4941 67.8646Z" fill="%23006CE0"/>%0A<path d="M55.4003 67.5835L55.4112 67.1322L55.4304 67.1327L55.4494 67.1348L55.4003 67.5835ZM80.6685 70.348L81.0872 70.5169L80.9593 70.834L80.6194 70.7968L80.6685 70.348ZM93.5264 83.8635L93.9022 84.1137L93.5264 83.8635ZM80.6685 88.2278L80.7132 87.7786L80.722 87.7795L80.7307 87.7807L80.6685 88.2278ZM64.5644 87.0772L64.1152 87.0325L64.2047 86.1341L64.6539 86.1788L64.6092 86.628L64.5644 87.0772ZM105.532 51.9976L105.35 52.4107L105.532 51.9976ZM105.861 52.7373L106.285 52.8929L105.861 52.7373ZM90.4685 46.0434L90.8872 46.2122L90.4685 46.0434ZM91.2693 45.7176L91.4512 45.3044L91.2693 45.7176ZM42.6285 67.2762L42.6394 66.8249L55.4112 67.1322L55.4003 67.5835L55.3895 68.0348L42.6176 67.7275L42.6285 67.2762ZM55.4003 67.5835L55.4494 67.1348L80.7176 69.8993L80.6685 70.348L80.6194 70.7968L55.3513 68.0323L55.4003 67.5835ZM80.6685 70.348L80.2498 70.1792L90.0498 45.8746L90.4685 46.0434L90.8872 46.2122L81.0872 70.5169L80.6685 70.348ZM91.2693 45.7176L91.4512 45.3044L105.714 51.5844L105.532 51.9976L105.35 52.4107L91.0874 46.1307L91.2693 45.7176ZM105.861 52.7373L106.285 52.8929C105.577 54.8196 102.979 61.8731 100.314 68.8111C98.9822 72.2797 97.6322 75.7221 96.493 78.4813C95.9235 79.8606 95.4054 81.0722 94.9678 82.0323C94.5348 82.9824 94.1682 83.7142 93.9022 84.1137L93.5264 83.8635L93.1507 83.6133C93.3711 83.2823 93.7106 82.6138 94.1463 81.6579C94.5775 80.7118 95.0908 79.5115 95.6584 78.1367C96.7934 75.3877 98.1403 71.9535 99.4717 68.4873C102.134 61.5557 104.73 54.5072 105.437 52.5818L105.861 52.7373ZM93.5264 83.8635L93.9022 84.1137C91.6661 87.4717 87.5724 88.8213 82.6859 88.8213V88.3699V87.9185C87.4433 87.9185 91.1593 86.6038 93.1507 83.6133L93.5264 83.8635ZM82.6859 88.3699V88.8213C81.9937 88.8213 81.2994 88.7714 80.6063 88.6749L80.6685 88.2278L80.7307 87.7807C81.3845 87.8717 82.0371 87.9185 82.6859 87.9185V88.3699ZM80.6685 88.2278L80.6238 88.677L64.5644 87.0772L64.6092 86.628L64.6539 86.1788L80.7132 87.7786L80.6685 88.2278ZM105.532 51.9976L105.714 51.5844C106.206 51.8008 106.483 52.354 106.285 52.8929L105.861 52.7373L105.437 52.5818C105.45 52.5466 105.447 52.5162 105.435 52.4897C105.423 52.4616 105.396 52.4308 105.35 52.4107L105.532 51.9976ZM90.4685 46.0434L90.0498 45.8746C90.2722 45.323 90.9069 45.0648 91.4512 45.3044L91.2693 45.7176L91.0874 46.1307C91.0096 46.0965 90.919 46.1334 90.8872 46.2122L90.4685 46.0434Z" fill="%230F141A"/>%0A<path d="M80.572 70.3479C81.4929 71.5766 82.1068 72.8053 82.7207 76.1841" stroke="%230F141A" stroke-width="0.902851"/>%0A<g clip-path="url(%23clip2_3022_49078)">%0A<path d="M68.021 135.714C68.9357 135.714 69.4207 134.921 69.2365 134.073C67.229 121.903 63.3982 100.899 63.3982 100.899L65.8907 93.5946C66.8054 90.8547 66.744 87.8137 65.6451 85.1351L62.907 78.3835C60.9609 72.3569 55.9759 67.8906 49.2841 67.8906H34.1448C26.4217 67.8906 20.5833 73.819 19.8528 81.3631C18.5144 95.5421 17.1147 114.421 13.2224 134.073C13.0383 134.927 13.5294 135.714 14.438 135.714H68.0087H68.021Z" fill="%23006CE0"/>%0A<path d="M19.8651 78.3159C18.404 93.7113 17.0103 115.152 13.2346 134.559C13.0505 135.413 13.5416 136.26 14.4502 136.26H68.0209C68.9357 136.26 69.4206 135.407 69.2365 134.559L63.3982 100.58L64.5524 97.6001C66.7441 92.0034 66.3757 85.6757 63.521 80.3187" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A</g>%0A<path d="M55.3165 126.867L53.7143 126.702L53.7816 110.28L55.0095 110.28C56.7875 111.683 57.9081 114.279 57.5693 119.23C57.2305 124.181 56.1327 126.352 55.3165 126.867Z" fill="%230F141A" stroke="%230F141A" stroke-width="0.902851" stroke-linejoin="round"/>%0A<path d="M68.6157 124.507C70.514 124.348 71.1053 123.344 71.161 122.758C71.2917 121.382 70.1731 120.937 69.5489 120.942C70.404 120.805 71.9747 120.658 72.0789 119.208C72.1831 117.758 70.2752 117.612 70.2366 117.619C71.312 117.65 72.2391 116.781 72.1796 115.832C72.1379 114.339 69.9233 114.347 69.9233 114.347C69.9233 114.347 71.8364 113.819 71.3295 112.18C71.0088 110.35 67.9564 111.284 66.3636 111.52C65.2283 111.625 64.2721 111.937 64.2721 111.937C64.7483 111.821 66.0386 111.441 66.0629 111.424C65.7068 111.026 63.8718 107.825 61.8457 109.575C60.7327 110.537 59.2892 111.54 57.875 112.457C55.604 112.52 53.993 112.486 52.136 112.35C47.8781 112.038 44.1724 115.792 44.6812 120.099C44.9832 122.655 46.7673 124.643 49.2999 124.779C53.944 125.027 60.893 124.876 66.4104 124.553L68.6157 124.507Z" fill="%23B78159" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M28.9165 86.9356L26.1538 109.052L55.008 110.28V126.868L16.9626 125.212C10.8863 124.948 6.38058 119.473 7.29015 113.46L12.0673 81.8746C13.3003 73.7222 20.0692 67.5345 28.3031 67.1053C32.917 66.8648 37.2442 66.6624 38.7393 66.6624" fill="%23006CE0"/>%0A<path d="M28.9165 86.9356L26.1538 109.052L55.008 110.28V126.868L16.9626 125.212C10.8863 124.948 6.38058 119.473 7.29015 113.46L12.0673 81.8746C13.3003 73.7222 20.0692 67.5345 28.3031 67.1053C32.917 66.8648 37.2442 66.6624 38.7393 66.6624" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A<g clip-path="url(%23clip3_3022_49078)">%0A<path d="M50.6726 67.2834L49.5917 59.4245C49.5917 59.4245 60.8204 60.2198 59.5969 50.3383C59.0726 46.1038 58.3201 42.2518 56.3172 37.9214C53.864 32.6158 50.4949 28.6539 42.0499 29.817C35.6484 30.7244 31.1282 36.6973 32.0078 43.0926L35.62 69.3565C36.1904 73.5041 40.0234 76.4035 44.1794 75.8312C48.3353 75.2588 51.2431 71.431 50.6726 67.2834V67.2834Z" fill="%23B78159" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M49.5916 59.4277C49.5916 59.4277 45.9152 59.38 42.5296 58.5836C42.2361 58.5145 42.0851 58.9186 42.3497 59.0593L50.1081 63.1833L49.5911 59.4245" fill="%230F141A"/>%0A<path d="M49.5916 59.4277C49.5916 59.4277 45.9152 59.38 42.5296 58.5836C42.2361 58.5145 42.0851 58.9186 42.3497 59.0593L50.1081 63.1833L49.5911 59.4245" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M46.5742 45.2258C46.2279 45.2735 45.8996 44.9668 45.841 44.5408C45.7824 44.1148 46.0157 43.7308 46.3621 43.6831C46.7085 43.6354 47.0368 43.942 47.0953 44.368C47.1539 44.794 46.9206 45.1781 46.5742 45.2258Z" fill="%230F141A"/>%0A<path d="M53.5943 42.642C53.2479 42.6897 52.9196 42.3831 52.861 41.9571C52.8024 41.531 53.0357 41.147 53.3821 41.0993C53.7285 41.0516 54.0568 41.3583 54.1154 41.7843C54.174 42.2103 53.9407 42.5943 53.5943 42.642Z" fill="%230F141A"/>%0A<path d="M48.744 40.7009C49.7891 42.3158 50.6135 43.9449 53.3133 45.2931C53.8923 45.5838 53.7738 46.4827 53.232 46.8376L52.1152 47.5648" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M52.8065 50.8809C52.8065 50.8809 49.5154 51.8044 46.8383 49.6348" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M31.9864 25.236C31.375 18.8441 24.6119 16.5246 21.1444 20.4511C15.8322 17.2792 10.2985 25.6285 17.1891 28.2471C11.959 29.9216 17.3937 38.3034 23.2424 35.0505L22.2591 36.4088C21.5147 37.4371 21.7049 38.8455 22.4896 39.8432C22.9506 40.4293 23.3201 41.06 23.258 41.5225C23.1958 41.985 23.0112 42.3002 22.8278 42.6133C22.5596 43.0714 22.2939 43.5249 22.4182 44.4287C22.6275 45.9502 25.2695 47.1367 25.2695 47.1367C24.2624 48.8257 25.3728 52.3936 28.4138 51.9748C27.7945 54.2305 29.6419 56.4566 30.908 56.5923C31.5887 59.2891 34.5767 60.738 34.5767 60.738C34.5767 60.738 36.0298 54.2112 35.5669 48.6938C35.5669 48.6938 38.7229 45.822 38.8394 45.4525C40.5072 43.6105 43.0878 37.6858 42.7184 35.2251C43.1648 38.1122 49.5458 38.1387 48.8009 34.7168C49.0267 35.6558 49.8361 36.4276 50.7797 36.614C52.0469 36.8612 53.3078 34.4488 53.3078 34.4488C54.2291 34.8363 54.8444 33.9545 55.2354 32.9297C55.8085 31.4281 55.3807 29.775 54.5674 28.3889C54.1219 27.6296 53.4442 27.0338 52.6344 26.6894L50.2506 25.6755C49.567 25.3848 48.949 24.9591 48.4336 24.424L48.2635 24.2474C47.0387 22.9757 45.2804 22.3661 43.5319 22.6069L41.7918 22.8466C41.2866 22.9161 40.7742 22.9154 40.2692 22.8443L37.9856 22.5231C36.3842 22.2978 34.7644 22.7859 33.5536 23.8587L32.2294 25.032C32.1501 25.1022 32.0691 25.1702 31.9864 25.236Z" fill="%23232B37" stroke="%230F141A" stroke-width="0.902851" stroke-miterlimit="10" stroke-linejoin="round"/>%0A<path d="M31.0659 26.1982C29.4088 27.6667 26.7002 29.9839 25.2129 33.2057" stroke="%23F3F3F7" stroke-width="1.2038"/>%0A<path d="M36.9379 49.3213C33.6442 47.6908 33.1899 45.9366 33.2856 44.8959C33.3482 44.2012 33.8069 43.5936 34.455 43.3304C35.244 43.0124 36.189 43.1013 36.9569 43.5689C38.7073 44.6324 39.3889 46.3263 39.3889 46.3263" fill="%23B78159"/>%0A<path d="M36.9379 49.3213C33.6442 47.6908 33.1899 45.9366 33.2856 44.8959C33.3482 44.2012 33.8069 43.5936 34.455 43.3304C35.244 43.0124 36.189 43.1013 36.9569 43.5689C38.7073 44.6324 39.3889 46.3263 39.3889 46.3263" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="square" stroke-linejoin="round"/>%0A</g>%0A<path d="M84.374 4.94727L92.017 12.5689" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M101.024 0.156738L101.024 10.9353" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M117.673 4.94727L110.03 12.5689" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M165.158 51.3831V38.7631L154.98 32.9329" stroke="%230F141A" stroke-width="0.902851"/>%0A<ellipse cx="2.42648" cy="2.4197" rx="2.42648" ry="2.4197" transform="matrix(-1 0 0 1 167.584 36.5625)" fill="%23DEDEE3" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M162.209 50.1254C162.3 49.1674 163.104 48.4355 164.066 48.4355H166.375C167.338 48.4355 168.142 49.1674 168.233 50.1254L168.274 50.5609C168.444 52.3605 167.029 53.9162 165.221 53.9162C163.413 53.9162 161.998 52.3605 162.168 50.5609L162.209 50.1254Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M126.621 33.084L118.353 41.2505L110.164 33.084" stroke="%230F141A" stroke-width="0.902851" stroke-linejoin="round"/>%0A<path d="M111.317 33.9131C109.718 33.9131 108.422 32.6168 108.422 31.0179L108.422 27.4752C108.422 25.8762 109.718 24.5799 111.317 24.5799C112.916 24.5799 114.212 25.8762 114.212 27.4752L114.212 31.0179C114.212 32.6168 112.916 33.9131 111.317 33.9131Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="0.902851"/>%0A<ellipse cx="2.42648" cy="2.4197" rx="2.42648" ry="2.4197" transform="matrix(-1 0 0 1 120.858 38.5281)" fill="%23DEDEE3" stroke="%230F141A" stroke-width="0.902851"/>%0A<rect x="135.873" y="24.0098" width="9.70592" height="7.86404" rx="1.2038" fill="%23DEDEE3" stroke="%230F141A" stroke-width="0.902851" stroke-linejoin="round"/>%0A<path d="M145.445 26.9066L136.336 29.4891C135.952 29.598 135.57 29.3094 135.57 28.91V24.9142C135.57 24.5817 135.839 24.3123 136.172 24.3123H145.28C145.613 24.3123 145.882 24.5817 145.882 24.9142V26.3275C145.882 26.5967 145.704 26.8331 145.445 26.9066Z" fill="%230F141A"/>%0A<path d="M151.389 8.01236C150.508 5.256 147.615 3.67433 144.819 4.42033L129.76 8.4387C126.964 9.18469 125.253 11.995 125.873 14.8209L127.972 24.3779C128.635 27.3966 131.687 29.2547 134.674 28.4578L150.615 24.2042C153.601 23.4073 155.312 20.2785 154.37 17.3341L151.389 8.01236Z" fill="%230F141A"/>%0A<path d="M149.693 8.49251C148.906 6.04684 146.337 4.64527 143.855 5.30755L128.26 9.46893C125.778 10.1312 124.257 12.6241 124.804 15.1339L126.886 24.692C127.471 27.3795 130.186 29.0359 132.844 28.3267L149.354 23.9214C152.012 23.2122 153.532 20.4256 152.689 17.8067L149.693 8.49251Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M152.875 17.9331L147.92 19.947C142.676 22.0825 137.084 23.6081 131.463 24.3445L127.093 24.822" stroke="%230F141A" stroke-width="0.902851"/>%0A<g clip-path="url(%23clip4_3022_49078)">%0A<path d="M131.606 19.858C132.576 19.5986 133.153 18.6034 132.892 17.6353C132.632 16.6672 131.634 16.0927 130.664 16.3521C129.693 16.6115 129.117 17.6066 129.377 18.5747C129.637 19.5428 130.635 20.1174 131.606 19.858Z" fill="%23006CE0" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M142.739 16.8831C143.71 16.6237 144.286 15.6286 144.026 14.6605C143.766 13.6923 142.768 13.1178 141.797 13.3772C140.827 13.6366 140.25 14.6317 140.511 15.5999C140.771 16.568 141.769 17.1425 142.739 16.8831Z" fill="%23006CE0" stroke="%230F141A" stroke-width="0.902851"/>%0A</g>%0A<path d="M125.55 35.1076C125.668 32.5368 127.786 30.5132 130.36 30.5132H151.091C153.664 30.5132 155.783 32.5368 155.901 35.1076L156.57 49.6742C156.696 52.4174 154.505 54.7102 151.759 54.7102H129.691C126.945 54.7102 124.755 52.4174 124.881 49.6742L125.55 35.1076Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M149.452 42.4223C150.676 42.4223 151.669 41.4326 151.669 40.2119C151.669 38.9911 150.676 38.0015 149.452 38.0015C148.227 38.0015 147.234 38.9911 147.234 40.2119C147.234 41.4326 148.227 42.4223 149.452 42.4223Z" fill="%23006CE0" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M141.588 39.9048H130.925" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M144.372 65.0095L143.7 64.8221C140.654 63.9729 137.425 64.0381 134.415 65.0095" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M146.861 61.0386L145.808 60.8428C141.213 59.9889 136.495 60.0555 131.926 61.0386" stroke="%230F141A" stroke-width="0.902851"/>%0A<path d="M165.447 98.2012C178.763 98.2012 189.548 87.4331 189.548 74.1654C189.548 60.8978 178.751 50.1296 165.447 50.1296C152.143 50.1296 141.346 60.8978 141.346 74.1654C141.346 87.4331 152.143 98.2012 165.447 98.2012Z" fill="%2300802F" stroke="%230F141A" stroke-width="0.902851" stroke-miterlimit="10"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M179.492 67.5165L163.133 84.1695C162.594 84.719 161.865 85.0215 161.109 85.0099C160.353 84.9982 159.633 84.6733 159.109 84.1075L151.402 75.781L155.485 71.7089L161.211 77.8943L175.527 63.3203L179.492 67.5165Z" fill="white" stroke="%230F141A" stroke-width="0.902851" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M162.209 50.1256C162.3 49.1677 163.104 48.4358 164.066 48.4358H166.375C167.338 48.4358 168.142 49.1677 168.233 50.1256L168.274 50.5611C168.444 52.3608 167.029 53.9165 165.221 53.9165C163.413 53.9165 161.998 52.3608 162.168 50.5611L162.209 50.1256Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="0.902851"/>%0A</g>%0A</g>%0A<defs>%0A<clipPath id="clip0_3022_49078">%0A<rect width="199.27" height="129.351" fill="white"/>%0A</clipPath>%0A<clipPath id="clip1_3022_49078">%0A<rect width="194.9" height="145.083" fill="white" transform="translate(0 -8.73975)"/>%0A</clipPath>%0A<clipPath id="clip2_3022_49078">%0A<rect width="64.2374" height="53.2221" fill="white" transform="translate(9.08154 65.6013)"/>%0A</clipPath>%0A<clipPath id="clip3_3022_49078">%0A<rect width="72.4427" height="70.6491" fill="white" transform="translate(8.25342 10.52)"/>%0A</clipPath>%0A<clipPath id="clip4_3022_49078">%0A<rect width="24.8668" height="8.47056" fill="white" transform="matrix(0.966106 -0.258145 0.259495 0.965744 125.934 15.1108)"/>%0A</clipPath>%0A</defs>%0A</svg>%0A';

// src/aipo/GetOffer/components/UnitsStep/UnitsStep.module.css
var UnitsStep_default = {
  beforeBeginContainer: "UnitsStep_beforeBeginContainer",
  expandableSectionEmbeddedImage: "UnitsStep_expandableSectionEmbeddedImage"
};

// src/aipo/GetOffer/components/UnitsStep/UnitsStep.tsx
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var UnitsStep = ({
  buyerData,
  errors,
  clearFieldError,
  writeableArtifact,
  isArtifactLocked,
  layoutComponents,
  logger,
  t
}) => {
  const { configurableUpfrontPricingTerms, usageBasedPricingTerms } = buyerData;
  const {
    artifact,
    setArtifact
    /* sendMessage */
  } = writeableArtifact;
  const [showGuidance, setShowGuidance] = useState(false);
  const [selectedGuidance, setSelectedGuidance] = useState("");
  const [panelSize, setPanelSize] = useState(680);
  const { LayoutSplitPanel } = layoutComponents;
  useEffect(() => {
    logger.updateContext({ SubPageType: "AWSMP-Enter-Units" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, []);
  const formatCurrency = useCallback(
    (amount) => {
      return `${new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: buyerData.currencyCode,
        maximumFractionDigits: 10
      }).format(amount)}`;
    },
    [buyerData.currencyCode]
  );
  const dimensionSelections = useMemo(() => {
    return artifact.offerRequest?.configurableUpfrontDimensionSelections || [];
  }, [artifact.offerRequest?.configurableUpfrontDimensionSelections]);
  const unitsMap = useMemo(() => {
    const map = {};
    dimensionSelections.forEach((selection) => {
      map[selection.dimensionKey] = selection.quantity;
    });
    return map;
  }, [dimensionSelections]);
  const tableData = useMemo(
    () => configurableUpfrontPricingTerms.rateCards.map((rateCard) => ({
      ...rateCard,
      numberOfUnits: unitsMap[rateCard.dimensionKey] || 0
    })),
    [configurableUpfrontPricingTerms.rateCards, unitsMap]
  );
  const updateUnits = useCallback(
    (dimensionKey, value) => {
      const numValue = Math.max(0, parseFloat(value) || 0);
      if (numValue % 1 !== 0) {
        return;
      }
      const updatedSelections = [...dimensionSelections];
      const existingIndex = updatedSelections.findIndex((s2) => s2.dimensionKey === dimensionKey);
      if (existingIndex >= 0) {
        updatedSelections[existingIndex] = { dimensionKey, quantity: numValue };
      } else {
        updatedSelections.push({ dimensionKey, quantity: numValue });
      }
      setArtifact((prevArtifact) => ({
        ...prevArtifact,
        offerRequest: {
          ...prevArtifact.offerRequest,
          configurableUpfrontDimensionSelections: updatedSelections
        }
      }));
    },
    [dimensionSelections, setArtifact]
  );
  const handleSubmitEdit = useCallback(
    (item, column, newValue) => {
      if (column.id === "numberOfUnits") {
        logger.biMetric({
          metricName: "Click",
          value: 1,
          unit: "Count",
          dimensions: {
            ClickFeat: "units-table",
            ClickObj: "number-of-units-editable-column",
            ClickAct: item.dimensionKey
          }
        });
        updateUnits(item.dimensionKey, newValue);
        if (errors?.unitsTableError) {
          clearFieldError("unitsTableError");
        }
      }
    },
    [updateUnits, errors?.unitsTableError, clearFieldError, logger]
  );
  const handleGuidanceClick = useCallback((supplementaryDescription) => {
    setSelectedGuidance(supplementaryDescription);
    setShowGuidance(true);
  }, []);
  const columnDefinitions = useMemo(
    () => [
      {
        id: "dimension",
        header: t("dimension"),
        cell: (item) => item.displayName,
        sortingField: "displayName",
        width: 200,
        minWidth: 150
      },
      {
        id: "description",
        header: t("description"),
        cell: (item) => item.description,
        width: 300,
        minWidth: 200
      },
      {
        id: "numberOfUnits",
        header: t("numberOfUnits"),
        cell: (item) => item.numberOfUnits,
        editConfig: isArtifactLocked ? void 0 : {
          ariaLabel: t("numberOfUnits"),
          editIconAriaLabel: "editable",
          errorIconAriaLabel: t("numberOfUnitsError"),
          editingCell: (item, { currentValue, setValue }) => /* @__PURE__ */ jsx(
            Input,
            {
              autoFocus: true,
              value: currentValue ?? item.numberOfUnits.toString(),
              onChange: (event) => setValue(event.detail.value),
              type: "number",
              inputMode: "numeric",
              step: 1
            }
          )
        },
        width: 200,
        minWidth: 150
      },
      {
        id: "guidance",
        header: t("guidance"),
        cell: (item) => item.supplementaryDescription ? /* @__PURE__ */ jsx(
          Link,
          {
            variant: "primary",
            href: "_",
            onFollow: (e) => {
              handleGuidanceClick(item.supplementaryDescription);
              e.preventDefault();
            },
            children: t("view")
          }
        ) : /* @__PURE__ */ jsx(Popover, { size: "small", position: "left", triggerType: "custom", dismissButton: false, content: t("noGuidanceAvailable"), children: /* @__PURE__ */ jsx("div", { style: { fontWeight: "bold", color: "#B4B4BB" }, children: t("view") }) }),
        width: 120,
        minWidth: 100
      }
    ],
    [isArtifactLocked, handleGuidanceClick]
  );
  const usageColumnDefinitions = [
    {
      id: "dimension",
      header: t("dimension"),
      cell: (item) => item.displayName,
      width: 500,
      minWidth: 350
    },
    {
      id: "cost",
      header: `${t("costPerUnit")} (${buyerData.currencyCode})`,
      cell: (item) => formatCurrency(item.price),
      width: 320,
      minWidth: 250
    }
  ];
  return /* @__PURE__ */ jsxs(SpaceBetween, { size: "l", children: [
    /* @__PURE__ */ jsx(ExpandableSection, { defaultExpanded: true, variant: "container", headerText: t("gettingYourPrivateOffer"), "data-testid": "getting-offer-container", children: /* @__PURE__ */ jsxs("div", { className: UnitsStep_default.beforeBeginContainer, children: [
      /* @__PURE__ */ jsx("div", { style: { paddingLeft: "16px", paddingRight: "16px" }, children: /* @__PURE__ */ jsxs(TextContent, { children: [
        /* @__PURE__ */ jsx("p", { children: t("enterNeedsQuoteInstantly") }),
        /* @__PURE__ */ jsxs("ul", { children: [
          /* @__PURE__ */ jsxs("li", { children: [
            /* @__PURE__ */ jsx("strong", { children: t("enterUnitsListItem") }),
            " - ",
            t("specifyDimensionRequirements")
          ] }),
          /* @__PURE__ */ jsxs("li", { children: [
            /* @__PURE__ */ jsx("strong", { children: t("enterContractNeedsListItem") }),
            " - ",
            t("defineContractDurationPreferences")
          ] }),
          /* @__PURE__ */ jsxs("li", { children: [
            /* @__PURE__ */ jsx("strong", { children: t("answerFewQuestions") }),
            " - ",
            t("fillOutSellerEvaluation")
          ] }),
          /* @__PURE__ */ jsxs("li", { children: [
            /* @__PURE__ */ jsx("strong", { children: t("getYourOffer") }),
            " - ",
            t("receivePersonalizedQuote")
          ] })
        ] }),
        /* @__PURE__ */ jsx("p", { children: t("finalSteps") }),
        /* @__PURE__ */ jsx("ul", { children: /* @__PURE__ */ jsxs("li", { children: [
          t("reviewPersonalizedPricing"),
          " ",
          /* @__PURE__ */ jsx(Link, { href: "https://us-east-1.console.aws.amazon.com/marketplace/private-offers", external: true, children: t("awsMarketplacePrivateOffers") }),
          " ",
          t("pageOrProcurementPage")
        ] }) })
      ] }) }),
      /* @__PURE__ */ jsx(
        "img",
        {
          alt: t("humanRobotCheckmarkAlt"),
          src: human_robot_success_default,
          className: UnitsStep_default.expandableSectionEmbeddedImage,
          style: { width: "289px", height: "239px" }
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx(
      Alert,
      {
        action: /* @__PURE__ */ jsx(
          Button,
          {
            href: `https://aws.amazon.com/marketplace/customer-connect/private-offer/${buyerData.listingId}`,
            external: true,
            onClick: () => {
              logger.biMetric({
                metricName: "Click",
                value: 1,
                unit: "Count",
                dimensions: {
                  ClickFeat: "custom-offer-alert",
                  ClickAct: "request-custom-offer"
                }
              });
            },
            children: t("connectWithRepresentative")
          }
        ),
        children: t("complexBusinessNeedsMessage")
      }
    ),
    /* @__PURE__ */ jsx(Container, { header: /* @__PURE__ */ jsx(Header, { description: t("enterUnitsGuidanceDescription"), children: t("enterUnitsHeader") }), children: /* @__PURE__ */ jsxs(SpaceBetween, { size: "l", children: [
      errors?.unitsTableError && /* @__PURE__ */ jsx(Alert, { type: "error", children: errors.unitsTableError }),
      /* @__PURE__ */ jsx(
        ManagedTable,
        {
          "data-testid": "enter-units-table",
          defaultPreferences: {
            contentDensity: "compact",
            ...usageBasedPricingTerms && usageBasedPricingTerms.length > 0 && { pageSize: 5 }
          },
          columnDefinitions,
          items: tableData,
          variant: "embedded",
          stickyHeader: true,
          submitEdit: isArtifactLocked ? void 0 : handleSubmitEdit,
          pagination: {},
          filtering: {
            filteringPlaceholder: t("findDimension")
          }
        }
      ),
      usageBasedPricingTerms && usageBasedPricingTerms.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          Header,
          {
            counter: `(${usageBasedPricingTerms.length})`,
            description: t("additionalUsageCostsDescription"),
            "data-testid": "usage-costs-header",
            children: t("additionalUsageCosts")
          }
        ),
        /* @__PURE__ */ jsx(
          ManagedTable,
          {
            "data-testid": "usage-costs-table",
            columnDefinitions: usageColumnDefinitions,
            defaultPreferences: {
              contentDensity: "compact",
              ...usageBasedPricingTerms && usageBasedPricingTerms.length > 0 && { pageSize: 5 }
            },
            items: usageBasedPricingTerms,
            variant: "embedded",
            stickyHeader: true,
            pagination: {},
            filtering: {
              filteringPlaceholder: t("findDimension")
            }
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ jsx(
      LayoutSplitPanel,
      {
        open: showGuidance,
        onToggle: (open) => setShowGuidance(open),
        onDismiss: () => setShowGuidance(false),
        onResize: (size) => setPanelSize(size),
        closeBehavior: "hide",
        header: t("guidanceHeader"),
        size: panelSize,
        children: /* @__PURE__ */ jsxs(SpaceBetween, { size: "l", children: [
          /* @__PURE__ */ jsx(TextContent, { children: /* @__PURE__ */ jsx("p", { children: selectedGuidance }) }),
          /* @__PURE__ */ jsx(Button, { variant: "normal", onClick: () => setShowGuidance(false), children: t("close") })
        ] })
      }
    )
  ] });
};

// src/aipo/GetOffer/components/ContractNeedsStep/ContractNeedsStep.tsx
import { useCallback as useCallback2, useState as useState2, useMemo as useMemo2, useEffect as useEffect2 } from "react";
import Container2 from "@amzn/awsui-components-react/polaris/container";
import SpaceBetween2 from "@amzn/awsui-components-react/polaris/space-between";
import Header2 from "@amzn/awsui-components-react/polaris/header";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import Select from "@amzn/awsui-components-react/polaris/select";
import RadioGroup from "@amzn/awsui-components-react/polaris/radio-group";
import DatePicker from "@amzn/awsui-components-react/polaris/date-picker";
import TextContent2 from "@amzn/awsui-components-react/polaris/text-content";
import Link2 from "@amzn/awsui-components-react/polaris/link";

// ../../node_modules/luxon/build/es6/luxon.mjs
var LuxonError = class extends Error {
};
var InvalidDateTimeError = class extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
};
var InvalidIntervalError = class extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
};
var InvalidDurationError = class extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
};
var ConflictingSpecificationError = class extends LuxonError {
};
var InvalidUnitError = class extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
};
var InvalidArgumentError = class extends LuxonError {
};
var ZoneIsAbstractError = class extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
};
var n = "numeric";
var s = "short";
var l = "long";
var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
var DATE_MED = {
  year: n,
  month: s,
  day: n
};
var DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
var DATE_FULL = {
  year: n,
  month: l,
  day: n
};
var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
var TIME_SIMPLE = {
  hour: n,
  minute: n
};
var TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var Zone = class {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
};
var singleton$1 = null;
var SystemZone = class _SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton$1 === null) {
      singleton$1 = new _SystemZone();
    }
    return singleton$1;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }
  /** @override **/
  get isValid() {
    return true;
  }
};
var dtfCache = /* @__PURE__ */ new Map();
function makeDTF(zoneName) {
  let dtf = dtfCache.get(zoneName);
  if (dtf === void 0) {
    dtf = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zoneName,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
    dtfCache.set(zoneName, dtf);
  }
  return dtf;
}
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
var ianaZoneCache = /* @__PURE__ */ new Map();
var IANAZone = class _IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    let zone = ianaZoneCache.get(name);
    if (zone === void 0) {
      ianaZoneCache.set(name, zone = new _IANAZone(name));
    }
    return zone;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache.clear();
    dtfCache.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(s2) {
    return this.isValidZone(s2);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e) {
      return false;
    }
  }
  constructor(name) {
    super();
    this.zoneName = name;
    this.valid = _IANAZone.isValidZone(name);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return false;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    if (!this.valid)
      return NaN;
    const date = new Date(ts);
    if (isNaN(date))
      return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date;
    const over = asTS % 1e3;
    asTS -= over >= 0 ? over : 1e3 + over;
    return (asUTC - asTS) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
};
var intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
var intlDTCache = /* @__PURE__ */ new Map();
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache.get(key);
  if (dtf === void 0) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache.set(key, dtf);
  }
  return dtf;
}
var intlNumCache = /* @__PURE__ */ new Map();
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache.get(key);
  if (inf === void 0) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache.set(key, inf);
  }
  return inf;
}
var intlRelCache = /* @__PURE__ */ new Map();
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts;
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache.get(key);
  if (inf === void 0) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache.set(key, inf);
  }
  return inf;
}
var sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
var intlResolvedOptionsCache = /* @__PURE__ */ new Map();
function getCachedIntResolvedOptions(locString) {
  let opts = intlResolvedOptionsCache.get(locString);
  if (opts === void 0) {
    opts = new Intl.DateTimeFormat(locString).resolvedOptions();
    intlResolvedOptionsCache.set(locString, opts);
  }
  return opts;
}
var weekInfoCache = /* @__PURE__ */ new Map();
function getCachedWeekInfo(locString) {
  let data = weekInfoCache.get(locString);
  if (!data) {
    const locale = new Intl.Locale(locString);
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    if (!("minimalDays" in data)) {
      data = { ...fallbackWeekSettings, ...data };
    }
    weekInfoCache.set(locString, data);
  }
  return data;
}
function parseLocaleString(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}
function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}
function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
  }
}
var PolyNumberFormatter = class {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const { padTo, floor, ...otherOpts } = opts;
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0)
        intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
};
var PolyDateFormatter = class {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = void 0;
    let z = void 0;
    if (this.opts.timeZone) {
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        z = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({ minutes: dt.offset });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z = dt.zone.name;
    } else {
      z = "UTC";
      this.dt = dt.setZone("UTC").plus({ minutes: dt.offset });
      this.originalZone = dt.zone;
    }
    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    if (this.originalZone) {
      return this.formatToParts().map(({ value }) => value).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map((part) => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName
          });
          return {
            ...part,
            value: offsetName
          };
        } else {
          return part;
        }
      });
    }
    return parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
};
var PolyRelFormatter = class {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
};
var fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
var Locale = class _Locale {
  static fromOpts(opts) {
    return _Locale.create(
      opts.locale,
      opts.numberingSystem,
      opts.outputCalendar,
      opts.weekSettings,
      opts.defaultToEN
    );
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new _Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache.clear();
    intlNumCache.clear();
    intlRelCache.clear();
    intlResolvedOptionsCache.clear();
    weekInfoCache.clear();
  }
  static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
    return _Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return _Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        validateWeekSettings(alts.weekSettings) || this.weekSettings,
        alts.defaultToEN || false
      );
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }
  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }
  months(length, format = false) {
    return listStuff(this, length, months, () => {
      const monthSpecialCase = this.intl === "ja" || this.intl.startsWith("ja-");
      format &= !monthSpecialCase;
      const intl = format ? { month: length, day: "numeric" } : { month: length }, formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        const mapper = !monthSpecialCase ? (dt) => this.extract(dt, intl, "month") : (dt) => this.dtFormatter(dt, intl).format();
        this.monthsCache[formatStr][length] = mapMonths(mapper);
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      const intl = format ? { weekday: length, year: "numeric", month: "long", day: "numeric" } : { weekday: length }, formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays(
          (dt) => this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length];
    });
  }
  meridiems() {
    return listStuff(
      this,
      void 0,
      () => meridiems,
      () => {
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(length) {
    return listStuff(this, length, eras, () => {
      const intl = { era: length };
      if (!this.eraCache[length]) {
        this.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(
          (dt) => this.extract(dt, intl, "era")
        );
      }
      return this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
};
var singleton = null;
var FixedOffsetZone = class _FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton === null) {
      singleton = new _FixedOffsetZone(0);
    }
    return singleton;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset2) {
    return offset2 === 0 ? _FixedOffsetZone.utcInstance : new _FixedOffsetZone(offset2);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s2) {
    if (s2) {
      const r = s2.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new _FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  }
  constructor(offset2) {
    super();
    this.fixed = offset2;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return true;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return true;
  }
};
var InvalidZone = class extends Zone {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return false;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return false;
  }
  /** @override **/
  get isValid() {
    return false;
  }
};
function normalizeZone(input, defaultZone2) {
  if (isUndefined(input) || input === null) {
    return defaultZone2;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default")
      return defaultZone2;
    else if (lowered === "local" || lowered === "system")
      return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt")
      return FixedOffsetZone.utcInstance;
    else
      return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    return input;
  } else {
    return new InvalidZone(input);
  }
}
var numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
var numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
};
var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
var digitRegexCache = /* @__PURE__ */ new Map();
function resetDigitRegexCache() {
  digitRegexCache.clear();
}
function digitRegex({ numberingSystem }, append = "") {
  const ns = numberingSystem || "latn";
  let appendCache = digitRegexCache.get(ns);
  if (appendCache === void 0) {
    appendCache = /* @__PURE__ */ new Map();
    digitRegexCache.set(ns, appendCache);
  }
  let regex = appendCache.get(append);
  if (regex === void 0) {
    regex = new RegExp(`${numberingSystems[ns]}${append}`);
    appendCache.set(append, regex);
  }
  return regex;
}
var now = () => Date.now();
var defaultZone = "system";
var defaultLocale = null;
var defaultNumberingSystem = null;
var defaultOutputCalendar = null;
var twoDigitCutoffYear = 60;
var throwOnInvalid;
var defaultWeekSettings = null;
var Settings = class {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n2) {
    now = n2;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  }
};
var Invalid = class {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
};
var nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
var leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(unit, value) {
  return new Invalid(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}
function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  const js = d.getUTCDay();
  return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i) => i < ordinal), day = ordinal - table[month0];
  return { month: month0 + 1, day };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(weekData) };
}
function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...timeObject(gregData) };
}
function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(ordinalData) };
}
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    }
    if (!isUndefined(obj.localWeekday))
      obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber))
      obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear))
      obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
  }
}
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear), validWeek = integerBetween(
    obj.weekNumber,
    1,
    weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)
  ), validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else
    return false;
}
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else
    return false;
}
function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else
    return false;
}
function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else
    return false;
}
function isUndefined(o) {
  return typeof o === "undefined";
}
function isNumber(o) {
  return typeof o === "number";
}
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
  return typeof o === "string";
}
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e) {
    return false;
  }
}
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return void 0;
  }
  return arr.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v) => !integerBetween(v, 1, 7))) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}
function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}
function floorMod(x, n2) {
  return x - n2 * Math.floor(x / n2);
}
function padStart(input, n2 = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n2, "0");
  } else {
    padded = ("" + input).padStart(n2, "0");
  }
  return padded;
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseInt(string, 10);
  }
}
function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return void 0;
  } else {
    return parseFloat(string);
  }
}
function parseMillis(fraction) {
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return void 0;
  } else {
    const f = parseFloat("0." + fraction) * 1e3;
    return Math.floor(f);
  }
}
function roundTo(number, digits, rounding = "round") {
  const factor = 10 ** digits;
  switch (rounding) {
    case "expand":
      return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
    case "trunc":
      return Math.trunc(number * factor) / factor;
    case "round":
      return Math.round(number * factor) / factor;
    case "floor":
      return Math.floor(number * factor) / factor;
    case "ceil":
      return Math.ceil(number * factor) / factor;
    default:
      throw new RangeError(`Value rounding ${rounding} is out of range`);
  }
}
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}
function objToLocalTS(obj) {
  let d = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else
    return year > Settings.twoDigitCutoffYear ? 1900 + year : 2e3 + year;
}
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts), intlOpts = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = { timeZoneName: offsetFormat, ...intlOpts };
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue))
    throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === void 0 || v === null)
        continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}
function formatOffset(offset2, format) {
  const hours = Math.trunc(Math.abs(offset2 / 60)), minutes = Math.trunc(Math.abs(offset2 % 60)), sign = offset2 >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}
var monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
var monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
var monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
var weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];
var weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
var weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
var meridiems = ["AM", "PM"];
var erasLong = ["Before Christ", "Anno Domini"];
var erasShort = ["BC", "AD"];
var erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }
  const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function stringifyTokens(splits, tokenToString) {
  let s2 = "";
  for (const token of splits) {
    if (token.literal) {
      s2 += token.val;
    } else {
      s2 += tokenToString(token.val);
    }
  }
  return s2;
}
var macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
var Formatter = class _Formatter {
  static create(locale, opts = {}) {
    return new _Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null, currentFull = "", bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0 || bracketed) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull === "" ? "'" : currentFull
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: /^\s+$/.test(currentFull), val: currentFull });
        }
        currentFull = c;
        current = c;
      }
    }
    if (currentFull.length > 0) {
      splits.push({ literal: bracketed || /^\s+$/.test(currentFull), val: currentFull });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }
  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, { ...this.opts, ...opts });
  }
  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }
  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }
  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }
  num(n2, p = 0, signDisplay = void 0) {
    if (this.opts.forceSimple) {
      return padStart(n2, p);
    }
    const opts = { ...this.opts };
    if (p > 0) {
      opts.padTo = p;
    }
    if (signDisplay) {
      opts.signDisplay = signDisplay;
    }
    return this.loc.numberFormatter(opts).format(n2);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract) => this.loc.extract(dt, opts, extract), formatOffset2 = (opts) => {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }
      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    }, meridiem = () => knownEnglish ? meridiemForDateTime(dt) : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), month = (length, standalone) => knownEnglish ? monthForDateTime(dt, length) : string(standalone ? { month: length } : { month: length, day: "numeric" }, "month"), weekday = (length, standalone) => knownEnglish ? weekdayForDateTime(dt, length) : string(
      standalone ? { weekday: length } : { weekday: length, month: "long", day: "numeric" },
      "weekday"
    ), maybeMacro = (token) => {
      const formatOpts = _Formatter.macroTokenToFormatOpts(token);
      if (formatOpts) {
        return this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token;
      }
    }, era = (length) => knownEnglish ? eraForDateTime(dt, length) : string({ era: length }, "era"), tokenToString = (token) => {
      switch (token) {
        case "S":
          return this.num(dt.millisecond);
        case "u":
        case "SSS":
          return this.num(dt.millisecond, 3);
        case "s":
          return this.num(dt.second);
        case "ss":
          return this.num(dt.second, 2);
        case "uu":
          return this.num(Math.floor(dt.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(dt.millisecond / 100));
        case "m":
          return this.num(dt.minute);
        case "mm":
          return this.num(dt.minute, 2);
        case "h":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
        case "hh":
          return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
        case "H":
          return this.num(dt.hour);
        case "HH":
          return this.num(dt.hour, 2);
        case "Z":
          return formatOffset2({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return formatOffset2({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return formatOffset2({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return dt.zoneName;
        case "a":
          return meridiem();
        case "d":
          return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
        case "dd":
          return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
        case "c":
          return this.num(dt.weekday);
        case "ccc":
          return weekday("short", true);
        case "cccc":
          return weekday("long", true);
        case "ccccc":
          return weekday("narrow", true);
        case "E":
          return this.num(dt.weekday);
        case "EEE":
          return weekday("short", false);
        case "EEEE":
          return weekday("long", false);
        case "EEEEE":
          return weekday("narrow", false);
        case "L":
          return useDateTimeFormatter ? string({ month: "numeric", day: "numeric" }, "month") : this.num(dt.month);
        case "LL":
          return useDateTimeFormatter ? string({ month: "2-digit", day: "numeric" }, "month") : this.num(dt.month, 2);
        case "LLL":
          return month("short", true);
        case "LLLL":
          return month("long", true);
        case "LLLLL":
          return month("narrow", true);
        case "M":
          return useDateTimeFormatter ? string({ month: "numeric" }, "month") : this.num(dt.month);
        case "MM":
          return useDateTimeFormatter ? string({ month: "2-digit" }, "month") : this.num(dt.month, 2);
        case "MMM":
          return month("short", false);
        case "MMMM":
          return month("long", false);
        case "MMMMM":
          return month("narrow", false);
        case "y":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
        case "yy":
          return useDateTimeFormatter ? string({ year: "2-digit" }, "year") : this.num(dt.year.toString().slice(-2), 2);
        case "yyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 4);
        case "yyyyyy":
          return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year, 6);
        case "G":
          return era("short");
        case "GG":
          return era("long");
        case "GGGGG":
          return era("narrow");
        case "kk":
          return this.num(dt.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(dt.weekYear, 4);
        case "W":
          return this.num(dt.weekNumber);
        case "WW":
          return this.num(dt.weekNumber, 2);
        case "n":
          return this.num(dt.localWeekNumber);
        case "nn":
          return this.num(dt.localWeekNumber, 2);
        case "ii":
          return this.num(dt.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(dt.localWeekYear, 4);
        case "o":
          return this.num(dt.ordinal);
        case "ooo":
          return this.num(dt.ordinal, 3);
        case "q":
          return this.num(dt.quarter);
        case "qq":
          return this.num(dt.quarter, 2);
        case "X":
          return this.num(Math.floor(dt.ts / 1e3));
        case "x":
          return this.num(dt.ts);
        default:
          return maybeMacro(token);
      }
    };
    return stringifyTokens(_Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
    const tokenToField = (token) => {
      switch (token[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, tokenToString = (lildur, info) => (token) => {
      const mapped = tokenToField(token);
      if (mapped) {
        const inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
        let signDisplay;
        if (this.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) {
          signDisplay = "never";
        } else if (this.opts.signMode === "all") {
          signDisplay = "always";
        } else {
          signDisplay = "auto";
        }
        return this.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
      } else {
        return token;
      }
    }, tokens = _Formatter.parseFormat(fmt), realTokens = tokens.reduce(
      (found, { literal, val }) => literal ? found : found.concat(val),
      []
    ), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t)), durationInfo = {
      isNegativeDuration: collapsed < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(collapsed.values)[0]
    };
    return stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
  }
};
var ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}
function combineExtractors(...extractors) {
  return (m) => extractors.reduce(
    ([mergedVals, mergedZone, cursor], ex) => {
      const [val, zone, next] = ex(m, cursor);
      return [{ ...mergedVals, ...val }, zone || mergedZone, next];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function parse(s2, ...patterns) {
  if (s2 == null) {
    return [null, null];
  }
  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s2);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}
function simpleParse(...keys) {
  return (match2, cursor) => {
    const ret = {};
    let i;
    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match2[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}
var offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
var isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
var isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
var isoTimeExtensionRegex = RegExp(`(?:[Tt]${isoTimeRegex.source})?`);
var isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
var extractISOOrdinalData = simpleParse("year", "ordinal");
var sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/;
var sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
var sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match2, pos, fallback) {
  const m = match2[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match2, cursor) {
  const item = {
    year: int(match2, cursor),
    month: int(match2, cursor + 1, 1),
    day: int(match2, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}
function extractISOTime(match2, cursor) {
  const item = {
    hours: int(match2, cursor, 0),
    minutes: int(match2, cursor + 1, 0),
    seconds: int(match2, cursor + 2, 0),
    milliseconds: parseMillis(match2[cursor + 3])
  };
  return [item, null, cursor + 4];
}
function extractISOOffset(match2, cursor) {
  const local = !match2[cursor] && !match2[cursor + 1], fullOffset = signedOffset(match2[cursor + 1], match2[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}
function extractIANAZone(match2, cursor) {
  const zone = match2[cursor] ? IANAZone.create(match2[cursor]) : null;
  return [{}, zone, cursor + 1];
}
var isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
var isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match2) {
  const [s2, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match2;
  const hasNegativePrefix = s2[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = (num, force = false) => num !== void 0 && (force || num && hasNegativePrefix) ? -num : num;
  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
    }
  ];
}
var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr)
    result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match2) {
  const [
    ,
    weekdayStr,
    dayStr,
    monthStr,
    yearStr,
    hourStr,
    minuteStr,
    secondStr,
    obsOffset,
    milOffset,
    offHourStr,
    offMinuteStr
  ] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset2;
  if (obsOffset) {
    offset2 = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset2 = 0;
  } else {
    offset2 = signedOffset(offHourStr, offMinuteStr);
  }
  return [result, new FixedOffsetZone(offset2)];
}
function preprocessRFC2822(s2) {
  return s2.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/;
var rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/;
var ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match2) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
function extractASCII(match2) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match2, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
var extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
var extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
var extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseISODate(s2) {
  return parse(
    s2,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}
function parseRFC2822Date(s2) {
  return parse(preprocessRFC2822(s2), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s2) {
  return parse(
    s2,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}
function parseISODuration(s2) {
  return parse(s2, [isoDuration, extractISODuration]);
}
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s2) {
  return parse(s2, [isoTimeOnly, extractISOTimeOnly]);
}
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseSQL(s2) {
  return parse(
    s2,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}
var INVALID$2 = "Invalid Duration";
var lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
};
var casualMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
};
var daysInYearAccurate = 146097 / 400;
var daysInMonthAccurate = 146097 / 4800;
var accurateMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
};
var orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
];
var reverseUnits = orderedUnits$1.slice(0).reverse();
function clone$1(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...alts.values || {} },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
function durationToMillis(matrix, vals) {
  let sum = vals.milliseconds ?? 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}
function normalizeValues(matrix, vals) {
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits$1.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);
  orderedUnits$1.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
var Duration = class _Duration {
  /**
   * @private
   */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config.matrix) {
      matrix = config.matrix;
    }
    this.values = config.values;
    this.loc = config.loc || Locale.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return _Duration.fromObject({ milliseconds: count }, opts);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`
      );
    }
    return new _Duration({
      values: normalizeObject(obj, _Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return _Duration.fromMillis(durationLike);
    } else if (_Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return _Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return _Duration.fromObject(parsed, opts);
    } else {
      return _Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return _Duration.fromObject(parsed, opts);
    } else {
      return _Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new _Duration({ invalid });
    }
  }
  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized)
      throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o) {
    return o && o.isLuxonDuration || false;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false
    };
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(opts = {}) {
    if (!this.isValid)
      return INVALID$2;
    const showZeros = opts.showZeros !== false;
    const l2 = orderedUnits$1.map((unit) => {
      const val = this.values[unit];
      if (isUndefined(val) || val === 0 && !showZeros) {
        return null;
      }
      return this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) }).format(val);
    }).filter((n2) => n2);
    return this.loc.listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts }).format(l2);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid)
      return {};
    return { ...this.values };
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid)
      return null;
    let s2 = "P";
    if (this.years !== 0)
      s2 += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0)
      s2 += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0)
      s2 += this.weeks + "W";
    if (this.days !== 0)
      s2 += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s2 += "T";
    if (this.hours !== 0)
      s2 += this.hours + "H";
    if (this.minutes !== 0)
      s2 += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s2 += roundTo(this.seconds + this.milliseconds / 1e3, 3) + "S";
    if (s2 === "P")
      s2 += "T0S";
    return s2;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid)
      return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 864e5)
      return null;
    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
      includeOffset: false
    };
    const dateTime = DateTime.fromMillis(millis, { zone: "UTC" });
    return dateTime.toISOTime(opts);
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    if (!this.isValid)
      return NaN;
    return durationToMillis(this.matrix, this.values);
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid)
      return this;
    const dur = _Duration.fromDurationLike(duration), result = {};
    for (const k of orderedUnits$1) {
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone$1(this, { values: result }, true);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid)
      return this;
    const dur = _Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid)
      return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone$1(this, { values: result }, true);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[_Duration.normalizeUnit(unit)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values) {
    if (!this.isValid)
      return this;
    const mixed = { ...this.values, ...normalizeObject(values, _Duration.normalizeUnit) };
    return clone$1(this, { values: mixed });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone$1(this, opts);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid)
      return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid)
      return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid)
      return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u) => _Duration.normalizeUnit(u));
    const built = {}, accumulated = {}, vals = this.toObject();
    let lastUnit;
    for (const k of orderedUnits$1) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        let own = 0;
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }
        if (isNumber(vals[k])) {
          own += vals[k];
        }
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1e3 - i * 1e3) / 1e3;
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone$1(this, { values: built }, true);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid)
      return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid)
      return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone$1(this, { values: negated }, true);
  }
  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid)
      return this;
    const vals = removeZeroes(this.values);
    return clone$1(this, { values: vals }, true);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      if (v1 === void 0 || v1 === 0)
        return v2 === void 0 || v2 === 0;
      return v1 === v2;
    }
    for (const u of orderedUnits$1) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
};
var INVALID$1 = "Invalid Interval";
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}
var Interval = class _Interval {
  /**
   * @private
   */
  constructor(config) {
    this.s = config.start;
    this.e = config.end;
    this.invalid = config.invalid || null;
    this.isLuxonInterval = true;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new _Interval({ invalid });
    }
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new _Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
    return _Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
    return _Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s2, e] = (text || "").split("/", 2);
    if (s2 && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s2, opts);
        startIsValid = start.isValid;
      } catch (e2) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e2) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return _Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return _Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s2, opts);
        if (dur.isValid) {
          return _Interval.before(end, dur);
        }
      }
    }
    return _Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o) {
    return o && o.isLuxonInterval || false;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid ? this.e ? this.e.minus(1) : null : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(unit = "milliseconds", opts) {
    if (!this.isValid)
      return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts?.useLocaleWeeks) {
      end = this.end.reconfigure({ locale: start.locale });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid)
      return false;
    return this.s > dateTime;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid)
      return false;
    return this.e <= dateTime;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid)
      return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start, end } = {}) {
    if (!this.isValid)
      return this;
    return _Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid)
      return [];
    const sorted = dateTimes.map(friendlyDateTime).filter((d) => this.contains(d)).sort((a, b) => a.toMillis() - b.toMillis()), results = [];
    let { s: s2 } = this, i = 0;
    while (s2 < this.e) {
      const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
      results.push(_Interval.fromDateTimes(s2, next));
      s2 = next;
      i += 1;
    }
    return results;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s: s2 } = this, idx = 1, next;
    const results = [];
    while (s2 < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(_Interval.fromDateTimes(s2, next));
      s2 = next;
      idx += 1;
    }
    return results;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid)
      return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid)
      return false;
    return +this.e === +other.s;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid)
      return false;
    return +other.e === +this.s;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid)
      return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid)
      return this;
    const s2 = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
    if (s2 >= e) {
      return null;
    } else {
      return _Interval.fromDateTimes(s2, e);
    }
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid)
      return this;
    const s2 = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
    return _Interval.fromDateTimes(s2, e);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals.sort((a, b) => a.s - b.s).reduce(
      ([sofar, current], item) => {
        if (!current) {
          return [sofar, item];
        } else if (current.overlaps(item) || current.abutsStart(item)) {
          return [sofar, current.union(item)];
        } else {
          return [sofar.concat([current]), item];
        }
      },
      [[], null]
    );
    if (final) {
      found.push(final);
    }
    return found;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null, currentCount = 0;
    const results = [], ends = intervals.map((i) => [
      { time: i.s, type: "s" },
      { time: i.e, type: "e" }
    ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b) => a.time - b.time);
    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(_Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return _Interval.merge(results);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return _Interval.xor([this].concat(intervals)).map((i) => this.intersection(i)).filter((i) => i && !i.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid)
      return INVALID$1;
    return `[${this.s.toISO()} \u2013 ${this.e.toISO()})`;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid)
      return INVALID$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid)
      return INVALID$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid)
      return INVALID$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, { separator = " \u2013 " } = {}) {
    if (!this.isValid)
      return INVALID$1;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return _Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
};
var Info = class {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({ month: 12 });
    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative(), localeWeek: hasLocaleWeekInfo() };
  }
};
function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
  const differs = [
    ["years", (a, b) => b.year - a.year],
    ["quarters", (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4],
    ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - days % 7) / 7;
      }
    ],
    ["days", dayDiff]
  ];
  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor = earlier.plus(results);
        if (cursor > later) {
          highWater = cursor;
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }
  return [cursor, results, highWater, lowestOrder];
}
function diff(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor;
  const lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({ [lowestOrder]: 1 });
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  const duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}
var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i) => i) {
  return { regex, deser: ([s2]) => post(parseDigits(s2)) };
}
var NBSP = String.fromCharCode(160);
var spaceOrNBSP = `[ ${NBSP}]`;
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s2) {
  return s2.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s2) {
  return s2.replace(/\./g, "").replace(spaceOrNBSPRegExp, " ").toLowerCase();
}
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s2]) => strings.findIndex((i) => stripInsensitivities(s2) === stripInsensitivities(i)) + startIndex
    };
  }
}
function offset(regex, groups) {
  return { regex, deser: ([, h, m]) => signedOffset(h, m), groups };
}
function simple(regex) {
  return { regex, deser: ([s2]) => s2 };
}
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function unitForToken(token, loc) {
  const one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal = (t) => ({ regex: RegExp(escapeToken(t.val)), deser: ([s2]) => s2, literal: true }), unitate = (t) => {
    if (token.literal) {
      return literal(t);
    }
    switch (t.val) {
      case "G":
        return oneOf(loc.eras("short"), 0);
      case "GG":
        return oneOf(loc.eras("long"), 0);
      case "y":
        return intUnit(oneToSix);
      case "yy":
        return intUnit(twoToFour, untruncateYear);
      case "yyyy":
        return intUnit(four);
      case "yyyyy":
        return intUnit(fourToSix);
      case "yyyyyy":
        return intUnit(six);
      case "M":
        return intUnit(oneOrTwo);
      case "MM":
        return intUnit(two);
      case "MMM":
        return oneOf(loc.months("short", true), 1);
      case "MMMM":
        return oneOf(loc.months("long", true), 1);
      case "L":
        return intUnit(oneOrTwo);
      case "LL":
        return intUnit(two);
      case "LLL":
        return oneOf(loc.months("short", false), 1);
      case "LLLL":
        return oneOf(loc.months("long", false), 1);
      case "d":
        return intUnit(oneOrTwo);
      case "dd":
        return intUnit(two);
      case "o":
        return intUnit(oneToThree);
      case "ooo":
        return intUnit(three);
      case "HH":
        return intUnit(two);
      case "H":
        return intUnit(oneOrTwo);
      case "hh":
        return intUnit(two);
      case "h":
        return intUnit(oneOrTwo);
      case "mm":
        return intUnit(two);
      case "m":
        return intUnit(oneOrTwo);
      case "q":
        return intUnit(oneOrTwo);
      case "qq":
        return intUnit(two);
      case "s":
        return intUnit(oneOrTwo);
      case "ss":
        return intUnit(two);
      case "S":
        return intUnit(oneToThree);
      case "SSS":
        return intUnit(three);
      case "u":
        return simple(oneToNine);
      case "uu":
        return simple(oneOrTwo);
      case "uuu":
        return intUnit(one);
      case "a":
        return oneOf(loc.meridiems(), 0);
      case "kkkk":
        return intUnit(four);
      case "kk":
        return intUnit(twoToFour, untruncateYear);
      case "W":
        return intUnit(oneOrTwo);
      case "WW":
        return intUnit(two);
      case "E":
      case "c":
        return intUnit(one);
      case "EEE":
        return oneOf(loc.weekdays("short", false), 1);
      case "EEEE":
        return oneOf(loc.weekdays("long", false), 1);
      case "ccc":
        return oneOf(loc.weekdays("short", true), 1);
      case "cccc":
        return oneOf(loc.weekdays("long", true), 1);
      case "Z":
      case "ZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
      case "ZZZ":
        return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);
      case " ":
        return simple(/[^\S\n\r]/);
      default:
        return literal(t);
    }
  };
  const unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}
var partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  const { type, value } = part;
  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  const style = formatOpts[type];
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return void 0;
}
function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [`^${re}$`, units];
}
function match(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}
function dateTimeFromMatches(matches) {
  const toField = (token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  const vals = Object.keys(matches).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches[k];
    }
    return r;
  }, {});
  return [vals, zone, specificOffset];
}
var dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(void 0)) {
    return token;
  }
  return tokens;
}
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}
var TokenParser = class {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
    this.units = this.tokens.map((t) => unitForToken(t, locale));
    this.disqualifyingUnit = this.units.find((t) => t.invalidReason);
    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }
  explainFromTokens(input) {
    if (!this.isValid) {
      return { input, tokens: this.tokens, invalidReason: this.invalidReason };
    } else {
      const [rawMatches, matches] = match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [null, null, void 0];
      if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
        throw new ConflictingSpecificationError(
          "Can't include meridiem when specifying 24-hour format"
        );
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset
      };
    }
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
};
function explainFromTokens(locale, input, format) {
  const parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}
function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map((p) => tokenForPart(p, formatOpts, resolvedOpts));
}
var INVALID = "Invalid DateTime";
var MAX_DATE = 864e13;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(
      dt.c,
      dt.loc.getMinDaysInFirstWeek(),
      dt.loc.getStartOfWeek()
    );
  }
  return dt.localWeekData;
}
function clone(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime({ ...current, ...alts, old: current });
}
function fixOffset(localTS, o, tz) {
  let utcGuess = localTS - o * 60 * 1e3;
  const o2 = tz.offset(utcGuess);
  if (o === o2) {
    return [utcGuess, o];
  }
  utcGuess -= (o2 - o) * 60 * 1e3;
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }
  return [localTS - Math.min(o2, o3) * 60 * 1e3, Math.max(o2, o3)];
}
function tsToObj(ts, offset2) {
  ts += offset2 * 60 * 1e3;
  const d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}
function objToTS(obj, offset2, zone) {
  return fixOffset(objToLocalTS(obj), offset2, zone);
}
function adjustTime(inst, dur) {
  const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = {
    ...inst.c,
    year,
    month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }, millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"), localTS = objToLocalTS(c);
  let [ts, o] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    o = inst.zone.offset(ts);
  }
  return { ts, o };
}
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, {
      ...opts,
      zone: interpretationZone,
      specificOffset
    });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
function toISODate(o, extended, precision) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0)
    c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (precision === "year")
    return c;
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    if (precision === "month")
      return c;
    c += "-";
  } else {
    c += padStart(o.c.month);
    if (precision === "month")
      return c;
  }
  c += padStart(o.c.day);
  return c;
}
function toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
  let showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
  switch (precision) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      c += padStart(o.c.hour);
      if (precision === "hour")
        break;
      if (extended) {
        c += ":";
        c += padStart(o.c.minute);
        if (precision === "minute")
          break;
        if (showSeconds) {
          c += ":";
          c += padStart(o.c.second);
        }
      } else {
        c += padStart(o.c.minute);
        if (precision === "minute")
          break;
        if (showSeconds) {
          c += padStart(o.c.second);
        }
      }
      if (precision === "second")
        break;
      if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
        c += ".";
        c += padStart(o.c.millisecond, 3);
      }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}
var defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
};
var orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"];
var orderedWeekUnits = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
];
var orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized)
    throw new InvalidUnitError(unit);
  return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}
function guessOffsetForZone(zone) {
  if (zoneOffsetTs === void 0) {
    zoneOffsetTs = Settings.now();
  }
  if (zone.type !== "iana") {
    return zone.offset(zoneOffsetTs);
  }
  const zoneName = zone.name;
  let offsetGuess = zoneOffsetGuessCache.get(zoneName);
  if (offsetGuess === void 0) {
    offsetGuess = zone.offset(zoneOffsetTs);
    zoneOffsetGuessCache.set(zoneName, offsetGuess);
  }
  return offsetGuess;
}
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }
  const loc = Locale.fromObject(opts);
  let ts, o;
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = guessOffsetForZone(zone);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = Settings.now();
  }
  return new DateTime({ ts, zone, loc, o });
}
function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round, rounding = isUndefined(opts.rounding) ? "trunc" : opts.rounding, format = (c, unit) => {
    c = roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
    const formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c, unit);
  }, differ = (unit) => {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else
        return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  };
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
  let opts = {}, args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}
var zoneOffsetTs;
var zoneOffsetGuessCache = /* @__PURE__ */ new Map();
var DateTime = class _DateTime {
  /**
   * @access private
   */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;
    let invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    let c = null, o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        [c, o] = [config.old.c, config.old.o];
      } else {
        const ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }
    this._zone = zone;
    this.loc = config.loc || Locale.create();
    this.invalid = invalid;
    this.weekData = null;
    this.localWeekData = null;
    this.c = c;
    this.o = o;
    this.isLuxonDateTime = true;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new _DateTime({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options = {}) {
    const ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return _DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return _DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new _DateTime({
      ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      return _DateTime.invalid("Timestamp out of range");
    } else {
      return new _DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new _DateTime({
        ts: seconds * 1e3,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return _DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);
    const tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
    let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return _DateTime.invalid(invalid);
    }
    const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new _DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc
    });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return _DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }
    if (!inst.isValid) {
      return _DateTime.invalid(inst.invalid);
    }
    return inst;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return _DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return _DateTime.fromFormat(text, fmt, opts);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new _DateTime({ invalid });
    }
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => t ? t.val : null).join("");
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }
  static resetCache() {
    zoneOffsetTs = void 0;
    zoneOffsetGuessCache.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
    }
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    const dayMs = 864e5;
    const minuteMs = 6e4;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);
    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) {
      return [clone(this, { ts: ts1 }), clone(this, { ts: ts2 })];
    }
    return [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset2 = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset2), opts);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return _DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone(this, { ts: newTS, zone });
    }
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone(this, { loc });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({ locale });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values) {
    if (!this.isValid)
      return this;
    const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);
    const settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian(
        { ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), ...normalized },
        minDaysInFirstWeek,
        startOfWeek
      );
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone(this, { ts, o });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid)
      return this;
    const dur = Duration.fromDurationLike(duration);
    return clone(this, adjustTime(this, dur));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid)
      return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone(this, adjustTime(this, dur));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit, { useLocaleWeeks = false } = {}) {
    if (!this.isValid)
      return this;
    const o = {}, normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      case "quarters":
      case "months":
        o.day = 1;
      case "weeks":
      case "days":
        o.hour = 0;
      case "hours":
        o.minute = 0;
      case "minutes":
        o.second = 0;
      case "seconds":
        o.millisecond = 0;
        break;
    }
    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const { weekday } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit, opts) {
    return this.isValid ? this.plus({ [unit]: 1 }).startOf(unit, opts).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false,
    precision = "milliseconds"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    precision = normalizeUnit(precision);
    const ext = format === "extended";
    let c = toISODate(this, ext, precision);
    if (orderedUnits.indexOf(precision) >= 3)
      c += "T";
    c += toISOTime(
      this,
      ext,
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone,
      precision
    );
    return c;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format = "extended", precision = "day" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended", normalizeUnit(precision));
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended",
    precision = "milliseconds"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    precision = normalizeUnit(precision);
    let c = includePrefix && orderedUnits.indexOf(precision) >= 3 ? "T" : "";
    return c + toISOTime(
      this,
      format === "extended",
      suppressSeconds,
      suppressMilliseconds,
      includeOffset,
      extendedZone,
      precision
    );
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid)
      return {};
    const base = { ...this.c };
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };
    const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(_DateTime.now(), unit, opts);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid)
      return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid)
      return null;
    const base = options.base || _DateTime.fromObject({}, { zone: this.zone }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = void 0;
    }
    return diffRelative(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid)
      return null;
    return diffRelative(options.base || _DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    });
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(_DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(_DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return _DateTime.fromFormatExplain(text, fmt, options);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    return new TokenParser(localeToUse, fmt);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined(text) || isUndefined(formatParser)) {
      throw new InvalidArgumentError(
        "fromFormatParser requires an input string and a format parser"
      );
    }
    const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
      locale,
      numberingSystem,
      defaultToEN: true
    });
    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError(
        `fromFormatParser called with a locale of ${localeToUse}, but the format parser was created for ${formatParser.locale}`
      );
    }
    const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
    if (invalidReason) {
      return _DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(
        result,
        zone,
        opts,
        `format ${formatParser.format}`,
        text,
        specificOffset
      );
    }
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
};
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}

// src/aipo/GetOffer/utils/duration-parser.ts
function parseLimitedISODurationToNumber(isoDuration2) {
  if (!isoDuration2)
    return void 0;
  const match2 = isoDuration2.match(/^P(\d+)([DMY])$/);
  return match2 ? Number(match2[1]) : void 0;
}
function parseLimitedISODurationUnit(isoDuration2) {
  if (!isoDuration2)
    return void 0;
  const match2 = isoDuration2.match(/^P(\d+)([DMY])$/);
  return match2 ? match2[2] : void 0;
}
function parseIso8601Duration(isoDuration2) {
  return Duration.fromISO(isoDuration2);
}
function convertUserInputToDuration(duration, unit) {
  switch (unit) {
    case "D":
      return Duration.fromObject({ days: duration });
    case "M":
      return Duration.fromObject({ months: duration });
    case "Y":
      return Duration.fromObject({ years: duration });
    default:
      throw new Error(`Unsupported duration unit: ${unit}`);
  }
}
function formatDurationForDisplay(isoDuration2) {
  if (!isoDuration2)
    return "";
  const number = parseInt(isoDuration2.slice(1, -1), 10);
  const unit = isoDuration2[isoDuration2.length - 1];
  let unitName;
  if (unit === "D") {
    unitName = number === 1 ? "day" : "days";
  } else if (unit === "M") {
    unitName = number === 1 ? "month" : "months";
  } else if (unit === "Y") {
    unitName = number === 1 ? "year" : "years";
  } else {
    unitName = "units";
  }
  return `${number} ${unitName}`;
}
function validateRequestedDurationIsValid(userDuration, minDuration, maxDuration) {
  if (!userDuration.isValid) {
    return {
      isValid: false,
      errorMessage: "Invalid duration format"
    };
  }
  if (!minDuration.isValid || !maxDuration.isValid) {
    return { isValid: true };
  }
  if (userDuration < minDuration) {
    return {
      isValid: false,
      errorMessage: `The requested duration must be at least ${formatDurationForDisplay(minDuration.toISO())}.`
    };
  }
  if (userDuration > maxDuration) {
    return {
      isValid: false,
      errorMessage: `The requested duration can be at most ${formatDurationForDisplay(maxDuration.toISO())}.`
    };
  }
  return { isValid: true };
}
function calculateDateConstraints(maxFutureStartDuration, offerExpirationDuration) {
  const now2 = DateTime.now();
  const maxFutureDate = now2.plus(parseIso8601Duration(maxFutureStartDuration)).plus(parseIso8601Duration(offerExpirationDuration));
  const minAllowedFutureStart = now2.plus(parseIso8601Duration(offerExpirationDuration));
  return {
    minDate: minAllowedFutureStart,
    maxDate: maxFutureDate
  };
}
function validateFutureStartDate(selectedDateString, maxFutureStartDuration, offerExpirationDuration) {
  const futureStart = DateTime.fromISO(selectedDateString, {
    zone: "utc"
  });
  if (!futureStart.isValid) {
    return {
      isValid: false,
      errorMessage: `Invalid future start date format: ${selectedDateString}`
    };
  }
  const { minDate, maxDate } = calculateDateConstraints(maxFutureStartDuration, offerExpirationDuration);
  if (futureStart <= minDate || futureStart > maxDate) {
    const minDateFormatted = minDate.plus({ days: 1 }).toFormat("yyyy/MM/dd");
    const maxDateFormatted = maxDate.toFormat("yyyy/MM/dd");
    return {
      isValid: false,
      errorMessage: `Future start date must be between ${minDateFormatted} and ${maxDateFormatted}.`
    };
  }
  return { isValid: true };
}
function isDateWithinConstraints(date, maxFutureStartDuration, offerExpirationDuration) {
  const { minDate, maxDate } = calculateDateConstraints(maxFutureStartDuration, offerExpirationDuration);
  const selectedDate = DateTime.fromJSDate(date, {
    zone: "utc"
  });
  return selectedDate > minDate && selectedDate <= maxDate;
}

// src/aipo/GetOffer/components/ContractNeedsStep/ContractNeedsStep.module.css
var ContractNeedsStep_default = {
  setDateField: "ContractNeedsStep_setDateField",
  durationOuterContainer: "ContractNeedsStep_durationOuterContainer",
  durationContainer: "ContractNeedsStep_durationContainer",
  flexGrow: "ContractNeedsStep_flexGrow"
};

// src/aipo/GetOffer/components/ContractNeedsStep/validation.ts
var validateContractNeedsStep = (artifact, contractDatePref, buyerOptions, t) => {
  let isValid = true;
  const errorProps = {};
  const durationNumber = parseLimitedISODurationToNumber(artifact.offerRequest.duration);
  const durationUnit = parseLimitedISODurationUnit(artifact.offerRequest.duration);
  if (!durationNumber || !durationUnit) {
    isValid = false;
    errorProps.durationError = t("validationEnterDuration");
  }
  if (contractDatePref === "custom" && !artifact.offerRequest.futureStartDate) {
    isValid = false;
    errorProps.customDateError = t("validationSelectStartDate");
  }
  if (durationNumber && durationUnit) {
    const durationValidation = isDurationValid(durationNumber, durationUnit, buyerOptions, t);
    if (!durationValidation.isValid) {
      isValid = false;
      errorProps.durationConstraintError = durationValidation.errorMessage;
    }
  }
  if (contractDatePref === "custom" && artifact.offerRequest.futureStartDate) {
    try {
      const dateValidation = validateFutureStartDate(
        artifact.offerRequest.futureStartDate,
        buyerOptions.maxFutureStartDuration,
        buyerOptions.expiration
      );
      if (!dateValidation.isValid) {
        isValid = false;
        errorProps.dateConstraintError = dateValidation.errorMessage;
      }
    } catch (error) {
      console.warn("Date constraint validation error:", error);
    }
  }
  return {
    isValid,
    errorProps
  };
};
var isDurationValid = (durationNumber, durationUnit, buyerOptions, t) => {
  try {
    const userDuration = convertUserInputToDuration(durationNumber, durationUnit);
    return validateRequestedDurationIsValid(
      userDuration,
      parseIso8601Duration(buyerOptions.minOfferDuration),
      parseIso8601Duration(buyerOptions.maxOfferDuration)
    );
  } catch (error) {
    console.warn("Duration constraint validation error:", error);
    return { isValid: false, errorMessage: t("validationInvalidDuration") };
  }
};

// src/aipo/GetOffer/components/ContractNeedsStep/ContractNeedsStep.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var getEarliestValidDate = (buyerOptions) => {
  const { minDate } = calculateDateConstraints(buyerOptions.maxFutureStartDuration, buyerOptions.expiration);
  return minDate.plus({ days: 1 }).toFormat("yyyy-MM-dd");
};
var getDurationOptions = (unit, buyerOptions, t) => {
  const baseOptions = unit === "M" ? Array.from({ length: 60 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) : Array.from({ length: 5 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` }));
  return baseOptions.map((option) => {
    const duration = parseInt(option.value, 10);
    const durationValidation = isDurationValid(unit === "Y" ? duration * 12 : duration, "M", buyerOptions, t);
    return durationValidation.isValid ? option : {
      ...option,
      disabled: true,
      disabledReason: t("optionNotIncludedInConfiguration")
    };
  });
};
var getDurationUnitOptions = (buyerOptions, t) => {
  const yearDurationOptions = getDurationOptions("Y", buyerOptions, t);
  const hasValidYear = yearDurationOptions.find((option) => !option.disabled) !== void 0;
  const baseYearOption = { label: t("years"), value: "Y" };
  const yearOption = hasValidYear ? baseYearOption : {
    ...baseYearOption,
    disabled: true,
    disabledReason: t("optionNotIncludedInConfiguration")
  };
  return [{ label: t("months"), value: "M" }, yearOption];
};
var ContractNeedsStep = ({
  errors,
  clearFieldError,
  contractDatePref,
  setContractDatePref,
  eulaUrl,
  listingId,
  buyerOptions,
  writeableArtifact,
  isArtifactLocked,
  logger,
  t
}) => {
  const { artifact, setArtifact } = writeableArtifact;
  useEffect2(() => {
    logger.updateContext({ SubPageType: "AWSMP-Contract-Needs" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, []);
  const [duration, setDuration] = useState2(parseLimitedISODurationToNumber(artifact.offerRequest?.duration));
  const [unit, setUnit] = useState2(parseLimitedISODurationUnit(artifact.offerRequest?.duration) ?? "M");
  const [customContractDate, setCustomContractDate] = useState2(artifact.offerRequest.futureStartDate || getEarliestValidDate(buyerOptions));
  const durationOptions = useMemo2(() => getDurationOptions(unit, buyerOptions, t), [unit, buyerOptions, t]);
  const durationUnitOptions = useMemo2(() => getDurationUnitOptions(buyerOptions, t), [buyerOptions, t]);
  const selectedDurationUnit = durationUnitOptions.find((option) => option.value === unit) ?? null;
  const updateArtifactDuration = useCallback2(
    (newDuration, newUnit) => {
      let durationToSet;
      if (newDuration && newDuration > 0) {
        if (newUnit === "Y") {
          durationToSet = `P${newDuration * 12}M`;
        } else {
          durationToSet = `P${newDuration}${newUnit}`;
        }
      }
      setArtifact((prevArtifact) => ({
        ...prevArtifact,
        offerRequest: {
          ...prevArtifact.offerRequest,
          duration: durationToSet
        }
      }));
    },
    [setArtifact]
  );
  const updateArtifactFutureStartDate = useCallback2(
    (newContractDatePref, newFutureStartDate) => {
      setArtifact((prevArtifact) => ({
        ...prevArtifact,
        offerRequest: {
          ...prevArtifact.offerRequest,
          futureStartDate: newContractDatePref === "auto" ? void 0 : newFutureStartDate
        }
      }));
    },
    [setArtifact]
  );
  const onDurationChanged = useCallback2(
    (e) => {
      logger.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickFeat: "contract-details",
          ClickObj: "duration-dropdown",
          ClickAct: e.detail.selectedOption.value || ""
        }
      });
      const newDuration = parseInt(e.detail.selectedOption.value || "0", 10);
      setDuration(newDuration);
      updateArtifactDuration(newDuration, unit);
    },
    [unit, updateArtifactDuration, logger]
  );
  const onUnitChanged = useCallback2(
    (e) => {
      logger.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickFeat: "contract-details",
          ClickObj: "duration-unit-dropdown",
          ClickAct: e.detail.selectedOption.label
        }
      });
      setUnit(e.detail.selectedOption.value);
      setDuration(void 0);
      updateArtifactDuration(void 0, e.detail.selectedOption.value);
    },
    [updateArtifactDuration, logger]
  );
  const onContractDatePrefChanged = useCallback2(
    (e) => {
      const newPref = e.detail.value;
      logger.biMetric({
        metricName: "Click",
        value: 1,
        unit: "Count",
        dimensions: {
          ClickFeat: "contract-details",
          ClickObj: "contract-start-date",
          ClickAct: newPref === "auto" ? "start-immediate" : "start-custom-date"
        }
      });
      setContractDatePref(newPref);
      updateArtifactFutureStartDate(newPref, customContractDate);
    },
    [customContractDate, updateArtifactFutureStartDate, setContractDatePref, logger]
  );
  const onCustomContractDateChanged = useCallback2(
    (e) => {
      setCustomContractDate(e.detail.value);
      updateArtifactFutureStartDate(contractDatePref, e.detail.value);
    },
    [contractDatePref, updateArtifactFutureStartDate]
  );
  const onCustomContractDateBlur = useCallback2(() => {
    if (errors?.customDateError) {
      clearFieldError("customDateError");
    }
    if (errors?.dateConstraintError) {
      clearFieldError("dateConstraintError");
    }
  }, [errors?.customDateError, errors?.dateConstraintError, clearFieldError]);
  const onDurationBlur = useCallback2(() => {
    if (errors?.durationError) {
      clearFieldError("durationError");
    }
    if (errors?.durationConstraintError) {
      clearFieldError("durationConstraintError");
    }
  }, [errors?.durationError, errors?.durationConstraintError, clearFieldError]);
  const canSelectCustomDate = useMemo2(() => {
    return Duration.fromISO(buyerOptions.maxFutureStartDuration).toMillis() > 0;
  }, [buyerOptions.maxFutureStartDuration]);
  const radioGroupItems = useMemo2(() => {
    return [
      {
        value: "auto",
        label: t("startDateAcceptOffer"),
        disabled: isArtifactLocked
      },
      ...canSelectCustomDate ? [
        {
          value: "custom",
          label: t("startOnSpecificDate"),
          disabled: isArtifactLocked
        }
      ] : []
    ];
  }, [canSelectCustomDate]);
  return /* @__PURE__ */ jsxs2(SpaceBetween2, { size: "s", children: [
    /* @__PURE__ */ jsx2(Container2, { header: /* @__PURE__ */ jsx2(Header2, { description: t("contractDurationDescription"), children: t("contractDurationAndStartDate") }), children: /* @__PURE__ */ jsxs2(SpaceBetween2, { size: "s", children: [
      /* @__PURE__ */ jsx2("div", { className: ContractNeedsStep_default.durationOuterContainer, children: /* @__PURE__ */ jsxs2("div", { className: ContractNeedsStep_default.durationContainer, children: [
        /* @__PURE__ */ jsx2("div", { className: ContractNeedsStep_default.flexGrow, children: /* @__PURE__ */ jsx2(FormField, { label: t("unitOfTime"), controlId: "unit-of-time", children: /* @__PURE__ */ jsx2(
          Select,
          {
            options: durationUnitOptions,
            selectedOption: selectedDurationUnit,
            onChange: onUnitChanged,
            disabled: isArtifactLocked,
            placeholder: t("chooseAnOption")
          }
        ) }) }),
        /* @__PURE__ */ jsx2("div", { className: ContractNeedsStep_default.flexGrow, children: /* @__PURE__ */ jsx2(FormField, { label: t("duration"), errorText: errors?.durationError || errors?.durationConstraintError, controlId: "duration", children: /* @__PURE__ */ jsx2(
          Select,
          {
            "data-testid": "duration-select",
            options: durationOptions,
            selectedOption: duration ? { label: duration.toString(), value: duration.toString() } : null,
            onChange: onDurationChanged,
            onBlur: onDurationBlur,
            disabled: isArtifactLocked,
            placeholder: t("chooseAnOption"),
            virtualScroll: true
          }
        ) }) })
      ] }) }),
      /* @__PURE__ */ jsxs2("div", { children: [
        /* @__PURE__ */ jsx2(FormField, { label: t("contractStartDate"), description: t("selectYourStartDate"), children: /* @__PURE__ */ jsx2(RadioGroup, { value: contractDatePref, items: radioGroupItems, onChange: onContractDatePrefChanged }) }),
        contractDatePref === "custom" && /* @__PURE__ */ jsx2(
          FormField,
          {
            label: t("setDate"),
            className: ContractNeedsStep_default.setDateField,
            errorText: errors?.customDateError || errors?.dateConstraintError,
            description: t("startDateConstraintDescription"),
            constraintText: t("dateFormatConstraint"),
            children: /* @__PURE__ */ jsx2(
              DatePicker,
              {
                placeholder: "YYYY/MM/DD",
                value: customContractDate,
                onChange: onCustomContractDateChanged,
                onBlur: onCustomContractDateBlur,
                isDateEnabled: (date) => isDateWithinConstraints(date, buyerOptions.maxFutureStartDuration, buyerOptions.expiration),
                disabled: isArtifactLocked
              }
            )
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ jsx2(Container2, { header: /* @__PURE__ */ jsx2(Header2, { children: t("eulaHeader") }), children: /* @__PURE__ */ jsxs2(SpaceBetween2, { size: "m", children: [
      /* @__PURE__ */ jsx2(TextContent2, { children: /* @__PURE__ */ jsxs2("p", { children: [
        t("offerGeneratedWithVendorEula"),
        " ",
        /* @__PURE__ */ jsx2(Link2, { variant: "primary", href: eulaUrl, external: true, children: t("endUserLicenseAgreement") }),
        "."
      ] }) }),
      /* @__PURE__ */ jsxs2(TextContent2, { children: [
        /* @__PURE__ */ jsx2("p", { children: /* @__PURE__ */ jsx2("strong", { children: t("doYouNeedCustomTerms") }) }),
        /* @__PURE__ */ jsx2("p", { children: /* @__PURE__ */ jsx2(
          Link2,
          {
            variant: "primary",
            href: `https://aws.amazon.com/marketplace/customer-connect/private-offer/${listingId}`,
            external: true,
            onFollow: () => {
              logger.biMetric({
                metricName: "Click",
                value: 1,
                unit: "Count",
                dimensions: {
                  ClickFeat: "eula-container",
                  ClickAct: "request-custom-offer"
                }
              });
            },
            children: t("connectWithRepresentative")
          }
        ) })
      ] })
    ] }) })
  ] });
};

// src/aipo/GetOffer/components/AssessmentStep/AssessmentStep.tsx
import { useCallback as useCallback3, useEffect as useEffect3 } from "react";
import Container3 from "@amzn/awsui-components-react/polaris/container";
import SpaceBetween3 from "@amzn/awsui-components-react/polaris/space-between";
import FormField2 from "@amzn/awsui-components-react/polaris/form-field";
import Textarea from "@amzn/awsui-components-react/polaris/textarea";
import { jsx as jsx3 } from "react/jsx-runtime";
var AssessmentStep = ({ errors, clearFieldError, writeableArtifact, isArtifactLocked, logger, t }) => {
  const { artifact, setArtifact } = writeableArtifact;
  useEffect3(() => {
    logger.updateContext({ SubPageType: "AWSMP-Assessment" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, []);
  const qualificationResponses = artifact.offerRequest.qualificationResponses || [];
  const updateResponse = (index, value) => {
    const truncatedValue = value.slice(0, 1e3);
    const updatedResponses = qualificationResponses.map((item, i) => i === index ? { ...item, response: truncatedValue } : item);
    setArtifact((prevArtifact) => ({
      ...prevArtifact,
      offerRequest: {
        ...prevArtifact.offerRequest,
        qualificationResponses: updatedResponses
      }
    }));
  };
  const onQuestionBlur = useCallback3(
    (index) => {
      if (errors?.[`${index}`]) {
        clearFieldError(`${index}`);
      }
    },
    [errors, clearFieldError]
  );
  return /* @__PURE__ */ jsx3(Container3, { children: /* @__PURE__ */ jsx3(SpaceBetween3, { size: "l", children: qualificationResponses.map((item, index) => /* @__PURE__ */ jsx3(
    FormField2,
    {
      label: item.question,
      errorText: errors?.[`${index}`],
      constraintText: t("characterCountGetOffer", { count: item.response.length }),
      children: /* @__PURE__ */ jsx3(
        Textarea,
        {
          value: item.response,
          onChange: ({ detail }) => updateResponse(index, detail.value),
          onBlur: () => onQuestionBlur(index),
          placeholder: item._exampleResponse,
          rows: 3,
          disabled: isArtifactLocked
        }
      )
    },
    index
  )) }) });
};

// src/aipo/GetOffer/components/ReviewOfferStep/ReviewOfferStep.tsx
import { useEffect as useEffect4 } from "react";
import SpaceBetween4 from "@amzn/awsui-components-react/polaris/space-between";
import Container4 from "@amzn/awsui-components-react/polaris/container";
import Header3 from "@amzn/awsui-components-react/polaris/header";
import Button2 from "@amzn/awsui-components-react/polaris/button";
import KeyValuePairs from "@amzn/awsui-components-react/polaris/key-value-pairs";
import Link3 from "@amzn/awsui-components-react/polaris/link";
import { ManagedTable as ManagedTable2 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";

// src/aipo/GetOffer/components/ReviewOfferStep/ReviewOfferStep.module.css
var ReviewOfferStep_default = {
  sectionHeader: "ReviewOfferStep_sectionHeader"
};

// src/aipo/GetOffer/components/ReviewOfferStep/ReviewOfferStep.tsx
import Alert2 from "@amzn/awsui-components-react/polaris/alert";
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var ReviewOfferStep = ({ onEditStep, writeableArtifact, isArtifactLocked, logger, buyerOptions, t }) => {
  const { artifact } = writeableArtifact;
  useEffect4(() => {
    logger.updateContext({ SubPageType: "AWSMP-Review" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, []);
  const dimensionMap = new Map(buyerOptions.configurableUpfrontPricingTerms.rateCards.map((card) => [card.dimensionKey, card]));
  const dimensionTableItems = artifact.offerRequest.configurableUpfrontDimensionSelections?.map((selection) => {
    const rateCard = dimensionMap.get(selection.dimensionKey);
    return {
      dimensionKey: selection.dimensionKey,
      displayName: rateCard?.displayName || selection.dimensionKey,
      description: rateCard?.description || t("noDescriptionProvided"),
      numberOfUnits: selection.quantity
    };
  }) ?? [];
  const formatStartDate = () => {
    if (artifact.offerRequest.futureStartDate) {
      return `${artifact.offerRequest.futureStartDate}`;
    }
    return t("startDateAcceptOfferReview");
  };
  const formatDuration = () => {
    const duration = artifact.offerRequest.duration;
    if (!duration)
      return "";
    return duration.slice(1, -1);
  };
  const formatUnit = () => {
    const duration = artifact.offerRequest.duration;
    if (!duration)
      return "";
    const unit = duration[duration.length - 1];
    return unit === "D" ? t("days") : unit === "M" ? t("months") : t("years");
  };
  return /* @__PURE__ */ jsxs3(SpaceBetween4, { size: "l", children: [
    /* @__PURE__ */ jsxs3("div", { children: [
      /* @__PURE__ */ jsxs3("div", { className: ReviewOfferStep_default.sectionHeader, children: [
        /* @__PURE__ */ jsx4("h3", { children: t("step1Units") }),
        /* @__PURE__ */ jsx4(Button2, { variant: "normal", onClick: () => onEditStep(0), disabled: isArtifactLocked, children: t("edit") })
      ] }),
      /* @__PURE__ */ jsx4(Container4, { header: /* @__PURE__ */ jsx4(Header3, { children: t("specifiedDimensions") }), children: /* @__PURE__ */ jsx4(
        ManagedTable2,
        {
          hidePreferences: true,
          preferenceKey: "review-dimensions-table",
          defaultPreferences: {
            contentDensity: "compact",
            pageSize: 10
          },
          columnDefinitions: [
            { id: "dimension", header: t("dimension"), cell: (item) => item.displayName },
            { id: "description", header: t("description"), cell: (item) => item.description },
            { id: "units", header: t("numberOfUnits"), cell: (item) => item.numberOfUnits }
          ],
          items: dimensionTableItems,
          pagination: {},
          variant: "embedded",
          trackBy: "dimensionKey"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs3("div", { children: [
      /* @__PURE__ */ jsxs3("div", { className: ReviewOfferStep_default.sectionHeader, children: [
        /* @__PURE__ */ jsx4("h3", { children: t("step2ContractNeeds") }),
        /* @__PURE__ */ jsx4(Button2, { variant: "normal", onClick: () => onEditStep(1), disabled: isArtifactLocked, children: t("edit") })
      ] }),
      /* @__PURE__ */ jsx4(Container4, { header: /* @__PURE__ */ jsx4(Header3, { children: t("contractStartDateAndDuration") }), children: /* @__PURE__ */ jsxs3(SpaceBetween4, { size: "m", children: [
        /* @__PURE__ */ jsx4(
          KeyValuePairs,
          {
            columns: 2,
            items: [
              { label: t("duration"), value: formatDuration() },
              { label: t("unitOfTime"), value: formatUnit() }
            ]
          }
        ),
        /* @__PURE__ */ jsx4(
          KeyValuePairs,
          {
            columns: 1,
            items: [
              { label: t("contractStartDate"), value: formatStartDate() },
              {
                label: t("eulaHeader"),
                value: /* @__PURE__ */ jsx4(Link3, { href: buyerOptions.eulaUrl, external: true, children: t("endUserLicenseAgreement") })
              }
            ]
          }
        )
      ] }) })
    ] }),
    artifact.offerRequest.qualificationResponses.length > 0 && /* @__PURE__ */ jsxs3("div", { children: [
      /* @__PURE__ */ jsxs3("div", { className: ReviewOfferStep_default.sectionHeader, children: [
        /* @__PURE__ */ jsx4("h3", { children: t("step3Questionnaire") }),
        /* @__PURE__ */ jsx4(Button2, { variant: "normal", onClick: () => onEditStep(2), disabled: isArtifactLocked, children: t("edit") })
      ] }),
      /* @__PURE__ */ jsx4(Container4, { header: /* @__PURE__ */ jsx4(Header3, { children: t("questionnaire") }), children: /* @__PURE__ */ jsx4(
        KeyValuePairs,
        {
          columns: 1,
          items: artifact.offerRequest.qualificationResponses?.map((qa) => ({
            label: qa.question,
            value: qa.response || t("noAnswerProvided")
          })) || []
        }
      ) })
    ] }),
    artifact.offerRequest.qualificationResponses.length === 0 && /* @__PURE__ */ jsxs3("div", { children: [
      /* @__PURE__ */ jsx4("div", { className: ReviewOfferStep_default.sectionHeader, children: /* @__PURE__ */ jsx4("h3", { children: t("step3Questionnaire") }) }),
      /* @__PURE__ */ jsx4(Container4, { header: /* @__PURE__ */ jsx4(Header3, { children: t("questionnaire") }), children: /* @__PURE__ */ jsx4(Alert2, { children: t("noQuestionnaireRequired") }) })
    ] })
  ] });
};

// src/aipo/GetOffer/components/SuccessPage/SuccessPage.tsx
import { useEffect as useEffect5 } from "react";
import SpaceBetween5 from "@amzn/awsui-components-react/polaris/space-between";
import Container6 from "@amzn/awsui-components-react/polaris/container";
import Header4 from "@amzn/awsui-components-react/polaris/header";
import Button3 from "@amzn/awsui-components-react/polaris/button";
import KeyValuePairs2 from "@amzn/awsui-components-react/polaris/key-value-pairs";
import Link4 from "@amzn/awsui-components-react/polaris/link";
import TextContent3 from "@amzn/awsui-components-react/polaris/text-content";
import { AppTrans } from "@amzn/awsmp-max-translations";

// src/aipo/GetOffer/components/HeroContainer/HeroContainer.tsx
import Container5 from "@amzn/awsui-components-react/polaris/container";

// src/aipo/GetOffer/components/HeroContainer/HeroContainer.module.css
var HeroContainer_default = {
  heroLayout: "HeroContainer_heroLayout",
  imageSection: "HeroContainer_imageSection",
  heroImage: "HeroContainer_heroImage",
  contentSection: "HeroContainer_contentSection"
};

// src/aipo/GetOffer/components/HeroContainer/HeroContainer.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var HeroContainer = ({ imageSrc, imageAlt, children, imageWidthPx, imageHeightPx }) => {
  const imageStyle = {
    ...imageWidthPx !== void 0 && { width: `${imageWidthPx}px` },
    ...imageHeightPx !== void 0 && { height: `${imageHeightPx}px` }
  };
  return /* @__PURE__ */ jsx5(Container5, { children: /* @__PURE__ */ jsxs4("div", { className: HeroContainer_default.heroLayout, children: [
    /* @__PURE__ */ jsx5("div", { className: HeroContainer_default.imageSection, children: /* @__PURE__ */ jsx5("img", { src: imageSrc, alt: imageAlt, className: HeroContainer_default.heroImage, style: Object.keys(imageStyle).length > 0 ? imageStyle : void 0 }) }),
    /* @__PURE__ */ jsx5("div", { className: HeroContainer_default.contentSection, children })
  ] }) });
};

// src/aipo/GetOffer/components/SuccessPage/SuccessPage.module.css
var SuccessPage_default = {
  largePrice: "SuccessPage_largePrice"
};

// src/aipo/GetOffer/components/SuccessPage/SuccessPage.tsx
import { ManagedTable as ManagedTable3 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var LOADING_FLASHBAR_ID = "epo-successpage-loading-flashbar";
var SuccessPage = ({ writeableArtifact, buyerOptions, flashbarManager, logger, t }) => {
  const { artifact } = writeableArtifact;
  useEffect5(() => {
    logger.updateContext({ SubPageType: "AWSMP-Success" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, []);
  const offer = artifact.offer;
  useEffect5(() => {
    flashbarManager.addItem({
      type: "in-progress",
      header: t("offerBeingGenerated"),
      content: /* @__PURE__ */ jsx6(TextContent3, { children: /* @__PURE__ */ jsx6(
        AppTrans,
        {
          i18nKey: "offerGenerationMessageComplete",
          values: { offerTitle: offer.offerTitle },
          components: {
            strong: /* @__PURE__ */ jsx6("strong", {})
          }
        }
      ) }),
      action: /* @__PURE__ */ jsx6(
        Button3,
        {
          "data-testid": "view-accept-offer-flashbar",
          href: `https://aws.amazon.com/marketplace/procurement/?productId=${artifact.offerRequest.productId}`,
          target: "_blank",
          iconAlign: "right",
          iconName: "external",
          onClick: () => {
            logger.biMetric({
              metricName: "Click",
              value: 1,
              unit: "Count",
              dimensions: {
                ClickFeat: "offer-ready-alert",
                ClickAct: "accept-private-offer"
              }
            });
          },
          children: t("viewAndAcceptPrivateOffer")
        }
      ),
      dismissible: false,
      id: LOADING_FLASHBAR_ID
    });
    return () => {
      flashbarManager.removeItem(LOADING_FLASHBAR_ID);
    };
  }, []);
  if (!offer || offer.eligibility !== "ELIGIBLE") {
    return null;
  }
  const formatStartDate = () => {
    if (artifact.offerRequest.futureStartDate) {
      return `${artifact.offerRequest.futureStartDate}`;
    }
    return t("dayIAcceptPrivateOffer");
  };
  const formatDuration = () => {
    const duration = artifact.offerRequest.duration;
    if (!duration)
      return "";
    const number = duration.slice(1, -1);
    const unit = duration[duration.length - 1];
    const unitName = unit === "D" ? t("daysLowercase") : unit === "M" ? t("monthsLowercase") : t("yearsLowercase");
    return `${number} ${unitName}`;
  };
  const discountPercentage = offer.listPrice && offer.discountedPrice ? Math.round((offer.listPrice - offer.discountedPrice) / offer.listPrice * 100) : 0;
  const showDiscount = discountPercentage > 0;
  const trackOfferDetailsClick = () => {
    logger.biMetric({
      metricName: "Click",
      value: 1,
      unit: "Count",
      dimensions: {
        ClickFeat: "offer-details",
        ClickAct: "accept-private-offer"
      }
    });
  };
  const trackProvideDetailsClick = () => {
    logger.biMetric({
      metricName: "Click",
      value: 1,
      unit: "Count",
      dimensions: {
        ClickFeat: "offer-details",
        ClickObj: "provide-details",
        ClickAct: "request-custom-offer"
      }
    });
  };
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: buyerOptions.currencyCode
    }).format(amount);
  };
  const getCurrencyDisplay = () => {
    const currencyName = new Intl.DisplayNames(["en"], { type: "currency" }).of(buyerOptions.currencyCode) || buyerOptions.currencyCode;
    return `${currencyName} | ${buyerOptions.currencyCode} (${new Intl.NumberFormat("en-US", { style: "currency", currency: buyerOptions.currencyCode }).format(0).replace("0.00", "").trim()})`;
  };
  const dimensionMap = new Map(buyerOptions.configurableUpfrontPricingTerms.rateCards.map((card) => [card.dimensionKey, card]));
  const dimensionTableItems = artifact.offerRequest.configurableUpfrontDimensionSelections?.map((selection) => {
    const rateCard = dimensionMap.get(selection.dimensionKey);
    return {
      dimensionKey: selection.dimensionKey,
      displayName: rateCard?.displayName || selection.dimensionKey,
      description: rateCard?.description || t("noDescriptionProvided"),
      numberOfUnits: selection.quantity
    };
  }) ?? [];
  return /* @__PURE__ */ jsxs5(SpaceBetween5, { size: "l", children: [
    /* @__PURE__ */ jsx6(TextContent3, { children: /* @__PURE__ */ jsx6("h2", { children: t("congratulationsOfferDetails") }) }),
    /* @__PURE__ */ jsx6(HeroContainer, { imageSrc: human_robot_success_default, imageAlt: t("successImageAlt"), imageWidthPx: 278, children: /* @__PURE__ */ jsx6("div", { style: { paddingLeft: "20px", paddingRight: "20px" }, children: /* @__PURE__ */ jsxs5(SpaceBetween5, { size: "m", children: [
      /* @__PURE__ */ jsxs5(TextContent3, { children: [
        /* @__PURE__ */ jsx6("h3", { children: t("nextSteps") }),
        /* @__PURE__ */ jsxs5("ol", { children: [
          /* @__PURE__ */ jsx6("li", { children: /* @__PURE__ */ jsx6(
            AppTrans,
            {
              i18nKey: showDiscount ? "reviewOfferWithDiscount" : "reviewOfferWithoutDiscount",
              components: {
                strong: /* @__PURE__ */ jsx6("strong", {})
              }
            }
          ) }),
          /* @__PURE__ */ jsx6("li", { children: /* @__PURE__ */ jsx6(
            AppTrans,
            {
              i18nKey: "shareContactDetailsComplete",
              components: {
                strong: /* @__PURE__ */ jsx6("strong", {}),
                provideInfoLink: /* @__PURE__ */ jsx6(
                  Link4,
                  {
                    variant: "primary",
                    href: `https://aws.amazon.com/marketplace/customer-connect/private-offer/${buyerOptions.listingId}`,
                    external: true,
                    onFollow: trackProvideDetailsClick,
                    children: t("provideInfoLinkText")
                  }
                )
              }
            }
          ) }),
          /* @__PURE__ */ jsx6("li", { children: /* @__PURE__ */ jsx6(
            AppTrans,
            {
              i18nKey: "acceptYourOfferComplete",
              components: {
                strong: /* @__PURE__ */ jsx6("strong", {}),
                viewAcceptOfferLink: /* @__PURE__ */ jsx6(
                  Link4,
                  {
                    variant: "primary",
                    href: `https://aws.amazon.com/marketplace/procurement/?productId=${artifact.offerRequest.productId}`,
                    external: true,
                    onFollow: trackOfferDetailsClick,
                    children: t("viewAcceptOfferLinkText")
                  }
                )
              }
            }
          ) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs5(SpaceBetween5, { direction: "horizontal", size: "s", children: [
        /* @__PURE__ */ jsx6(
          Button3,
          {
            "data-testid": "provide-details-button",
            variant: "normal",
            href: `https://aws.amazon.com/marketplace/customer-connect/private-offer/${buyerOptions.listingId}`,
            target: "_blank",
            iconAlign: "right",
            iconName: "external",
            onClick: trackProvideDetailsClick,
            children: t("provideMyDetails")
          }
        ),
        /* @__PURE__ */ jsx6(
          Button3,
          {
            "data-testid": "view-accept-offer-button",
            variant: "primary",
            href: `https://aws.amazon.com/marketplace/procurement/?productId=${artifact.offerRequest.productId}`,
            target: "_blank",
            iconAlign: "right",
            iconName: "external",
            onClick: trackOfferDetailsClick,
            children: t("viewAndAcceptPrivateOffer")
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ jsx6(Container6, { header: /* @__PURE__ */ jsx6(Header4, { children: t("offerDetails") }), children: /* @__PURE__ */ jsxs5(SpaceBetween5, { size: "m", children: [
      /* @__PURE__ */ jsx6(KeyValuePairs2, { columns: 1, items: [{ label: t("offerName"), value: offer?.offerTitle || t("expressPrivateOffer") }] }),
      /* @__PURE__ */ jsx6(
        ManagedTable3,
        {
          columnDefinitions: [
            { id: "dimension", header: t("dimension"), cell: (item) => item.displayName },
            { id: "description", header: t("description"), cell: (item) => item.description },
            { id: "units", header: t("numberOfUnits"), cell: (item) => item.numberOfUnits }
          ],
          items: dimensionTableItems,
          variant: "borderless",
          header: /* @__PURE__ */ jsx6(Header4, { children: t("specifiedDimensions") }),
          hidePreferences: true,
          preferenceKey: "review-dimensions-table",
          defaultPreferences: {
            contentDensity: "compact",
            pageSize: 10
          },
          pagination: {},
          trackBy: "dimensionKey"
        }
      ),
      /* @__PURE__ */ jsx6(
        KeyValuePairs2,
        {
          columns: 3,
          items: [
            {
              label: t("totalContractPrice"),
              value: /* @__PURE__ */ jsx6("div", { className: SuccessPage_default.largePrice, children: formatCurrency(offer.discountedPrice || 0) })
            },
            { label: t("offerCurrency"), value: getCurrencyDisplay() },
            ...showDiscount ? [{ label: t("discount"), value: `${discountPercentage}%` }] : []
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx6(Container6, { header: /* @__PURE__ */ jsx6(Header4, { children: t("contractNeeds") }), children: /* @__PURE__ */ jsx6(
      KeyValuePairs2,
      {
        columns: 3,
        items: [
          { label: t("startDate"), value: formatStartDate() },
          { label: t("duration"), value: formatDuration() },
          {
            label: t("eulaHeader"),
            value: /* @__PURE__ */ jsx6(Link4, { variant: "secondary", href: buyerOptions.eulaUrl, external: true, children: t("endUserLicenseAgreement") })
          }
        ]
      }
    ) })
  ] });
};

// src/aipo/GetOffer/components/IneligiblePage/IneligiblePage.tsx
import { useEffect as useEffect6 } from "react";
import SpaceBetween6 from "@amzn/awsui-components-react/polaris/space-between";
import Button4 from "@amzn/awsui-components-react/polaris/button";
import TextContent4 from "@amzn/awsui-components-react/polaris/text-content";

// src/aipo/GetOffer/assets/human-human-success.svg
var human_human_success_default = 'data:image/svg+xml,<svg width="284" height="212" viewBox="0 0 284 212" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g clip-path="url(%23clip0_3291_629435)">%0A<path d="M165.005 142.178L166.31 146.086L143.481 153.022L142.611 150.85C143.487 147.768 146.245 144.884 152.913 142.659C159.58 140.433 163.888 141.388 165.005 142.178Z" fill="%230F141A" stroke="%230F141A" stroke-width="2" stroke-linejoin="round"/>%0A<path d="M159.759 142.246L161.253 144.079C162.747 145.911 163.183 148.427 162.273 150.611C161.186 153.227 159.493 155.343 156.042 155.861C151.018 156.611 147.745 154.559 146.134 149.21C145.582 147.373 145.365 145.462 145.371 143.547L145.387 139.036C145.617 136.26 146.937 133.263 147.625 131.633L148.293 125.449L148.905 117.571C149.105 116.485 149.527 115.155 150.831 115.214C152.096 115.364 151.872 115.507 151.86 116.454L152.033 114.465C152.284 113.294 152.602 112.032 154.098 111.961C155.47 112.171 154.842 113.573 154.786 114.836L155.104 112.715C155.398 111.369 156.108 110.532 157.448 110.709C158.532 110.994 158.651 111.871 158.651 111.871C158.651 111.871 158.497 112.575 158.693 112.526C159.712 112.287 160.786 112.809 161.178 113.785C161.508 114.626 161.617 115.619 161.631 116.275L162.657 128.877C162.622 130.029 162.439 130.492 162.177 131.611C161.464 134.725 159.985 141.179 159.754 142.258L159.759 142.246Z" fill="%23D6AA8A" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M153.402 127.893L154.77 115.056" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M151.826 116.533L150.913 129.173" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M156.866 129.861L157.363 114.566C157.363 114.566 157.29 112.925 158.394 112.596" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M145.39 139.399L145.681 137.401C145.964 135.453 146.92 133.578 148.217 131.999C149.096 130.928 150.206 130.065 151.441 129.424L152.561 128.847L155.096 124.135C155.964 122.63 157.546 121.994 159.446 122.595C160.129 122.813 160.652 123.43 160.672 124.149C160.677 124.399 160.633 124.668 160.479 124.896L157.07 131.171C156.312 132.456 155.603 135.391 155.644 135.375" fill="%23D6AA8A"/>%0A<path d="M145.39 139.399L145.681 137.401C145.964 135.453 146.92 133.578 148.217 131.999C149.096 130.928 150.206 130.065 151.441 129.424L152.561 128.847L155.096 124.135C155.964 122.63 157.546 121.994 159.446 122.595C160.129 122.813 160.652 123.43 160.672 124.149C160.677 124.399 160.633 124.668 160.479 124.896L157.07 131.171C156.312 132.456 155.603 135.391 155.644 135.375" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M196.335 150.429L187.739 173.059C181.678 189.013 159.29 189.508 152.531 173.837L142.809 151.297L165.002 142.612L170.224 155.206L176.005 140.989C179.96 131.264 188.859 124.41 199.292 123.242C206.205 122.469 213.133 121.766 215.482 121.766" fill="%23006CE0"/>%0A<path d="M196.335 150.429L187.739 173.059C181.678 189.013 159.29 189.508 152.531 173.837L142.809 151.297L165.002 142.612L170.224 155.206L176.005 140.989C179.96 131.264 188.859 124.41 199.292 123.242C206.205 122.469 213.133 121.766 215.482 121.766" stroke="%230F141A" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M168.861 154.709C168.656 154.197 168.905 153.615 169.418 153.409C169.93 153.204 170.512 153.453 170.718 153.965L169.79 154.337L168.861 154.709ZM169.79 154.337L170.718 153.965L175.94 166.994L175.012 167.366L174.084 167.738L168.861 154.709L169.79 154.337Z" fill="%230F141A"/>%0A<path d="M257.884 212.676C259.167 212.676 258.619 210.834 258.375 209.611C253.712 181.504 252.875 161.329 250.957 141.121C249.937 130.387 240.713 123.503 229.634 123.503H207.93C196.86 123.503 189.063 130.437 187.477 141.094C184.141 163.499 184.537 180.554 180.16 210.656C179.888 211.861 179.938 213.069 181.203 213.069L257.884 212.676Z" fill="%23006CE0"/>%0A<path d="M187.427 146.346C184.286 168.359 183.471 188.212 179.468 217.762C179.196 218.976 179.944 220.153 181.209 220.153H257.885C259.168 220.153 259.857 218.994 259.617 217.762C254.245 190.06 253.121 160.528 250.959 138.529" fill="%23006CE0"/>%0A<path d="M187.427 146.346C184.286 168.359 183.471 188.212 179.468 217.762C179.196 218.976 179.944 220.153 181.209 220.153H257.885C259.168 220.153 259.857 218.994 259.617 217.762C254.245 190.06 253.121 160.528 250.959 138.529" stroke="%230F141A" stroke-width="2" stroke-linejoin="round"/>%0A<path d="M284.441 252.292C284.387 253.65 283.256 254.709 281.916 254.657C280.94 254.619 280.123 253.996 279.775 253.139C279.756 254.29 279.725 255.41 279.684 256.442C279.631 257.801 278.5 258.86 277.16 258.808C275.819 258.755 274.775 257.611 274.828 256.253L274.834 256.088C274.774 256.959 274.708 257.791 274.635 258.544C274.505 259.899 273.291 260.886 271.975 260.756C270.638 260.626 269.664 259.423 269.794 258.064C270.069 255.211 270.231 247.369 270.35 243.893C270.35 243.893 268.018 252.61 267.389 255.519C267.101 256.85 265.803 257.695 264.494 257.396C263.184 257.106 262.356 255.791 262.644 254.464C263.313 251.409 264.143 248.296 264.816 245.789C265.158 244.516 265.529 243.135 265.775 242.111C265.578 241.443 265.447 240.751 265.403 240.019L265.342 239.043C263.843 241.305 262.652 242.888 262.562 243.002C261.744 244.078 260.316 244.512 259.073 244.175C258.159 243.993 256.982 243.082 256.973 242.354C256.966 241.819 258.361 240.457 258.708 240.001C258.749 239.955 262.305 235.244 264.76 230.486C264.47 228.187 264.195 226.504 263.839 224.836C262.517 218.65 266.993 212.757 273.315 213.004C276.902 213.144 280.025 215.355 280.77 218.866C282.897 228.891 284.667 246.743 284.45 252.283L284.445 252.283L284.441 252.292Z" fill="%23D6AA8A" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M242.579 150.429C242.579 150.429 249.126 169.183 252.588 181.698C257.266 198.603 259.986 225.996 259.986 225.996H285.226C285.226 225.996 283.445 208.624 275.652 178.224C272.497 165.915 268.616 154.817 265.113 145.966C259.77 132.467 247.013 123.735 232.556 122.41C228.448 122.033 224.981 121.766 223.432 121.766" fill="%23006CE0"/>%0A<path d="M242.579 150.429C242.579 150.429 249.126 169.183 252.588 181.698C257.266 198.603 259.986 225.996 259.986 225.996H285.226C285.226 225.996 283.445 208.624 275.652 178.224C272.497 165.915 268.616 154.817 265.113 145.966C259.77 132.467 247.013 123.735 232.556 122.41C228.448 122.033 224.981 121.766 223.432 121.766" stroke="%230F141A" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M207.689 125.193V113.977C207.689 113.977 192.073 117.257 191.882 103.18C191.801 97.1481 192.113 91.6077 194.09 85.156C196.51 77.2515 200.477 71.0524 212.562 71.0524C221.728 71.0885 229.23 78.5824 229.23 87.7096V125.193C229.23 131.112 224.407 135.913 218.459 135.913C212.512 135.913 207.689 131.112 207.689 125.193Z" fill="%23D6AA8A" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M207.689 113.981C207.689 113.981 212.844 113.205 217.445 111.437C217.843 111.283 218.134 111.82 217.789 112.068L207.689 119.341V113.977" fill="%230F141A"/>%0A<path d="M207.689 113.981C207.689 113.981 212.844 113.205 217.445 111.437C217.843 111.283 218.134 111.82 217.789 112.068L207.689 119.341V113.977" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M209.186 93.4752C209.681 93.4752 210.083 92.9823 210.083 92.3743C210.083 91.7663 209.681 91.2734 209.186 91.2734C208.69 91.2734 208.288 91.7663 208.288 92.3743C208.288 92.9823 208.69 93.4752 209.186 93.4752Z" fill="%230F141A"/>%0A<path d="M198.827 91.21C199.323 91.21 199.725 90.7171 199.725 90.1092C199.725 89.5012 199.323 89.0083 198.827 89.0083C198.332 89.0083 197.93 89.5012 197.93 90.1092C197.93 90.7171 198.332 91.21 198.827 91.21Z" fill="%230F141A"/>%0A<path d="M205.264 87.5558C204.108 90.0192 203.265 92.46 199.734 94.8693C198.977 95.3881 199.317 96.6243 200.146 97.0168L201.855 97.8199" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M201.525 102.598C201.525 102.598 206.326 103.256 209.667 99.7012" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M222.703 89.7275L219.656 93.2018C217.869 91.5838 219.007 86.6585 217.462 85.5861C214.976 83.8551 214.672 80.7789 214.985 78.6576C214.985 78.6576 196.341 84.8711 193.056 73.4506C191.91 69.4713 193.46 66.4563 196.265 64.2738C198.832 62.2747 202.084 61.5127 205.349 61.4986C210.645 61.4845 217.847 64.3302 220.49 63.841C222.425 63.4835 223.837 62.7733 224.127 62.6228C225.477 61.9313 230.112 61.588 232.555 66.8561C232.555 66.8561 234.828 72.6698 237.88 73.6764C237.88 73.6764 246.18 74.8664 239.995 87.9097L228.795 108.836L225.749 89.7275H222.703Z" fill="%23232B37" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M223.511 97.3853C227.822 94.4662 228.121 91.9216 227.786 90.4824C227.564 89.5214 226.802 88.7589 225.841 88.5153C224.671 88.222 223.361 88.5288 222.373 89.3319C220.12 91.1592 219.49 93.6632 219.49 93.6632" fill="%23D6AA8A"/>%0A<path d="M223.511 97.3853C227.822 94.4662 228.121 91.9216 227.786 90.4824C227.564 89.5214 226.802 88.7589 225.841 88.5153C224.671 88.222 223.361 88.5288 222.373 89.3319C220.12 91.1592 219.49 93.6632 219.49 93.6632" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M222.686 98.5034C221.399 102.322 217.591 103.624 214.436 103.624" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M212.927 105.524C211.842 105.524 210.962 104.646 210.962 103.563C210.962 102.48 211.842 101.602 212.927 101.602C214.012 101.602 214.892 102.48 214.892 103.563C214.892 104.646 214.012 105.524 212.927 105.524Z" fill="%23FA6F00" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M223.689 98.6202C220.147 98.6202 217.276 95.7544 217.276 92.2193C217.276 88.6842 220.147 85.8185 223.689 85.8185C227.231 85.8185 230.103 88.6842 230.103 92.2193C230.103 95.7544 227.231 98.6202 223.689 98.6202Z" fill="%23FA6F00" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M120.737 120.463L118.57 123.467L137.203 136.098L140.236 132.623C139.802 129.583 136.792 126.979 130.732 123.467C124.672 119.955 121.984 119.913 120.737 120.463Z" fill="%230F141A" stroke="%230F141A" stroke-width="2" stroke-linejoin="round"/>%0A<path d="M123.321 121.894L121.397 123.258C119.473 124.623 118.382 126.931 118.67 129.278C119.012 132.089 120.07 134.581 123.241 136.004C127.86 138.072 131.547 136.972 134.526 132.25C135.547 130.629 136.266 128.846 136.773 127L137.965 122.649C138.489 119.914 138.025 116.674 137.801 114.919L138.816 108.783L140.338 101.03C140.436 99.9303 140.388 98.5353 139.121 98.2436C137.868 98.0493 138.045 98.2476 137.803 99.1628L138.169 97.2002C138.242 96.0051 138.274 94.704 136.859 94.235C135.486 94.0701 135.713 95.5886 135.429 96.8199L135.692 94.6922C135.77 93.3165 135.313 92.3205 133.981 92.1313C132.865 92.1161 132.515 92.9286 132.515 92.9286C132.515 92.9286 132.475 93.6478 132.3 93.5486C131.387 93.0454 130.217 93.2612 129.58 94.096C129.038 94.818 128.668 95.7452 128.478 96.3738L124.12 108.239C123.845 109.357 123.897 109.852 123.848 111C123.699 114.191 123.39 120.804 123.322 121.906L123.321 121.894Z" fill="%23B78159" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M133.261 109.769L135.386 97.0368" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M137.815 99.2475L135.306 111.669" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M129.412 110.737L133.029 95.8698C133.029 95.8698 133.539 94.3087 132.567 93.696" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M137.866 122.999L138.122 120.996C138.372 119.044 137.957 116.981 137.136 115.113C136.579 113.846 135.745 112.717 134.732 111.769L133.813 110.913L132.642 105.695C132.213 104.013 130.865 102.976 128.883 103.047C128.168 103.074 127.502 103.528 127.29 104.216C127.219 104.455 127.189 104.726 127.275 104.987L128.865 111.945C129.248 113.385 129.142 116.402 129.107 116.376" fill="%23B78159"/>%0A<path d="M137.866 122.999L138.122 120.996C138.372 119.044 137.957 116.981 137.136 115.113C136.579 113.846 135.745 112.717 134.732 111.769L133.813 110.913L132.642 105.695C132.213 104.013 130.865 102.976 128.883 103.047C128.168 103.074 127.502 103.528 127.29 104.216C127.219 104.455 127.189 104.726 127.275 104.987L128.865 111.945C129.248 113.385 129.142 116.402 129.107 116.376" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M73.5032 150.429L96.2689 162.777C104.397 167.186 114.518 165.103 120.245 157.844L139.799 133.057L120.3 120.897L105.568 140.875L84.2797 127.233C80.888 125.06 77.0868 123.612 73.1002 123.034C66.9188 122.138 57.7599 120.897 54.4379 120.897" fill="%23DEDEE3"/>%0A<path d="M73.5032 150.429L96.2689 162.777C104.397 167.186 114.518 165.103 120.245 157.844L139.799 133.057L120.3 120.897L105.568 140.875L84.2797 127.233C80.888 125.06 77.0868 123.612 73.1002 123.034C66.9188 122.138 57.7599 120.897 54.4379 120.897" stroke="%230F141A" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M106.521 141.19C106.695 140.666 106.412 140.1 105.888 139.925C105.364 139.751 104.798 140.035 104.623 140.559L105.572 140.874L106.521 141.19ZM105.572 140.874C104.623 140.559 104.623 140.559 104.623 140.559C104.623 140.559 104.623 140.56 104.623 140.56C104.623 140.56 104.623 140.561 104.622 140.561C104.622 140.562 104.622 140.563 104.621 140.564C104.621 140.567 104.62 140.57 104.618 140.574C104.616 140.581 104.613 140.592 104.609 140.604C104.601 140.629 104.59 140.665 104.576 140.71C104.55 140.8 104.513 140.93 104.469 141.098C104.382 141.432 104.268 141.918 104.155 142.542C103.929 143.788 103.706 145.585 103.706 147.823H104.706H105.706C105.706 145.718 105.916 144.041 106.123 142.899C106.226 142.328 106.329 141.891 106.405 141.601C106.442 141.457 106.473 141.349 106.493 141.28C106.504 141.245 106.511 141.22 106.516 141.205C106.519 141.198 106.52 141.193 106.521 141.19C106.521 141.189 106.522 141.188 106.522 141.188C106.522 141.188 106.522 141.188 106.522 141.189C106.521 141.189 106.521 141.189 106.521 141.189C106.521 141.189 106.521 141.189 106.521 141.19C106.521 141.19 106.521 141.19 105.572 140.874Z" fill="%230F141A"/>%0A<path d="M12.2223 212.676C10.9449 212.676 11.4898 210.834 11.7335 209.611C16.3759 181.504 17.2098 161.329 19.119 141.121C20.1346 130.387 29.3197 123.503 40.3509 123.503H61.9619C72.984 123.503 80.7474 130.437 82.3271 141.094C85.6491 163.499 85.2546 180.554 89.6128 210.656C89.8836 211.861 89.8332 213.069 88.5739 213.069L12.2223 212.676Z" fill="%23DEDEE3"/>%0A<path d="M82.3768 146.346C85.5047 168.359 86.316 188.212 90.3015 217.762C90.5723 218.976 89.8276 220.153 88.5683 220.153H12.2212C10.9438 220.153 10.2578 218.994 10.497 217.762C15.8456 190.06 16.9651 160.528 19.1181 138.529" fill="%23DEDEE3"/>%0A<path d="M82.3768 146.346C85.5047 168.359 86.316 188.212 90.3015 217.762C90.5723 218.976 89.8276 220.153 88.5683 220.153H12.2212C10.9438 220.153 10.2578 218.994 10.497 217.762C15.8456 190.06 16.9651 160.528 19.1181 138.529" stroke="%230F141A" stroke-width="2" stroke-linejoin="round"/>%0A<path d="M69.9223 206.887L67.6606 206.652L67.7556 183.435L69.4889 183.435C71.9987 185.418 73.5806 189.089 73.1023 196.088C72.6241 203.088 71.0744 206.157 69.9223 206.887Z" fill="%230F141A" stroke="%230F141A" stroke-width="2" stroke-linejoin="round"/>%0A<path d="M95.7979 202.811C97.1323 202.569 98.0223 201.304 97.7847 199.986C97.6116 199.027 96.883 198.307 95.9884 198.082C97.1226 197.903 98.2248 197.716 99.2394 197.532C100.574 197.29 101.464 196.025 101.226 194.708C100.989 193.39 99.7129 192.517 98.3785 192.759L98.2165 192.789C99.0688 192.608 99.8813 192.426 100.615 192.25C101.936 191.932 102.743 190.595 102.432 189.313C102.118 188.009 100.795 187.214 99.4697 187.533C96.6891 188.202 88.964 189.454 85.5462 190.056C85.5462 190.056 93.8354 186.537 96.6219 185.51C97.8974 185.04 98.5517 183.639 98.0748 182.387C97.6065 181.133 96.1933 180.498 94.922 180.968C91.9966 182.054 89.0353 183.308 86.6516 184.322C85.4414 184.837 84.1291 185.397 83.1509 185.783C82.4634 185.681 81.7618 185.647 81.0326 185.706L80.0602 185.782C82.087 183.985 83.486 182.588 83.5859 182.483C84.5356 181.524 84.7658 180.053 84.2609 178.871C83.954 177.993 82.8915 176.958 82.1709 177.049C81.6411 177.117 80.4887 178.686 80.0863 179.092C80.0462 179.139 75.8853 183.309 71.5249 186.398C69.215 186.431 67.5156 186.395 65.819 186.275C59.522 185.83 54.3183 191.075 55.4391 197.289C56.0749 200.813 58.6924 203.591 62.2646 203.838C72.4648 204.544 90.3479 203.807 95.7909 202.821L95.7902 202.817L95.7979 202.811Z" fill="%23B78159" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M98.3377 192.765L86.6627 194.499L98.3377 192.765Z" fill="%23B78159"/>%0A<path d="M98.3377 192.765L86.6627 194.499" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M95.919 198.091L85.4729 198.883L95.919 198.091Z" fill="%23B78159"/>%0A<path d="M95.919 198.091L85.4729 198.883" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M32.6568 150.429L28.7569 181.698L69.4874 183.435V206.887L18.6185 204.67C8.52538 204.23 1.04077 195.137 2.54925 185.148L8.3492 146.739C10.3948 133.193 21.6443 122.896 35.3271 122.211C40.4189 121.956 44.8009 121.766 46.5225 121.766" fill="%23DEDEE3"/>%0A<path d="M32.6568 150.429L28.7569 181.698L69.4874 183.435V206.887L18.6185 204.67C8.52538 204.23 1.04077 195.137 2.54925 185.148L8.3492 146.739C10.3948 133.193 21.6443 122.896 35.3271 122.211C40.4189 121.956 44.8009 121.766 46.5225 121.766" stroke="%230F141A" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>%0A<g clip-path="url(%23clip1_3291_629435)">%0A<path d="M63.3677 122.644L61.8419 111.533C61.8419 111.533 77.6922 112.657 75.9651 98.6863C75.225 92.6994 74.1628 87.2533 71.3356 81.1308C67.8725 73.6295 63.1168 68.028 51.1959 69.6724C42.1596 70.9553 35.7789 79.4001 37.0205 88.442L42.1195 125.575C42.9247 131.439 48.3354 135.539 54.2019 134.729C60.0684 133.92 64.1729 128.508 63.3677 122.644Z" fill="%23B78159" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M61.842 111.537C61.842 111.537 56.6525 111.47 51.8734 110.344C51.459 110.246 51.2459 110.818 51.6195 111.016L62.5712 116.847L61.8414 111.533" fill="%230F141A"/>%0A<path d="M61.842 111.537C61.842 111.537 56.6525 111.47 51.8734 110.344C51.459 110.246 51.2459 110.818 51.6195 111.016L62.5712 116.847L61.8414 111.533" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M57.5817 91.4579C57.0927 91.5254 56.6293 91.0918 56.5466 90.4895C56.4638 89.8872 56.7932 89.3442 57.2821 89.2768C57.7711 89.2093 58.2345 89.6429 58.3172 90.2452C58.3999 90.8475 58.0706 91.3905 57.5817 91.4579Z" fill="%230F141A"/>%0A<path d="M67.4913 87.8045C67.0024 87.8719 66.5389 87.4384 66.4562 86.8361C66.3735 86.2337 66.7029 85.6908 67.1918 85.6233C67.6808 85.5559 68.1442 85.9895 68.2269 86.5918C68.3096 87.1941 67.9803 87.7371 67.4913 87.8045Z" fill="%230F141A"/>%0A<path d="M60.645 85.0603C62.1203 87.3434 63.284 89.6467 67.095 91.553C67.9123 91.964 67.7451 93.2349 66.9803 93.7366L65.4038 94.7648" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M65.8308 98.4363C65.8308 98.4363 62.1257 98.5733 58.833 97.5852Z" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M70.7274 77.3699C72.1558 76.1344 72.1462 73.4429 70.479 72.5552C76.8883 68.3974 70.5092 62.6479 65.4823 66.3862C74.6201 57.1615 56.1097 50.9303 54.7232 61.2947C55.5848 51.3283 40.1893 50.1906 42.1566 62.1515C36.4108 52.9823 20.0977 59.8546 30.1654 70.3814C16.4544 65.5494 14.9013 83.4494 27.0224 85.7199C18.19 84.0606 17.2509 90.1365 17.1186 93.2236C16.9108 98.0743 21.6663 101.67 25.6565 101.252C24.0851 108.921 32.5955 110.377 35.3206 104.741C37.6875 109.237 41.7438 106.924 42.9882 103.245C43.7443 99.1953 41.1254 96.0495 41.1254 96.0495C38.7428 94.6246 46.6824 91.9247 47.1836 91.8555C49.5231 89.2624 51.3226 80.6275 50.804 77.1701C51.4339 81.2458 60.4802 81.2651 59.3267 76.3817C59.6175 77.732 60.773 78.8575 62.1174 79.1208C63.8944 79.4653 65.6684 76.0789 65.6684 76.0789C65.6684 76.0789 69.0423 78.7816 70.7153 77.3452L70.7188 77.3711L70.7274 77.3699Z" fill="%23232B37" stroke="%230F141A" stroke-width="1.5" stroke-miterlimit="10" stroke-linejoin="round"/>%0A<path d="M43.978 97.2487C39.3285 94.9435 38.6873 92.4634 38.8224 90.9919C38.9108 90.0097 39.5582 89.1507 40.473 88.7786C41.5868 88.3289 42.9207 88.4546 44.0048 89.1157C46.4756 90.6193 47.4378 93.0142 47.4378 93.0142" fill="%23B78159"/>%0A<path d="M43.978 97.2487C39.3285 94.9435 38.6873 92.4634 38.8224 90.9919C38.9108 90.0097 39.5582 89.1507 40.473 88.7786C41.5868 88.3289 42.9207 88.4546 44.0048 89.1157C46.4756 90.6193 47.4378 93.0142 47.4378 93.0142" stroke="%230F141A" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>%0A</g>%0A<path d="M144.753 71.6574C160.922 71.6574 174.019 58.5451 174.019 42.3891C174.019 26.2332 160.908 13.1208 144.753 13.1208C128.599 13.1208 115.488 26.2332 115.488 42.3891C115.488 58.5451 128.599 71.6574 144.753 71.6574Z" fill="%23006CE0" stroke="%230F141A" stroke-width="1.5" stroke-miterlimit="10"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M161.808 34.2926L141.944 54.5709C141.288 55.2399 140.403 55.6084 139.485 55.5942C138.568 55.58 137.693 55.1843 137.057 54.4953L127.698 44.3562L132.657 39.3976L139.609 46.9296L156.993 29.1829L161.808 34.2926Z" fill="white" stroke="%230F141A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M153.285 80.5094L150.78 90.7061" stroke="%230F141A" stroke-width="1.5"/>%0A<path d="M164.167 86.0964L156.899 93.6744" stroke="%230F141A" stroke-width="1.5"/>%0A<path d="M170.335 96.8625L160.252 99.7912" stroke="%230F141A" stroke-width="1.5"/>%0A<line x1="-8.74228e-08" y1="211" x2="283.512" y2="211" stroke="%230F141A" stroke-width="2"/>%0A</g>%0A<defs>%0A<clipPath id="clip0_3291_629435">%0A<rect width="284" height="212" fill="white"/>%0A</clipPath>%0A<clipPath id="clip1_3291_629435">%0A<rect width="102.26" height="99.8871" fill="white" transform="translate(3.48828 42.3892)"/>%0A</clipPath>%0A</defs>%0A</svg>%0A';

// src/aipo/GetOffer/components/IneligiblePage/IneligiblePage.tsx
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var IneligiblePage = ({ buyerOptions, logger, t }) => {
  useEffect6(() => {
    logger.updateContext({ SubPageType: "AWSMP-Ineligible" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, []);
  return /* @__PURE__ */ jsxs6(SpaceBetween6, { size: "l", children: [
    /* @__PURE__ */ jsx7(TextContent4, { children: /* @__PURE__ */ jsx7("h1", { children: t("didNotQualifyForOffer") }) }),
    /* @__PURE__ */ jsx7(HeroContainer, { imageSrc: human_human_success_default, imageAlt: t("humanToHumanSuccessAlt"), imageWidthPx: 202, imageHeightPx: 133, children: /* @__PURE__ */ jsx7("div", { style: { paddingLeft: "24px", paddingRight: "24px" }, children: /* @__PURE__ */ jsxs6(SpaceBetween6, { size: "m", children: [
      /* @__PURE__ */ jsxs6(TextContent4, { children: [
        /* @__PURE__ */ jsx7("h3", { children: t("startDiscussionWithSales") }),
        /* @__PURE__ */ jsx7("p", { children: t("expressOffersNotAvailableMessage") })
      ] }),
      /* @__PURE__ */ jsx7(
        Button4,
        {
          variant: "primary",
          href: `https://aws.amazon.com/marketplace/customer-connect/private-offer/${buyerOptions.listingId}`,
          target: "_blank",
          iconAlign: "right",
          iconName: "external",
          onClick: () => {
            logger.biMetric({
              metricName: "Click",
              value: 1,
              unit: "Count",
              dimensions: {
                ClickFeat: "ineligible-container",
                ClickAct: "request-custom-offer"
              }
            });
          },
          children: t("connectWithRepresentative")
        }
      )
    ] }) }) })
  ] });
};

// src/aipo/GetOffer/components/UnonboardedPage/UnonboardedPage.tsx
import { useEffect as useEffect7 } from "react";
import SpaceBetween7 from "@amzn/awsui-components-react/polaris/space-between";
import Button5 from "@amzn/awsui-components-react/polaris/button";
import TextContent5 from "@amzn/awsui-components-react/polaris/text-content";

// src/aipo/GetOffer/assets/human-robot-error.svg
var human_robot_error_default = 'data:image/svg+xml,<svg width="186" height="129" viewBox="0 0 186 129" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g clip-path="url(%23clip0_5688_91748)">%0A<path d="M122.816 97.3877L121.362 97.3797L121.362 115.004L122.816 115.012C124.685 113.505 125.651 110.618 125.244 105.363C124.836 100.109 123.686 97.9274 122.816 97.3877Z" fill="%230F141A" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M138.218 107.452C138.631 107.885 140.779 110.237 141.604 111.137C141.804 111.361 141.841 111.687 141.683 111.94C140.452 113.947 138.263 112.809 138.263 112.809C138.263 112.809 139.249 114.004 139.881 114.641C140.514 115.272 143.655 116.053 144.838 116.949C146.021 117.845 145.487 118.905 145.487 118.905C145.295 119.301 144.968 119.586 144.657 119.486C144.267 119.359 143.483 119.033 143.483 119.033C143.483 119.033 144.983 120.167 144.422 121.285C144.012 122.215 143.003 122.39 142.38 122.222C142.27 122.189 141.892 121.468 141.892 121.468C141.892 121.468 142.411 122.412 141.969 123.256C141.679 123.822 141.098 124.072 140.604 124.14C140.155 124.202 139.785 124.056 139.364 123.889L137.095 122.894C137.095 122.894 137.057 122.789 136.605 123.223C135.577 124.213 134.098 122.826 133.535 122.528C130.175 120.617 127.744 117.852 125.609 114.697C125.049 113.949 121.898 111.779 121.898 111.779C118.013 111.43 114.09 112.614 114.137 106.247C114.17 101.843 116.577 98.1743 123.613 99.793L130.1 101.799C134.31 102.287 137.696 106.88 138.199 107.425L138.218 107.439L138.218 107.452Z" fill="%23EAC7AF" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<mask id="path-3-inside-1_5688_91748" fill="white">%0A<path d="M137.048 122.17C137.048 122.17 137.239 121.075 135.473 119.868C135.473 119.868 132.228 118.062 130.82 115.957"/>%0A</mask>%0A<path d="M137.048 122.17C137.048 122.17 137.239 121.075 135.473 119.868C135.473 119.868 132.228 118.062 130.82 115.957" fill="%23EAC7AF"/>%0A<path d="M135.473 119.868L135.826 119.233L135.855 119.249L135.883 119.268L135.473 119.868ZM137.048 122.17C136.332 122.045 136.332 122.046 136.332 122.047C136.332 122.047 136.332 122.047 136.332 122.048C136.332 122.049 136.332 122.049 136.332 122.05C136.331 122.052 136.331 122.053 136.331 122.055C136.33 122.057 136.33 122.06 136.33 122.062C136.329 122.067 136.328 122.071 136.328 122.074C136.327 122.08 136.327 122.082 136.327 122.081C136.328 122.079 136.328 122.065 136.326 122.038C136.322 121.986 136.307 121.885 136.25 121.746C136.139 121.474 135.848 121.005 135.062 120.468L135.473 119.868L135.883 119.268C136.863 119.938 137.36 120.62 137.596 121.197C137.712 121.483 137.76 121.731 137.775 121.922C137.783 122.017 137.782 122.097 137.779 122.16C137.777 122.191 137.775 122.218 137.772 122.241C137.771 122.252 137.769 122.262 137.768 122.271C137.768 122.276 137.767 122.28 137.766 122.284C137.766 122.286 137.766 122.287 137.765 122.289C137.765 122.29 137.765 122.291 137.765 122.292C137.765 122.292 137.765 122.293 137.765 122.293C137.765 122.294 137.765 122.294 137.048 122.17ZM135.473 119.868C135.119 120.503 135.119 120.503 135.119 120.503C135.119 120.503 135.119 120.503 135.119 120.503C135.118 120.503 135.118 120.502 135.118 120.502C135.117 120.502 135.116 120.501 135.115 120.501C135.113 120.5 135.11 120.498 135.107 120.496C135.099 120.492 135.089 120.486 135.076 120.479C135.05 120.464 135.012 120.442 134.964 120.414C134.867 120.357 134.73 120.275 134.561 120.171C134.223 119.962 133.759 119.66 133.248 119.291C132.244 118.564 130.994 117.525 130.216 116.361L130.82 115.957L131.424 115.553C132.054 116.495 133.131 117.411 134.101 118.113C134.577 118.458 135.012 118.74 135.327 118.935C135.484 119.033 135.611 119.108 135.697 119.159C135.741 119.184 135.774 119.203 135.796 119.216C135.807 119.222 135.815 119.226 135.82 119.229C135.822 119.231 135.824 119.232 135.825 119.232C135.826 119.233 135.826 119.233 135.826 119.233C135.826 119.233 135.826 119.233 135.826 119.233C135.826 119.233 135.826 119.233 135.826 119.233C135.826 119.233 135.826 119.233 135.473 119.868Z" fill="%230F141A" mask="url(%23path-3-inside-1_5688_91748)"/>%0A<path d="M137.048 122.17C137.048 122.17 137.239 121.075 135.473 119.868C135.473 119.868 132.228 118.062 130.82 115.957C130.984 114.889 131.126 112.417 130.356 111.106C129.926 110.339 128.684 108.614 127.129 107.819" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<mask id="path-6-inside-2_5688_91748" fill="white">%0A<path d="M141.962 121.594C141.962 121.594 141.68 121.017 140.617 120.54L138.005 119.496C136.877 119.05 135.874 118.351 135.055 117.458L132.649 114.83"/>%0A</mask>%0A<path d="M141.962 121.594C141.962 121.594 141.68 121.017 140.617 120.54L138.005 119.496C136.877 119.05 135.874 118.351 135.055 117.458L132.649 114.83" fill="%23EAC7AF"/>%0A<path d="M140.617 120.54L140.887 119.865L140.901 119.871L140.915 119.877L140.617 120.54ZM138.005 119.496L138.272 118.82L138.274 118.821L138.005 119.496ZM135.055 117.458L134.519 117.949L134.519 117.948L135.055 117.458ZM141.962 121.594C141.309 121.913 141.309 121.913 141.309 121.914C141.309 121.914 141.31 121.914 141.31 121.914C141.31 121.915 141.31 121.915 141.31 121.916C141.311 121.917 141.311 121.918 141.312 121.919C141.313 121.92 141.313 121.922 141.314 121.923C141.316 121.926 141.317 121.928 141.318 121.93C141.32 121.934 141.321 121.936 141.321 121.936C141.32 121.935 141.316 121.927 141.306 121.913C141.286 121.884 141.244 121.83 141.174 121.759C141.034 121.619 140.771 121.406 140.319 121.203L140.617 120.54L140.915 119.877C141.526 120.152 141.936 120.465 142.203 120.733C142.335 120.866 142.431 120.985 142.497 121.08C142.53 121.127 142.555 121.168 142.575 121.201C142.584 121.217 142.593 121.232 142.599 121.244C142.602 121.25 142.605 121.256 142.608 121.261C142.609 121.263 142.611 121.266 142.612 121.268C142.612 121.269 142.613 121.27 142.613 121.271C142.614 121.272 142.614 121.272 142.614 121.273C142.614 121.273 142.614 121.274 142.614 121.274C142.615 121.274 142.615 121.274 141.962 121.594ZM140.617 120.54L140.348 121.215L137.735 120.171L138.005 119.496L138.274 118.821L140.887 119.865L140.617 120.54ZM138.005 119.496L137.738 120.172C136.504 119.684 135.411 118.921 134.519 117.949L135.055 117.458L135.591 116.966C136.338 117.781 137.249 118.416 138.272 118.82L138.005 119.496ZM135.055 117.458L134.519 117.948L132.113 115.32L132.649 114.83L133.185 114.339L135.591 116.967L135.055 117.458Z" fill="%230F141A" mask="url(%23path-6-inside-2_5688_91748)"/>%0A<path d="M141.962 121.594C141.962 121.594 141.68 121.017 140.617 120.54L138.005 119.496C136.877 119.05 135.874 118.351 135.055 117.458L132.901 115.112" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M135.227 113.446L137.744 115.957C138.287 116.477 138.895 116.84 139.569 117.165C140.398 117.576 142.692 118.63 143.372 118.994" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M136.028 111.572C134.812 113.324 133.907 114.394 131.949 115.358" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M138.256 112.811L134.009 108.629C133.346 108.845 131.827 109.016 131.054 107.966" stroke="%230F141A" stroke-width="1.09021" stroke-miterlimit="10"/>%0A<path d="M70.4752 99.6705L83.0856 111.332C85.6376 113.692 88.9856 115.003 92.4616 115.003H122.49V97.3869H95.5074L78.3507 81.5119C73.2466 76.7891 66.7145 73.8804 59.7785 73.3826C56.2664 73.1306 52.8621 72.9199 51.2947 72.9199" fill="%23006CE0"/>%0A<path d="M70.4752 99.6705L83.0856 111.332C85.6376 113.692 88.9856 115.003 92.4616 115.003H122.49V97.3869H95.5074L78.3507 81.5119C73.2466 76.7891 66.7145 73.8804 59.7785 73.3826C56.2664 73.1306 52.8621 72.9199 51.2947 72.9199" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<g clip-path="url(%23clip1_5688_91748)">%0A<path d="M75.715 145.929C76.6838 145.929 77.1974 145.088 77.0024 144.187C74.8763 131.262 70.8191 108.955 70.8191 108.955L73.4589 101.197C74.4276 98.2871 74.3626 95.0575 73.1988 92.2128L70.299 85.0423C68.2379 78.6418 62.9583 73.8984 55.8713 73.8984H39.8377C31.6583 73.8984 25.475 80.1946 24.7013 88.2067C23.2839 103.265 21.8015 123.315 17.6793 144.187C17.4842 145.094 18.0044 145.929 18.9667 145.929H75.702H75.715Z" fill="%23006CE0"/>%0A<path d="M24.7141 84.9707C23.1667 101.321 21.6906 124.092 17.692 144.703C17.4969 145.61 18.0171 146.51 18.9794 146.51H75.7147C76.6835 146.51 77.1971 145.603 77.0021 144.703L70.819 108.616L72.0413 105.451C74.3625 99.5074 73.9724 92.7871 70.949 87.0977" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A</g>%0A<path d="M51.0563 43.2592L49.8063 45.7437L34.9326 37.7309L36.1955 34.5068C38.3708 33.7398 41.1494 34.839 45.59 37.652C50.0306 40.4651 50.9906 42.2385 51.0563 43.2592Z" fill="%230F141A" stroke="%230F141A" stroke-width="1.09021" stroke-linejoin="round"/>%0A<path d="M46.1717 42.05C46.4949 41.5471 48.1575 38.8376 48.7974 37.8C48.9513 37.5434 48.9247 37.2167 48.7208 36.9985C47.1251 35.2653 45.1891 36.7943 45.1891 36.7943C45.1891 36.7943 45.9303 35.4377 46.4304 34.6936C46.9319 33.9559 49.8732 32.5979 50.8657 31.4965C51.8583 30.395 51.1293 29.4583 51.1293 29.4583C50.8648 29.106 50.4883 28.8891 50.2011 29.0461C49.8425 29.2439 49.1331 29.711 49.1331 29.711C49.1331 29.711 50.392 28.3173 49.6257 27.3282C49.044 26.4949 48.0175 26.514 47.4367 26.7961C47.3346 26.8497 47.1004 27.6269 47.1004 27.6269C47.1004 27.6269 47.431 26.6046 46.8342 25.8606C46.4402 25.3616 45.8211 25.2263 45.3213 25.2531C44.8675 25.2774 44.5319 25.4905 44.1492 25.733L42.108 27.137C42.108 27.137 42.0904 27.2467 41.5627 26.9072C40.3611 26.1313 39.1721 27.77 38.6747 28.1683C35.7343 30.6749 33.8724 33.8426 32.3758 37.3358C31.968 38.1743 29.284 40.8953 29.284 40.8953C25.5274 41.9713 21.4403 41.5527 22.7071 47.7809C23.5832 52.0882 26.6546 55.2265 33.268 52.3114L39.2668 49.1206C43.3155 47.8468 45.7672 42.7085 46.1577 42.0793L46.1743 42.0627L46.1717 42.05Z" fill="%23EAC7AF" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M42.1999 27.8546C42.1999 27.8546 42.5968 28.8909 41.0904 30.4071C41.0904 30.4071 38.2442 32.7887 37.2618 35.1166" fill="%23EAC7AF"/>%0A<path d="M42.1999 27.8546C42.1999 27.8546 42.5968 28.8909 41.0904 30.4071C41.0904 30.4071 38.2442 32.7887 37.2618 35.1166C37.628 36.1325 38.2413 38.5267 37.7343 39.9561C37.4581 40.7883 36.5666 42.7129 35.1892 43.785" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M47.1455 27.4922C47.1455 27.4922 46.9786 28.1099 46.0244 28.7787L43.6538 30.2949C42.6292 30.9446 41.7766 31.8188 41.1418 32.8488L39.2782 35.8774" fill="%23EAC7AF"/>%0A<path d="M47.1455 27.4922C47.1455 27.4922 46.9786 28.1099 46.0244 28.7787L43.6537 30.2949C42.6292 30.9446 41.7766 31.8188 41.1418 32.8488L39.4715 35.5532" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M42.081 36.7451L44.0766 33.8097C44.5107 33.1983 45.0398 32.7274 45.6406 32.282C46.3778 31.7229 48.4328 30.2565 49.0322 29.7715" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M43.2271 38.4284C41.6948 36.9415 40.5991 36.0648 38.4879 35.4905" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M45.1826 36.7949L41.8047 41.6933C41.2279 41.6469 39.8578 41.7966 38.9915 42.7666" stroke="%230F141A" stroke-width="1.09021" stroke-miterlimit="10"/>%0A<path d="M26.3924 85.0848L11.2139 76.1114C3.06248 71.2924 2.06922 59.8856 9.26497 53.7302L24.7526 40.4819L33.4744 49.5669L19.6649 61.9227L37.1079 69.8718C40.3731 71.3598 43.2082 73.6515 45.3011 76.5662C48.0036 80.33 51.5944 85.4446 52.6752 87.5187" fill="%23006CE0"/>%0A<path d="M26.3924 85.0848L11.2139 76.1114C3.06248 71.2924 2.06922 59.8856 9.26497 53.7302L24.7526 40.4819L33.4744 49.5669L19.6649 61.9227L37.1079 69.8718C40.3731 71.3598 43.2082 73.6515 45.3011 76.5662C48.0036 80.33 51.5944 85.4446 52.6752 87.5187" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M20.521 60.0538C20.7305 59.8376 21.0756 59.8322 21.2918 60.0417C21.508 60.2512 21.5134 60.5963 21.3039 60.8125L20.9124 60.4332L20.521 60.0538ZM20.9124 60.4332C21.3039 60.8125 21.3038 60.8126 21.3037 60.8127C21.3036 60.8128 21.3035 60.8129 21.3034 60.813C21.3033 60.8131 21.3031 60.8133 21.3029 60.8136C21.3025 60.814 21.3019 60.8145 21.3013 60.8151C21.3001 60.8164 21.2986 60.8179 21.2967 60.8199C21.2929 60.8237 21.2876 60.829 21.281 60.8357C21.2677 60.8489 21.2488 60.8677 21.2242 60.8915C21.1749 60.9391 21.103 61.0071 21.0084 61.0926C20.8191 61.2636 20.5388 61.5047 20.1672 61.7929C19.4239 62.3693 18.3145 63.1348 16.8359 63.9052L16.584 63.4218L16.3321 62.9384C17.7466 62.2013 18.8014 61.4725 19.4991 60.9314C19.8479 60.6609 20.1073 60.4375 20.2775 60.2837C20.3627 60.2068 20.4255 60.1473 20.4661 60.108C20.4863 60.0884 20.5011 60.0738 20.5102 60.0647C20.5148 60.0601 20.518 60.0569 20.5198 60.055C20.5207 60.0541 20.5212 60.0536 20.5214 60.0534C20.5215 60.0533 20.5215 60.0532 20.5215 60.0533C20.5214 60.0534 20.5214 60.0534 20.5213 60.0535C20.5212 60.0535 20.5212 60.0536 20.5211 60.0536C20.5211 60.0537 20.521 60.0538 20.9124 60.4332Z" fill="%230F141A"/>%0A<g clip-path="url(%23clip2_5688_91748)">%0A<path d="M57.3535 76.9455L58.8727 68.6593C58.8727 68.6593 69.902 73.2008 71.9485 62.8273C72.8255 58.382 73.3461 54.2465 72.7679 49.2121C72.06 43.0441 69.9855 37.9264 61.1064 36.2871C54.3672 35.0705 47.8402 39.5892 46.604 46.3321L41.527 74.0236C40.7253 78.3966 43.6187 82.5973 47.9883 83.404C52.3579 84.2107 56.5518 81.3185 57.3535 76.9455Z" fill="%23EAC7AF" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M58.8714 68.6616C58.8714 68.6616 55.1897 67.3892 52.0488 65.4585C51.7765 65.2911 51.4906 65.6484 51.7102 65.8784L58.1454 72.6213L58.872 68.6583" fill="%230F141A"/>%0A<path d="M58.8714 68.6616C58.8714 68.6616 55.1897 67.3892 52.0488 65.4585C51.7765 65.2911 51.4906 65.6484 51.7102 65.8784L58.1454 72.6213L58.872 68.6583" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="round" stroke-linejoin="round"/>%0A<g clip-path="url(%23clip3_5688_91748)">%0A<path d="M60.5502 53.3154C60.186 53.2481 59.9575 52.8295 60.0398 52.3803C60.1222 51.9312 60.4842 51.6216 60.8484 51.6888C61.2126 51.756 61.4411 52.1747 61.3587 52.6238C61.2764 53.073 60.9144 53.3826 60.5502 53.3154Z" fill="%230F141A"/>%0A<path d="M68.4672 53.0478C68.103 52.9805 67.8745 52.5619 67.9568 52.1128C68.0392 51.6636 68.4012 51.354 68.7654 51.4212C69.1296 51.4885 69.358 51.9071 69.2757 52.3562C69.1933 52.8054 68.8314 53.115 68.4672 53.0478Z" fill="%230F141A"/>%0A<path d="M64.2328 49.4759C64.7484 51.4526 65.0373 53.3702 67.3054 55.629C67.7913 56.115 67.3741 56.9822 66.7115 57.1597L65.3471 57.5211" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M60.8462 58.8004C60.8462 58.8004 63.4631 58.9519 64.4479 60.7922" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A</g>%0A<line x1="0.545107" y1="-0.545107" x2="1.87852" y2="-0.545107" transform="matrix(-0.999779 -0.00209776 -0.00208409 1.00021 67.041 52.6406)" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="round"/>%0A<ellipse cx="3.90156" cy="3.91426" rx="3.90156" ry="3.91426" transform="matrix(-0.983381 -0.181552 -0.180334 0.983605 75.2305 48.8457)" stroke="%230F141A" stroke-width="1.09021"/>%0A<ellipse cx="3.90156" cy="3.91426" rx="3.90156" ry="3.91426" transform="matrix(-0.983381 -0.181552 -0.180334 0.983605 65.2471 49.2129)" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M45.4075 54.7259C45.646 55.7362 45.6792 56.8123 45.4689 57.8974C45.1308 59.6456 44.2182 61.134 42.9657 62.2036L42.9268 62.829L42.8142 62.3297C41.1502 63.6772 38.9269 64.3053 36.6607 63.864C32.5828 63.0699 29.923 59.1106 30.7148 55.0251C31.5062 50.933 35.4517 48.2639 39.523 49.0585C39.6284 49.079 39.7328 49.1016 39.8362 49.1263L39.6408 48.2597C38.8275 44.6446 39.5381 38.8971 41.1139 35.5517C45.2483 26.7838 52.481 28.3252 58.5245 29.6132C61.1934 30.182 63.6304 30.7014 65.4662 30.2616C74.1408 28.1809 78.4684 37.1838 74.989 41.5225C70.5386 47.0685 59.6223 40.3638 59.6223 40.3638C59.5441 41.9773 57.759 45.5128 55.6947 46.4381C55.0648 46.7193 54.5969 47.7303 54.1021 48.7994C53.5871 49.9123 53.043 51.0882 52.2566 51.5695L50.8088 48.6486C50.8088 48.6486 49.5314 54.2392 45.4075 54.7259Z" fill="%23855900" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M49.4976 54.256C46.7257 51.5148 46.8506 49.5943 47.292 48.5766C47.5853 47.8967 48.2481 47.4367 48.9872 47.3871C49.8862 47.3291 50.8071 47.7334 51.4244 48.4608C52.8322 50.1163 52.9559 52.0516 52.9559 52.0516" fill="%23EAC7AF"/>%0A<path d="M49.4976 54.256C46.7257 51.5148 46.8506 49.5943 47.292 48.5765C47.5853 47.8967 48.2481 47.4367 48.9872 47.3871C49.8862 47.3291 50.8071 47.7334 51.4244 48.4608C52.8322 50.1163 52.9559 52.0516 52.9559 52.0516" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="square" stroke-linejoin="round"/>%0A<path d="M40.3086 50.0273C40.5107 50.7281 43.0941 52.8635 44.5751 53.8003" stroke="%23F3F3F7" stroke-width="1.45362"/>%0A<path d="M48.8188 58.232C46.9677 57.8903 47.1267 56.5523 47.8982 55.197C48.6445 53.8859 50.5232 54.2327 50.7556 55.7245C50.9959 57.2666 50.6699 58.5738 48.8188 58.232Z" fill="%23FA6F00" stroke="%230F141A" stroke-width="1.09021" stroke-linejoin="round"/>%0A</g>%0A<path d="M160.252 50.5519V37.149L149.473 30.957" stroke="%230F141A" stroke-width="1.09021"/>%0A<circle cx="2.56982" cy="2.56982" r="2.56982" transform="matrix(-1 0 0 1 162.822 34.8105)" fill="%23DEDEE3" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M157.129 49.2152C157.225 48.1975 158.079 47.4199 159.101 47.4199H161.535C162.558 47.4199 163.412 48.1975 163.508 49.2152L163.553 49.687C163.732 51.5931 162.233 53.2406 160.318 53.2406C158.404 53.2406 156.904 51.5931 157.084 49.687L157.129 49.2152Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M117.039 45.8955L107.324 36.5193L120.173 30.4766" stroke="%230F141A" stroke-width="1.09021"/>%0A<ellipse cx="2.56982" cy="2.56982" rx="2.56982" ry="2.56982" transform="matrix(-1 0 0 1 110.536 35.1504)" fill="%23DEDEE3" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M118.045 46.031C119.242 47.2285 119.242 49.1699 118.045 50.3674L115.372 53.04C114.175 54.2375 112.233 54.2375 111.036 53.04C109.838 51.8426 109.838 49.9011 111.036 48.7037L113.708 46.031C114.906 44.8336 116.847 44.8336 118.045 46.031Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="1.09021"/>%0A<rect x="129.238" y="21.4805" width="10.2793" height="8.35192" rx="1.45362" fill="%23DEDEE3" stroke="%230F141A" stroke-width="1.09021" stroke-linejoin="round"/>%0A<path d="M139.311 24.5744L129.843 27.2663C129.378 27.3982 128.917 27.0497 128.917 26.5672V22.5276C128.917 22.1262 129.242 21.8008 129.644 21.8008H139.112C139.513 21.8008 139.839 22.1262 139.839 22.5276V23.8753C139.839 24.2001 139.623 24.4855 139.311 24.5744Z" fill="%230F141A"/>%0A<path d="M145.909 5.21079C144.849 1.88144 141.359 -0.0265024 137.983 0.877861L123.504 4.75759C120.129 5.66195 118.061 9.05927 118.807 12.4729L120.685 21.0647C121.482 24.7108 125.163 26.9522 128.768 25.9862L144.039 21.8944C147.644 20.9284 149.711 17.1467 148.579 13.5906L145.909 5.21079Z" fill="%230F141A"/>%0A<path d="M144.086 5.63893C143.14 2.68486 140.041 0.994165 137.044 1.79704L121.831 5.87336C118.835 6.67623 116.997 9.6899 117.654 12.7215L119.554 21.486C120.257 24.7322 123.533 26.7302 126.741 25.8705L142.791 21.57C145.999 20.7103 147.837 17.3422 146.823 14.1792L144.086 5.63893Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M147.243 15.0274L141.996 17.1663C136.442 19.4343 130.519 21.0545 124.567 21.8366L119.938 22.3438" stroke="%230F141A" stroke-width="1.09021"/>%0A<g clip-path="url(%23clip4_5688_91748)">%0A<path d="M124.718 17.0703C125.746 16.7947 126.356 15.7379 126.081 14.7097C125.805 13.6815 124.748 13.0714 123.72 13.3469C122.692 13.6224 122.082 14.6792 122.357 15.7074C122.633 16.7356 123.69 17.3458 124.718 17.0703Z" fill="%23006CE0" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M136.51 13.912C137.538 13.6365 138.148 12.5797 137.873 11.5515C137.597 10.5233 136.54 9.91316 135.512 10.1887C134.484 10.4642 133.874 11.521 134.149 12.5492C134.425 13.5774 135.482 14.1875 136.51 13.912Z" fill="%23006CE0" stroke="%230F141A" stroke-width="1.09021"/>%0A</g>%0A<path d="M118.274 33.9353C118.416 30.8307 120.974 28.3867 124.082 28.3867H144.671C147.779 28.3867 150.337 30.8307 150.479 33.9353L151.123 48.0046C151.275 51.3167 148.631 54.0849 145.315 54.0849H123.438C120.123 54.0849 117.478 51.3167 117.63 48.0046L118.274 33.9353Z" fill="%23F3F3F7" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M143.619 41.0349C144.916 41.0349 145.967 39.9839 145.967 38.6874C145.967 37.3909 144.916 36.3398 143.619 36.3398C142.322 36.3398 141.271 37.3909 141.271 38.6874C141.271 39.9839 142.322 41.0349 143.619 41.0349Z" fill="%23006CE0" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M135.291 38.3613H123.997" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M138.239 65.0234L137.528 64.8245C134.302 63.9227 130.881 63.9919 127.694 65.0234" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M140.876 60.8047L139.76 60.5968C134.895 59.69 129.897 59.7606 125.059 60.8047" stroke="%230F141A" stroke-width="1.09021"/>%0A<path d="M157.414 54.6718C158.813 52.2491 162.309 52.2491 163.708 54.6718L185.048 91.6327C186.446 94.0554 184.698 97.0838 181.9 97.0838H139.222C136.424 97.0838 134.676 94.0554 136.074 91.6327L157.414 54.6718Z" fill="%23DB0000" stroke="%230F141A" stroke-width="1.09021" stroke-linejoin="round"/>%0A<path d="M157.481 83.248L163.64 83.248L163.64 65.7988L157.481 65.7988L157.481 83.248Z" fill="white" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="round" stroke-linejoin="round"/>%0A<path d="M160.561 86.4742C158.86 86.4742 157.481 87.8529 157.481 89.5535C157.481 91.2542 158.86 92.6328 160.561 92.6328C162.261 92.6328 163.64 91.2542 163.64 89.5535C163.64 87.8529 162.261 86.4742 160.561 86.4742Z" fill="white" stroke="%230F141A" stroke-width="1.09021" stroke-linecap="round" stroke-linejoin="round"/>%0A</g>%0A<defs>%0A<clipPath id="clip0_5688_91748">%0A<rect width="186" height="129" fill="white"/>%0A</clipPath>%0A<clipPath id="clip1_5688_91748">%0A<rect width="68.0322" height="56.524" fill="white" transform="translate(13.293 71.4668)"/>%0A</clipPath>%0A<clipPath id="clip2_5688_91748">%0A<rect width="76.7222" height="75.0321" fill="white" transform="translate(12.416 12.9688)"/>%0A</clipPath>%0A<clipPath id="clip3_5688_91748">%0A<rect width="23.4094" height="16.3095" fill="white" transform="matrix(0.983381 0.181552 -0.180334 0.983605 54.0117 45.5977)"/>%0A</clipPath>%0A<clipPath id="clip4_5688_91748">%0A<rect width="26.3407" height="8.99438" fill="white" transform="translate(118.712 12.0293) rotate(-15)"/>%0A</clipPath>%0A</defs>%0A</svg>%0A';

// ../../tool-configs/awsmp-max-monitoring-frontend/lib/metrics-constants.js
var CustomOpsMetricName;
(function(CustomOpsMetricName2) {
  CustomOpsMetricName2["ClientSide404"] = "ClientSide404";
  CustomOpsMetricName2["ClientSide500"] = "ClientSide500";
  CustomOpsMetricName2["ClientSideNonFatalToolCallError"] = "ClientSideNonFatalToolCallError";
  CustomOpsMetricName2["EPOBuyerUnonboardedPageRender"] = "EPOBuyerUnonboardedPageRender";
})(CustomOpsMetricName || (CustomOpsMetricName = {}));
var CustomOpsSdkServiceName;
(function(CustomOpsSdkServiceName2) {
  CustomOpsSdkServiceName2["MARKETPLACE_DISCOVERY"] = "MarketplaceDiscovery";
  CustomOpsSdkServiceName2["MARKETPLACE_AGREEMENT"] = "MarketplaceAgreement";
  CustomOpsSdkServiceName2["MARKETPLACE_CATALOG"] = "MarketplaceCatalog";
})(CustomOpsSdkServiceName || (CustomOpsSdkServiceName = {}));

// ../../node_modules/@smithy/middleware-stack/dist-es/MiddlewareStack.js
var getAllAliases = (name, aliases) => {
  const _aliases = [];
  if (name) {
    _aliases.push(name);
  }
  if (aliases) {
    for (const alias of aliases) {
      _aliases.push(alias);
    }
  }
  return _aliases;
};
var getMiddlewareNameWithAliases = (name, aliases) => {
  return `${name || "anonymous"}${aliases && aliases.length > 0 ? ` (a.k.a. ${aliases.join(",")})` : ""}`;
};
var constructStack = () => {
  let absoluteEntries = [];
  let relativeEntries = [];
  let identifyOnResolve = false;
  const entriesNameSet = /* @__PURE__ */ new Set();
  const sort = (entries) => entries.sort((a, b) => stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"]);
  const removeByName = (toRemove) => {
    let isRemoved = false;
    const filterCb = (entry) => {
      const aliases = getAllAliases(entry.name, entry.aliases);
      if (aliases.includes(toRemove)) {
        isRemoved = true;
        for (const alias of aliases) {
          entriesNameSet.delete(alias);
        }
        return false;
      }
      return true;
    };
    absoluteEntries = absoluteEntries.filter(filterCb);
    relativeEntries = relativeEntries.filter(filterCb);
    return isRemoved;
  };
  const removeByReference = (toRemove) => {
    let isRemoved = false;
    const filterCb = (entry) => {
      if (entry.middleware === toRemove) {
        isRemoved = true;
        for (const alias of getAllAliases(entry.name, entry.aliases)) {
          entriesNameSet.delete(alias);
        }
        return false;
      }
      return true;
    };
    absoluteEntries = absoluteEntries.filter(filterCb);
    relativeEntries = relativeEntries.filter(filterCb);
    return isRemoved;
  };
  const cloneTo = (toStack) => {
    absoluteEntries.forEach((entry) => {
      toStack.add(entry.middleware, { ...entry });
    });
    relativeEntries.forEach((entry) => {
      toStack.addRelativeTo(entry.middleware, { ...entry });
    });
    toStack.identifyOnResolve?.(stack.identifyOnResolve());
    return toStack;
  };
  const expandRelativeMiddlewareList = (from) => {
    const expandedMiddlewareList = [];
    from.before.forEach((entry) => {
      if (entry.before.length === 0 && entry.after.length === 0) {
        expandedMiddlewareList.push(entry);
      } else {
        expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
      }
    });
    expandedMiddlewareList.push(from);
    from.after.reverse().forEach((entry) => {
      if (entry.before.length === 0 && entry.after.length === 0) {
        expandedMiddlewareList.push(entry);
      } else {
        expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
      }
    });
    return expandedMiddlewareList;
  };
  const getMiddlewareList = (debug = false) => {
    const normalizedAbsoluteEntries = [];
    const normalizedRelativeEntries = [];
    const normalizedEntriesNameMap = {};
    absoluteEntries.forEach((entry) => {
      const normalizedEntry = {
        ...entry,
        before: [],
        after: []
      };
      for (const alias of getAllAliases(normalizedEntry.name, normalizedEntry.aliases)) {
        normalizedEntriesNameMap[alias] = normalizedEntry;
      }
      normalizedAbsoluteEntries.push(normalizedEntry);
    });
    relativeEntries.forEach((entry) => {
      const normalizedEntry = {
        ...entry,
        before: [],
        after: []
      };
      for (const alias of getAllAliases(normalizedEntry.name, normalizedEntry.aliases)) {
        normalizedEntriesNameMap[alias] = normalizedEntry;
      }
      normalizedRelativeEntries.push(normalizedEntry);
    });
    normalizedRelativeEntries.forEach((entry) => {
      if (entry.toMiddleware) {
        const toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
        if (toMiddleware === void 0) {
          if (debug) {
            return;
          }
          throw new Error(`${entry.toMiddleware} is not found when adding ${getMiddlewareNameWithAliases(entry.name, entry.aliases)} middleware ${entry.relation} ${entry.toMiddleware}`);
        }
        if (entry.relation === "after") {
          toMiddleware.after.push(entry);
        }
        if (entry.relation === "before") {
          toMiddleware.before.push(entry);
        }
      }
    });
    const mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce((wholeList, expandedMiddlewareList) => {
      wholeList.push(...expandedMiddlewareList);
      return wholeList;
    }, []);
    return mainChain;
  };
  const stack = {
    add: (middleware, options = {}) => {
      const { name, override, aliases: _aliases } = options;
      const entry = {
        step: "initialize",
        priority: "normal",
        middleware,
        ...options
      };
      const aliases = getAllAliases(name, _aliases);
      if (aliases.length > 0) {
        if (aliases.some((alias) => entriesNameSet.has(alias))) {
          if (!override)
            throw new Error(`Duplicate middleware name '${getMiddlewareNameWithAliases(name, _aliases)}'`);
          for (const alias of aliases) {
            const toOverrideIndex = absoluteEntries.findIndex((entry2) => entry2.name === alias || entry2.aliases?.some((a) => a === alias));
            if (toOverrideIndex === -1) {
              continue;
            }
            const toOverride = absoluteEntries[toOverrideIndex];
            if (toOverride.step !== entry.step || entry.priority !== toOverride.priority) {
              throw new Error(`"${getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases)}" middleware with ${toOverride.priority} priority in ${toOverride.step} step cannot be overridden by "${getMiddlewareNameWithAliases(name, _aliases)}" middleware with ${entry.priority} priority in ${entry.step} step.`);
            }
            absoluteEntries.splice(toOverrideIndex, 1);
          }
        }
        for (const alias of aliases) {
          entriesNameSet.add(alias);
        }
      }
      absoluteEntries.push(entry);
    },
    addRelativeTo: (middleware, options) => {
      const { name, override, aliases: _aliases } = options;
      const entry = {
        middleware,
        ...options
      };
      const aliases = getAllAliases(name, _aliases);
      if (aliases.length > 0) {
        if (aliases.some((alias) => entriesNameSet.has(alias))) {
          if (!override)
            throw new Error(`Duplicate middleware name '${getMiddlewareNameWithAliases(name, _aliases)}'`);
          for (const alias of aliases) {
            const toOverrideIndex = relativeEntries.findIndex((entry2) => entry2.name === alias || entry2.aliases?.some((a) => a === alias));
            if (toOverrideIndex === -1) {
              continue;
            }
            const toOverride = relativeEntries[toOverrideIndex];
            if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) {
              throw new Error(`"${getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases)}" middleware ${toOverride.relation} "${toOverride.toMiddleware}" middleware cannot be overridden by "${getMiddlewareNameWithAliases(name, _aliases)}" middleware ${entry.relation} "${entry.toMiddleware}" middleware.`);
            }
            relativeEntries.splice(toOverrideIndex, 1);
          }
        }
        for (const alias of aliases) {
          entriesNameSet.add(alias);
        }
      }
      relativeEntries.push(entry);
    },
    clone: () => cloneTo(constructStack()),
    use: (plugin) => {
      plugin.applyToStack(stack);
    },
    remove: (toRemove) => {
      if (typeof toRemove === "string")
        return removeByName(toRemove);
      else
        return removeByReference(toRemove);
    },
    removeByTag: (toRemove) => {
      let isRemoved = false;
      const filterCb = (entry) => {
        const { tags, name, aliases: _aliases } = entry;
        if (tags && tags.includes(toRemove)) {
          const aliases = getAllAliases(name, _aliases);
          for (const alias of aliases) {
            entriesNameSet.delete(alias);
          }
          isRemoved = true;
          return false;
        }
        return true;
      };
      absoluteEntries = absoluteEntries.filter(filterCb);
      relativeEntries = relativeEntries.filter(filterCb);
      return isRemoved;
    },
    concat: (from) => {
      const cloned = cloneTo(constructStack());
      cloned.use(from);
      cloned.identifyOnResolve(identifyOnResolve || cloned.identifyOnResolve() || (from.identifyOnResolve?.() ?? false));
      return cloned;
    },
    applyToStack: cloneTo,
    identify: () => {
      return getMiddlewareList(true).map((mw) => {
        const step = mw.step ?? mw.relation + " " + mw.toMiddleware;
        return getMiddlewareNameWithAliases(mw.name, mw.aliases) + " - " + step;
      });
    },
    identifyOnResolve(toggle) {
      if (typeof toggle === "boolean")
        identifyOnResolve = toggle;
      return identifyOnResolve;
    },
    resolve: (handler, context) => {
      for (const middleware of getMiddlewareList().map((entry) => entry.middleware).reverse()) {
        handler = middleware(handler, context);
      }
      if (identifyOnResolve) {
        console.log(stack.identify());
      }
      return handler;
    }
  };
  return stack;
};
var stepWeights = {
  initialize: 5,
  serialize: 4,
  build: 3,
  finalizeRequest: 2,
  deserialize: 1
};
var priorityWeights = {
  high: 3,
  normal: 2,
  low: 1
};

// ../../node_modules/@smithy/types/dist-es/middleware.js
var SMITHY_CONTEXT_KEY = "__smithy_context";

// ../../node_modules/@smithy/core/dist-es/submodules/schema/deref.js
var deref = (schemaRef) => {
  if (typeof schemaRef === "function") {
    return schemaRef();
  }
  return schemaRef;
};

// ../../node_modules/@smithy/util-middleware/dist-es/getSmithyContext.js
var getSmithyContext = (context) => context[SMITHY_CONTEXT_KEY] || (context[SMITHY_CONTEXT_KEY] = {});

// ../../node_modules/@smithy/core/dist-es/submodules/schema/schemas/translateTraits.js
function translateTraits(indicator) {
  if (typeof indicator === "object") {
    return indicator;
  }
  indicator = indicator | 0;
  const traits = {};
  let i = 0;
  for (const trait of [
    "httpLabel",
    "idempotent",
    "idempotencyToken",
    "sensitive",
    "httpPayload",
    "httpResponseCode",
    "httpQueryParams"
  ]) {
    if ((indicator >> i++ & 1) === 1) {
      traits[trait] = 1;
    }
  }
  return traits;
}

// ../../node_modules/@smithy/core/dist-es/submodules/schema/schemas/NormalizedSchema.js
var NormalizedSchema = class _NormalizedSchema {
  ref;
  memberName;
  static symbol = Symbol.for("@smithy/nor");
  symbol = _NormalizedSchema.symbol;
  name;
  schema;
  _isMemberSchema;
  traits;
  memberTraits;
  normalizedTraits;
  constructor(ref, memberName) {
    this.ref = ref;
    this.memberName = memberName;
    const traitStack = [];
    let _ref = ref;
    let schema = ref;
    this._isMemberSchema = false;
    while (isMemberSchema(_ref)) {
      traitStack.push(_ref[1]);
      _ref = _ref[0];
      schema = deref(_ref);
      this._isMemberSchema = true;
    }
    if (traitStack.length > 0) {
      this.memberTraits = {};
      for (let i = traitStack.length - 1; i >= 0; --i) {
        const traitSet = traitStack[i];
        Object.assign(this.memberTraits, translateTraits(traitSet));
      }
    } else {
      this.memberTraits = 0;
    }
    if (schema instanceof _NormalizedSchema) {
      const computedMemberTraits = this.memberTraits;
      Object.assign(this, schema);
      this.memberTraits = Object.assign({}, computedMemberTraits, schema.getMemberTraits(), this.getMemberTraits());
      this.normalizedTraits = void 0;
      this.memberName = memberName ?? schema.memberName;
      return;
    }
    this.schema = deref(schema);
    if (isStaticSchema(this.schema)) {
      this.name = `${this.schema[1]}#${this.schema[2]}`;
      this.traits = this.schema[3];
    } else {
      this.name = this.memberName ?? String(schema);
      this.traits = 0;
    }
    if (this._isMemberSchema && !memberName) {
      throw new Error(`@smithy/core/schema - NormalizedSchema member init ${this.getName(true)} missing member name.`);
    }
  }
  static [Symbol.hasInstance](lhs) {
    const isPrototype = this.prototype.isPrototypeOf(lhs);
    if (!isPrototype && typeof lhs === "object" && lhs !== null) {
      const ns = lhs;
      return ns.symbol === this.symbol;
    }
    return isPrototype;
  }
  static of(ref) {
    const sc = deref(ref);
    if (sc instanceof _NormalizedSchema) {
      return sc;
    }
    if (isMemberSchema(sc)) {
      const [ns, traits] = sc;
      if (ns instanceof _NormalizedSchema) {
        Object.assign(ns.getMergedTraits(), translateTraits(traits));
        return ns;
      }
      throw new Error(`@smithy/core/schema - may not init unwrapped member schema=${JSON.stringify(ref, null, 2)}.`);
    }
    return new _NormalizedSchema(sc);
  }
  getSchema() {
    const sc = this.schema;
    if (sc[0] === 0) {
      return sc[4];
    }
    return sc;
  }
  getName(withNamespace = false) {
    const { name } = this;
    const short = !withNamespace && name && name.includes("#");
    return short ? name.split("#")[1] : name || void 0;
  }
  getMemberName() {
    return this.memberName;
  }
  isMemberSchema() {
    return this._isMemberSchema;
  }
  isListSchema() {
    const sc = this.getSchema();
    return typeof sc === "number" ? sc >= 64 && sc < 128 : sc[0] === 1;
  }
  isMapSchema() {
    const sc = this.getSchema();
    return typeof sc === "number" ? sc >= 128 && sc <= 255 : sc[0] === 2;
  }
  isStructSchema() {
    const sc = this.getSchema();
    return sc[0] === 3 || sc[0] === -3;
  }
  isBlobSchema() {
    const sc = this.getSchema();
    return sc === 21 || sc === 42;
  }
  isTimestampSchema() {
    const sc = this.getSchema();
    return typeof sc === "number" && sc >= 4 && sc <= 7;
  }
  isUnitSchema() {
    return this.getSchema() === "unit";
  }
  isDocumentSchema() {
    return this.getSchema() === 15;
  }
  isStringSchema() {
    return this.getSchema() === 0;
  }
  isBooleanSchema() {
    return this.getSchema() === 2;
  }
  isNumericSchema() {
    return this.getSchema() === 1;
  }
  isBigIntegerSchema() {
    return this.getSchema() === 17;
  }
  isBigDecimalSchema() {
    return this.getSchema() === 19;
  }
  isStreaming() {
    const { streaming } = this.getMergedTraits();
    return !!streaming || this.getSchema() === 42;
  }
  isIdempotencyToken() {
    const match2 = (traits2) => (traits2 & 4) === 4 || !!traits2?.idempotencyToken;
    const { normalizedTraits, traits, memberTraits } = this;
    return match2(normalizedTraits) || match2(traits) || match2(memberTraits);
  }
  getMergedTraits() {
    return this.normalizedTraits ?? (this.normalizedTraits = {
      ...this.getOwnTraits(),
      ...this.getMemberTraits()
    });
  }
  getMemberTraits() {
    return translateTraits(this.memberTraits);
  }
  getOwnTraits() {
    return translateTraits(this.traits);
  }
  getKeySchema() {
    const [isDoc, isMap] = [this.isDocumentSchema(), this.isMapSchema()];
    if (!isDoc && !isMap) {
      throw new Error(`@smithy/core/schema - cannot get key for non-map: ${this.getName(true)}`);
    }
    const schema = this.getSchema();
    const memberSchema = isDoc ? 15 : schema[4] ?? 0;
    return member([memberSchema, 0], "key");
  }
  getValueSchema() {
    const sc = this.getSchema();
    const [isDoc, isMap, isList] = [this.isDocumentSchema(), this.isMapSchema(), this.isListSchema()];
    const memberSchema = typeof sc === "number" ? 63 & sc : sc && typeof sc === "object" && (isMap || isList) ? sc[3 + sc[0]] : isDoc ? 15 : void 0;
    if (memberSchema != null) {
      return member([memberSchema, 0], isMap ? "value" : "member");
    }
    throw new Error(`@smithy/core/schema - ${this.getName(true)} has no value member.`);
  }
  getMemberSchema(memberName) {
    const struct = this.getSchema();
    if (this.isStructSchema() && struct[4].includes(memberName)) {
      const i = struct[4].indexOf(memberName);
      const memberSchema = struct[5][i];
      return member(isMemberSchema(memberSchema) ? memberSchema : [memberSchema, 0], memberName);
    }
    if (this.isDocumentSchema()) {
      return member([15, 0], memberName);
    }
    throw new Error(`@smithy/core/schema - ${this.getName(true)} has no no member=${memberName}.`);
  }
  getMemberSchemas() {
    const buffer = {};
    try {
      for (const [k, v] of this.structIterator()) {
        buffer[k] = v;
      }
    } catch (ignored) {
    }
    return buffer;
  }
  getEventStreamMember() {
    if (this.isStructSchema()) {
      for (const [memberName, memberSchema] of this.structIterator()) {
        if (memberSchema.isStreaming() && memberSchema.isStructSchema()) {
          return memberName;
        }
      }
    }
    return "";
  }
  *structIterator() {
    if (this.isUnitSchema()) {
      return;
    }
    if (!this.isStructSchema()) {
      throw new Error("@smithy/core/schema - cannot iterate non-struct schema.");
    }
    const struct = this.getSchema();
    for (let i = 0; i < struct[4].length; ++i) {
      yield [struct[4][i], member([struct[5][i], 0], struct[4][i])];
    }
  }
};
function member(memberSchema, memberName) {
  if (memberSchema instanceof NormalizedSchema) {
    return Object.assign(memberSchema, {
      memberName,
      _isMemberSchema: true
    });
  }
  const internalCtorAccess = NormalizedSchema;
  return new internalCtorAccess(memberSchema, memberName);
}
var isMemberSchema = (sc) => Array.isArray(sc) && sc.length === 2;
var isStaticSchema = (sc) => Array.isArray(sc) && sc.length >= 5;

// ../../node_modules/@smithy/core/dist-es/submodules/schema/TypeRegistry.js
var TypeRegistry = class _TypeRegistry {
  namespace;
  schemas;
  exceptions;
  static registries = /* @__PURE__ */ new Map();
  constructor(namespace, schemas = /* @__PURE__ */ new Map(), exceptions = /* @__PURE__ */ new Map()) {
    this.namespace = namespace;
    this.schemas = schemas;
    this.exceptions = exceptions;
  }
  static for(namespace) {
    if (!_TypeRegistry.registries.has(namespace)) {
      _TypeRegistry.registries.set(namespace, new _TypeRegistry(namespace));
    }
    return _TypeRegistry.registries.get(namespace);
  }
  register(shapeId, schema) {
    const qualifiedName = this.normalizeShapeId(shapeId);
    const registry = _TypeRegistry.for(qualifiedName.split("#")[0]);
    registry.schemas.set(qualifiedName, schema);
  }
  getSchema(shapeId) {
    const id = this.normalizeShapeId(shapeId);
    if (!this.schemas.has(id)) {
      throw new Error(`@smithy/core/schema - schema not found for ${id}`);
    }
    return this.schemas.get(id);
  }
  registerError(es, ctor) {
    const $error = es;
    const registry = _TypeRegistry.for($error[1]);
    registry.schemas.set($error[1] + "#" + $error[2], $error);
    registry.exceptions.set($error, ctor);
  }
  getErrorCtor(es) {
    const $error = es;
    const registry = _TypeRegistry.for($error[1]);
    return registry.exceptions.get($error);
  }
  getBaseException() {
    for (const exceptionKey of this.exceptions.keys()) {
      if (Array.isArray(exceptionKey)) {
        const [, ns, name] = exceptionKey;
        const id = ns + "#" + name;
        if (id.startsWith("smithy.ts.sdk.synthetic.") && id.endsWith("ServiceException")) {
          return exceptionKey;
        }
      }
    }
    return void 0;
  }
  find(predicate) {
    return [...this.schemas.values()].find(predicate);
  }
  clear() {
    this.schemas.clear();
    this.exceptions.clear();
  }
  normalizeShapeId(shapeId) {
    if (shapeId.includes("#")) {
      return shapeId;
    }
    return this.namespace + "#" + shapeId;
  }
};

// ../../node_modules/@smithy/smithy-client/dist-es/schemaLogFilter.js
var SENSITIVE_STRING = "***SensitiveInformation***";
function schemaLogFilter(schema, data) {
  if (data == null) {
    return data;
  }
  const ns = NormalizedSchema.of(schema);
  if (ns.getMergedTraits().sensitive) {
    return SENSITIVE_STRING;
  }
  if (ns.isListSchema()) {
    const isSensitive = !!ns.getValueSchema().getMergedTraits().sensitive;
    if (isSensitive) {
      return SENSITIVE_STRING;
    }
  } else if (ns.isMapSchema()) {
    const isSensitive = !!ns.getKeySchema().getMergedTraits().sensitive || !!ns.getValueSchema().getMergedTraits().sensitive;
    if (isSensitive) {
      return SENSITIVE_STRING;
    }
  } else if (ns.isStructSchema() && typeof data === "object") {
    const object = data;
    const newObject = {};
    for (const [member2, memberNs] of ns.structIterator()) {
      if (object[member2] != null) {
        newObject[member2] = schemaLogFilter(memberNs, object[member2]);
      }
    }
    return newObject;
  }
  return data;
}

// ../../node_modules/@smithy/smithy-client/dist-es/command.js
var Command = class {
  middlewareStack = constructStack();
  schema;
  static classBuilder() {
    return new ClassBuilder();
  }
  resolveMiddlewareWithContext(clientStack, configuration, options, { middlewareFn, clientName, commandName, inputFilterSensitiveLog, outputFilterSensitiveLog, smithyContext, additionalContext, CommandCtor }) {
    for (const mw of middlewareFn.bind(this)(CommandCtor, clientStack, configuration, options)) {
      this.middlewareStack.use(mw);
    }
    const stack = clientStack.concat(this.middlewareStack);
    const { logger } = configuration;
    const handlerExecutionContext = {
      logger,
      clientName,
      commandName,
      inputFilterSensitiveLog,
      outputFilterSensitiveLog,
      [SMITHY_CONTEXT_KEY]: {
        commandInstance: this,
        ...smithyContext
      },
      ...additionalContext
    };
    const { requestHandler } = configuration;
    return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
  }
};
var ClassBuilder = class {
  _init = () => {
  };
  _ep = {};
  _middlewareFn = () => [];
  _commandName = "";
  _clientName = "";
  _additionalContext = {};
  _smithyContext = {};
  _inputFilterSensitiveLog = void 0;
  _outputFilterSensitiveLog = void 0;
  _serializer = null;
  _deserializer = null;
  _operationSchema;
  init(cb) {
    this._init = cb;
  }
  ep(endpointParameterInstructions) {
    this._ep = endpointParameterInstructions;
    return this;
  }
  m(middlewareSupplier) {
    this._middlewareFn = middlewareSupplier;
    return this;
  }
  s(service, operation, smithyContext = {}) {
    this._smithyContext = {
      service,
      operation,
      ...smithyContext
    };
    return this;
  }
  c(additionalContext = {}) {
    this._additionalContext = additionalContext;
    return this;
  }
  n(clientName, commandName) {
    this._clientName = clientName;
    this._commandName = commandName;
    return this;
  }
  f(inputFilter = (_) => _, outputFilter = (_) => _) {
    this._inputFilterSensitiveLog = inputFilter;
    this._outputFilterSensitiveLog = outputFilter;
    return this;
  }
  ser(serializer) {
    this._serializer = serializer;
    return this;
  }
  de(deserializer) {
    this._deserializer = deserializer;
    return this;
  }
  sc(operation) {
    this._operationSchema = operation;
    this._smithyContext.operationSchema = operation;
    return this;
  }
  build() {
    const closure = this;
    let CommandRef;
    return CommandRef = class extends Command {
      input;
      static getEndpointParameterInstructions() {
        return closure._ep;
      }
      constructor(...[input]) {
        super();
        this.input = input ?? {};
        closure._init(this);
        this.schema = closure._operationSchema;
      }
      resolveMiddleware(stack, configuration, options) {
        const op = closure._operationSchema;
        const input = op?.[4] ?? op?.input;
        const output = op?.[5] ?? op?.output;
        return this.resolveMiddlewareWithContext(stack, configuration, options, {
          CommandCtor: CommandRef,
          middlewareFn: closure._middlewareFn,
          clientName: closure._clientName,
          commandName: closure._commandName,
          inputFilterSensitiveLog: closure._inputFilterSensitiveLog ?? (op ? schemaLogFilter.bind(null, input) : (_) => _),
          outputFilterSensitiveLog: closure._outputFilterSensitiveLog ?? (op ? schemaLogFilter.bind(null, output) : (_) => _),
          smithyContext: closure._smithyContext,
          additionalContext: closure._additionalContext
        });
      }
      serialize = closure._serializer;
      deserialize = closure._deserializer;
    };
  }
};

// ../../node_modules/@smithy/smithy-client/dist-es/exceptions.js
var ServiceException = class _ServiceException extends Error {
  $fault;
  $response;
  $retryable;
  $metadata;
  constructor(options) {
    super(options.message);
    Object.setPrototypeOf(this, Object.getPrototypeOf(this).constructor.prototype);
    this.name = options.name;
    this.$fault = options.$fault;
    this.$metadata = options.$metadata;
  }
  static isInstance(value) {
    if (!value)
      return false;
    const candidate = value;
    return _ServiceException.prototype.isPrototypeOf(candidate) || Boolean(candidate.$fault) && Boolean(candidate.$metadata) && (candidate.$fault === "client" || candidate.$fault === "server");
  }
  static [Symbol.hasInstance](instance) {
    if (!instance)
      return false;
    const candidate = instance;
    if (this === _ServiceException) {
      return _ServiceException.isInstance(instance);
    }
    if (_ServiceException.isInstance(instance)) {
      if (candidate.name && this.name) {
        return this.prototype.isPrototypeOf(instance) || candidate.name === this.name;
      }
      return this.prototype.isPrototypeOf(instance);
    }
    return false;
  }
};

// ../../tool-configs/awsmp-max-monitoring-frontend/lib/sdk-metrics/types.js
var STATUS_CODE_CLASS;
(function(STATUS_CODE_CLASS2) {
  STATUS_CODE_CLASS2["TWO_HUNDRED"] = "200";
  STATUS_CODE_CLASS2["FOUR_HUNDRED"] = "400";
  STATUS_CODE_CLASS2["FIVE_HUNDRED"] = "500";
})(STATUS_CODE_CLASS || (STATUS_CODE_CLASS = {}));

// src/aipo/GetOffer/components/UnonboardedPage/UnonboardedPage.tsx
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var UnonboardedPage = ({ listingId, logger, t }) => {
  useEffect7(() => {
    logger.updateContext({ SubPageType: "AWSMP-Unonboarded" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
    logger.opsMetric({
      metricName: CustomOpsMetricName.EPOBuyerUnonboardedPageRender,
      unit: "Count",
      value: 1
    });
  }, []);
  return /* @__PURE__ */ jsxs7(SpaceBetween7, { size: "l", children: [
    /* @__PURE__ */ jsx8(TextContent5, { children: /* @__PURE__ */ jsx8("h1", { children: t("expressOffersNotAvailableForProduct") }) }),
    /* @__PURE__ */ jsx8(HeroContainer, { imageSrc: human_robot_error_default, imageAlt: t("humanRobotErrorAlt"), imageWidthPx: 186, imageHeightPx: 129, children: /* @__PURE__ */ jsx8("div", { style: { paddingLeft: "24px", paddingRight: "24px" }, children: /* @__PURE__ */ jsxs7(SpaceBetween7, { size: "m", children: [
      /* @__PURE__ */ jsxs7(TextContent5, { children: [
        /* @__PURE__ */ jsx8("h3", { children: t("startDiscussionWithSales") }),
        /* @__PURE__ */ jsx8("p", { children: t("expressOffersNotEnabledMessage") })
      ] }),
      /* @__PURE__ */ jsx8(
        Button5,
        {
          variant: "primary",
          href: `https://aws.amazon.com/marketplace/customer-connect/private-offer/${listingId}`,
          target: "_blank",
          iconAlign: "right",
          iconName: "external",
          onClick: () => {
            logger.biMetric({
              metricName: "Click",
              value: 1,
              unit: "Count",
              dimensions: {
                ClickFeat: "unonboarded-container",
                ClickAct: "request-custom-offer"
              }
            });
          },
          children: t("connectWithRepresentative")
        }
      )
    ] }) }) })
  ] });
};

// src/aipo/GetOffer/GetOffer.tsx
import { LoadingSpinner } from "@amzn/awsmp-max-ux-patterns/LoadingSpinner";

// src/aipo/GetOffer/components/UnitsStep/validation.ts
var validateUnitsStep = (artifact, t) => {
  const errorProps = {};
  let isValid = true;
  const selections = artifact.offerRequest.configurableUpfrontDimensionSelections || [];
  const hasUnits = selections.some((s2) => s2.quantity > 0);
  if (!hasUnits) {
    isValid = false;
    errorProps.unitsTableError = t("validationSelectAtLeastOneUnit");
  }
  const areUnitsOverLimit = selections.some((s2) => s2.quantity > 1e6);
  if (areUnitsOverLimit) {
    isValid = false;
    errorProps.unitsTableError = t("validationUnitsOverLimit");
  }
  const hasFractionalUnits = selections.some((s2) => s2.quantity % 1 !== 0);
  if (hasFractionalUnits) {
    isValid = false;
    errorProps.unitsTableError = t("numberOfUnitsFractionalError");
  }
  return {
    isValid,
    errorProps
  };
};

// src/aipo/GetOffer/components/AssessmentStep/validation.ts
var validateAssessmentStep = (artifact, t) => {
  let isValid = true;
  const errorProps = {};
  const responses = artifact.offerRequest.qualificationResponses || [];
  responses.forEach((response, index) => {
    if (!response.response || response.response.trim() === "") {
      isValid = false;
      errorProps[`${index}`] = t("validationQuestionRequired");
    }
  });
  return {
    isValid,
    errorProps
  };
};

// src/aipo/GetOffer/GetOffer.tsx
import { ScrollToTop } from "@amzn/awsmp-max-ux-patterns/ScrollToTop";
import { isEpoErrorOutput } from "@amzn/awsmp-max-model";
import { MaxTokenData, GrantAction } from "@amzn/awsmp-max-data";

// src/aipo/GetOffer/utils/auth-utils.ts
var USER_INFO_SIGNED_COOKIE_NAME = "aws-userInfo-signed";
var MAX_FRAGMENT_OVERRIDE_QUERY_PARAM = "awsmpMaxFragmentOverride";
function parseCookie(cookieName, cookieString) {
  const cookie = cookieString.match(`${cookieName}=([^;]*)`);
  if (!cookie || !cookie[1]) {
    return void 0;
  }
  return cookie[1];
}
function isAuthenticated() {
  if (window.location.hostname === "localhost") {
    return new URLSearchParams(window.location.search).has("mockauth");
  }
  return !!parseCookie(USER_INFO_SIGNED_COOKIE_NAME, document.cookie);
}
function isAuthenticationError(error) {
  return typeof error === "object" && error !== null && "name" in error && error.name === "AuthenticationError";
}
async function epoBuyerSignIn(props) {
  return clientSideSignIn({
    hashRoute: "epo/offer",
    hashQueryParams: props
  });
}
async function epoSellerSignIn() {
  return clientSideSignIn({
    hashRoute: "epo",
    hashQueryParams: {}
  });
}
async function clientSideSignIn(props) {
  const { hashRoute, hashQueryParams } = props;
  const signInBase = window.location.hostname === "localhost" ? "https://aws.amazon.com/marketplace" : `${window.location.origin}/marketplace`;
  const signInUrl = `${signInBase}/login`;
  if (hashRoute.startsWith("#") || hashRoute.startsWith("/")) {
    throw new Error(`Client-side sign in: HashRoute must not start with # or /. Passed hashRoute was: ${hashRoute}`);
  }
  if (hashRoute.includes("#") || hashRoute.includes("%")) {
    throw new Error(`Client-side sign in: HashRoute cannot include # or % characters. Passed hashRoute was: ${hashRoute}`);
  }
  const searchParams = new URLSearchParams();
  let setQuery = false;
  for (const searchParamKey of Object.keys(hashQueryParams)) {
    searchParams.set(searchParamKey, hashQueryParams[searchParamKey]);
    setQuery = true;
  }
  const hashPath = setQuery ? `${hashRoute}?${searchParams.toString()}` : hashRoute;
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set(MAX_FRAGMENT_OVERRIDE_QUERY_PARAM, encodeURIComponent(hashPath));
  window.history.replaceState({}, "", currentUrl.toString());
  window.location.href = signInUrl;
  await new Promise((resolve) => setTimeout(resolve, 5e3));
}

// src/aipo/GetOffer/utils/wizard-utils.ts
function determineWizardStep(artifact) {
  const { offerRequest } = artifact;
  if (!offerRequest?.configurableUpfrontDimensionSelections || offerRequest.configurableUpfrontDimensionSelections.length === 0) {
    return 0;
  }
  const qualificationResponses = offerRequest?.qualificationResponses || [];
  if (!offerRequest?.duration || qualificationResponses.length === 0) {
    return 1;
  }
  const hasIncompleteResponses = qualificationResponses.some((q) => !q.response || q.response.trim() === "");
  if (hasIncompleteResponses) {
    return 2;
  }
  return 3;
}

// src/aipo/GetOffer/GetOffer.tsx
import Box from "@amzn/awsui-components-react/polaris/box";
import { Fragment as Fragment2, jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var GetOffer = ({
  projectId,
  validateProductId,
  writeableArtifact,
  renderMessages,
  layoutComponents,
  flashbarManager,
  logger,
  queryParamListingId,
  setBreadcrumbs,
  NotFound,
  withAsyncErrors,
  t
}) => {
  const { artifact, isArtifactLocked, setArtifact, callMcpTool, commitArtifactUpdate } = writeableArtifact;
  const [buyerOptions, setBuyerOptions] = useState3(null);
  const [isUnonboarded, setIsUnonboarded] = useState3(false);
  const [isSubmitting, setIsSubmitting] = useState3(false);
  const [isLoadingAssessment, setIsLoadingAssessment] = useState3(false);
  const [activeStepIndex, setActiveStepIndex] = useState3(determineWizardStep(artifact));
  const [stepErrors, setStepErrors] = useState3({});
  const [contractDatePref, setContractDatePref] = useState3(artifact.offerRequest?.futureStartDate ? "custom" : "auto");
  const buyerOptionsMessageSent = useRef(false);
  useEffect8(() => {
    validateProductId();
  }, []);
  useEffect8(() => {
    const unloadEvent = (event) => {
      if (activeStepIndex <= 2) {
        event.preventDefault();
        event.returnValue = "";
        return t("unsavedChangesWarning");
      }
    };
    window.addEventListener("beforeunload", unloadEvent);
    return () => {
      window.removeEventListener("beforeunload", unloadEvent);
    };
  }, [activeStepIndex]);
  useEffect8(() => {
    logger.updateContext({ PageType: "AWSMP-EPO-Request" });
  }, []);
  const userIsAuthenticated = isAuthenticated();
  useEffect8(() => {
    if (buyerOptionsMessageSent.current || isArtifactLocked)
      return;
    const loadBuyerOptions = async () => {
      buyerOptionsMessageSent.current = true;
      try {
        const result = await callMcpTool("getExpressPrivateOfferBuyerOptions", {
          productId: artifact.offerRequest.productId
        });
        setBuyerOptions(result);
        setBreadcrumbs([
          { text: t("awsMarketplace"), href: "https://aws.amazon.com/marketplace", isAbsoluteUrl: true },
          { text: result.productName, href: `https://aws.amazon.com/marketplace/pp/${result.listingId}`, isAbsoluteUrl: true },
          { text: t("getExpressPrivateOffer"), href: "/#/epo/offer" }
        ]);
      } catch (error) {
        if (isEpoErrorOutput(error) && error.statusCode === 404) {
          setIsUnonboarded(true);
        } else {
          throw {
            wrappedError: {
              error,
              isFatal: true
            }
          };
        }
      }
    };
    withAsyncErrors(loadBuyerOptions());
  }, [isArtifactLocked, callMcpTool]);
  const cancelUrl = React4.useMemo(() => {
    if (!buyerOptions) {
      return "https://aws.amazon.com/marketplace";
    }
    return `https://aws.amazon.com/marketplace/pp/${buyerOptions.listingId}`;
  }, [buyerOptions]);
  const offer = artifact.offer;
  const hasTerminalState = offer && (offer.eligibility === "ELIGIBLE" || offer.eligibility === "INELIGIBLE");
  const clearStepErrors = () => {
    setStepErrors({});
  };
  const clearFieldError = (errorKey) => {
    setStepErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[errorKey];
      return newErrors;
    });
  };
  const stepValidations = [
    (artifact2) => validateUnitsStep(artifact2, t),
    (artifact2) => validateContractNeedsStep(artifact2, contractDatePref, buyerOptions, t),
    (artifact2) => validateAssessmentStep(artifact2, t)
  ];
  const validateCurrentStep = () => {
    const validation = stepValidations[activeStepIndex]?.(artifact);
    if (validation && !validation.isValid) {
      setStepErrors(validation.errorProps);
      return false;
    }
    return true;
  };
  const handleSubmit = async () => {
    if (isSubmitting)
      return;
    if (!userIsAuthenticated) {
      await epoBuyerSignIn({
        projectId,
        listingId: buyerOptions.listingId,
        productId: artifact.offerRequest.productId
      });
      return;
    }
    setIsSubmitting(true);
    try {
      const tokens = await MaxTokenData.getInstance(logger).generateTokens([
        { action: GrantAction.RequestExpressPrivateOffer, productId: artifact.offerRequest.productId, requireUsagesRemaining: true }
      ]);
      await writeableArtifact.shareProject(
        projectId,
        tokens[0]
        // targetWebIdentityToken (MAX token)
      );
      const result = await writeableArtifact.callMcpTool("processEpoBuyerRequest", {}, tokens[0]);
      const updatedArtifact = {
        ...artifact,
        offer: result.offer
      };
      setArtifact(updatedArtifact);
      await writeableArtifact.commitArtifactUpdate(updatedArtifact, tokens[0]);
    } catch (error) {
      if (isAuthenticationError(error)) {
        await epoBuyerSignIn({
          projectId,
          listingId: buyerOptions.listingId,
          productId: artifact.offerRequest.productId
        });
        return;
      }
      throw {
        wrappedError: {
          error,
          isFatal: false
        }
      };
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleAssessmentLoading = async () => {
    if (isLoadingAssessment)
      return;
    setIsLoadingAssessment(true);
    try {
      const result = await callMcpTool("getExpressPrivateOfferBuyerQuestions", {
        productId: artifact.offerRequest.productId
      });
      const questions = result.questions;
      const formattedQuestions = questions.map((q) => ({
        question: q.question,
        response: "",
        _exampleResponse: q.exampleResponse || ""
      }));
      setArtifact((prevArtifact) => ({
        ...prevArtifact,
        offerRequest: {
          ...prevArtifact.offerRequest,
          qualificationResponses: formattedQuestions
        }
      }));
      if (questions.length > 0) {
        setActiveStepIndex(2);
      } else {
        setActiveStepIndex(3);
      }
    } catch (error) {
      throw {
        wrappedError: {
          error,
          isFatal: false
        }
      };
    } finally {
      setIsLoadingAssessment(false);
    }
  };
  if (isUnonboarded) {
    if (!queryParamListingId) {
      return /* @__PURE__ */ jsx9(NotFound, {});
    } else {
      return /* @__PURE__ */ jsxs8(Fragment2, { children: [
        /* @__PURE__ */ jsx9(ScrollToTop, { forceScroll: true }),
        /* @__PURE__ */ jsx9(UnonboardedPage, { listingId: queryParamListingId, logger, t })
      ] });
    }
  }
  if (hasTerminalState && buyerOptions) {
    if (offer.eligibility === "ELIGIBLE") {
      return /* @__PURE__ */ jsxs8(Fragment2, { children: [
        /* @__PURE__ */ jsx9(ScrollToTop, { forceScroll: true }),
        /* @__PURE__ */ jsx9(SuccessPage, { writeableArtifact, buyerOptions, flashbarManager, logger, t })
      ] });
    } else {
      return /* @__PURE__ */ jsxs8(Fragment2, { children: [
        /* @__PURE__ */ jsx9(ScrollToTop, { forceScroll: true }),
        /* @__PURE__ */ jsx9(IneligiblePage, { buyerOptions, logger, t })
      ] });
    }
  }
  if (!buyerOptions) {
    return /* @__PURE__ */ jsx9(LoadingSpinner, {});
  }
  return /* @__PURE__ */ jsxs8(SpaceBetween8, { size: "xs", children: [
    /* @__PURE__ */ jsx9(
      Wizard,
      {
        activeStepIndex,
        submitButtonText: isSubmitting ? t("generating") : userIsAuthenticated ? t("generateMyOffer") : t("signInAndGenerateOffer"),
        isLoadingNextStep: isSubmitting || isLoadingAssessment || isArtifactLocked,
        onSubmit: () => withAsyncErrors(handleSubmit()),
        onNavigate: async ({ detail }) => {
          const currentStep = activeStepIndex;
          const nextStep = detail.requestedStepIndex;
          const isValid = validateCurrentStep();
          if (!isValid) {
            return;
          }
          if (detail.requestedStepIndex === 2 && (artifact.offerRequest?.qualificationResponses || []).length === 0 && (detail.reason === "skip" || detail.reason === "step")) {
            return;
          }
          if (detail.requestedStepIndex === 2 && detail.reason === "previous") {
            clearStepErrors();
            setActiveStepIndex(1);
            return;
          }
          if (detail.reason === "next") {
            clearStepErrors();
            if (currentStep === 1 && nextStep === 2 && (artifact.offerRequest?.qualificationResponses || []).length === 0) {
              if (artifact.offerRequest?.qualificationResponses !== void 0) {
                await commitArtifactUpdate();
                setActiveStepIndex(3);
                return;
              }
              withAsyncErrors(handleAssessmentLoading());
              return;
            } else {
              await commitArtifactUpdate();
            }
          } else {
            clearStepErrors();
          }
          setActiveStepIndex(detail.requestedStepIndex);
        },
        steps: [
          {
            title: t("enterUnitsTitle"),
            description: t("enterUnitsDescription"),
            // info: <HelpPanelLink pathslug={HELP_PANEL_PATHSLUG.EPO_ENTER_UNITS} />,
            content: /* @__PURE__ */ jsx9(
              UnitsStep,
              {
                buyerData: buyerOptions,
                errors: stepErrors,
                clearFieldError,
                writeableArtifact,
                isArtifactLocked,
                renderMessages,
                layoutComponents,
                logger,
                t
              }
            )
          },
          {
            title: t("enterContractNeedsTitle"),
            description: t("enterContractNeedsDescription"),
            // info: <HelpPanelLink pathslug={HELP_PANEL_PATHSLUG.EPO_ENTER_CONTRACT_NEEDS} />,
            content: /* @__PURE__ */ jsx9(
              ContractNeedsStep,
              {
                errors: stepErrors,
                clearFieldError,
                contractDatePref,
                setContractDatePref,
                eulaUrl: buyerOptions.eulaUrl,
                listingId: buyerOptions.listingId,
                buyerOptions,
                writeableArtifact,
                isArtifactLocked,
                logger,
                t
              }
            )
          },
          {
            title: t("answerQuestionnaireTitle"),
            description: t("answerQuestionnaireDescription"),
            content: /* @__PURE__ */ jsx9(
              AssessmentStep,
              {
                errors: stepErrors,
                clearFieldError,
                writeableArtifact,
                isArtifactLocked,
                logger,
                t
              }
            )
          },
          {
            title: t("reviewYourOfferTitle"),
            // info: <HelpPanelLink pathslug={HELP_PANEL_PATHSLUG.EPO_REVIEW} />,
            content: /* @__PURE__ */ jsx9(
              ReviewOfferStep,
              {
                onEditStep: setActiveStepIndex,
                writeableArtifact,
                isArtifactLocked,
                logger,
                buyerOptions,
                t
              }
            )
          }
        ],
        onCancel: () => window.location.href = cancelUrl
      }
    ),
    isSubmitting && /* @__PURE__ */ jsx9("div", { style: { display: "flex", flexDirection: "row", justifyContent: "flex-end" }, children: /* @__PURE__ */ jsx9(Box, { variant: "small", color: "text-status-inactive", children: t("offerPreviewLoadingMessage") }) })
  ] });
};

// src/aipo/GetOffer/constants/mockData.ts
var mockQualificationResponses = [
  {
    response: "",
    question: "What is your company size?",
    _exampleResponse: "Ex. 1-50 employees, 51-200 employees, 200+ employees"
  },
  {
    response: "",
    question: "What industry is your company in?",
    _exampleResponse: "Ex. Healthcare, Technology, Finance, Retail, Manufacturing"
  },
  {
    response: "",
    question: "What will you use this product for?",
    _exampleResponse: "Ex. Data analytics, Customer management, Reporting, Compliance"
  }
];

// src/aipo/ListConfig/ListConfig.tsx
import * as React5 from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ManagedTable as ManagedTable4 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";
import Header5 from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween9 from "@amzn/awsui-components-react/polaris/space-between";
import Box2 from "@amzn/awsui-components-react/polaris/box";
import Button6 from "@amzn/awsui-components-react/polaris/button";
import Icon from "@amzn/awsui-components-react/polaris/icon";
import { FatalErrorPage } from "@amzn/awsmp-max-ux-patterns/FatalErrorPage";
import { MaxTokenData as MaxTokenData2, GrantAction as GrantAction2 } from "@amzn/awsmp-max-data";

// ../../node_modules/serialize-error/error-constructors.js
var list = [
  // Native ES errors https://262.ecma-international.org/12.0/#sec-well-known-intrinsic-objects
  EvalError,
  RangeError,
  ReferenceError,
  SyntaxError,
  TypeError,
  URIError,
  // Built-in errors
  globalThis.DOMException,
  // Node-specific errors
  // https://nodejs.org/api/errors.html
  globalThis.AssertionError,
  globalThis.SystemError
].filter(Boolean).map(
  (constructor) => [constructor.name, constructor]
);
var errorConstructors = new Map(list);
var error_constructors_default = errorConstructors;

// ../../node_modules/serialize-error/index.js
var commonProperties = [
  {
    property: "name",
    enumerable: false
  },
  {
    property: "message",
    enumerable: false
  },
  {
    property: "stack",
    enumerable: false
  },
  {
    property: "code",
    enumerable: true
  },
  {
    property: "cause",
    enumerable: false
  }
];
var toJsonWasCalled = /* @__PURE__ */ new WeakSet();
var toJSON = (from) => {
  toJsonWasCalled.add(from);
  const json = from.toJSON();
  toJsonWasCalled.delete(from);
  return json;
};
var getErrorConstructor = (name) => error_constructors_default.get(name) ?? Error;
var destroyCircular = ({
  from,
  seen,
  to,
  forceEnumerable,
  maxDepth,
  depth,
  useToJSON,
  serialize
}) => {
  if (!to) {
    if (Array.isArray(from)) {
      to = [];
    } else if (!serialize && isErrorLike(from)) {
      const Error2 = getErrorConstructor(from.name);
      to = new Error2();
    } else {
      to = {};
    }
  }
  seen.push(from);
  if (depth >= maxDepth) {
    return to;
  }
  if (useToJSON && typeof from.toJSON === "function" && !toJsonWasCalled.has(from)) {
    return toJSON(from);
  }
  const continueDestroyCircular = (value) => destroyCircular({
    from: value,
    seen: [...seen],
    forceEnumerable,
    maxDepth,
    depth,
    useToJSON,
    serialize
  });
  for (const [key, value] of Object.entries(from)) {
    if (value && value instanceof Uint8Array && value.constructor.name === "Buffer") {
      to[key] = "[object Buffer]";
      continue;
    }
    if (value !== null && typeof value === "object" && typeof value.pipe === "function") {
      to[key] = "[object Stream]";
      continue;
    }
    if (typeof value === "function") {
      continue;
    }
    if (!value || typeof value !== "object") {
      try {
        to[key] = value;
      } catch {
      }
      continue;
    }
    if (!seen.includes(from[key])) {
      depth++;
      to[key] = continueDestroyCircular(from[key]);
      continue;
    }
    to[key] = "[Circular]";
  }
  for (const { property, enumerable } of commonProperties) {
    if (typeof from[property] !== "undefined" && from[property] !== null) {
      Object.defineProperty(to, property, {
        value: isErrorLike(from[property]) ? continueDestroyCircular(from[property]) : from[property],
        enumerable: forceEnumerable ? true : enumerable,
        configurable: true,
        writable: true
      });
    }
  }
  return to;
};
function serializeError(value, options = {}) {
  const {
    maxDepth = Number.POSITIVE_INFINITY,
    useToJSON = true
  } = options;
  if (typeof value === "object" && value !== null) {
    return destroyCircular({
      from: value,
      seen: [],
      forceEnumerable: true,
      maxDepth,
      depth: 0,
      useToJSON,
      serialize: true
    });
  }
  if (typeof value === "function") {
    return `[Function: ${value.name || "anonymous"}]`;
  }
  return value;
}
function isErrorLike(value) {
  return Boolean(value) && typeof value === "object" && "name" in value && "message" in value && "stack" in value;
}

// src/aipo/utils/apiErrorUtil.ts
var handleApiError = (error, flashbarManager, t, logger) => {
  if (isAuthenticationError(error)) {
    if (logger) {
      logger.log("Authentication error detected in handleApiError, sign-in flow will be triggered");
    }
    return;
  }
  const statusCode = error?.statusCode || error?.$metadata?.httpStatusCode;
  const is4xxError = statusCode && Math.floor(statusCode / 100) === 4;
  if (logger) {
    if (is4xxError) {
      logger.error(`API 4xx error (${statusCode}):`, void 0, serializeError(error));
    } else {
      logger.error(`API error (${statusCode || "unknown"}):`, void 0, serializeError(error));
    }
  }
  if (flashbarManager) {
    if (is4xxError) {
      const errorMessage = error?.message || (t ? t("validationErrorOccurred") : "Validation error occurred");
      flashbarManager.addItem({
        type: "error",
        content: errorMessage,
        dismissible: true,
        id: `error-4xx-${errorMessage}`
        // Unique ID prevents duplicates
      });
    } else {
      flashbarManager.addItem({
        type: "error",
        header: t ? t("errorSomethingWentWrong") : "Something went wrong",
        content: t ? t("errorInternalError") : "We're experiencing an internal error. Please try again, and if the problem continues, contact support.",
        dismissible: true,
        id: "error-5xx-generic"
        // Same ID prevents duplicate generic errors
      });
    }
  }
};

// ../../node_modules/@smithy/middleware-serde/dist-es/serdePlugin.js
var serializerMiddlewareOption = {
  name: "serializerMiddleware",
  step: "serialize",
  tags: ["SERIALIZER"],
  override: true
};

// ../../node_modules/@smithy/core/dist-es/setFeature.js
function setFeature(context, feature, value) {
  if (!context.__smithy_context) {
    context.__smithy_context = {
      features: {}
    };
  } else if (!context.__smithy_context.features) {
    context.__smithy_context.features = {};
  }
  context.__smithy_context.features[feature] = value;
}

// ../../node_modules/@smithy/querystring-parser/dist-es/index.js
function parseQueryString(querystring) {
  const query = {};
  querystring = querystring.replace(/^\?/, "");
  if (querystring) {
    for (const pair of querystring.split("&")) {
      let [key, value = null] = pair.split("=");
      key = decodeURIComponent(key);
      if (value) {
        value = decodeURIComponent(value);
      }
      if (!(key in query)) {
        query[key] = value;
      } else if (Array.isArray(query[key])) {
        query[key].push(value);
      } else {
        query[key] = [query[key], value];
      }
    }
  }
  return query;
}

// ../../node_modules/@smithy/url-parser/dist-es/index.js
var parseUrl = (url) => {
  if (typeof url === "string") {
    return parseUrl(new URL(url));
  }
  const { hostname, pathname, port, protocol, search } = url;
  let query;
  if (search) {
    query = parseQueryString(search);
  }
  return {
    hostname,
    port: port ? parseInt(port) : void 0,
    protocol,
    path: pathname,
    query
  };
};

// ../../node_modules/@smithy/middleware-endpoint/dist-es/service-customizations/s3.js
var resolveParamsForS3 = async (endpointParams) => {
  const bucket = endpointParams?.Bucket || "";
  if (typeof endpointParams.Bucket === "string") {
    endpointParams.Bucket = bucket.replace(/#/g, encodeURIComponent("#")).replace(/\?/g, encodeURIComponent("?"));
  }
  if (isArnBucketName(bucket)) {
    if (endpointParams.ForcePathStyle === true) {
      throw new Error("Path-style addressing cannot be used with ARN buckets");
    }
  } else if (!isDnsCompatibleBucketName(bucket) || bucket.indexOf(".") !== -1 && !String(endpointParams.Endpoint).startsWith("http:") || bucket.toLowerCase() !== bucket || bucket.length < 3) {
    endpointParams.ForcePathStyle = true;
  }
  if (endpointParams.DisableMultiRegionAccessPoints) {
    endpointParams.disableMultiRegionAccessPoints = true;
    endpointParams.DisableMRAP = true;
  }
  return endpointParams;
};
var DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var DOTS_PATTERN = /\.\./;
var isDnsCompatibleBucketName = (bucketName) => DOMAIN_PATTERN.test(bucketName) && !IP_ADDRESS_PATTERN.test(bucketName) && !DOTS_PATTERN.test(bucketName);
var isArnBucketName = (bucketName) => {
  const [arn, partition, service, , , bucket] = bucketName.split(":");
  const isArn = arn === "arn" && bucketName.split(":").length >= 6;
  const isValidArn = Boolean(isArn && partition && service && bucket);
  if (isArn && !isValidArn) {
    throw new Error(`Invalid ARN: ${bucketName} was an invalid ARN.`);
  }
  return isValidArn;
};

// ../../node_modules/@smithy/middleware-endpoint/dist-es/adaptors/createConfigValueProvider.js
var createConfigValueProvider = (configKey, canonicalEndpointParamKey, config) => {
  const configProvider = async () => {
    const configValue = config[configKey] ?? config[canonicalEndpointParamKey];
    if (typeof configValue === "function") {
      return configValue();
    }
    return configValue;
  };
  if (configKey === "credentialScope" || canonicalEndpointParamKey === "CredentialScope") {
    return async () => {
      const credentials = typeof config.credentials === "function" ? await config.credentials() : config.credentials;
      const configValue = credentials?.credentialScope ?? credentials?.CredentialScope;
      return configValue;
    };
  }
  if (configKey === "accountId" || canonicalEndpointParamKey === "AccountId") {
    return async () => {
      const credentials = typeof config.credentials === "function" ? await config.credentials() : config.credentials;
      const configValue = credentials?.accountId ?? credentials?.AccountId;
      return configValue;
    };
  }
  if (configKey === "endpoint" || canonicalEndpointParamKey === "endpoint") {
    return async () => {
      if (config.isCustomEndpoint === false) {
        return void 0;
      }
      const endpoint = await configProvider();
      if (endpoint && typeof endpoint === "object") {
        if ("url" in endpoint) {
          return endpoint.url.href;
        }
        if ("hostname" in endpoint) {
          const { protocol, hostname, port, path } = endpoint;
          return `${protocol}//${hostname}${port ? ":" + port : ""}${path}`;
        }
      }
      return endpoint;
    };
  }
  return configProvider;
};

// ../../node_modules/@smithy/middleware-endpoint/dist-es/adaptors/getEndpointFromConfig.browser.js
var getEndpointFromConfig = async (serviceId) => void 0;

// ../../node_modules/@smithy/middleware-endpoint/dist-es/adaptors/toEndpointV1.js
var toEndpointV1 = (endpoint) => {
  if (typeof endpoint === "object") {
    if ("url" in endpoint) {
      return parseUrl(endpoint.url);
    }
    return endpoint;
  }
  return parseUrl(endpoint);
};

// ../../node_modules/@smithy/middleware-endpoint/dist-es/adaptors/getEndpointFromInstructions.js
var getEndpointFromInstructions = async (commandInput, instructionsSupplier, clientConfig, context) => {
  if (!clientConfig.isCustomEndpoint) {
    let endpointFromConfig;
    if (clientConfig.serviceConfiguredEndpoint) {
      endpointFromConfig = await clientConfig.serviceConfiguredEndpoint();
    } else {
      endpointFromConfig = await getEndpointFromConfig(clientConfig.serviceId);
    }
    if (endpointFromConfig) {
      clientConfig.endpoint = () => Promise.resolve(toEndpointV1(endpointFromConfig));
      clientConfig.isCustomEndpoint = true;
    }
  }
  const endpointParams = await resolveParams(commandInput, instructionsSupplier, clientConfig);
  if (typeof clientConfig.endpointProvider !== "function") {
    throw new Error("config.endpointProvider is not set.");
  }
  const endpoint = clientConfig.endpointProvider(endpointParams, context);
  return endpoint;
};
var resolveParams = async (commandInput, instructionsSupplier, clientConfig) => {
  const endpointParams = {};
  const instructions = instructionsSupplier?.getEndpointParameterInstructions?.() || {};
  for (const [name, instruction] of Object.entries(instructions)) {
    switch (instruction.type) {
      case "staticContextParams":
        endpointParams[name] = instruction.value;
        break;
      case "contextParams":
        endpointParams[name] = commandInput[instruction.name];
        break;
      case "clientContextParams":
      case "builtInParams":
        endpointParams[name] = await createConfigValueProvider(instruction.name, name, clientConfig)();
        break;
      case "operationContextParams":
        endpointParams[name] = instruction.get(commandInput);
        break;
      default:
        throw new Error("Unrecognized endpoint parameter instruction: " + JSON.stringify(instruction));
    }
  }
  if (Object.keys(instructions).length === 0) {
    Object.assign(endpointParams, clientConfig);
  }
  if (String(clientConfig.serviceId).toLowerCase() === "s3") {
    await resolveParamsForS3(endpointParams);
  }
  return endpointParams;
};

// ../../node_modules/@smithy/middleware-endpoint/dist-es/endpointMiddleware.js
var endpointMiddleware = ({ config, instructions }) => {
  return (next, context) => async (args) => {
    if (config.isCustomEndpoint) {
      setFeature(context, "ENDPOINT_OVERRIDE", "N");
    }
    const endpoint = await getEndpointFromInstructions(args.input, {
      getEndpointParameterInstructions() {
        return instructions;
      }
    }, { ...config }, context);
    context.endpointV2 = endpoint;
    context.authSchemes = endpoint.properties?.authSchemes;
    const authScheme = context.authSchemes?.[0];
    if (authScheme) {
      context["signing_region"] = authScheme.signingRegion;
      context["signing_service"] = authScheme.signingName;
      const smithyContext = getSmithyContext(context);
      const httpAuthOption = smithyContext?.selectedHttpAuthScheme?.httpAuthOption;
      if (httpAuthOption) {
        httpAuthOption.signingProperties = Object.assign(httpAuthOption.signingProperties || {}, {
          signing_region: authScheme.signingRegion,
          signingRegion: authScheme.signingRegion,
          signing_service: authScheme.signingName,
          signingName: authScheme.signingName,
          signingRegionSet: authScheme.signingRegionSet
        }, authScheme.properties);
      }
    }
    return next({
      ...args
    });
  };
};

// ../../node_modules/@smithy/middleware-endpoint/dist-es/getEndpointPlugin.js
var endpointMiddlewareOptions = {
  step: "serialize",
  tags: ["ENDPOINT_PARAMETERS", "ENDPOINT_V2", "ENDPOINT"],
  name: "endpointV2Middleware",
  override: true,
  relation: "before",
  toMiddleware: serializerMiddlewareOption.name
};
var getEndpointPlugin = (config, instructions) => ({
  applyToStack: (clientStack) => {
    clientStack.addRelativeTo(endpointMiddleware({
      config,
      instructions
    }), endpointMiddlewareOptions);
  }
});

// ../../node_modules/@aws-sdk/client-marketplace-catalog/dist-es/endpoint/EndpointParameters.js
var commonParams = {
  UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
  Endpoint: { type: "builtInParams", name: "endpoint" },
  Region: { type: "builtInParams", name: "region" },
  UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" }
};

// ../../node_modules/@aws-sdk/client-marketplace-catalog/dist-es/models/MarketplaceCatalogServiceException.js
var MarketplaceCatalogServiceException = class _MarketplaceCatalogServiceException extends ServiceException {
  constructor(options) {
    super(options);
    Object.setPrototypeOf(this, _MarketplaceCatalogServiceException.prototype);
  }
};

// ../../node_modules/@aws-sdk/client-marketplace-catalog/dist-es/models/models_0.js
var AccessDeniedException = class _AccessDeniedException extends MarketplaceCatalogServiceException {
  name = "AccessDeniedException";
  $fault = "client";
  Message;
  constructor(opts) {
    super({
      name: "AccessDeniedException",
      $fault: "client",
      ...opts
    });
    Object.setPrototypeOf(this, _AccessDeniedException.prototype);
    this.Message = opts.Message;
  }
};
var InternalServiceException = class _InternalServiceException extends MarketplaceCatalogServiceException {
  name = "InternalServiceException";
  $fault = "server";
  Message;
  constructor(opts) {
    super({
      name: "InternalServiceException",
      $fault: "server",
      ...opts
    });
    Object.setPrototypeOf(this, _InternalServiceException.prototype);
    this.Message = opts.Message;
  }
};
var ThrottlingException = class _ThrottlingException extends MarketplaceCatalogServiceException {
  name = "ThrottlingException";
  $fault = "client";
  Message;
  constructor(opts) {
    super({
      name: "ThrottlingException",
      $fault: "client",
      ...opts
    });
    Object.setPrototypeOf(this, _ThrottlingException.prototype);
    this.Message = opts.Message;
  }
};
var ValidationException = class _ValidationException extends MarketplaceCatalogServiceException {
  name = "ValidationException";
  $fault = "client";
  Message;
  constructor(opts) {
    super({
      name: "ValidationException",
      $fault: "client",
      ...opts
    });
    Object.setPrototypeOf(this, _ValidationException.prototype);
    this.Message = opts.Message;
  }
};
var ResourceInUseException = class _ResourceInUseException extends MarketplaceCatalogServiceException {
  name = "ResourceInUseException";
  $fault = "client";
  Message;
  constructor(opts) {
    super({
      name: "ResourceInUseException",
      $fault: "client",
      ...opts
    });
    Object.setPrototypeOf(this, _ResourceInUseException.prototype);
    this.Message = opts.Message;
  }
};
var ResourceNotFoundException = class _ResourceNotFoundException extends MarketplaceCatalogServiceException {
  name = "ResourceNotFoundException";
  $fault = "client";
  Message;
  constructor(opts) {
    super({
      name: "ResourceNotFoundException",
      $fault: "client",
      ...opts
    });
    Object.setPrototypeOf(this, _ResourceNotFoundException.prototype);
    this.Message = opts.Message;
  }
};
var ResourceNotSupportedException = class _ResourceNotSupportedException extends MarketplaceCatalogServiceException {
  name = "ResourceNotSupportedException";
  $fault = "client";
  Message;
  constructor(opts) {
    super({
      name: "ResourceNotSupportedException",
      $fault: "client",
      ...opts
    });
    Object.setPrototypeOf(this, _ResourceNotSupportedException.prototype);
    this.Message = opts.Message;
  }
};
var ServiceQuotaExceededException = class _ServiceQuotaExceededException extends MarketplaceCatalogServiceException {
  name = "ServiceQuotaExceededException";
  $fault = "client";
  Message;
  constructor(opts) {
    super({
      name: "ServiceQuotaExceededException",
      $fault: "client",
      ...opts
    });
    Object.setPrototypeOf(this, _ServiceQuotaExceededException.prototype);
    this.Message = opts.Message;
  }
};

// ../../node_modules/@aws-sdk/client-marketplace-catalog/dist-es/schemas/schemas_0.js
var _ADE = "AccessDeniedException";
var _AED = "AvailabilityEndDate";
var _APEIF = "AmiProductEntityIdFilter";
var _APF = "AmiProductFilters";
var _APLMDF = "AmiProductLastModifiedDateFilter";
var _APLMDFDR = "AmiProductLastModifiedDateFilterDateRange";
var _APS = "AmiProductSort";
var _APSm = "AmiProductSummary";
var _APTF = "AmiProductTitleFilter";
var _APVF = "AmiProductVisibilityFilter";
var _AV = "AfterValue";
var _BA = "BuyerAccounts";
var _BDE = "BatchDescribeEntities";
var _BDED = "BatchDescribeErrorDetail";
var _BDER = "BatchDescribeEntitiesRequest";
var _BDERa = "BatchDescribeEntitiesResponse";
var _BV = "BeforeValue";
var _C = "Catalog";
var _CCS = "CancelChangeSet";
var _CCSR = "CancelChangeSetRequest";
var _CCSRa = "CancelChangeSetResponse";
var _CD = "CreatedDate";
var _CN = "ChangeName";
var _CPEIF = "ContainerProductEntityIdFilter";
var _CPF = "ContainerProductFilters";
var _CPLMDF = "ContainerProductLastModifiedDateFilter";
var _CPLMDFDR = "ContainerProductLastModifiedDateFilterDateRange";
var _CPS = "ContainerProductSort";
var _CPSo = "ContainerProductSummary";
var _CPTF = "ContainerProductTitleFilter";
var _CPVF = "ContainerProductVisibilityFilter";
var _CRT = "ClientRequestToken";
var _CS = "ChangeSummary";
var _CSA = "ChangeSetArn";
var _CSD = "ChangeSetDescription";
var _CSI = "ChangeSetId";
var _CSN = "ChangeSetName";
var _CSSL = "ChangeSetSummaryList";
var _CSSLI = "ChangeSetSummaryListItem";
var _CST = "ChangeSetTags";
var _CSh = "ChangeSet";
var _CT = "ChangeType";
var _Ch = "Change";
var _D = "Details";
var _DCS = "DescribeChangeSet";
var _DCSR = "DescribeChangeSetRequest";
var _DCSRe = "DescribeChangeSetResponse";
var _DD = "DetailsDocument";
var _DE = "DescribeEntity";
var _DER = "DescribeEntityRequest";
var _DERe = "DescribeEntityResponse";
var _DPEIF = "DataProductEntityIdFilter";
var _DPF = "DataProductFilters";
var _DPLMDF = "DataProductLastModifiedDateFilter";
var _DPLMDFDR = "DataProductLastModifiedDateFilterDateRange";
var _DPS = "DataProductSort";
var _DPSa = "DataProductSummary";
var _DPTF = "DataProductTitleFilter";
var _DPVF = "DataProductVisibilityFilter";
var _DR = "DateRange";
var _DRP = "DeleteResourcePolicy";
var _DRPR = "DeleteResourcePolicyRequest";
var _DRPRe = "DeleteResourcePolicyResponse";
var _E = "Errors";
var _EA = "EntityArn";
var _EC = "ErrorCode";
var _ED = "EntityDetails";
var _EDL = "ErrorDetailList";
var _EDn = "EntityDetail";
var _EDr = "ErrorDetail";
var _EI = "EntityId";
var _EIL = "EntityIdList";
var _EIn = "EntityIdentifier";
var _EM = "ErrorMessage";
var _ER = "EntityRequest";
var _ERL = "EntityRequestList";
var _ES = "EntitySummary";
var _ESL = "EntitySummaryList";
var _ET = "EntityTags";
var _ETF = "EntityTypeFilters";
var _ETS = "EntityTypeSort";
var _ETn = "EndTime";
var _ETnt = "EntityType";
var _En = "Entity";
var _F = "Filter";
var _FC = "FailureCode";
var _FD = "FailureDescription";
var _FL = "FilterList";
var _GRP = "GetResourcePolicy";
var _GRPR = "GetResourcePolicyRequest";
var _GRPRe = "GetResourcePolicyResponse";
var _I = "Intent";
var _ISE = "InternalServiceException";
var _Id = "Identifier";
var _K = "Key";
var _LCS = "ListChangeSets";
var _LCSR = "ListChangeSetsRequest";
var _LCSRi = "ListChangeSetsResponse";
var _LE = "ListEntities";
var _LER = "ListEntitiesRequest";
var _LERi = "ListEntitiesResponse";
var _LMD = "LastModifiedDate";
var _LTFR = "ListTagsForResource";
var _LTFRR = "ListTagsForResourceRequest";
var _LTFRRi = "ListTagsForResourceResponse";
var _M = "Message";
var _MAI = "ManufacturerAccountId";
var _MLN = "ManufacturerLegalName";
var _MLPEIF = "MachineLearningProductEntityIdFilter";
var _MLPF = "MachineLearningProductFilters";
var _MLPLMDF = "MachineLearningProductLastModifiedDateFilter";
var _MLPLMDFDR = "MachineLearningProductLastModifiedDateFilterDateRange";
var _MLPS = "MachineLearningProductSummary";
var _MLPSa = "MachineLearningProductSort";
var _MLPTF = "MachineLearningProductTitleFilter";
var _MLPVF = "MachineLearningProductVisibilityFilter";
var _MR = "MaxResults";
var _N = "Name";
var _NT = "NextToken";
var _OAEDF = "OfferAvailabilityEndDateFilter";
var _OAEDFDR = "OfferAvailabilityEndDateFilterDateRange";
var _OBAF = "OfferBuyerAccountsFilter";
var _OEIF = "OfferEntityIdFilter";
var _OES = "OfferExtendedStatus";
var _OF = "OfferFilters";
var _OLMDF = "OfferLastModifiedDateFilter";
var _OLMDFDR = "OfferLastModifiedDateFilterDateRange";
var _ONF = "OfferNameFilter";
var _OPIF = "OfferProductIdFilter";
var _ORAIF = "OfferResaleAuthorizationIdFilter";
var _ORDF = "OfferReleaseDateFilter";
var _ORDFDR = "OfferReleaseDateFilterDateRange";
var _OS = "OfferSummary";
var _OSF = "OfferStateFilter";
var _OSf = "OfferSort";
var _OT = "OwnershipType";
var _OTF = "OfferTargetingFilter";
var _P = "Policy";
var _PI = "ProductId";
var _PN = "ProductName";
var _PRP = "PutResourcePolicy";
var _PRPR = "PutResourcePolicyRequest";
var _PRPRu = "PutResourcePolicyResponse";
var _PT = "ProductTitle";
var _RA = "ResourceArn";
var _RAAEDF = "ResaleAuthorizationAvailabilityEndDateFilter";
var _RAAEDFDR = "ResaleAuthorizationAvailabilityEndDateFilterDateRange";
var _RACDF = "ResaleAuthorizationCreatedDateFilter";
var _RACDFDR = "ResaleAuthorizationCreatedDateFilterDateRange";
var _RAEIF = "ResaleAuthorizationEntityIdFilter";
var _RAF = "ResaleAuthorizationFilters";
var _RAI = "ResaleAuthorizationId";
var _RAID = "ResellerAccountID";
var _RALMDF = "ResaleAuthorizationLastModifiedDateFilter";
var _RALMDFDR = "ResaleAuthorizationLastModifiedDateFilterDateRange";
var _RAMAIF = "ResaleAuthorizationManufacturerAccountIdFilter";
var _RAMLNF = "ResaleAuthorizationManufacturerLegalNameFilter";
var _RANF = "ResaleAuthorizationNameFilter";
var _RAOESF = "ResaleAuthorizationOfferExtendedStatusFilter";
var _RAPIF = "ResaleAuthorizationProductIdFilter";
var _RAPNF = "ResaleAuthorizationProductNameFilter";
var _RARAIDF = "ResaleAuthorizationResellerAccountIDFilter";
var _RARLNF = "ResaleAuthorizationResellerLegalNameFilter";
var _RAS = "ResaleAuthorizationSummary";
var _RASF = "ResaleAuthorizationStatusFilter";
var _RASe = "ResaleAuthorizationSort";
var _RCL = "RequestedChangeList";
var _RD = "ReleaseDate";
var _RIUE = "ResourceInUseException";
var _RLN = "ResellerLegalName";
var _RNFE = "ResourceNotFoundException";
var _RNSE = "ResourceNotSupportedException";
var _S = "Status";
var _SB = "SortBy";
var _SCS = "StartChangeSet";
var _SCSR = "StartChangeSetRequest";
var _SCSRt = "StartChangeSetResponse";
var _SO = "SortOrder";
var _SQEE = "ServiceQuotaExceededException";
var _SSPEIF = "SaaSProductEntityIdFilter";
var _SSPF = "SaaSProductFilters";
var _SSPLMDF = "SaaSProductLastModifiedDateFilter";
var _SSPLMDFDR = "SaaSProductLastModifiedDateFilterDateRange";
var _SSPS = "SaaSProductSummary";
var _SSPSa = "SaaSProductSort";
var _SSPTF = "SaaSProductTitleFilter";
var _SSPVF = "SaaSProductVisibilityFilter";
var _ST = "StartTime";
var _So = "Sort";
var _St = "State";
var _T = "Type";
var _TE = "ThrottlingException";
var _TK = "TagKeys";
var _TL = "TagList";
var _TR = "TagResource";
var _TRR = "TagResourceRequest";
var _TRRa = "TagResourceResponse";
var _Ta = "Tags";
var _Tag = "Tag";
var _Tar = "Targeting";
var _UR = "UntagResource";
var _URR = "UntagResourceRequest";
var _URRn = "UntagResourceResponse";
var _V = "Visibility";
var _VE = "ValidationException";
var _VL = "ValueList";
var _Va = "Value";
var _WCV = "WildCardValue";
var _c = "client";
var _cSI = "changeSetId";
var _ca = "catalog";
var _e = "error";
var _eI = "entityId";
var _h = "http";
var _hE = "httpError";
var _hQ = "httpQuery";
var _rA = "resourceArn";
var _s = "server";
var _sm = "smithy.ts.sdk.synthetic.com.amazonaws.marketplacecatalog";
var n0 = "com.amazonaws.marketplacecatalog";
var AccessDeniedException2 = [
  -3,
  n0,
  _ADE,
  {
    [_e]: _c,
    [_hE]: 403
  },
  [_M],
  [0]
];
TypeRegistry.for(n0).registerError(AccessDeniedException2, AccessDeniedException);
var AmiProductEntityIdFilter = [3, n0, _APEIF, 0, [_VL], [64 | 0]];
var AmiProductFilters = [
  3,
  n0,
  _APF,
  0,
  [_EI, _LMD, _PT, _V],
  [
    () => AmiProductEntityIdFilter,
    () => AmiProductLastModifiedDateFilter,
    () => AmiProductTitleFilter,
    () => AmiProductVisibilityFilter
  ]
];
var AmiProductLastModifiedDateFilter = [
  3,
  n0,
  _APLMDF,
  0,
  [_DR],
  [() => AmiProductLastModifiedDateFilterDateRange]
];
var AmiProductLastModifiedDateFilterDateRange = [3, n0, _APLMDFDR, 0, [_AV, _BV], [0, 0]];
var AmiProductSort = [3, n0, _APS, 0, [_SB, _SO], [0, 0]];
var AmiProductSummary = [3, n0, _APSm, 0, [_PT, _V], [0, 0]];
var AmiProductTitleFilter = [3, n0, _APTF, 0, [_VL, _WCV], [64 | 0, 0]];
var AmiProductVisibilityFilter = [3, n0, _APVF, 0, [_VL], [64 | 0]];
var BatchDescribeEntitiesRequest = [3, n0, _BDER, 0, [_ERL], [() => EntityRequestList]];
var BatchDescribeEntitiesResponse = [
  3,
  n0,
  _BDERa,
  0,
  [_ED, _E],
  [() => EntityDetails, () => Errors]
];
var BatchDescribeErrorDetail = [3, n0, _BDED, 0, [_EC, _EM], [0, 0]];
var CancelChangeSetRequest = [
  3,
  n0,
  _CCSR,
  0,
  [_C, _CSI],
  [
    [
      0,
      {
        [_hQ]: _ca
      }
    ],
    [
      0,
      {
        [_hQ]: _cSI
      }
    ]
  ]
];
var CancelChangeSetResponse = [3, n0, _CCSRa, 0, [_CSI, _CSA], [0, 0]];
var Change = [
  3,
  n0,
  _Ch,
  0,
  [_CT, _En, _ET, _D, _DD, _CN],
  [0, () => Entity, () => TagList, 0, 15, 0]
];
var ChangeSetSummaryListItem = [
  3,
  n0,
  _CSSLI,
  0,
  [_CSI, _CSA, _CSN, _ST, _ETn, _S, _EIL, _FC],
  [0, 0, 0, 0, 0, 0, 64 | 0, 0]
];
var ChangeSummary = [
  3,
  n0,
  _CS,
  0,
  [_CT, _En, _D, _DD, _EDL, _CN],
  [0, () => Entity, 0, 15, () => ErrorDetailList, 0]
];
var ContainerProductEntityIdFilter = [3, n0, _CPEIF, 0, [_VL], [64 | 0]];
var ContainerProductFilters = [
  3,
  n0,
  _CPF,
  0,
  [_EI, _LMD, _PT, _V],
  [
    () => ContainerProductEntityIdFilter,
    () => ContainerProductLastModifiedDateFilter,
    () => ContainerProductTitleFilter,
    () => ContainerProductVisibilityFilter
  ]
];
var ContainerProductLastModifiedDateFilter = [
  3,
  n0,
  _CPLMDF,
  0,
  [_DR],
  [() => ContainerProductLastModifiedDateFilterDateRange]
];
var ContainerProductLastModifiedDateFilterDateRange = [
  3,
  n0,
  _CPLMDFDR,
  0,
  [_AV, _BV],
  [0, 0]
];
var ContainerProductSort = [3, n0, _CPS, 0, [_SB, _SO], [0, 0]];
var ContainerProductSummary = [3, n0, _CPSo, 0, [_PT, _V], [0, 0]];
var ContainerProductTitleFilter = [3, n0, _CPTF, 0, [_VL, _WCV], [64 | 0, 0]];
var ContainerProductVisibilityFilter = [3, n0, _CPVF, 0, [_VL], [64 | 0]];
var DataProductEntityIdFilter = [3, n0, _DPEIF, 0, [_VL], [64 | 0]];
var DataProductFilters = [
  3,
  n0,
  _DPF,
  0,
  [_EI, _PT, _V, _LMD],
  [
    () => DataProductEntityIdFilter,
    () => DataProductTitleFilter,
    () => DataProductVisibilityFilter,
    () => DataProductLastModifiedDateFilter
  ]
];
var DataProductLastModifiedDateFilter = [
  3,
  n0,
  _DPLMDF,
  0,
  [_DR],
  [() => DataProductLastModifiedDateFilterDateRange]
];
var DataProductLastModifiedDateFilterDateRange = [
  3,
  n0,
  _DPLMDFDR,
  0,
  [_AV, _BV],
  [0, 0]
];
var DataProductSort = [3, n0, _DPS, 0, [_SB, _SO], [0, 0]];
var DataProductSummary = [3, n0, _DPSa, 0, [_PT, _V], [0, 0]];
var DataProductTitleFilter = [3, n0, _DPTF, 0, [_VL, _WCV], [64 | 0, 0]];
var DataProductVisibilityFilter = [3, n0, _DPVF, 0, [_VL], [64 | 0]];
var DeleteResourcePolicyRequest = [
  3,
  n0,
  _DRPR,
  0,
  [_RA],
  [
    [
      0,
      {
        [_hQ]: _rA
      }
    ]
  ]
];
var DeleteResourcePolicyResponse = [3, n0, _DRPRe, 0, [], []];
var DescribeChangeSetRequest = [
  3,
  n0,
  _DCSR,
  0,
  [_C, _CSI],
  [
    [
      0,
      {
        [_hQ]: _ca
      }
    ],
    [
      0,
      {
        [_hQ]: _cSI
      }
    ]
  ]
];
var DescribeChangeSetResponse = [
  3,
  n0,
  _DCSRe,
  0,
  [_CSI, _CSA, _CSN, _I, _ST, _ETn, _S, _FC, _FD, _CSh],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, () => ChangeSetDescription]
];
var DescribeEntityRequest = [
  3,
  n0,
  _DER,
  0,
  [_C, _EI],
  [
    [
      0,
      {
        [_hQ]: _ca
      }
    ],
    [
      0,
      {
        [_hQ]: _eI
      }
    ]
  ]
];
var DescribeEntityResponse = [
  3,
  n0,
  _DERe,
  0,
  [_ETnt, _EIn, _EA, _LMD, _D, _DD],
  [0, 0, 0, 0, 0, 15]
];
var Entity = [3, n0, _En, 0, [_T, _Id], [0, 0]];
var EntityDetail = [3, n0, _EDn, 0, [_ETnt, _EA, _EIn, _LMD, _DD], [0, 0, 0, 0, 15]];
var EntityRequest = [3, n0, _ER, 0, [_C, _EI], [0, 0]];
var EntitySummary = [
  3,
  n0,
  _ES,
  0,
  [_N, _ETnt, _EI, _EA, _LMD, _V, _APSm, _CPSo, _DPSa, _SSPS, _OS, _RAS, _MLPS],
  [
    0,
    0,
    0,
    0,
    0,
    0,
    () => AmiProductSummary,
    () => ContainerProductSummary,
    () => DataProductSummary,
    () => SaaSProductSummary,
    () => OfferSummary,
    () => ResaleAuthorizationSummary,
    () => MachineLearningProductSummary
  ]
];
var ErrorDetail = [3, n0, _EDr, 0, [_EC, _EM], [0, 0]];
var Filter = [3, n0, _F, 0, [_N, _VL], [0, 64 | 0]];
var GetResourcePolicyRequest = [
  3,
  n0,
  _GRPR,
  0,
  [_RA],
  [
    [
      0,
      {
        [_hQ]: _rA
      }
    ]
  ]
];
var GetResourcePolicyResponse = [3, n0, _GRPRe, 0, [_P], [0]];
var InternalServiceException2 = [
  -3,
  n0,
  _ISE,
  {
    [_e]: _s,
    [_hE]: 500
  },
  [_M],
  [0]
];
TypeRegistry.for(n0).registerError(InternalServiceException2, InternalServiceException);
var ListChangeSetsRequest = [
  3,
  n0,
  _LCSR,
  0,
  [_C, _FL, _So, _MR, _NT],
  [0, () => FilterList, () => Sort, 1, 0]
];
var ListChangeSetsResponse = [
  3,
  n0,
  _LCSRi,
  0,
  [_CSSL, _NT],
  [() => ChangeSetSummaryList, 0]
];
var ListEntitiesRequest = [
  3,
  n0,
  _LER,
  0,
  [_C, _ETnt, _FL, _So, _NT, _MR, _OT, _ETF, _ETS],
  [0, 0, () => FilterList, () => Sort, 0, 1, 0, () => EntityTypeFilters, () => EntityTypeSort]
];
var ListEntitiesResponse = [3, n0, _LERi, 0, [_ESL, _NT], [() => EntitySummaryList, 0]];
var ListTagsForResourceRequest = [3, n0, _LTFRR, 0, [_RA], [0]];
var ListTagsForResourceResponse = [3, n0, _LTFRRi, 0, [_RA, _Ta], [0, () => TagList]];
var MachineLearningProductEntityIdFilter = [3, n0, _MLPEIF, 0, [_VL], [64 | 0]];
var MachineLearningProductFilters = [
  3,
  n0,
  _MLPF,
  0,
  [_EI, _LMD, _PT, _V],
  [
    () => MachineLearningProductEntityIdFilter,
    () => MachineLearningProductLastModifiedDateFilter,
    () => MachineLearningProductTitleFilter,
    () => MachineLearningProductVisibilityFilter
  ]
];
var MachineLearningProductLastModifiedDateFilter = [
  3,
  n0,
  _MLPLMDF,
  0,
  [_DR],
  [() => MachineLearningProductLastModifiedDateFilterDateRange]
];
var MachineLearningProductLastModifiedDateFilterDateRange = [
  3,
  n0,
  _MLPLMDFDR,
  0,
  [_AV, _BV],
  [0, 0]
];
var MachineLearningProductSort = [3, n0, _MLPSa, 0, [_SB, _SO], [0, 0]];
var MachineLearningProductSummary = [3, n0, _MLPS, 0, [_PT, _V], [0, 0]];
var MachineLearningProductTitleFilter = [3, n0, _MLPTF, 0, [_VL, _WCV], [64 | 0, 0]];
var MachineLearningProductVisibilityFilter = [3, n0, _MLPVF, 0, [_VL], [64 | 0]];
var OfferAvailabilityEndDateFilter = [
  3,
  n0,
  _OAEDF,
  0,
  [_DR],
  [() => OfferAvailabilityEndDateFilterDateRange]
];
var OfferAvailabilityEndDateFilterDateRange = [3, n0, _OAEDFDR, 0, [_AV, _BV], [0, 0]];
var OfferBuyerAccountsFilter = [3, n0, _OBAF, 0, [_WCV], [0]];
var OfferEntityIdFilter = [3, n0, _OEIF, 0, [_VL], [64 | 0]];
var OfferFilters = [
  3,
  n0,
  _OF,
  0,
  [_EI, _N, _PI, _RAI, _RD, _AED, _BA, _St, _Tar, _LMD],
  [
    () => OfferEntityIdFilter,
    () => OfferNameFilter,
    () => OfferProductIdFilter,
    () => OfferResaleAuthorizationIdFilter,
    () => OfferReleaseDateFilter,
    () => OfferAvailabilityEndDateFilter,
    () => OfferBuyerAccountsFilter,
    () => OfferStateFilter,
    () => OfferTargetingFilter,
    () => OfferLastModifiedDateFilter
  ]
];
var OfferLastModifiedDateFilter = [
  3,
  n0,
  _OLMDF,
  0,
  [_DR],
  [() => OfferLastModifiedDateFilterDateRange]
];
var OfferLastModifiedDateFilterDateRange = [3, n0, _OLMDFDR, 0, [_AV, _BV], [0, 0]];
var OfferNameFilter = [3, n0, _ONF, 0, [_VL, _WCV], [64 | 0, 0]];
var OfferProductIdFilter = [3, n0, _OPIF, 0, [_VL], [64 | 0]];
var OfferReleaseDateFilter = [
  3,
  n0,
  _ORDF,
  0,
  [_DR],
  [() => OfferReleaseDateFilterDateRange]
];
var OfferReleaseDateFilterDateRange = [3, n0, _ORDFDR, 0, [_AV, _BV], [0, 0]];
var OfferResaleAuthorizationIdFilter = [3, n0, _ORAIF, 0, [_VL], [64 | 0]];
var OfferSort = [3, n0, _OSf, 0, [_SB, _SO], [0, 0]];
var OfferStateFilter = [3, n0, _OSF, 0, [_VL], [64 | 0]];
var OfferSummary = [
  3,
  n0,
  _OS,
  0,
  [_N, _PI, _RAI, _RD, _AED, _BA, _St, _Tar],
  [0, 0, 0, 0, 0, 64 | 0, 0, 64 | 0]
];
var OfferTargetingFilter = [3, n0, _OTF, 0, [_VL], [64 | 0]];
var PutResourcePolicyRequest = [3, n0, _PRPR, 0, [_RA, _P], [0, 0]];
var PutResourcePolicyResponse = [3, n0, _PRPRu, 0, [], []];
var ResaleAuthorizationAvailabilityEndDateFilter = [
  3,
  n0,
  _RAAEDF,
  0,
  [_DR, _VL],
  [() => ResaleAuthorizationAvailabilityEndDateFilterDateRange, 64 | 0]
];
var ResaleAuthorizationAvailabilityEndDateFilterDateRange = [
  3,
  n0,
  _RAAEDFDR,
  0,
  [_AV, _BV],
  [0, 0]
];
var ResaleAuthorizationCreatedDateFilter = [
  3,
  n0,
  _RACDF,
  0,
  [_DR, _VL],
  [() => ResaleAuthorizationCreatedDateFilterDateRange, 64 | 0]
];
var ResaleAuthorizationCreatedDateFilterDateRange = [
  3,
  n0,
  _RACDFDR,
  0,
  [_AV, _BV],
  [0, 0]
];
var ResaleAuthorizationEntityIdFilter = [3, n0, _RAEIF, 0, [_VL], [64 | 0]];
var ResaleAuthorizationFilters = [
  3,
  n0,
  _RAF,
  0,
  [_EI, _N, _PI, _CD, _AED, _MAI, _PN, _MLN, _RAID, _RLN, _S, _OES, _LMD],
  [
    () => ResaleAuthorizationEntityIdFilter,
    () => ResaleAuthorizationNameFilter,
    () => ResaleAuthorizationProductIdFilter,
    () => ResaleAuthorizationCreatedDateFilter,
    () => ResaleAuthorizationAvailabilityEndDateFilter,
    () => ResaleAuthorizationManufacturerAccountIdFilter,
    () => ResaleAuthorizationProductNameFilter,
    () => ResaleAuthorizationManufacturerLegalNameFilter,
    () => ResaleAuthorizationResellerAccountIDFilter,
    () => ResaleAuthorizationResellerLegalNameFilter,
    () => ResaleAuthorizationStatusFilter,
    () => ResaleAuthorizationOfferExtendedStatusFilter,
    () => ResaleAuthorizationLastModifiedDateFilter
  ]
];
var ResaleAuthorizationLastModifiedDateFilter = [
  3,
  n0,
  _RALMDF,
  0,
  [_DR],
  [() => ResaleAuthorizationLastModifiedDateFilterDateRange]
];
var ResaleAuthorizationLastModifiedDateFilterDateRange = [
  3,
  n0,
  _RALMDFDR,
  0,
  [_AV, _BV],
  [0, 0]
];
var ResaleAuthorizationManufacturerAccountIdFilter = [
  3,
  n0,
  _RAMAIF,
  0,
  [_VL, _WCV],
  [64 | 0, 0]
];
var ResaleAuthorizationManufacturerLegalNameFilter = [
  3,
  n0,
  _RAMLNF,
  0,
  [_VL, _WCV],
  [64 | 0, 0]
];
var ResaleAuthorizationNameFilter = [3, n0, _RANF, 0, [_VL, _WCV], [64 | 0, 0]];
var ResaleAuthorizationOfferExtendedStatusFilter = [3, n0, _RAOESF, 0, [_VL], [64 | 0]];
var ResaleAuthorizationProductIdFilter = [3, n0, _RAPIF, 0, [_VL, _WCV], [64 | 0, 0]];
var ResaleAuthorizationProductNameFilter = [3, n0, _RAPNF, 0, [_VL, _WCV], [64 | 0, 0]];
var ResaleAuthorizationResellerAccountIDFilter = [
  3,
  n0,
  _RARAIDF,
  0,
  [_VL, _WCV],
  [64 | 0, 0]
];
var ResaleAuthorizationResellerLegalNameFilter = [
  3,
  n0,
  _RARLNF,
  0,
  [_VL, _WCV],
  [64 | 0, 0]
];
var ResaleAuthorizationSort = [3, n0, _RASe, 0, [_SB, _SO], [0, 0]];
var ResaleAuthorizationStatusFilter = [3, n0, _RASF, 0, [_VL], [64 | 0]];
var ResaleAuthorizationSummary = [
  3,
  n0,
  _RAS,
  0,
  [_N, _PI, _PN, _MAI, _MLN, _RAID, _RLN, _S, _OES, _CD, _AED],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
];
var ResourceInUseException2 = [
  -3,
  n0,
  _RIUE,
  {
    [_e]: _c,
    [_hE]: 423
  },
  [_M],
  [0]
];
TypeRegistry.for(n0).registerError(ResourceInUseException2, ResourceInUseException);
var ResourceNotFoundException2 = [
  -3,
  n0,
  _RNFE,
  {
    [_e]: _c,
    [_hE]: 404
  },
  [_M],
  [0]
];
TypeRegistry.for(n0).registerError(ResourceNotFoundException2, ResourceNotFoundException);
var ResourceNotSupportedException2 = [
  -3,
  n0,
  _RNSE,
  {
    [_e]: _c,
    [_hE]: 415
  },
  [_M],
  [0]
];
TypeRegistry.for(n0).registerError(ResourceNotSupportedException2, ResourceNotSupportedException);
var SaaSProductEntityIdFilter = [3, n0, _SSPEIF, 0, [_VL], [64 | 0]];
var SaaSProductFilters = [
  3,
  n0,
  _SSPF,
  0,
  [_EI, _PT, _V, _LMD],
  [
    () => SaaSProductEntityIdFilter,
    () => SaaSProductTitleFilter,
    () => SaaSProductVisibilityFilter,
    () => SaaSProductLastModifiedDateFilter
  ]
];
var SaaSProductLastModifiedDateFilter = [
  3,
  n0,
  _SSPLMDF,
  0,
  [_DR],
  [() => SaaSProductLastModifiedDateFilterDateRange]
];
var SaaSProductLastModifiedDateFilterDateRange = [
  3,
  n0,
  _SSPLMDFDR,
  0,
  [_AV, _BV],
  [0, 0]
];
var SaaSProductSort = [3, n0, _SSPSa, 0, [_SB, _SO], [0, 0]];
var SaaSProductSummary = [3, n0, _SSPS, 0, [_PT, _V], [0, 0]];
var SaaSProductTitleFilter = [3, n0, _SSPTF, 0, [_VL, _WCV], [64 | 0, 0]];
var SaaSProductVisibilityFilter = [3, n0, _SSPVF, 0, [_VL], [64 | 0]];
var ServiceQuotaExceededException2 = [
  -3,
  n0,
  _SQEE,
  {
    [_e]: _c,
    [_hE]: 402
  },
  [_M],
  [0]
];
TypeRegistry.for(n0).registerError(ServiceQuotaExceededException2, ServiceQuotaExceededException);
var Sort = [3, n0, _So, 0, [_SB, _SO], [0, 0]];
var StartChangeSetRequest = [
  3,
  n0,
  _SCSR,
  0,
  [_C, _CSh, _CSN, _CRT, _CST, _I],
  [0, () => RequestedChangeList, 0, [0, 4], () => TagList, 0]
];
var StartChangeSetResponse = [3, n0, _SCSRt, 0, [_CSI, _CSA], [0, 0]];
var Tag = [3, n0, _Tag, 0, [_K, _Va], [0, 0]];
var TagResourceRequest = [3, n0, _TRR, 0, [_RA, _Ta], [0, () => TagList]];
var TagResourceResponse = [3, n0, _TRRa, 0, [], []];
var ThrottlingException2 = [
  -3,
  n0,
  _TE,
  {
    [_e]: _c,
    [_hE]: 429
  },
  [_M],
  [0]
];
TypeRegistry.for(n0).registerError(ThrottlingException2, ThrottlingException);
var UntagResourceRequest = [3, n0, _URR, 0, [_RA, _TK], [0, 64 | 0]];
var UntagResourceResponse = [3, n0, _URRn, 0, [], []];
var ValidationException2 = [
  -3,
  n0,
  _VE,
  {
    [_e]: _c,
    [_hE]: 422
  },
  [_M],
  [0]
];
TypeRegistry.for(n0).registerError(ValidationException2, ValidationException);
var MarketplaceCatalogServiceException2 = [
  -3,
  _sm,
  "MarketplaceCatalogServiceException",
  0,
  [],
  []
];
TypeRegistry.for(_sm).registerError(MarketplaceCatalogServiceException2, MarketplaceCatalogServiceException);
var AmiProductEntityIdFilterValueList = 64 | 0;
var AmiProductTitleFilterValueList = 64 | 0;
var AmiProductVisibilityFilterValueList = 64 | 0;
var ChangeSetDescription = [1, n0, _CSD, 0, () => ChangeSummary];
var ChangeSetSummaryList = [1, n0, _CSSL, 0, () => ChangeSetSummaryListItem];
var ContainerProductEntityIdFilterValueList = 64 | 0;
var ContainerProductTitleFilterValueList = 64 | 0;
var ContainerProductVisibilityFilterValueList = 64 | 0;
var DataProductEntityIdFilterValueList = 64 | 0;
var DataProductTitleFilterValueList = 64 | 0;
var DataProductVisibilityFilterValueList = 64 | 0;
var EntityRequestList = [1, n0, _ERL, 0, () => EntityRequest];
var EntitySummaryList = [1, n0, _ESL, 0, () => EntitySummary];
var ErrorDetailList = [1, n0, _EDL, 0, () => ErrorDetail];
var FilterList = [1, n0, _FL, 0, () => Filter];
var MachineLearningProductEntityIdFilterValueList = 64 | 0;
var MachineLearningProductTitleFilterValueList = 64 | 0;
var MachineLearningProductVisibilityFilterValueList = 64 | 0;
var OfferBuyerAccountsList = 64 | 0;
var OfferEntityIdFilterValueList = 64 | 0;
var OfferNameFilterValueList = 64 | 0;
var OfferProductIdFilterValueList = 64 | 0;
var OfferResaleAuthorizationIdFilterValueList = 64 | 0;
var OfferStateFilterValueList = 64 | 0;
var OfferTargetingFilterValueList = 64 | 0;
var OfferTargetingList = 64 | 0;
var RequestedChangeList = [1, n0, _RCL, 0, () => Change];
var ResaleAuthorizationAvailabilityEndDateFilterValueList = 64 | 0;
var ResaleAuthorizationCreatedDateFilterValueList = 64 | 0;
var ResaleAuthorizationEntityIdFilterValueList = 64 | 0;
var ResaleAuthorizationManufacturerAccountIdFilterValueList = 64 | 0;
var ResaleAuthorizationManufacturerLegalNameFilterValueList = 64 | 0;
var ResaleAuthorizationNameFilterValueList = 64 | 0;
var ResaleAuthorizationOfferExtendedStatusFilterValueList = 64 | 0;
var ResaleAuthorizationProductIdFilterValueList = 64 | 0;
var ResaleAuthorizationProductNameFilterValueList = 64 | 0;
var ResaleAuthorizationResellerAccountIDFilterValueList = 64 | 0;
var ResaleAuthorizationResellerLegalNameFilterValueList = 64 | 0;
var ResaleAuthorizationStatusFilterValueList = 64 | 0;
var ResourceIdList = 64 | 0;
var SaaSProductEntityIdFilterValueList = 64 | 0;
var SaaSProductTitleFilterValueList = 64 | 0;
var SaaSProductVisibilityFilterValueList = 64 | 0;
var TagKeyList = 64 | 0;
var TagList = [1, n0, _TL, 0, () => Tag];
var ValueList = 64 | 0;
var EntityDetails = [2, n0, _ED, 0, 0, () => EntityDetail];
var Errors = [2, n0, _E, 0, 0, () => BatchDescribeErrorDetail];
var EntityTypeFilters = [
  3,
  n0,
  _ETF,
  0,
  [_DPF, _SSPF, _APF, _OF, _CPF, _RAF, _MLPF],
  [
    () => DataProductFilters,
    () => SaaSProductFilters,
    () => AmiProductFilters,
    () => OfferFilters,
    () => ContainerProductFilters,
    () => ResaleAuthorizationFilters,
    () => MachineLearningProductFilters
  ]
];
var EntityTypeSort = [
  3,
  n0,
  _ETS,
  0,
  [_DPS, _SSPSa, _APS, _OSf, _CPS, _RASe, _MLPSa],
  [
    () => DataProductSort,
    () => SaaSProductSort,
    () => AmiProductSort,
    () => OfferSort,
    () => ContainerProductSort,
    () => ResaleAuthorizationSort,
    () => MachineLearningProductSort
  ]
];
var BatchDescribeEntities = [
  9,
  n0,
  _BDE,
  {
    [_h]: ["POST", "/BatchDescribeEntities", 200]
  },
  () => BatchDescribeEntitiesRequest,
  () => BatchDescribeEntitiesResponse
];
var CancelChangeSet = [
  9,
  n0,
  _CCS,
  {
    [_h]: ["PATCH", "/CancelChangeSet", 200]
  },
  () => CancelChangeSetRequest,
  () => CancelChangeSetResponse
];
var DeleteResourcePolicy = [
  9,
  n0,
  _DRP,
  {
    [_h]: ["DELETE", "/DeleteResourcePolicy", 200]
  },
  () => DeleteResourcePolicyRequest,
  () => DeleteResourcePolicyResponse
];
var DescribeChangeSet = [
  9,
  n0,
  _DCS,
  {
    [_h]: ["GET", "/DescribeChangeSet", 200]
  },
  () => DescribeChangeSetRequest,
  () => DescribeChangeSetResponse
];
var DescribeEntity = [
  9,
  n0,
  _DE,
  {
    [_h]: ["GET", "/DescribeEntity", 200]
  },
  () => DescribeEntityRequest,
  () => DescribeEntityResponse
];
var GetResourcePolicy = [
  9,
  n0,
  _GRP,
  {
    [_h]: ["GET", "/GetResourcePolicy", 200]
  },
  () => GetResourcePolicyRequest,
  () => GetResourcePolicyResponse
];
var ListChangeSets = [
  9,
  n0,
  _LCS,
  {
    [_h]: ["POST", "/ListChangeSets", 200]
  },
  () => ListChangeSetsRequest,
  () => ListChangeSetsResponse
];
var ListEntities = [
  9,
  n0,
  _LE,
  {
    [_h]: ["POST", "/ListEntities", 200]
  },
  () => ListEntitiesRequest,
  () => ListEntitiesResponse
];
var ListTagsForResource = [
  9,
  n0,
  _LTFR,
  {
    [_h]: ["POST", "/ListTagsForResource", 200]
  },
  () => ListTagsForResourceRequest,
  () => ListTagsForResourceResponse
];
var PutResourcePolicy = [
  9,
  n0,
  _PRP,
  {
    [_h]: ["POST", "/PutResourcePolicy", 200]
  },
  () => PutResourcePolicyRequest,
  () => PutResourcePolicyResponse
];
var StartChangeSet = [
  9,
  n0,
  _SCS,
  {
    [_h]: ["POST", "/StartChangeSet", 200]
  },
  () => StartChangeSetRequest,
  () => StartChangeSetResponse
];
var TagResource = [
  9,
  n0,
  _TR,
  {
    [_h]: ["POST", "/TagResource", 200]
  },
  () => TagResourceRequest,
  () => TagResourceResponse
];
var UntagResource = [
  9,
  n0,
  _UR,
  {
    [_h]: ["POST", "/UntagResource", 200]
  },
  () => UntagResourceRequest,
  () => UntagResourceResponse
];

// ../../node_modules/@aws-sdk/client-marketplace-catalog/dist-es/commands/BatchDescribeEntitiesCommand.js
var BatchDescribeEntitiesCommand = class extends Command.classBuilder().ep(commonParams).m(function(Command2, cs, config, o) {
  return [getEndpointPlugin(config, Command2.getEndpointParameterInstructions())];
}).s("AWSMPSeymour", "BatchDescribeEntities", {}).n("MarketplaceCatalogClient", "BatchDescribeEntitiesCommand").sc(BatchDescribeEntities).build() {
};

// ../../node_modules/@aws-sdk/client-marketplace-catalog/dist-es/commands/DescribeEntityCommand.js
var DescribeEntityCommand = class extends Command.classBuilder().ep(commonParams).m(function(Command2, cs, config, o) {
  return [getEndpointPlugin(config, Command2.getEndpointParameterInstructions())];
}).s("AWSMPSeymour", "DescribeEntity", {}).n("MarketplaceCatalogClient", "DescribeEntityCommand").sc(DescribeEntity).build() {
};

// ../../node_modules/@aws-sdk/client-marketplace-catalog/dist-es/commands/ListEntitiesCommand.js
var ListEntitiesCommand = class extends Command.classBuilder().ep(commonParams).m(function(Command2, cs, config, o) {
  return [getEndpointPlugin(config, Command2.getEndpointParameterInstructions())];
}).s("AWSMPSeymour", "ListEntities", {}).n("MarketplaceCatalogClient", "ListEntitiesCommand").sc(ListEntities).build() {
};

// src/aipo/CreateConfig/services/marketplaceApiService.ts
import { getCapiClient } from "@amzn/awsmp-max-data";
var MarketplaceApiService = class {
  client;
  logger;
  constructor(logger) {
    this.client = getCapiClient(logger);
    this.logger = logger;
  }
  /**
   * Transform AWS dimension to UI format
   */
  transformAwsDimensionToUI(awsDim, index) {
    return {
      dimension: awsDim.Name || awsDim.Key || `Dimension ${index}`,
      apiIdentifier: awsDim.Key || `dimension_${index}`,
      description: awsDim.Description || `${awsDim.Name || awsDim.Key} pricing dimension`
    };
  }
  /**
   * Check if a product passes the dimension filter
   */
  doesProductPassDimensionFilter(entityDetail) {
    try {
      if (!entityDetail.DetailsDocument) {
        return false;
      }
      let detailsDoc;
      if (typeof entityDetail.DetailsDocument === "string") {
        detailsDoc = JSON.parse(entityDetail.DetailsDocument);
      } else {
        detailsDoc = entityDetail.DetailsDocument;
      }
      if (!detailsDoc.Dimensions || !Array.isArray(detailsDoc.Dimensions)) {
        return false;
      }
      const hasEntitledDimension = detailsDoc.Dimensions.some((dimension) => {
        const types = dimension.Types;
        if (!Array.isArray(types)) {
          return false;
        }
        return types.includes("Entitled");
      });
      const hasRequestPrivateOfferEngagement = (() => {
        if (!detailsDoc.BuyerEngagement || !Array.isArray(detailsDoc.BuyerEngagement)) {
          return false;
        }
        return detailsDoc.BuyerEngagement.some((engagement) => {
          return engagement.EngagementOption === "RequestPrivateOffer";
        });
      })();
      return hasEntitledDimension && hasRequestPrivateOfferEngagement;
    } catch (error) {
      this.logger.error("Error checking dimension filter", void 0, serializeError(error));
      return false;
    }
  }
  /**
   * Fetch batch entity details using BatchDescribeEntities API
   * Processes entities in batches of 20 due to API limitations
   */
  async fetchBatchEntityDetails(entitySummaryList, productsToFilter) {
    if (!entitySummaryList || entitySummaryList.length === 0) {
      return { filteredProducts: productsToFilter, entityDetails: {} };
    }
    const allEntityDetails = {};
    for (let i = 0; i < entitySummaryList.length; i += 20) {
      const batch = entitySummaryList.slice(i, i + 20);
      const batchRequests = batch.filter((entity) => entity.EntityId).map((entity) => ({
        Catalog: "AWSMarketplace",
        EntityId: entity.EntityId
      }));
      if (batchRequests.length > 0) {
        const command = new BatchDescribeEntitiesCommand({
          EntityRequestList: batchRequests
        });
        const response = await this.client.send(command);
        Object.assign(allEntityDetails, response.EntityDetails || {});
      }
    }
    const filteredProducts = productsToFilter.filter((product) => {
      const entityDetail = allEntityDetails[product.id];
      if (!entityDetail) {
        return false;
      }
      return this.doesProductPassDimensionFilter(entityDetail);
    });
    return { filteredProducts, entityDetails: allEntityDetails };
  }
  /**
   * Fetch marketplace products with pagination support
   *
   * @param includeLimited - If true, includes "Limited" visibility products in addition to "Public"
   */
  async fetchMarketplaceProducts(includeLimited = false) {
    const allEntitySummaries = [];
    let nextToken;
    const visibilityList = includeLimited ? ["Public", "Limited"] : ["Public"];
    do {
      const commandInput = {
        Catalog: "AWSMarketplace",
        EntityType: "SaaSProduct",
        MaxResults: 50,
        EntityTypeFilters: {
          SaaSProductFilters: {
            Visibility: {
              ValueList: visibilityList
            }
          }
        }
      };
      if (nextToken) {
        commandInput.NextToken = nextToken;
      }
      const command = new ListEntitiesCommand(commandInput);
      const response = await this.client.send(command);
      if (response.EntitySummaryList && response.EntitySummaryList.length > 0) {
        allEntitySummaries.push(...response.EntitySummaryList);
      }
      nextToken = response.NextToken;
    } while (nextToken);
    if (allEntitySummaries.length > 0) {
      const products = allEntitySummaries.map((entity) => {
        return {
          id: entity.EntityId || "",
          name: entity.SaaSProductSummary?.ProductTitle || entity.EntityId || "Unknown Product"
        };
      }).filter((p) => p.id);
      const { filteredProducts, entityDetails } = await this.fetchBatchEntityDetails(allEntitySummaries, products);
      return {
        products: filteredProducts,
        entityDetails
      };
    } else {
      return {
        products: [],
        entityDetails: {}
      };
    }
  }
  /**
   * Extract product dimensions from BatchDescribeEntities results
   * Returns a Map for O(1) lookups by apiIdentifier
   */
  extractProductDimensions(productId, batchEntityDetails) {
    try {
      const entityDetail = batchEntityDetails[productId];
      if (!entityDetail) {
        return /* @__PURE__ */ new Map();
      }
      const dimensionsMap = /* @__PURE__ */ new Map();
      if (entityDetail.DetailsDocument) {
        try {
          let detailsDoc;
          if (typeof entityDetail.DetailsDocument === "string") {
            detailsDoc = JSON.parse(entityDetail.DetailsDocument);
          } else {
            detailsDoc = entityDetail.DetailsDocument;
          }
          if (detailsDoc.Dimensions && Array.isArray(detailsDoc.Dimensions)) {
            const allDimensions = detailsDoc.Dimensions;
            allDimensions.forEach((awsDim, index) => {
              const types = awsDim.Types;
              if (Array.isArray(types) && types.includes("Entitled")) {
                const dimension = this.transformAwsDimensionToUI(awsDim, index);
                dimensionsMap.set(dimension.apiIdentifier, dimension);
              }
            });
          }
        } catch (parseError) {
          this.logger.error("Failed to parse DetailsDocument", void 0, serializeError(parseError));
          throw new Error("Failed to parse product details");
        }
      } else {
        throw new Error("No product details available");
      }
      return dimensionsMap;
    } catch (error) {
      this.logger.error("Failed to extract product dimensions from batch results", void 0, serializeError(error));
      throw error;
    }
  }
  async fetchProductDetails(productId) {
    const command = new DescribeEntityCommand({
      Catalog: "AWSMarketplace",
      EntityId: productId
    });
    const response = await this.client.send(command);
    const dimensionsMap = /* @__PURE__ */ new Map();
    let productName = productId;
    let productCode;
    if (response.DetailsDocument) {
      const detailsDoc = typeof response.DetailsDocument === "string" ? JSON.parse(response.DetailsDocument) : response.DetailsDocument;
      const productTitle = detailsDoc?.Description?.ProductTitle;
      if (productTitle) {
        productName = productTitle;
      }
      const productCodeValue = detailsDoc?.Description?.ProductCode;
      if (productCodeValue) {
        productCode = productCodeValue;
      }
      if (detailsDoc.Dimensions && Array.isArray(detailsDoc.Dimensions)) {
        detailsDoc.Dimensions.forEach((dimension) => {
          const key = dimension.Key;
          const name = dimension.Name || key;
          if (key) {
            dimensionsMap.set(key, name);
          }
        });
      }
    }
    return { name: productName, dimensions: dimensionsMap, productCode };
  }
  /**
   * Fetch product name for a single product ID using DescribeEntity API
   * Returns the product name (ProductTitle) or falls back to productId
   * Throws error if API call fails
   */
  async fetchProductName(productId) {
    const details = await this.fetchProductDetails(productId);
    return details.name;
  }
  /**
   * Get a test product with 201 dimensions for testing purposes
   * Returns mock data with a product containing 201 dimensions
   */
  getTestProductWith201Dimensions() {
    const testProductId = "test-product-201-dimensions";
    const testProduct = {
      id: testProductId,
      name: "Test Product with 201 Dimensions"
    };
    const testDimensions = Array.from({ length: 201 }, (_, index) => ({
      Key: `dimension_${index + 1}`,
      Name: `Test Dimension ${index + 1}`,
      Description: `Description for test dimension ${index + 1}`,
      Types: ["Entitled"],
      Unit: "Units"
    }));
    const entityDetail = {
      EntityId: testProductId,
      EntityType: "SaaSProduct",
      LastModifiedDate: (/* @__PURE__ */ new Date()).toISOString(),
      DetailsDocument: {
        Description: {
          ProductTitle: "Test Product with 201 Dimensions"
        },
        Dimensions: testDimensions,
        BuyerEngagement: [
          {
            EngagementOption: "RequestPrivateOffer"
          }
        ]
      }
    };
    const dimensionsMap = /* @__PURE__ */ new Map();
    testDimensions.forEach((awsDim, index) => {
      const dimension = this.transformAwsDimensionToUI(awsDim, index);
      dimensionsMap.set(dimension.apiIdentifier, dimension);
    });
    return {
      product: testProduct,
      entityDetail,
      dimensions: dimensionsMap
    };
  }
  /**
   * Fetch product names for given product IDs using BatchDescribeEntities
   * Processes product IDs in batches of 20 due to API limitations
   * Returns a Map of productId to product name
   * Throws error if API call fails
   */
  async fetchProductNames(productIds) {
    const productNameMap = /* @__PURE__ */ new Map();
    if (!productIds || productIds.length === 0) {
      return productNameMap;
    }
    for (let i = 0; i < productIds.length; i += 20) {
      const batch = productIds.slice(i, i + 20);
      const batchCommand = new BatchDescribeEntitiesCommand({
        EntityRequestList: batch.map((id) => ({
          Catalog: "AWSMarketplace",
          EntityId: id
        }))
      });
      const batchResponse = await this.client.send(batchCommand);
      const entityDetails = batchResponse.EntityDetails || {};
      for (const [entityId, details] of Object.entries(entityDetails)) {
        try {
          const detailsDoc = typeof details.DetailsDocument === "string" ? JSON.parse(details.DetailsDocument) : details.DetailsDocument;
          const productTitle = detailsDoc?.Description?.ProductTitle || entityId;
          productNameMap.set(entityId, productTitle);
        } catch (parseError) {
          this.logger.error(`Failed to parse details for product ${entityId}`, void 0, serializeError(parseError));
          productNameMap.set(entityId, entityId);
        }
      }
    }
    return productNameMap;
  }
};

// src/aipo/ListConfig/ListConfig.tsx
import { jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var ListConfig = ({ t, flashbarManager, maxService, setBreadcrumbs, logger }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React5.useState(true);
  const [configurations, setConfigurations] = React5.useState([]);
  const [hasError, setHasError] = React5.useState(false);
  const [isNotFound, setIsNotFound] = React5.useState(false);
  const [hasAuthError, setHasAuthError] = React5.useState(false);
  const location = useLocation();
  React5.useEffect(() => {
    setBreadcrumbs([
      { text: t("awsMarketplace"), href: "https://aws.amazon.com/marketplace", isAbsoluteUrl: true },
      { text: t("expressPrivateOfferConfigurations"), href: "/epo" }
    ]);
    logger.updateContext({ PageType: "AWSMP-EPO-List-Config" });
    logger.updateContext({ SubPageType: "AWSMP-List-Configuration" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, [setBreadcrumbs, logger]);
  React5.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const created = params.get("created");
    const deleted = params.get("deleted");
    const productId = params.get("productId");
    const productName = params.get("productName");
    if (flashbarManager && productId && productName) {
      if (created === "true") {
        flashbarManager.addItem({
          type: "success",
          content: t("configurationCreatedSuccess", { productName }),
          buttonText: t("viewConfiguration"),
          onButtonClick: () => {
            navigate(`/epo/${productId}`);
          },
          dismissible: true
        });
      } else if (deleted === "true") {
        flashbarManager.addItem({
          type: "success",
          content: t("configurationDeletedSuccess", { productName }),
          dismissible: true
        });
      }
      navigate("/epo", { replace: true });
    }
  }, [location.search]);
  const loadConfigurations = React5.useCallback(async () => {
    if (!maxService?.directToolCallWithoutStreaming || hasError || isNotFound) {
      return;
    }
    try {
      const tokens = await MaxTokenData2.getInstance(logger).generateTokens([
        { action: GrantAction2.CreateExpressPrivateOfferConfiguration },
        { action: GrantAction2.DeleteExpressPrivateOfferConfiguration }
      ]);
      const token = tokens[0];
      if (!token) {
        logger.error("Failed to generate token for listing configurations");
        return;
      }
      const result = await maxService.directToolCallWithoutStreaming({
        toolName: "listExpressPrivateOfferConfigurations",
        toolInput: {},
        webIdentityTokenOverride: token,
        agent: { agentId: "epo-seller-qualification" }
      });
      const summaries = result.aipoConfigurationSummaries || [];
      if (summaries && summaries.length > 0) {
        const productIds = [...new Set(summaries.map((s2) => s2.productId).filter(Boolean))];
        if (productIds.length > 0) {
          const productNameMap = await new MarketplaceApiService(logger).fetchProductNames(productIds);
          const configItems = summaries.map((summary) => {
            const productId = summary.productId || "";
            const productName = productNameMap.get(productId) || productId;
            const productDisplay = productName !== productId ? `${productName} (${productId})` : productId;
            return {
              id: productId,
              product: productDisplay,
              status: summary.status || "",
              // Keep original status value from backend
              dateCreated: summary.createdAt || (/* @__PURE__ */ new Date()).toISOString()
            };
          });
          setConfigurations(configItems);
        } else {
          setConfigurations([]);
        }
      } else {
        setConfigurations([]);
      }
    } catch (error) {
      if (isAuthenticationError(error)) {
        setHasAuthError(true);
        await epoSellerSignIn();
        return;
      }
      const statusCode = error?.statusCode || error?.$metadata?.httpStatusCode;
      const is4xxError = statusCode && Math.floor(statusCode / 100) === 4;
      if (is4xxError) {
        setIsNotFound(true);
      } else {
        setHasError(true);
      }
      if (flashbarManager) {
        handleApiError(error, flashbarManager, t, logger);
      }
    }
  }, [maxService, flashbarManager, logger, t, hasError, isNotFound]);
  React5.useEffect(() => {
    if (!maxService?.directToolCallWithoutStreaming || hasError || isNotFound) {
      return;
    }
    const fetchConfigurations = async () => {
      setIsLoading(true);
      try {
        await loadConfigurations();
      } finally {
        setIsLoading(false);
      }
    };
    fetchConfigurations();
  }, [loadConfigurations, maxService]);
  const formatRelativeTime2 = (dateString) => {
    const now2 = /* @__PURE__ */ new Date();
    const date = new Date(dateString);
    const diffInMs = now2.getTime() - date.getTime();
    const diffInMinutes = Math.floor(diffInMs / (1e3 * 60));
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInWeeks = Math.floor(diffInDays / 7);
    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMinutes < 1) {
      return "Just now";
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes === 1 ? "" : "s"} ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours === 1 ? "" : "s"} ago`;
    } else if (diffInDays < 7) {
      return `${diffInDays} day${diffInDays === 1 ? "" : "s"} ago`;
    } else if (diffInDays < 30) {
      return `${diffInWeeks} week${diffInWeeks === 1 ? "" : "s"} ago`;
    } else if (diffInMonths < 12) {
      return `${diffInMonths} month${diffInMonths === 1 ? "" : "s"} ago`;
    } else {
      const diffInYears = Math.floor(diffInMonths / 12);
      return `${diffInYears} year${diffInYears === 1 ? "" : "s"} ago`;
    }
  };
  const renderStatus = (status) => {
    const getStatusConfig = (status2) => {
      switch (status2) {
        case "PENDING":
          return {
            icon: "status-pending",
            color: "#5f6b7a",
            // grey
            text: t("statusPending")
            // Translated text for display
          };
        case "ACTIVE":
          return {
            icon: "status-positive",
            color: "#037f0c",
            // green
            text: t("statusActive")
            // Translated text for display
          };
        case "FAILED":
          return {
            icon: "status-negative",
            color: "#d91515",
            // red
            text: t("statusFailed")
            // Translated text for display
          };
        default:
          return {
            icon: "status-in-progress",
            color: "#5f6b7a",
            text: status2
          };
      }
    };
    const config = getStatusConfig(status);
    return /* @__PURE__ */ jsxs9(SpaceBetween9, { direction: "horizontal", size: "xs", alignItems: "center", children: [
      /* @__PURE__ */ jsx10(Icon, { name: config.icon, variant: status === "ACTIVE" ? "success" : status === "FAILED" ? "error" : "subtle" }),
      /* @__PURE__ */ jsx10("span", { style: { color: config.color }, children: config.text })
    ] });
  };
  const [selectedItems, setSelectedItems] = React5.useState([]);
  const [isDeleting, setIsDeleting] = React5.useState(false);
  const hasSelection = selectedItems.length > 0;
  const handleRemoveItems = async () => {
    if (selectedItems.length > 0 && maxService?.directToolCallWithoutStreaming) {
      const selectedItem = selectedItems[0];
      const productIdToDelete = selectedItem.id;
      const productName = selectedItem.product;
      setIsDeleting(true);
      try {
        const tokens = await MaxTokenData2.getInstance(logger).generateTokens([
          { action: GrantAction2.DeleteExpressPrivateOfferConfiguration, requireUsagesRemaining: true }
        ]);
        const token = tokens[0];
        if (!token) {
          logger.error("Failed to generate token for deleting configuration");
          if (flashbarManager) {
            flashbarManager.addItem({
              type: "error",
              header: t("failedToDeleteConfiguration"),
              content: t("unableToGenerateToken"),
              dismissible: true
            });
          }
          return;
        }
        await maxService.directToolCallWithoutStreaming({
          toolName: "deleteExpressPrivateOfferConfiguration",
          toolInput: { productId: productIdToDelete },
          webIdentityTokenOverride: token,
          agent: { agentId: "epo-seller-qualification" }
        });
        if (flashbarManager) {
          flashbarManager.addItem({
            type: "success",
            content: t("configurationDeletedSuccess", { productName }),
            dismissible: true
          });
        }
        setSelectedItems([]);
        await loadConfigurations();
      } catch (error) {
        logger.error("Error deleting configuration:", void 0, serializeError(error));
        handleApiError(error, flashbarManager, t, logger);
      } finally {
        setIsDeleting(false);
      }
    }
  };
  const columnDefinitions = [
    {
      id: "product",
      header: t("product"),
      cell: (item) => item.product,
      sortingField: "product"
    },
    {
      id: "status",
      header: t("status"),
      cell: (item) => renderStatus(item.status),
      sortingField: "status"
    },
    {
      id: "dateCreated",
      header: t("dateCreated"),
      cell: (item) => formatRelativeTime2(item.dateCreated),
      sortingField: "dateCreated"
    }
  ];
  if (!hasAuthError && hasError) {
    return /* @__PURE__ */ jsx10(FatalErrorPage, { logger });
  }
  return /* @__PURE__ */ jsx10("div", { style: { marginTop: "4px" }, children: /* @__PURE__ */ jsx10(
    ManagedTable4,
    {
      preferenceKey: "aipo-configurations-table",
      defaultPreferences: {
        pageSize: 10,
        wrapLines: true
      },
      hidePreferences: true,
      columnDefinitions,
      items: configurations,
      loading: isLoading,
      variant: "embedded",
      selectedItems,
      onSelectionChange: ({ detail }) => setSelectedItems(detail.selectedItems),
      selectionType: "single",
      ariaLabels: {
        allItemsSelectionLabel: () => t("allConfigurations"),
        itemSelectionLabel: (_, item) => item.product
      },
      trackBy: "id",
      pagination: {},
      filtering: {
        filteringPlaceholder: t("searchByProduct"),
        filteringFunction: (item, filteringText) => {
          const searchText = filteringText.toLowerCase();
          return item.product.toLowerCase().includes(searchText);
        }
      },
      empty: /* @__PURE__ */ jsxs9(Box2, { textAlign: "center", color: "inherit", children: [
        /* @__PURE__ */ jsx10("b", { children: t("noConfigurationsFound") }),
        /* @__PURE__ */ jsx10(Box2, { padding: { bottom: "s" }, variant: "p", color: "inherit", children: t("createFirstConfiguration") })
      ] }),
      header: /* @__PURE__ */ jsx10(
        Header5,
        {
          counter: `(${configurations.length})`,
          description: t("expressPrivateOfferDescription"),
          actions: /* @__PURE__ */ jsxs9(SpaceBetween9, { direction: "horizontal", size: "xs", children: [
            /* @__PURE__ */ jsx10(
              Button6,
              {
                disabled: !hasSelection,
                onClick: () => {
                  logger.biMetric({
                    metricName: "Click",
                    dimensions: {
                      ClickFeat: "express-private-offer-configurations-table",
                      ClickAct: "view"
                    },
                    value: 1,
                    unit: "Count"
                  });
                  if (selectedItems.length > 0) {
                    const productId = selectedItems[0].id;
                    navigate(`/epo/${productId}`);
                  }
                },
                children: t("viewDetails")
              }
            ),
            /* @__PURE__ */ jsx10(
              Button6,
              {
                disabled: !hasSelection || isDeleting,
                loading: isDeleting,
                onClick: () => {
                  logger.biMetric({
                    metricName: "Click",
                    dimensions: {
                      ClickFeat: "express-private-offer-configurations-table",
                      ClickAct: "remove"
                    },
                    value: 1,
                    unit: "Count"
                  });
                  handleRemoveItems();
                },
                children: t("remove")
              }
            ),
            /* @__PURE__ */ jsx10(
              Button6,
              {
                variant: "primary",
                onClick: () => {
                  logger.biMetric({
                    metricName: "Click",
                    dimensions: {
                      ClickFeat: "express-private-offer-configurations-table",
                      ClickAct: "Create-express-private-offer-button"
                    },
                    value: 1,
                    unit: "Count"
                  });
                  navigate("/epo/create");
                },
                children: t("createConfiguration")
              }
            )
          ] }),
          children: t("expressPrivateOfferConfigurations")
        }
      )
    }
  ) });
};

// src/aipo/CreateConfig/CreateConfig.tsx
import * as React14 from "react";
import { useNavigate as useNavigate2, useSearchParams } from "react-router-dom";
import { useState as useState9 } from "react";
import Wizard2 from "@amzn/awsui-components-react/polaris/wizard";

// src/aipo/CreateConfig/components/SelectProductDimensionsStep/validation.ts
var validateSelectProductDimensionsStep = (artifact, t) => {
  const errorProps = {};
  if (!artifact) {
    return { isValid: true, errorProps: {} };
  }
  const selectedProductId = artifact.configurationRequest.productId || "";
  const dimensionRates = artifact.configurationRequest.configurableUpfrontDimensionRates;
  if (!selectedProductId || selectedProductId.trim() === "") {
    errorProps.productError = t("validationSelectProduct");
  }
  if (selectedProductId && (!dimensionRates || !dimensionRates.dimensionRates || dimensionRates.dimensionRates.length === 0)) {
    errorProps.dimensionsError = t("validationSelectDimension");
  }
  if (dimensionRates && dimensionRates.dimensionRates && dimensionRates.dimensionRates.length > 25) {
    errorProps.dimensionLimitError = t("validationDimensionLimit");
  }
  return {
    isValid: Object.keys(errorProps).length === 0,
    errorProps
  };
};

// src/aipo/CreateConfig/CreateConfig.tsx
import Link6 from "@amzn/awsui-components-react/polaris/link";

// src/aipo/CreateConfig/services/buyerProfileQuestionsService.ts
async function generateAndUpdateBuyerProfileQuestions(writeableArtifact, maxToken, flashbarManager, logger) {
  try {
    const result = await writeableArtifact.callMcpTool("generateExpressPrivateOfferSellerQualificationQuestions", {}, maxToken);
    const validationErrors = {};
    let hasValidationErrors = false;
    if (result && Array.isArray(result.qualifications)) {
      result.qualifications.forEach((qual, index) => {
        if (qual._validationError) {
          validationErrors[index] = qual._validationError;
          hasValidationErrors = true;
        }
      });
    }
    const currentArtifact = writeableArtifact.artifact;
    if (!currentArtifact?.configurationRequest.discountStrategy || !("qualifications" in currentArtifact.configurationRequest.discountStrategy)) {
      return {
        hasValidationErrors,
        validationErrors,
        result
      };
    }
    const updatedQualifications = [...currentArtifact.configurationRequest.discountStrategy.qualifications || []];
    if (result && Array.isArray(result.qualifications)) {
      result.qualifications.forEach((resultQual, index) => {
        if (updatedQualifications[index]) {
          updatedQualifications[index] = {
            ...updatedQualifications[index],
            buyerQuestions: resultQual.buyerQuestions || []
          };
          if (resultQual._validationError) {
            updatedQualifications[index]._validationError = resultQual._validationError;
          } else {
            const { _validationError, ...rest } = updatedQualifications[index];
            updatedQualifications[index] = rest;
          }
        }
      });
    }
    const updatedArtifact = {
      ...currentArtifact,
      configurationRequest: {
        ...currentArtifact.configurationRequest,
        discountStrategy: {
          ...currentArtifact.configurationRequest.discountStrategy,
          qualifications: updatedQualifications
        }
      }
    };
    writeableArtifact.setArtifact(updatedArtifact);
    return {
      hasValidationErrors,
      validationErrors,
      result,
      updatedArtifact
    };
  } catch (error) {
    if (logger) {
      logger.error("Error generating buyer profile questions", void 0, serializeError(error));
    }
    const is400Error = error?.statusCode === 400;
    if (flashbarManager) {
      if (is400Error) {
        const errorMessage = error?.message || "Validation error occurred";
        flashbarManager.addItem({
          type: "error",
          content: errorMessage,
          dismissible: true
        });
      } else {
        if (logger) {
          const statusCode = error?.statusCode || error?.$metadata?.httpStatusCode;
          if (statusCode !== 401 && statusCode !== 403) {
            logger.opsMetric({
              metricName: CustomOpsMetricName.ClientSideNonFatalToolCallError,
              unit: "Count",
              value: 1
            });
          }
        }
        flashbarManager.addItem({
          type: "error",
          header: "Something went wrong",
          content: "We're experiencing an internal error. Please try again, and if the problem continues, contact support.",
          dismissible: true
        });
      }
    }
    throw error;
  }
}

// src/aipo/CreateConfig/CreateConfig.tsx
import { MaxTokenData as MaxTokenData4, GrantAction as GrantAction4 } from "@amzn/awsmp-max-data";

// src/aipo/CreateConfig/components/AdditionalInformationStep/AdditionalInformationStep.tsx
import * as React6 from "react";
import { useState as useState5 } from "react";
import Header6 from "@amzn/awsui-components-react/polaris/header";
import Input2 from "@amzn/awsui-components-react/polaris/input";
import Button7 from "@amzn/awsui-components-react/polaris/button";
import Link5 from "@amzn/awsui-components-react/polaris/link";
import Icon2 from "@amzn/awsui-components-react/polaris/icon";
import Textarea2 from "@amzn/awsui-components-react/polaris/textarea";
import FormField3 from "@amzn/awsui-components-react/polaris/form-field";
import SpaceBetween10 from "@amzn/awsui-components-react/polaris/space-between";
import KeyValuePairs3 from "@amzn/awsui-components-react/polaris/key-value-pairs";
import Alert3 from "@amzn/awsui-components-react/polaris/alert";
import ExpandableSection2 from "@amzn/awsui-components-react/polaris/expandable-section";
import Box3 from "@amzn/awsui-components-react/polaris/box";
import TextContent6 from "@cloudscape-design/components/text-content";
import { ManagedTable as ManagedTable5 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";
import { Fragment as Fragment3, jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
var AdditionalInformationStep = ({
  writeableArtifact,
  errors,
  clearFieldError,
  layoutComponents,
  productDimensions = /* @__PURE__ */ new Map(),
  logger,
  t
}) => {
  const { artifact, setArtifact } = writeableArtifact;
  const { LayoutSplitPanel } = layoutComponents;
  const priceValidationErrors = React6.useRef(/* @__PURE__ */ new Map());
  const [showEditorPanel, setShowEditorPanel] = useState5(false);
  const [editingDimension, setEditingDimension] = useState5(null);
  const [editorPanelSize, setEditorPanelSize] = useState5(500);
  const [showDimensionGuidanceWarning, setShowDimensionGuidanceWarning] = useState5(true);
  React6.useEffect(() => {
    return () => {
      priceValidationErrors.current.clear();
    };
  }, []);
  React6.useEffect(() => {
    logger.updateContext({ PageType: "AWSMP-EPO-Create-Config" });
    logger.updateContext({ SubPageType: "AWSMP-Set-Pricing-And-Details" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, []);
  const selectedDimensions = React6.useMemo(() => {
    if (!artifact?.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates) {
      return [];
    }
    return artifact.configurationRequest.configurableUpfrontDimensionRates.dimensionRates.reduce((acc, dimRate) => {
      const matchingDimension = productDimensions.get(dimRate.dimensionKey);
      if (matchingDimension) {
        acc.push({
          ...matchingDimension,
          pricePerUnit: dimRate.price,
          expressPrivateOfferDescription: dimRate.supplementaryDescription
        });
      }
      return acc;
    }, []);
  }, [artifact?.configurationRequest.configurableUpfrontDimensionRates, productDimensions]);
  const handlePriceChange = (dimensionId, newPrice) => {
    setArtifact((prev) => {
      const currentRates = prev.configurationRequest.configurableUpfrontDimensionRates;
      if (!currentRates?.dimensionRates) {
        return prev;
      }
      const updatedDimensionRates = currentRates.dimensionRates.map(
        (dimRate) => dimRate.dimensionKey === dimensionId ? { ...dimRate, price: newPrice || 0 } : dimRate
      );
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          configurableUpfrontDimensionRates: {
            dimensionRates: updatedDimensionRates,
            ...currentRates.duration && { duration: currentRates.duration }
          }
        }
      };
    });
    if (newPrice !== null && newPrice !== void 0 && errors.missingPricesError) {
      clearFieldError("missingPricesError");
    }
  };
  const handleDescriptionChange = (dimensionId, newDescription) => {
    setArtifact((prev) => {
      const currentRates = prev.configurationRequest.configurableUpfrontDimensionRates;
      if (!currentRates?.dimensionRates) {
        return prev;
      }
      const updatedDimensionRates = currentRates.dimensionRates.map(
        (dimRate) => dimRate.dimensionKey === dimensionId ? { ...dimRate, supplementaryDescription: newDescription || void 0 } : dimRate
      );
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          configurableUpfrontDimensionRates: {
            dimensionRates: updatedDimensionRates,
            ...currentRates.duration && { duration: currentRates.duration }
          }
        }
      };
    });
  };
  const openDescriptionEditor = (dimension) => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "price-and-details-table",
        ClickObj: "guidance-column",
        ClickAct: dimension.dimension
      },
      value: 1,
      unit: "Count"
    });
    setEditingDimension(dimension);
    setShowEditorPanel(true);
  };
  const handleSubmitEdit = React6.useCallback(
    (item, column, newValue) => {
      if (column.id === "pricePerUnit") {
        logger.biMetric({
          metricName: "Click",
          dimensions: {
            ClickFeat: "price-and-details-table",
            ClickObj: "price-per-month-column",
            ClickAct: item.dimension
          },
          value: 1,
          unit: "Count"
        });
        priceValidationErrors.current.delete(item.apiIdentifier);
        const valueString = String(newValue || "").trim();
        if (!valueString) {
          priceValidationErrors.current.set(item.apiIdentifier, t("validationPriceRequired"));
          throw new Error("Validation error");
        }
        const numericValue = parseFloat(valueString);
        if (isNaN(numericValue)) {
          priceValidationErrors.current.set(item.apiIdentifier, t("validationPriceValidNumber"));
          throw new Error("Validation error");
        }
        if (numericValue <= 0) {
          priceValidationErrors.current.set(item.apiIdentifier, t("validationPriceGreaterThanZero"));
          throw new Error("Validation error");
        }
        if (numericValue > 1e6) {
          priceValidationErrors.current.set(item.apiIdentifier, t("validationPriceMaxExceeded"));
          throw new Error("Validation error");
        }
        const decimalIndex = valueString.indexOf(".");
        if (decimalIndex !== -1) {
          const decimalPlaces = valueString.length - decimalIndex - 1;
          if (decimalPlaces > 7) {
            priceValidationErrors.current.set(item.apiIdentifier, t("validationPriceMaxDecimals"));
            throw new Error("Validation error");
          }
        }
        handlePriceChange(item.apiIdentifier, numericValue);
        if (errors.missingPricesError) {
          clearFieldError("missingPricesError");
        }
      }
    },
    [handlePriceChange, errors.missingPricesError, clearFieldError, logger]
  );
  const hasDescription = (dimension) => {
    return !!(dimension.expressPrivateOfferDescription && dimension.expressPrivateOfferDescription.trim().length > 0);
  };
  const DescriptionEditor = ({ dimension }) => {
    const [expressOfferDescription, setExpressOfferDescription] = useState5(dimension.expressPrivateOfferDescription || "");
    const [validationError, setValidationError] = useState5(null);
    const [hasLoggedTextareaClick, setHasLoggedTextareaClick] = useState5(false);
    const formatNumber = (num) => {
      return num.toLocaleString("en-US");
    };
    const handleSave = () => {
      logger.biMetric({
        metricName: "Click",
        dimensions: {
          ClickFeat: "edit-guidance-panel",
          ClickAct: "save"
        },
        value: 1,
        unit: "Count"
      });
      if (validationError) {
        return;
      }
      handleDescriptionChange(dimension.apiIdentifier, expressOfferDescription);
      setShowEditorPanel(false);
    };
    const handleCancel = () => {
      logger.biMetric({
        metricName: "Click",
        dimensions: {
          ClickFeat: "edit-guidance-panel",
          ClickAct: "cancel"
        },
        value: 1,
        unit: "Count"
      });
      setShowEditorPanel(false);
    };
    return /* @__PURE__ */ jsxs10(SpaceBetween10, { size: "l", children: [
      /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11("p", { children: t("dimensionGuidanceInstructions") }) }),
      /* @__PURE__ */ jsx11(
        KeyValuePairs3,
        {
          columns: 2,
          items: [
            {
              label: /* @__PURE__ */ jsx11("strong", { children: t("dimensionName") }),
              value: dimension.dimension
            },
            {
              label: /* @__PURE__ */ jsx11("strong", { children: t("apiIdentifier") }),
              value: dimension.apiIdentifier
            }
          ]
        }
      ),
      /* @__PURE__ */ jsxs10(TextContent6, { children: [
        /* @__PURE__ */ jsx11("strong", { children: t("currentDimensionDescription") }),
        /* @__PURE__ */ jsx11("p", { children: dimension.description || t("noDescriptionProvided") })
      ] }),
      /* @__PURE__ */ jsx11(
        FormField3,
        {
          stretch: true,
          label: /* @__PURE__ */ jsxs10(Fragment3, { children: [
            t("dimensionGuidance"),
            " - ",
            /* @__PURE__ */ jsx11("i", { children: t("optional") })
          ] }),
          description: t("dimensionGuidanceDescription"),
          errorText: validationError || void 0,
          constraintText: t("guidanceCharacterCount", { count: formatNumber(expressOfferDescription.length), max: "1,000" }),
          children: /* @__PURE__ */ jsx11(
            Textarea2,
            {
              value: expressOfferDescription,
              onFocus: () => {
                if (!hasLoggedTextareaClick) {
                  logger.biMetric({
                    metricName: "Click",
                    dimensions: {
                      ClickFeat: "edit-guidance-panel",
                      ClickAct: "dimension-guidance"
                    },
                    value: 1,
                    unit: "Count"
                  });
                  setHasLoggedTextareaClick(true);
                }
              },
              onChange: ({ detail }) => {
                setExpressOfferDescription(detail.value);
                if (detail.value.length > 1e3) {
                  setValidationError(t("validationGuidanceTooLong", { count: formatNumber(detail.value.length), max: "1000" }));
                } else {
                  setValidationError(null);
                }
              },
              placeholder: t("enterGuidancePlaceholder"),
              rows: 6,
              invalid: !!validationError
            }
          )
        }
      ),
      /* @__PURE__ */ jsx11(
        ExpandableSection2,
        {
          headerText: t("exampleDimensionGuidance"),
          onChange: ({ detail }) => {
            if (detail.expanded) {
              logger.biMetric({
                metricName: "Click",
                dimensions: {
                  ClickFeat: "edit-guidance-panel",
                  ClickAct: "example-private-offer-descriptions"
                },
                value: 1,
                unit: "Count"
              });
            }
          },
          children: /* @__PURE__ */ jsx11(SpaceBetween10, { size: "s", children: /* @__PURE__ */ jsx11(Box3, { children: t("exampleGuidanceText") }) })
        }
      ),
      /* @__PURE__ */ jsx11("div", { style: { display: "flex", justifyContent: "flex-end" }, children: /* @__PURE__ */ jsxs10(SpaceBetween10, { direction: "horizontal", size: "xs", children: [
        /* @__PURE__ */ jsx11(Button7, { variant: "link", onClick: handleCancel, children: t("cancel") }),
        /* @__PURE__ */ jsx11(Button7, { "data-testid": "save-guidance-button", variant: "normal", onClick: handleSave, children: t("save") })
      ] }) })
    ] });
  };
  return /* @__PURE__ */ jsxs10(SpaceBetween10, { size: "l", children: [
    /* @__PURE__ */ jsx11(
      ManagedTable5,
      {
        preferenceKey: "aipo-dimension-prices-table",
        hidePreferences: true,
        stickyColumns: { last: 1 },
        wrapLines: false,
        filtering: {
          filteringPlaceholder: "Find dimensions",
          filteringAriaLabel: "Find dimensions"
        },
        pagination: {},
        columnDefinitions: [
          {
            id: "dimension",
            header: t("dimensionName"),
            cell: (item) => item.dimension,
            sortingField: "dimension"
          },
          {
            id: "apiIdentifier",
            header: t("apiIdentifier"),
            cell: (item) => item.apiIdentifier,
            sortingField: "apiIdentifier"
          },
          {
            id: "pricePerUnit",
            header: t("pricePerMonth"),
            cell: (item) => {
              return item.pricePerUnit !== null && item.pricePerUnit !== void 0 ? item.pricePerUnit.toString() : "0";
            },
            minWidth: 211,
            editConfig: {
              ariaLabel: t("pricePerMonth"),
              editIconAriaLabel: t("editable"),
              errorIconAriaLabel: t("priceValidationError"),
              validation: (item) => {
                if (priceValidationErrors.current.has(item.apiIdentifier)) {
                  return priceValidationErrors.current.get(item.apiIdentifier);
                }
                return void 0;
              },
              editingCell: (item, { currentValue, setValue }) => {
                return /* @__PURE__ */ jsx11(
                  Input2,
                  {
                    autoFocus: true,
                    type: "number",
                    value: currentValue ?? (item.pricePerUnit !== null && item.pricePerUnit !== void 0 ? item.pricePerUnit.toString() : ""),
                    onChange: (event) => setValue(event.detail.value),
                    placeholder: "0"
                  }
                );
              }
            }
          },
          {
            id: "expressPrivateOfferDescription",
            header: t("guidance"),
            cell: (item) => {
              if (hasDescription(item)) {
                return /* @__PURE__ */ jsxs10("div", { style: { display: "flex", alignItems: "center", gap: "8px" }, children: [
                  /* @__PURE__ */ jsx11(Icon2, { name: "status-positive", variant: "success" }),
                  /* @__PURE__ */ jsx11("span", { style: { color: "#037f0c" }, children: t("complete") })
                ] });
              }
              return /* @__PURE__ */ jsxs10("div", { style: { display: "flex", alignItems: "center", gap: "8px" }, children: [
                /* @__PURE__ */ jsx11(Icon2, { name: "status-warning", variant: "warning" }),
                /* @__PURE__ */ jsx11("span", { style: { color: "#855900" }, children: t("incomplete") })
              ] });
            }
          },
          {
            id: "actions",
            header: t("actions"),
            minWidth: 144,
            cell: (item) => /* @__PURE__ */ jsx11(Link5, { onFollow: () => openDescriptionEditor(item), children: t("editGuidance") })
          }
        ],
        items: selectedDimensions,
        trackBy: "apiIdentifier",
        submitEdit: handleSubmitEdit,
        header: /* @__PURE__ */ jsxs10(SpaceBetween10, { size: "s", children: [
          /* @__PURE__ */ jsx11(Header6, { variant: "h2", counter: `(${selectedDimensions.length})`, description: t("pricingAndGuidanceDescription"), children: t("pricingAndGuidance") }),
          showDimensionGuidanceWarning && /* @__PURE__ */ jsx11("div", { style: { marginBottom: "10px" }, children: /* @__PURE__ */ jsx11(
            Alert3,
            {
              header: t("addDimensionGuidanceHeader"),
              type: "info",
              dismissible: true,
              onDismiss: () => setShowDimensionGuidanceWarning(false),
              children: t("addDimensionGuidanceMessage")
            }
          ) })
        ] })
      }
    ),
    errors.missingPricesError && /* @__PURE__ */ jsx11(Alert3, { type: "error", dismissible: true, onDismiss: () => clearFieldError("missingPricesError"), children: errors.missingPricesError }),
    showEditorPanel && editingDimension && /* @__PURE__ */ jsx11(
      LayoutSplitPanel,
      {
        open: showEditorPanel,
        onToggle: (open) => setShowEditorPanel(open),
        onDismiss: () => setShowEditorPanel(false),
        onResize: (size) => setEditorPanelSize(size),
        closeBehavior: "hide",
        header: t("editGuidance"),
        size: editorPanelSize,
        children: /* @__PURE__ */ jsx11(DescriptionEditor, { dimension: editingDimension })
      }
    )
  ] });
};

// src/aipo/CreateConfig/components/OfferSettingsStep/OfferSettingsStep.tsx
import * as React7 from "react";
import Container7 from "@amzn/awsui-components-react/polaris/container";
import Header7 from "@amzn/awsui-components-react/polaris/header";
import FormField4 from "@amzn/awsui-components-react/polaris/form-field";
import Input3 from "@amzn/awsui-components-react/polaris/input";
import Select2 from "@amzn/awsui-components-react/polaris/select";
import Checkbox from "@amzn/awsui-components-react/polaris/checkbox";
import SpaceBetween11 from "@amzn/awsui-components-react/polaris/space-between";

// src/aipo/CreateConfig/utils/inputUtils.ts
var parseIntegerValue = (value) => {
  if (!value || value === "")
    return void 0;
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? void 0 : parsed;
};

// src/aipo/CreateConfig/components/OfferSettingsStep/OfferSettingsStep.tsx
import { Fragment as Fragment4, jsx as jsx12, jsxs as jsxs11 } from "react/jsx-runtime";
var monthsToISO8601 = (months2) => `P${months2}M`;
var iso8601ToMonths = (duration) => duration ? duration.slice(1, -1) : "";
var daysToISO8601 = (days) => `P${days}D`;
var iso8601ToDays = (duration) => duration ? duration.slice(1, -1) : "";
var OfferSettingsStep = ({
  writeableArtifact,
  errors,
  clearFieldError,
  setFieldError,
  onFdaEnabledChange,
  logger,
  t
}) => {
  const { artifact, setArtifact } = writeableArtifact;
  React7.useEffect(() => {
    logger.updateContext({ PageType: "AWSMP-EPO-Create-Config" });
    logger.updateContext({ SubPageType: "AWSMP-Configure-Offer-Settings" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, []);
  const minOfferDuration = iso8601ToMonths(artifact?.configurationRequest.minOfferDuration || "");
  const maxOfferDuration = iso8601ToMonths(artifact?.configurationRequest.maxOfferDuration || "");
  const eulaType = artifact?.configurationRequest.eulaType || "";
  const expiration = iso8601ToDays(artifact?.configurationRequest.expiration || "");
  const maxFutureStartDuration = iso8601ToDays(artifact?.configurationRequest.maxFutureStartDuration || "");
  const duration = artifact?.configurationRequest.maxFutureStartDuration;
  const fdaEnabled = duration !== void 0 && duration !== "P0D";
  const handleMinOfferDurationChange = (value) => {
    let newMinOfferDuration;
    let errorMessage;
    if (value === "") {
      newMinOfferDuration = "";
      errorMessage = void 0;
    } else {
      const integerValue = parseIntegerValue(value);
      if (integerValue !== void 0 && integerValue > 60) {
        errorMessage = "Minimum offer duration must not be greater than 60";
      } else {
        errorMessage = void 0;
      }
      newMinOfferDuration = integerValue !== void 0 && integerValue > 0 ? monthsToISO8601(integerValue) : "";
    }
    setFieldError("minOfferDurationError", errorMessage);
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        minOfferDuration: newMinOfferDuration
      }
    }));
  };
  const handleMaxOfferDurationChange = (value) => {
    let newMaxOfferDuration;
    let errorMessage;
    if (value === "") {
      newMaxOfferDuration = "";
      errorMessage = void 0;
    } else {
      const integerValue = parseIntegerValue(value);
      if (integerValue !== void 0 && integerValue > 60) {
        errorMessage = "Maximum offer duration must not be greater than 60.";
      } else {
        errorMessage = void 0;
      }
      newMaxOfferDuration = integerValue !== void 0 && integerValue > 0 ? monthsToISO8601(integerValue) : "";
    }
    setFieldError("maxOfferDurationError", errorMessage);
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        maxOfferDuration: newMaxOfferDuration
      }
    }));
  };
  const handleEulaTypeChange = (selectedOption) => {
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        eulaType: selectedOption.value || "PUBLIC_OFFER_EULA"
      }
    }));
    if (errors.eulaTypeError) {
      clearFieldError("eulaTypeError");
    }
  };
  const handleExpirationChange = (value) => {
    const integerValue = parseIntegerValue(value);
    if (value && integerValue !== void 0 && (integerValue < 1 || integerValue > 365)) {
      setFieldError("expirationError", "Adjust the value to ensure it is between 1 and 365 days.");
    } else {
      setFieldError("expirationError", void 0);
    }
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        expiration: (integerValue ?? 0) > 0 ? daysToISO8601(integerValue ?? 0) : ""
      }
    }));
  };
  const handleMaxFutureStartDurationChange = (value) => {
    const integerValue = parseIntegerValue(value);
    if (value && integerValue !== void 0 && integerValue > 365) {
      setFieldError("maxFutureStartDurationError", "Maximum range is 365 days.");
    } else {
      setFieldError("maxFutureStartDurationError", void 0);
    }
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        maxFutureStartDuration: (integerValue ?? 0) > 0 ? daysToISO8601(integerValue ?? 0) : ""
      }
    }));
  };
  const handleFdaEnabledChange = (checked) => {
    if (onFdaEnabledChange) {
      onFdaEnabledChange(checked);
    }
    if (checked) {
      setArtifact((prev) => ({
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          maxFutureStartDuration: ""
        }
      }));
    } else {
      setArtifact((prev) => ({
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          maxFutureStartDuration: daysToISO8601(0)
        }
      }));
      if (errors.maxFutureStartDurationError) {
        clearFieldError("maxFutureStartDurationError");
      }
    }
  };
  return /* @__PURE__ */ jsx12(Container7, { header: /* @__PURE__ */ jsx12(Header7, { variant: "h2", children: "Offer settings" }), children: /* @__PURE__ */ jsxs11(SpaceBetween11, { direction: "vertical", size: "l", children: [
    /* @__PURE__ */ jsxs11(SpaceBetween11, { direction: "horizontal", size: "l", children: [
      /* @__PURE__ */ jsx12(FormField4, { label: t("minimumOfferDurationInMonths"), errorText: errors.minOfferDurationError, children: /* @__PURE__ */ jsx12(
        Input3,
        {
          "data-testid": "min-offer-duration-input",
          value: minOfferDuration,
          onFocus: () => {
            logger.biMetric({
              metricName: "Click",
              dimensions: {
                ClickFeat: "offer-settings",
                ClickAct: "minimum-offer-duration"
              },
              value: 1,
              unit: "Count"
            });
          },
          onChange: ({ detail }) => handleMinOfferDurationChange(detail.value),
          type: "number",
          placeholder: t("enterDuration"),
          invalid: !!errors.minOfferDurationError
        }
      ) }),
      /* @__PURE__ */ jsx12(FormField4, { label: t("maximumOfferDurationInMonths"), errorText: errors.maxOfferDurationError, children: /* @__PURE__ */ jsx12(
        Input3,
        {
          "data-testid": "max-offer-duration-input",
          value: maxOfferDuration,
          onFocus: () => {
            logger.biMetric({
              metricName: "Click",
              dimensions: {
                ClickFeat: "offer-settings",
                ClickAct: "maximum-offer-duration"
              },
              value: 1,
              unit: "Count"
            });
          },
          onChange: ({ detail }) => handleMaxOfferDurationChange(detail.value),
          type: "number",
          placeholder: t("enterDuration"),
          invalid: !!errors.maxOfferDurationError
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx12(
      FormField4,
      {
        label: t("offerExpirationDurationInDays"),
        description: t("offerExpirationDurationDescription"),
        constraintText: t("offerExpirationDurationConstraint"),
        errorText: errors.expirationError,
        children: /* @__PURE__ */ jsx12(
          Input3,
          {
            "data-testid": "offer-expiration-input",
            value: expiration,
            onFocus: () => {
              logger.biMetric({
                metricName: "Click",
                dimensions: {
                  ClickFeat: "offer-settings",
                  ClickAct: "offer-expiration-duration"
                },
                value: 1,
                unit: "Count"
              });
            },
            onChange: ({ detail }) => handleExpirationChange(detail.value),
            type: "number",
            placeholder: t("enterExpirationDuration"),
            invalid: !!errors.expirationError
          }
        )
      }
    ),
    /* @__PURE__ */ jsx12(
      FormField4,
      {
        label: /* @__PURE__ */ jsxs11(Fragment4, { children: [
          /* @__PURE__ */ jsx12("b", { children: t("futureDatedAgreementFda") }),
          " - ",
          /* @__PURE__ */ jsx12("i", { children: t("optional") })
        ] }),
        description: t("futureDatedAgreementFdaDescription"),
        children: /* @__PURE__ */ jsx12(Checkbox, { "data-testid": "fda-checkbox", checked: fdaEnabled, onChange: ({ detail }) => handleFdaEnabledChange(detail.checked), children: t("enableFdaForCustomers") })
      }
    ),
    fdaEnabled && /* @__PURE__ */ jsx12(
      FormField4,
      {
        label: t("fdaValidityRangeInDays"),
        description: t("fdaValidityRangeDescription"),
        constraintText: t("fdaValidityRangeConstraint"),
        errorText: errors.maxFutureStartDurationError,
        children: /* @__PURE__ */ jsx12(
          Input3,
          {
            "data-testid": "fda-validity-range-input",
            value: maxFutureStartDuration,
            onFocus: () => {
              logger.biMetric({
                metricName: "Click",
                dimensions: {
                  ClickFeat: "offer-settings",
                  ClickAct: "max-future-start-duration"
                },
                value: 1,
                unit: "Count"
              });
            },
            onChange: ({ detail }) => handleMaxFutureStartDurationChange(detail.value),
            type: "number",
            placeholder: t("enterNumberOfDays"),
            invalid: !!errors.maxFutureStartDurationError
          }
        )
      }
    ),
    /* @__PURE__ */ jsx12(FormField4, { label: t("endUserLicenseAgreement"), description: t("eulaDescription"), errorText: errors.eulaTypeError, children: /* @__PURE__ */ jsx12(
      Select2,
      {
        "data-testid": "eula-type-select",
        selectedOption: eulaType === "PUBLIC_OFFER_EULA" ? { label: t("publicOfferEula"), value: "PUBLIC_OFFER_EULA" } : eulaType === "STANDARD_CONTRACT_MARKETPLACE" ? { label: t("standardContractForMarketplace"), value: "STANDARD_CONTRACT_MARKETPLACE" } : null,
        onChange: ({ detail }) => {
          logger.biMetric({
            metricName: "Click",
            dimensions: {
              ClickFeat: "offer-settings",
              ClickAct: "eula-type-dropdown"
            },
            value: 1,
            unit: "Count"
          });
          handleEulaTypeChange(detail.selectedOption);
        },
        options: [
          { label: t("publicOfferEula"), value: "PUBLIC_OFFER_EULA" },
          { label: t("standardContractForMarketplace"), value: "STANDARD_CONTRACT_MARKETPLACE" }
        ],
        placeholder: t("selectEula"),
        invalid: !!errors.eulaTypeError
      }
    ) })
  ] }) });
};

// src/aipo/CreateConfig/components/AdditionalInformationStep/validation.ts
var validateAdditionalInformationStep = (artifact, t) => {
  const errorProps = {};
  if (!artifact) {
    return { isValid: false, errorProps: {} };
  }
  const dimensionRates = artifact.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates || [];
  const missingPrices = dimensionRates.filter((dimension) => dimension.price === null || dimension.price === void 0 || dimension.price <= 0);
  if (missingPrices.length > 0) {
    errorProps.missingPricesError = t("validationMissingPrices");
  }
  return {
    isValid: Object.keys(errorProps).length === 0,
    errorProps
  };
};

// src/aipo/CreateConfig/components/OfferSettingsStep/validation.ts
var iso8601ToMonths2 = (duration) => duration ? parseInt(duration.slice(1, -1), 10) : 0;
var validateOfferSettingsStep = (artifact, t, fdaEnabled) => {
  if (!artifact) {
    return { isValid: true, errorProps: {} };
  }
  const errorProps = {};
  let isValid = true;
  if (!artifact.configurationRequest.minOfferDuration) {
    errorProps.minOfferDurationError = t("validationMinOfferDurationRequired");
    isValid = false;
  }
  if (!artifact.configurationRequest.maxOfferDuration) {
    errorProps.maxOfferDurationError = t("validationMaxOfferDurationRequired");
    isValid = false;
  }
  if (!artifact.configurationRequest.eulaType) {
    errorProps.eulaTypeError = t("validationEulaRequired");
    isValid = false;
  }
  if (!artifact.configurationRequest.expiration) {
    errorProps.expirationError = t("validationOfferExpirationRequired");
    isValid = false;
  }
  if (fdaEnabled && !artifact.configurationRequest.maxFutureStartDuration) {
    errorProps.maxFutureStartDurationError = t("validationFdaRequired");
    isValid = false;
  }
  if (artifact.configurationRequest.minOfferDuration) {
    const minMonths = iso8601ToMonths2(artifact.configurationRequest.minOfferDuration);
    if (minMonths > 60) {
      errorProps.minOfferDurationError = t("validationMinOfferDurationLimit");
      isValid = false;
    }
  }
  if (artifact.configurationRequest.maxOfferDuration) {
    const maxMonths = iso8601ToMonths2(artifact.configurationRequest.maxOfferDuration);
    if (maxMonths > 60) {
      errorProps.maxOfferDurationError = t("validationMaxOfferDurationLimit");
      isValid = false;
    }
  }
  if (artifact.configurationRequest.minOfferDuration && artifact.configurationRequest.maxOfferDuration) {
    const minMonths = iso8601ToMonths2(artifact.configurationRequest.minOfferDuration);
    const maxMonths = iso8601ToMonths2(artifact.configurationRequest.maxOfferDuration);
    if (minMonths > maxMonths) {
      errorProps.maxOfferDurationError = t("validationMaxOfferDurationGreaterThanMin");
      isValid = false;
    }
  }
  return {
    isValid,
    errorProps
  };
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/DiscountStrategyStep.tsx
import * as React11 from "react";
import Container12 from "@amzn/awsui-components-react/polaris/container";
import Header11 from "@amzn/awsui-components-react/polaris/header";
import FormField7 from "@amzn/awsui-components-react/polaris/form-field";
import Input6 from "@amzn/awsui-components-react/polaris/input";
import Checkbox2 from "@amzn/awsui-components-react/polaris/checkbox";
import Alert7 from "@amzn/awsui-components-react/polaris/alert";
import SpaceBetween16 from "@amzn/awsui-components-react/polaris/space-between";
import Icon5 from "@amzn/awsui-components-react/polaris/icon";
import Popover2 from "@amzn/awsui-components-react/polaris/popover";
import KeyValuePairs4 from "@amzn/awsui-components-react/polaris/key-value-pairs";
import TextContent11 from "@cloudscape-design/components/text-content";

// src/aipo/CreateConfig/components/DiscountStrategyStep/DiscountStrategyStep.module.css
var DiscountStrategyStep_default = {
  buyerProfileLabel: "DiscountStrategyStep_buyerProfileLabel",
  aiIcon: "DiscountStrategyStep_aiIcon",
  aiAssisted: "DiscountStrategyStep_aiAssisted",
  generatedByAi: "DiscountStrategyStep_generatedByAi",
  dimensionSeparator: "DiscountStrategyStep_dimensionSeparator",
  innerQuestionnaireContainer: "DiscountStrategyStep_innerQuestionnaireContainer",
  askQuestionButtonContainer: "DiscountStrategyStep_askQuestionButtonContainer"
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/PerDimensionDiscountEditor.tsx
import * as React8 from "react";
import Container8 from "@amzn/awsui-components-react/polaris/container";
import Header8 from "@amzn/awsui-components-react/polaris/header";
import Input4 from "@amzn/awsui-components-react/polaris/input";
import Alert4 from "@amzn/awsui-components-react/polaris/alert";
import SpaceBetween12 from "@amzn/awsui-components-react/polaris/space-between";
import TextContent7 from "@cloudscape-design/components/text-content";
import AttributeEditor from "@cloudscape-design/components/attribute-editor";

// src/aipo/CreateConfig/components/DiscountStrategyStep/discountValidationHelpers.ts
var rangesOverlap = (range1, range2) => {
  const r1HasBoth = range1.minValue !== null && range1.maxValue !== null;
  const r2HasBoth = range2.minValue !== null && range2.maxValue !== null;
  if (r1HasBoth && r2HasBoth) {
    return range1.minValue <= range2.maxValue && range2.minValue <= range1.maxValue;
  }
  if (r1HasBoth) {
    return range2.minValue !== null && range2.minValue >= range1.minValue && range2.minValue <= range1.maxValue || range2.maxValue !== null && range2.maxValue >= range1.minValue && range2.maxValue <= range1.maxValue;
  }
  if (r2HasBoth) {
    return range1.minValue !== null && range1.minValue >= range2.minValue && range1.minValue <= range2.maxValue || range1.maxValue !== null && range1.maxValue >= range2.minValue && range1.maxValue <= range2.maxValue;
  }
  return range1.minValue !== null && range2.minValue !== null && range1.maxValue === null && range2.maxValue === null && range1.minValue === range2.minValue || range1.maxValue !== null && range2.maxValue !== null && range1.minValue === null && range2.minValue === null && range1.maxValue === range2.maxValue;
};
var detectRangeErrors = (prefix, tiers, t) => {
  const errorFlags = {};
  const errorMessages = {};
  if (!tiers || tiers.length === 0) {
    return { errorFlags, errorMessages };
  }
  for (let i = 0; i < tiers.length; i++) {
    const tier = tiers[i];
    if (tier.minValue !== null && typeof tier.minValue === "number" && tier.minValue < 0) {
      const key = `${prefix}-${i}-minValue`;
      errorFlags[key] = true;
      errorMessages[key] = t("validationMinimumValueMustBeZeroOrAbove");
    }
    if (tier.minValue !== null && tier.maxValue !== null && typeof tier.minValue === "number" && typeof tier.maxValue === "number" && tier.maxValue < tier.minValue) {
      const key = `${prefix}-${i}-maxValue-range`;
      errorFlags[key] = true;
      errorMessages[key] = t("validationAdjustMaxValueLargerThanMin");
    }
  }
  if (tiers.length < 2) {
    return { errorFlags, errorMessages };
  }
  for (let i = 0; i < tiers.length - 1; i++) {
    const tierA = tiers[i];
    for (let j = i + 1; j < tiers.length; j++) {
      const tierB = tiers[j];
      if (rangesOverlap(tierA, tierB)) {
        const overlappingTiers = [
          { tier: tierA, index: i },
          { tier: tierB, index: j }
        ];
        overlappingTiers.forEach(({ tier, index }) => {
          if (tier.minValue !== null) {
            const key = `${prefix}-${index}-minValue`;
            if (!errorMessages[key]) {
              errorFlags[key] = true;
              errorMessages[key] = t("validationAdjustValueNoRangesOverlap");
            }
          }
          if (tier.maxValue !== null) {
            const key = `${prefix}-${index}-maxValue`;
            if (!errorMessages[key]) {
              errorFlags[key] = true;
              errorMessages[key] = t("validationAdjustValueNoRangesOverlap");
            }
          }
        });
      }
    }
  }
  return { errorFlags, errorMessages };
};
var getErrorText = (errorMessages, key) => {
  return errorMessages[key] || void 0;
};
var getIncompleteFieldError = (value, fieldType, t) => {
  if (value === null || value === void 0) {
    return fieldType === "quantity" ? t("validationUnitQuantityRequired") : t("validationDiscountRequired");
  }
  return void 0;
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/PerDimensionDiscountEditor.tsx
import { jsx as jsx13, jsxs as jsxs12 } from "react/jsx-runtime";
var PerDimensionDiscountEditor = ({
  writeableArtifact,
  productDimensions,
  clearFieldError,
  showFieldErrors,
  logger,
  t
  // openHelpPanel,
}) => {
  const { artifact, setArtifact, isArtifactLocked } = writeableArtifact;
  const discountStrategy = artifact?.configurationRequest.discountStrategy;
  const availableDimensions = React8.useMemo(() => {
    return artifact?.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates?.map((rate) => {
      const realDimension = productDimensions.get(rate.dimensionKey);
      return {
        key: rate.dimensionKey,
        name: realDimension?.dimension || rate.dimensionKey
      };
    }) || [];
  }, [artifact?.configurationRequest.configurableUpfrontDimensionRates, productDimensions]);
  const dimensionTiers = React8.useMemo(() => {
    if (!discountStrategy || discountStrategy.strategy !== "PER_DIMENSION_TCV" && discountStrategy.strategy !== "PER_DIMENSION_TCV_WITH_QUALIFICATION") {
      return {};
    }
    const tiers = discountStrategy.perDimensionTcvTiers || {};
    const result = {};
    Object.entries(tiers).forEach(([dimensionKey, tierArray]) => {
      result[dimensionKey] = tierArray.map((tier, index) => ({
        id: `${dimensionKey}-${index}`,
        minValue: tier.minValue,
        maxValue: tier.maxValue,
        discountPercentage: tier.discountPercentage
      }));
    });
    return result;
  }, [discountStrategy]);
  const perDimensionValidationCache = React8.useMemo(() => {
    const cache = {};
    Object.entries(dimensionTiers).forEach(([dimensionKey, tiers]) => {
      const tierData = tiers.map((tier) => ({
        minValue: tier.minValue,
        maxValue: tier.maxValue,
        discountPercentage: tier.discountPercentage
      }));
      cache[dimensionKey] = detectRangeErrors(dimensionKey, tierData, t);
    });
    return cache;
  }, [dimensionTiers]);
  const getTotalPerDimensionTierCount = React8.useMemo(() => {
    let totalTiers = 0;
    Object.values(dimensionTiers).forEach((tiers) => {
      totalTiers += tiers.length;
    });
    return totalTiers;
  }, [dimensionTiers]);
  const isPerDimensionTierLimitExceeded = getTotalPerDimensionTierCount >= 25;
  const handleUpdatePerDimensionTier = (dimensionKey, tierIndex, field, value) => {
    if (clearFieldError) {
      clearFieldError("perDimensionError");
    }
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy || prev.configurationRequest.discountStrategy.strategy !== "PER_DIMENSION_TCV" && prev.configurationRequest.discountStrategy.strategy !== "PER_DIMENSION_TCV_WITH_QUALIFICATION") {
        return prev;
      }
      const updatedTiers = { ...prev.configurationRequest.discountStrategy.perDimensionTcvTiers };
      if (!updatedTiers[dimensionKey]) {
        updatedTiers[dimensionKey] = [];
      }
      const tiersCopy = [...updatedTiers[dimensionKey]];
      if (tiersCopy[tierIndex]) {
        tiersCopy[tierIndex] = {
          minValue: tiersCopy[tierIndex].minValue,
          maxValue: tiersCopy[tierIndex].maxValue,
          discountPercentage: tiersCopy[tierIndex].discountPercentage,
          [field]: value === "" ? null : parseIntegerValue(value)
        };
        updatedTiers[dimensionKey] = tiersCopy;
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            perDimensionTcvTiers: updatedTiers
          }
        }
      };
    });
  };
  const handleAddPerDimensionTier = (dimensionKey, dimensionName) => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "per-dimension-config",
        ClickObj: "add-new-range",
        ClickAct: dimensionName
      },
      value: 1,
      unit: "Count"
    });
    if (clearFieldError) {
      clearFieldError("perDimensionError");
    }
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy || prev.configurationRequest.discountStrategy.strategy !== "PER_DIMENSION_TCV" && prev.configurationRequest.discountStrategy.strategy !== "PER_DIMENSION_TCV_WITH_QUALIFICATION") {
        return prev;
      }
      const updatedTiers = { ...prev.configurationRequest.discountStrategy.perDimensionTcvTiers };
      if (!updatedTiers[dimensionKey]) {
        updatedTiers[dimensionKey] = [];
      }
      const tiersCopy = [...updatedTiers[dimensionKey]];
      if (tiersCopy.length < 5) {
        tiersCopy.push({
          minValue: null,
          maxValue: null,
          discountPercentage: null
        });
        updatedTiers[dimensionKey] = tiersCopy;
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            perDimensionTcvTiers: updatedTiers
          }
        }
      };
    });
  };
  const handleRemovePerDimensionTier = (dimensionKey, tierIndex, dimensionName) => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "per-dimension-config",
        ClickObj: "remove",
        ClickAct: dimensionName
      },
      value: 1,
      unit: "Count"
    });
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy || prev.configurationRequest.discountStrategy.strategy !== "PER_DIMENSION_TCV" && prev.configurationRequest.discountStrategy.strategy !== "PER_DIMENSION_TCV_WITH_QUALIFICATION") {
        return prev;
      }
      const updatedTiers = { ...prev.configurationRequest.discountStrategy.perDimensionTcvTiers };
      if (updatedTiers[dimensionKey]) {
        const tiersCopy = [...updatedTiers[dimensionKey]];
        tiersCopy.splice(tierIndex, 1);
        updatedTiers[dimensionKey] = tiersCopy;
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            perDimensionTcvTiers: updatedTiers
          }
        }
      };
    });
  };
  return /* @__PURE__ */ jsx13(
    Container8,
    {
      header: /* @__PURE__ */ jsx13(
        Header8,
        {
          variant: "h2",
          description: t("perDimensionDiscountsEditorDescription"),
          children: t("perDimensionDiscountsHeader")
        }
      ),
      children: /* @__PURE__ */ jsxs12(SpaceBetween12, { direction: "vertical", size: "l", children: [
        /* @__PURE__ */ jsx13(Alert4, { type: "info", children: t("perDimensionDefaultDiscountInfo") }),
        availableDimensions.map((dimension, dimensionIndex) => /* @__PURE__ */ jsxs12("div", { children: [
          /* @__PURE__ */ jsxs12(SpaceBetween12, { size: "l", children: [
            /* @__PURE__ */ jsxs12(TextContent7, { children: [
              /* @__PURE__ */ jsx13("strong", { children: t("dimensionName") }),
              /* @__PURE__ */ jsx13("p", { children: dimension.name })
            ] }),
            /* @__PURE__ */ jsx13(
              AttributeEditor,
              {
                items: dimensionTiers[dimension.key] || [],
                onAddButtonClick: () => handleAddPerDimensionTier(dimension.key, dimension.name),
                onRemoveButtonClick: ({ detail }) => handleRemovePerDimensionTier(dimension.key, detail.itemIndex, dimension.name),
                isItemRemovable: () => getTotalPerDimensionTierCount > 1,
                definition: [
                  {
                    label: t("minimumUnitQuantity"),
                    errorText: (item, itemIndex) => {
                      const cache = perDimensionValidationCache[dimension.key];
                      const overlapError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-minValue`) : void 0;
                      const rangeError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-minValue-range`) : void 0;
                      const incompleteError = showFieldErrors ? getIncompleteFieldError(item.minValue, "quantity", t) : void 0;
                      return overlapError || rangeError || incompleteError;
                    },
                    control: (item, itemIndex) => {
                      const cache = perDimensionValidationCache[dimension.key];
                      const overlapError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-minValue`) : void 0;
                      const rangeError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-minValue-range`) : void 0;
                      const incompleteError = showFieldErrors ? getIncompleteFieldError(item.minValue, "quantity", t) : void 0;
                      const hasError = !!(overlapError || rangeError || incompleteError);
                      return /* @__PURE__ */ jsx13(
                        Input4,
                        {
                          value: item.minValue?.toString() || "",
                          onFocus: () => {
                            logger.biMetric({
                              metricName: "Click",
                              dimensions: {
                                ClickFeat: "per-dimension-config",
                                ClickObj: "from-unit-input",
                                ClickAct: dimension.name
                              },
                              value: 1,
                              unit: "Count"
                            });
                          },
                          onChange: ({ detail }) => handleUpdatePerDimensionTier(dimension.key, itemIndex, "minValue", detail.value),
                          type: "number",
                          placeholder: "Enter unit quantity",
                          invalid: hasError,
                          disabled: isArtifactLocked
                        }
                      );
                    }
                  },
                  {
                    label: t("maximumUnitQuantity"),
                    errorText: (item, itemIndex) => {
                      const cache = perDimensionValidationCache[dimension.key];
                      const overlapError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-maxValue`) : void 0;
                      const rangeError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-maxValue-range`) : void 0;
                      const incompleteError = showFieldErrors ? getIncompleteFieldError(item.maxValue, "quantity", t) : void 0;
                      return overlapError || rangeError || incompleteError;
                    },
                    control: (item, itemIndex) => {
                      const cache = perDimensionValidationCache[dimension.key];
                      const overlapError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-maxValue`) : void 0;
                      const rangeError = cache ? getErrorText(cache.errorMessages, `${dimension.key}-${itemIndex}-maxValue-range`) : void 0;
                      const incompleteError = showFieldErrors ? getIncompleteFieldError(item.maxValue, "quantity", t) : void 0;
                      const hasError = !!(overlapError || rangeError || incompleteError);
                      return /* @__PURE__ */ jsx13(
                        Input4,
                        {
                          value: item.maxValue?.toString() || "",
                          onFocus: () => {
                            logger.biMetric({
                              metricName: "Click",
                              dimensions: {
                                ClickFeat: "per-dimension-config",
                                ClickObj: "to-unit-input",
                                ClickAct: dimension.name
                              },
                              value: 1,
                              unit: "Count"
                            });
                          },
                          onChange: ({ detail }) => handleUpdatePerDimensionTier(dimension.key, itemIndex, "maxValue", detail.value),
                          type: "number",
                          placeholder: t("enterUnitQuantity"),
                          invalid: hasError,
                          disabled: isArtifactLocked
                        }
                      );
                    }
                  },
                  {
                    label: t("discountPercentage"),
                    errorText: (item) => {
                      const invalidDiscountError = item.discountPercentage !== null && item.discountPercentage >= 100 ? t("discountPercentageMustBeBelowHundred") : item.discountPercentage !== null && item.discountPercentage <= 0 ? t("discountPercentageMustBeGreaterThanZero") : void 0;
                      const incompleteError = showFieldErrors ? getIncompleteFieldError(item.discountPercentage, "discount", t) : void 0;
                      return invalidDiscountError || incompleteError;
                    },
                    control: (item, itemIndex) => {
                      const invalidDiscountError = item.discountPercentage !== null && (item.discountPercentage >= 100 || item.discountPercentage <= 0);
                      const incompleteError = showFieldErrors ? getIncompleteFieldError(item.discountPercentage, "discount", t) : void 0;
                      return /* @__PURE__ */ jsx13(
                        Input4,
                        {
                          value: item.discountPercentage?.toString() || "",
                          onFocus: () => {
                            logger.biMetric({
                              metricName: "Click",
                              dimensions: {
                                ClickFeat: "per-dimension-config",
                                ClickObj: "discount-input",
                                ClickAct: dimension.name
                              },
                              value: 1,
                              unit: "Count"
                            });
                          },
                          onChange: ({ detail }) => handleUpdatePerDimensionTier(dimension.key, itemIndex, "discountPercentage", detail.value),
                          type: "number",
                          placeholder: t("enterDiscount"),
                          invalid: !!(invalidDiscountError || incompleteError),
                          disabled: isArtifactLocked
                        }
                      );
                    }
                  }
                ],
                addButtonText: t("addNewTier"),
                removeButtonText: t("remove"),
                empty: t("noDiscountTierForDimension"),
                disableAddButton: isPerDimensionTierLimitExceeded || (dimensionTiers[dimension.key] || []).length >= 5 || isArtifactLocked,
                gridLayout: [
                  {
                    rows: [[2, 2, 2]],
                    breakpoint: "s"
                  },
                  {
                    rows: [[1], [1], [1]],
                    removeButton: { ownRow: true }
                  }
                ],
                additionalInfo: /* @__PURE__ */ jsx13(TextContent7, { children: /* @__PURE__ */ jsx13("small", { children: isPerDimensionTierLimitExceeded ? t("perDimensionTierLimitExceeded") : (dimensionTiers[dimension.key] || []).length >= 5 ? t("perDimensionTierLimitReached", { count: getTotalPerDimensionTierCount }) : t("perDimensionTiersAvailable", {
                  available: 5 - (dimensionTiers[dimension.key] || []).length,
                  count: getTotalPerDimensionTierCount
                }) }) })
              }
            )
          ] }),
          dimensionIndex < availableDimensions.length - 1 && /* @__PURE__ */ jsx13("hr", { className: DiscountStrategyStep_default.dimensionSeparator })
        ] }, dimension.key))
      ] })
    }
  );
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/TcvDiscountEditor.tsx
import * as React9 from "react";
import Container9 from "@amzn/awsui-components-react/polaris/container";
import Header9 from "@amzn/awsui-components-react/polaris/header";
import Input5 from "@amzn/awsui-components-react/polaris/input";
import Alert5 from "@amzn/awsui-components-react/polaris/alert";
import SpaceBetween13 from "@amzn/awsui-components-react/polaris/space-between";
import TextContent8 from "@cloudscape-design/components/text-content";
import AttributeEditor2 from "@cloudscape-design/components/attribute-editor";
import { jsx as jsx14, jsxs as jsxs13 } from "react/jsx-runtime";
var TcvDiscountEditor = ({
  writeableArtifact,
  clearFieldError,
  showFieldErrors,
  logger,
  t
  // openHelpPanel,
}) => {
  const { artifact, setArtifact, isArtifactLocked } = writeableArtifact;
  const discountStrategy = artifact?.configurationRequest.discountStrategy;
  const tcvTiers = React9.useMemo(() => {
    if (!discountStrategy || discountStrategy.strategy !== "TOTAL_TCV" && discountStrategy.strategy !== "TOTAL_TCV_WITH_QUALIFICATION") {
      return [];
    }
    return discountStrategy.totalTcvTiers?.map((tier, index) => ({
      id: `tcv-${index}`,
      minValue: tier.minValue,
      maxValue: tier.maxValue,
      discountPercentage: tier.discountPercentage
    })) || [];
  }, [discountStrategy]);
  const tcvValidationCache = React9.useMemo(() => {
    const tierData = tcvTiers.map((tier) => ({
      minValue: tier.minValue,
      maxValue: tier.maxValue,
      discountPercentage: tier.discountPercentage
    }));
    return detectRangeErrors("tcv", tierData, t);
  }, [tcvTiers, t]);
  const handleUpdateTcvTier = (tierIndex, field, value) => {
    if (clearFieldError) {
      clearFieldError("tcvDiscountsError");
    }
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy || prev.configurationRequest.discountStrategy.strategy !== "TOTAL_TCV" && prev.configurationRequest.discountStrategy.strategy !== "TOTAL_TCV_WITH_QUALIFICATION") {
        return prev;
      }
      const tiersCopy = [...prev.configurationRequest.discountStrategy.totalTcvTiers || []];
      if (tiersCopy[tierIndex]) {
        tiersCopy[tierIndex] = {
          ...tiersCopy[tierIndex],
          [field]: value === "" ? null : parseIntegerValue(value)
        };
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            totalTcvTiers: tiersCopy
          }
        }
      };
    });
  };
  const handleAddTcvTier = () => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "tcv-config",
        ClickObj: "add-new-range",
        ClickAct: "tcv"
      },
      value: 1,
      unit: "Count"
    });
    if (clearFieldError) {
      clearFieldError("tcvDiscountsError");
    }
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy || prev.configurationRequest.discountStrategy.strategy !== "TOTAL_TCV" && prev.configurationRequest.discountStrategy.strategy !== "TOTAL_TCV_WITH_QUALIFICATION") {
        return prev;
      }
      const tiersCopy = [...prev.configurationRequest.discountStrategy.totalTcvTiers || []];
      if (tiersCopy.length < 10) {
        tiersCopy.push({
          minValue: null,
          maxValue: null,
          discountPercentage: null
        });
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            totalTcvTiers: tiersCopy
          }
        }
      };
    });
  };
  const handleRemoveTcvTier = (tierIndex) => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "tcv-config",
        ClickObj: "remove",
        ClickAct: "tcv"
      },
      value: 1,
      unit: "Count"
    });
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy || prev.configurationRequest.discountStrategy.strategy !== "TOTAL_TCV" && prev.configurationRequest.discountStrategy.strategy !== "TOTAL_TCV_WITH_QUALIFICATION") {
        return prev;
      }
      const tiersCopy = [...prev.configurationRequest.discountStrategy.totalTcvTiers || []];
      tiersCopy.splice(tierIndex, 1);
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            totalTcvTiers: tiersCopy
          }
        }
      };
    });
  };
  return /* @__PURE__ */ jsx14(
    Container9,
    {
      header: /* @__PURE__ */ jsx14(
        Header9,
        {
          variant: "h2",
          description: t("tcvDiscountStrategyDescription"),
          children: t("tcvDiscountStrategyHeader")
        }
      ),
      children: /* @__PURE__ */ jsxs13(SpaceBetween13, { direction: "vertical", size: "l", children: [
        /* @__PURE__ */ jsx14(Alert5, { type: "info", children: t("tcvDefaultDiscountInfo") }),
        /* @__PURE__ */ jsx14(
          AttributeEditor2,
          {
            items: tcvTiers,
            onAddButtonClick: handleAddTcvTier,
            onRemoveButtonClick: ({ detail }) => handleRemoveTcvTier(detail.itemIndex),
            isItemRemovable: () => tcvTiers.length > 1,
            definition: [
              {
                label: t("minimumValueUsd"),
                errorText: (item, itemIndex) => {
                  const overlapError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-minValue`);
                  const rangeError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-minValue-range`);
                  const incompleteError = showFieldErrors ? getIncompleteFieldError(item.minValue, "quantity", t) : void 0;
                  return overlapError || rangeError || incompleteError;
                },
                control: (item, itemIndex) => {
                  const overlapError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-minValue`);
                  const rangeError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-minValue-range`);
                  const incompleteError = showFieldErrors ? getIncompleteFieldError(item.minValue, "quantity", t) : void 0;
                  const hasError = !!(overlapError || rangeError || incompleteError);
                  return /* @__PURE__ */ jsx14(
                    Input5,
                    {
                      value: item.minValue?.toString() || "",
                      onFocus: () => {
                        logger.biMetric({
                          metricName: "Click",
                          dimensions: {
                            ClickFeat: "tcv-config",
                            ClickAct: "tcv-from-range"
                          },
                          value: 1,
                          unit: "Count"
                        });
                      },
                      onChange: ({ detail }) => handleUpdateTcvTier(itemIndex, "minValue", detail.value),
                      type: "number",
                      placeholder: t("enterAmount"),
                      invalid: hasError,
                      disabled: isArtifactLocked
                    }
                  );
                }
              },
              {
                label: t("maximumValueUsd"),
                errorText: (item, itemIndex) => {
                  const overlapError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-maxValue`);
                  const rangeError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-maxValue-range`);
                  const incompleteError = showFieldErrors ? getIncompleteFieldError(item.maxValue, "quantity", t) : void 0;
                  return overlapError || rangeError || incompleteError;
                },
                control: (item, itemIndex) => {
                  const overlapError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-maxValue`);
                  const rangeError = getErrorText(tcvValidationCache.errorMessages, `tcv-${itemIndex}-maxValue-range`);
                  const incompleteError = showFieldErrors ? getIncompleteFieldError(item.maxValue, "quantity", t) : void 0;
                  const hasError = !!(overlapError || rangeError || incompleteError);
                  return /* @__PURE__ */ jsx14(
                    Input5,
                    {
                      value: item.maxValue?.toString() || "",
                      onFocus: () => {
                        logger.biMetric({
                          metricName: "Click",
                          dimensions: {
                            ClickFeat: "tcv-config",
                            ClickAct: "tcv-to-range"
                          },
                          value: 1,
                          unit: "Count"
                        });
                      },
                      onChange: ({ detail }) => handleUpdateTcvTier(itemIndex, "maxValue", detail.value),
                      type: "number",
                      placeholder: t("enterAmount"),
                      invalid: hasError,
                      disabled: isArtifactLocked
                    }
                  );
                }
              },
              {
                label: t("discountPercentage"),
                errorText: (item) => {
                  const invalidDiscountError = item.discountPercentage !== null && item.discountPercentage >= 100 ? t("discountPercentageMustBeBelowHundred") : item.discountPercentage !== null && item.discountPercentage <= 0 ? t("discountPercentageMustBeGreaterThanZero") : void 0;
                  const incompleteError = showFieldErrors ? getIncompleteFieldError(item.discountPercentage, "discount", t) : void 0;
                  return invalidDiscountError || incompleteError;
                },
                control: (item, itemIndex) => {
                  const invalidDiscountError = item.discountPercentage !== null && (item.discountPercentage >= 100 || item.discountPercentage <= 0);
                  const incompleteError = showFieldErrors ? getIncompleteFieldError(item.discountPercentage, "discount", t) : void 0;
                  return /* @__PURE__ */ jsx14(
                    Input5,
                    {
                      value: item.discountPercentage?.toString() || "",
                      onFocus: () => {
                        logger.biMetric({
                          metricName: "Click",
                          dimensions: {
                            ClickFeat: "tcv-config",
                            ClickAct: "tcv-discount-percentage"
                          },
                          value: 1,
                          unit: "Count"
                        });
                      },
                      onChange: ({ detail }) => handleUpdateTcvTier(itemIndex, "discountPercentage", detail.value),
                      type: "number",
                      placeholder: t("enterDiscount"),
                      invalid: !!(invalidDiscountError || incompleteError),
                      disabled: isArtifactLocked
                    }
                  );
                }
              }
            ],
            addButtonText: t("addNewTier"),
            removeButtonText: t("remove"),
            empty: t("noDiscountTiersConfigured"),
            disableAddButton: tcvTiers.length >= 10 || isArtifactLocked,
            gridLayout: [
              {
                rows: [[2, 2, 2]],
                breakpoint: "s"
              },
              {
                rows: [[1], [1], [1]],
                removeButton: { ownRow: true }
              }
            ],
            additionalInfo: /* @__PURE__ */ jsx14(TextContent8, { children: /* @__PURE__ */ jsx14("small", { children: tcvTiers.length >= 10 ? t("tcvTierLimitReached") : t("tcvTiersAvailable", { available: 10 - tcvTiers.length }) }) })
          }
        )
      ] })
    }
  );
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/BuyerProfileEditor.tsx
import * as React10 from "react";
import Container11 from "@amzn/awsui-components-react/polaris/container";
import Header10 from "@amzn/awsui-components-react/polaris/header";
import Button9 from "@amzn/awsui-components-react/polaris/button";
import Select3 from "@amzn/awsui-components-react/polaris/select";
import Textarea4 from "@amzn/awsui-components-react/polaris/textarea";
import FormField6 from "@amzn/awsui-components-react/polaris/form-field";
import Alert6 from "@amzn/awsui-components-react/polaris/alert";
import Icon4 from "@amzn/awsui-components-react/polaris/icon";
import SpaceBetween15 from "@amzn/awsui-components-react/polaris/space-between";
import TextContent10 from "@cloudscape-design/components/text-content";
import Grid from "@cloudscape-design/components/grid";
import { MaxTokenData as MaxTokenData3, GrantAction as GrantAction3 } from "@amzn/awsmp-max-data";

// src/aipo/CreateConfig/components/DiscountStrategyStep/QuestionnairePreviewModal.tsx
import Modal from "@amzn/awsui-components-react/polaris/modal";
import Box4 from "@amzn/awsui-components-react/polaris/box";
import Button8 from "@amzn/awsui-components-react/polaris/button";
import SpaceBetween14 from "@amzn/awsui-components-react/polaris/space-between";
import TextContent9 from "@cloudscape-design/components/text-content";
import Icon3 from "@amzn/awsui-components-react/polaris/icon";
import Container10 from "@amzn/awsui-components-react/polaris/container";
import FormField5 from "@amzn/awsui-components-react/polaris/form-field";
import Textarea3 from "@amzn/awsui-components-react/polaris/textarea";
import { Fragment as Fragment5, jsx as jsx15, jsxs as jsxs14 } from "react/jsx-runtime";
var QuestionnairePreviewModal = ({ visible, onDismiss, questions, logger, t }) => {
  return /* @__PURE__ */ jsx15(
    Modal,
    {
      className: "awsui-visual-refresh",
      visible,
      onDismiss,
      size: "max",
      header: /* @__PURE__ */ jsxs14(Fragment5, { children: [
        /* @__PURE__ */ jsxs14(SpaceBetween14, { direction: "horizontal", size: "s", alignItems: "center", children: [
          /* @__PURE__ */ jsx15(TextContent9, { children: /* @__PURE__ */ jsx15("h2", { children: t("customerPreview") }) }),
          /* @__PURE__ */ jsx15(TextContent9, { children: /* @__PURE__ */ jsxs14("div", { className: DiscountStrategyStep_default.aiIcon, children: [
            /* @__PURE__ */ jsx15(Icon3, { name: "gen-ai", size: "small" }),
            /* @__PURE__ */ jsx15("span", { className: DiscountStrategyStep_default.generatedByAi, children: t("generatedByAi") })
          ] }) })
        ] }),
        /* @__PURE__ */ jsx15(TextContent9, { children: /* @__PURE__ */ jsx15("p", { children: t("reviewGeneratedQuestionnaire") }) })
      ] }),
      footer: /* @__PURE__ */ jsx15(Box4, { className: "awsui-visual-refresh", float: "right", children: /* @__PURE__ */ jsx15(
        Button8,
        {
          variant: "primary",
          onClick: () => {
            logger.biMetric({
              metricName: "Click",
              dimensions: {
                ClickFeat: "modal",
                ClickObj: "close-questionnaire-preview",
                ClickAct: "close-modal"
              },
              value: 1,
              unit: "Count"
            });
            onDismiss();
          },
          children: t("closePreview")
        }
      ) }),
      children: /* @__PURE__ */ jsx15(SpaceBetween14, { direction: "vertical", size: "l", children: /* @__PURE__ */ jsxs14(SpaceBetween14, { size: "xs", children: [
        /* @__PURE__ */ jsx15(TextContent9, { children: /* @__PURE__ */ jsx15("strong", { children: t("customerView") }) }),
        /* @__PURE__ */ jsx15(Container10, { className: `awsui-visual-refresh ${DiscountStrategyStep_default.innerQuestionnaireContainer}`, children: /* @__PURE__ */ jsxs14(SpaceBetween14, { size: "s", children: [
          /* @__PURE__ */ jsxs14(TextContent9, { children: [
            /* @__PURE__ */ jsx15("h2", { children: t("questionnaire") }),
            /* @__PURE__ */ jsx15("p", { children: t("answerAdditionalQuestions") })
          ] }),
          /* @__PURE__ */ jsx15(Container10, { className: "awsui-visual-refresh", children: /* @__PURE__ */ jsx15(SpaceBetween14, { direction: "vertical", size: "l", children: questions.map((q, index) => /* @__PURE__ */ jsxs14(SpaceBetween14, { size: "xxs", children: [
            /* @__PURE__ */ jsx15(TextContent9, { children: /* @__PURE__ */ jsx15("strong", { children: q.question }) }),
            /* @__PURE__ */ jsx15(FormField5, { constraintText: t("characterCountZero"), children: /* @__PURE__ */ jsx15(Textarea3, { value: "", placeholder: q.exampleResponse || t("enterYourAnswer"), rows: 3, onChange: () => {
            } }) })
          ] }, index)) }) })
        ] }) })
      ] }) })
    }
  );
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/validation.ts
var validateDiscountStrategyStep = (artifact, t) => {
  const errorProps = {};
  let isValid = true;
  if (!artifact) {
    return { isValid: true, errorProps: {} };
  }
  const discountStrategy = artifact.configurationRequest.discountStrategy;
  const maxDiscountPercentage = artifact.configurationRequest.maxDiscountPercentage;
  const maxTotalContractValue = artifact.configurationRequest.maxTotalContractValue;
  if (!discountStrategy && maxDiscountPercentage !== 0) {
    errorProps.discountStrategyError = { body: t("validationDiscountStrategyRequired") };
    isValid = false;
  }
  if (maxDiscountPercentage === null || maxDiscountPercentage === void 0) {
    errorProps.maxDiscountError = t("validationFieldRequired");
    isValid = false;
  } else if (maxDiscountPercentage < 0 || maxDiscountPercentage >= 100) {
    errorProps.maxDiscountError = t("validationDiscountPercentageRange");
    isValid = false;
  } else if (maxDiscountPercentage === 0 && discountStrategy) {
    errorProps.maxDiscountError = t("validationDiscountGreaterThanZero");
    isValid = false;
  }
  if (maxTotalContractValue === null || maxTotalContractValue === void 0) {
    errorProps.maxTcvError = t("validationFieldRequired");
    isValid = false;
  } else if (maxTotalContractValue <= 0) {
    errorProps.maxTcvError = t("validationMaxTcvGreaterThanZero");
    isValid = false;
  } else if (maxTotalContractValue >= 1e6) {
    errorProps.maxTcvError = t("validationMaxTcvBelowLimit");
    isValid = false;
  }
  if (discountStrategy) {
    switch (discountStrategy.strategy) {
      case "PER_DIMENSION_TCV":
      case "PER_DIMENSION_TCV_WITH_QUALIFICATION":
        if (!discountStrategy.perDimensionTcvTiers || Object.keys(discountStrategy.perDimensionTcvTiers).length === 0) {
          errorProps.perDimensionError = { body: t("validationPerDimensionRequiresTiers") };
          isValid = false;
        } else {
          const totalTiers = Object.values(discountStrategy.perDimensionTcvTiers).reduce((total, tiers) => total + (tiers?.length || 0), 0);
          if (totalTiers === 0) {
            errorProps.perDimensionError = { body: t("validationDefineOneTier") };
            isValid = false;
          } else {
            const hasIncompleteFields = Object.values(discountStrategy.perDimensionTcvTiers).some(
              (tiers) => tiers?.some((tier) => tier.minValue === null || tier.maxValue === null || tier.discountPercentage === null)
            );
            const hasInvalidDiscountPercentage = Object.values(discountStrategy.perDimensionTcvTiers).some(
              (tiers) => tiers?.some((tier) => tier.discountPercentage !== null && (tier.discountPercentage <= 0 || tier.discountPercentage >= 100))
            );
            const hasRangeErrors = Object.entries(discountStrategy.perDimensionTcvTiers).some(([dimensionKey, tiers]) => {
              const tierData = tiers?.map((tier) => ({
                minValue: tier.minValue,
                maxValue: tier.maxValue,
                discountPercentage: tier.discountPercentage
              }));
              const { errorFlags } = detectRangeErrors(dimensionKey, tierData || [], t);
              return Object.keys(errorFlags).length > 0;
            });
            if (hasIncompleteFields || hasInvalidDiscountPercentage || hasRangeErrors) {
              errorProps.perDimensionError = { showFieldLevelErrors: true };
              isValid = false;
            }
          }
        }
        if (discountStrategy.strategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION") {
          if (!discountStrategy.qualifications || discountStrategy.qualifications.length === 0) {
            errorProps.buyerProfileError = { body: t("validationPerDimensionQualificationRequired") };
            isValid = false;
          } else {
            const hasEmptyDetail = discountStrategy.qualifications.some((qual) => !qual.detail || qual.detail.trim() === "");
            if (hasEmptyDetail) {
              errorProps.buyerProfileError = { showFieldLevelErrors: true };
              isValid = false;
            }
          }
        }
        break;
      case "TOTAL_TCV":
      case "TOTAL_TCV_WITH_QUALIFICATION":
        if (!discountStrategy.totalTcvTiers || discountStrategy.totalTcvTiers.length === 0) {
          errorProps.tcvDiscountsError = { body: t("validationTcvRequiresTiers") };
          isValid = false;
        } else {
          const hasIncompleteFields = discountStrategy.totalTcvTiers.some(
            (tier) => tier.minValue === null || tier.maxValue === null || tier.discountPercentage === null
          );
          const hasInvalidDiscountPercentage = discountStrategy.totalTcvTiers.some(
            (tier) => tier.discountPercentage !== null && (tier.discountPercentage <= 0 || tier.discountPercentage >= 100)
          );
          const tierData = discountStrategy.totalTcvTiers.map((tier) => ({
            minValue: tier.minValue,
            maxValue: tier.maxValue,
            discountPercentage: tier.discountPercentage
          }));
          const { errorFlags } = detectRangeErrors("tcv", tierData, t);
          const hasRangeErrors = Object.keys(errorFlags).length > 0;
          if (hasIncompleteFields || hasInvalidDiscountPercentage || hasRangeErrors) {
            errorProps.tcvDiscountsError = { showFieldLevelErrors: true };
            isValid = false;
          }
        }
        if (discountStrategy.strategy === "TOTAL_TCV_WITH_QUALIFICATION") {
          if (!discountStrategy.qualifications || discountStrategy.qualifications.length === 0) {
            errorProps.buyerProfileError = { body: t("validationTcvQualificationRequired") };
            isValid = false;
          } else {
            const hasEmptyDetail = discountStrategy.qualifications.some((qual) => !qual.detail || qual.detail.trim() === "");
            if (hasEmptyDetail) {
              errorProps.buyerProfileError = { showFieldLevelErrors: true };
              isValid = false;
            }
          }
        }
        break;
      case "QUALIFICATION":
        if (!discountStrategy.qualifications || discountStrategy.qualifications.length === 0) {
          errorProps.buyerProfileError = { body: t("validationQualificationRequired") };
          isValid = false;
        } else {
          const hasEmptyDetail = discountStrategy.qualifications.some((qual) => !qual.detail || qual.detail.trim() === "");
          if (hasEmptyDetail) {
            errorProps.buyerProfileError = { showFieldLevelErrors: true };
            isValid = false;
          }
        }
        break;
    }
  }
  return {
    isValid,
    errorProps
  };
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/BuyerProfileEditor.tsx
import { jsx as jsx16, jsxs as jsxs15 } from "react/jsx-runtime";
var BuyerProfileEditor = ({
  writeableArtifact,
  clearFieldError,
  setFieldError,
  showFieldErrors,
  logger,
  flashbarManager,
  t
  // openHelpPanel,
}) => {
  const { artifact, setArtifact, isArtifactLocked } = writeableArtifact;
  const discountStrategy = artifact?.configurationRequest.discountStrategy;
  const [isGeneratingQuestions, setIsGeneratingQuestions] = React10.useState(false);
  const [isQuestionnaireModalVisible, setIsQuestionnaireModalVisible] = React10.useState(false);
  const [generatedQuestions, setGeneratedQuestions] = React10.useState([]);
  const [validationErrors, setValidationErrors] = React10.useState({});
  const qualificationItems = React10.useMemo(() => {
    if (!discountStrategy)
      return [];
    const qualifications = (() => {
      switch (discountStrategy.strategy) {
        case "QUALIFICATION":
        case "PER_DIMENSION_TCV_WITH_QUALIFICATION":
        case "TOTAL_TCV_WITH_QUALIFICATION":
          return discountStrategy.qualifications || [];
        default:
          return [];
      }
    })();
    return qualifications.map((qual, index) => ({
      id: `qual-${index}`,
      qualifyingTheme: qual.qualifyingTheme,
      detail: qual.detail,
      generatedQuestions: qual.buyerQuestions
    }));
  }, [discountStrategy]);
  React10.useEffect(() => {
    const hasEmptyThemes = qualificationItems.some((qual) => !qual.qualifyingTheme || qual.qualifyingTheme.trim() === "");
    const hasEmptyDetails = qualificationItems.some((qual) => !qual.detail || qual.detail.trim() === "");
    const hasCharacterLimitErrors = qualificationItems.some((qual) => qual.detail.length > 1e3);
    if (!hasEmptyThemes && !hasEmptyDetails && !hasCharacterLimitErrors && qualificationItems.length > 0) {
      clearFieldError("buyerProfileError");
    }
  }, [qualificationItems]);
  const handleUpdateQualificationTheme = (qualificationIndex, theme) => {
    if (!theme)
      return;
    setValidationErrors((prev) => {
      const updated = { ...prev };
      delete updated[qualificationIndex];
      if (Object.keys(updated).length === 0) {
        clearFieldError("buyerProfileAIValidationError");
      }
      return updated;
    });
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy) {
        return prev;
      }
      const qualifications = (() => {
        switch (prev.configurationRequest.discountStrategy.strategy) {
          case "QUALIFICATION":
          case "PER_DIMENSION_TCV_WITH_QUALIFICATION":
          case "TOTAL_TCV_WITH_QUALIFICATION":
            return [...prev.configurationRequest.discountStrategy.qualifications || []];
          default:
            return [];
        }
      })();
      if (qualifications[qualificationIndex]) {
        const { _validationError, ...rest } = qualifications[qualificationIndex];
        qualifications[qualificationIndex] = {
          ...rest,
          qualifyingTheme: theme,
          buyerQuestions: []
          // Clear questions when theme changes
        };
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            qualifications
          }
        }
      };
    });
  };
  const handleUpdateQualificationDetail = (qualificationIndex, detail) => {
    if (detail.length > 1e3) {
      setFieldError("buyerProfileCharacterLimitError", "Buyer profile details exceed character limit");
    } else {
      setFieldError("buyerProfileCharacterLimitError", void 0);
    }
    setValidationErrors((prev) => {
      const updated = { ...prev };
      delete updated[qualificationIndex];
      if (Object.keys(updated).length === 0) {
        clearFieldError("buyerProfileAIValidationError");
      }
      return updated;
    });
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy) {
        return prev;
      }
      const qualifications = (() => {
        switch (prev.configurationRequest.discountStrategy.strategy) {
          case "QUALIFICATION":
          case "PER_DIMENSION_TCV_WITH_QUALIFICATION":
          case "TOTAL_TCV_WITH_QUALIFICATION":
            return [...prev.configurationRequest.discountStrategy.qualifications || []];
          default:
            return [];
        }
      })();
      if (qualifications[qualificationIndex]) {
        const { _validationError, ...rest } = qualifications[qualificationIndex];
        qualifications[qualificationIndex] = {
          ...rest,
          detail,
          buyerQuestions: []
          // Clear questions when details change
        };
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            qualifications
          }
        }
      };
    });
  };
  const handleAddQualification = () => {
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy) {
        return prev;
      }
      const qualifications = (() => {
        switch (prev.configurationRequest.discountStrategy.strategy) {
          case "QUALIFICATION":
          case "PER_DIMENSION_TCV_WITH_QUALIFICATION":
          case "TOTAL_TCV_WITH_QUALIFICATION":
            return [...prev.configurationRequest.discountStrategy.qualifications || []];
          default:
            return [];
        }
      })();
      if (qualifications.length < 5) {
        qualifications.push({
          qualifyingTheme: "",
          detail: "",
          buyerQuestions: []
        });
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            qualifications
          }
        }
      };
    });
  };
  const handleRemoveQualification = (qualificationIndex) => {
    setValidationErrors((prev) => {
      const updated = {};
      Object.entries(prev).forEach(([indexStr, error]) => {
        const index = parseInt(indexStr, 10);
        if (index < qualificationIndex) {
          updated[index] = error;
        } else if (index > qualificationIndex) {
          updated[index - 1] = error;
        }
      });
      if (Object.keys(updated).length === 0) {
        clearFieldError("buyerProfileAIValidationError");
      }
      return updated;
    });
    setArtifact((prev) => {
      if (!prev.configurationRequest.discountStrategy) {
        return prev;
      }
      const qualifications = (() => {
        switch (prev.configurationRequest.discountStrategy.strategy) {
          case "QUALIFICATION":
          case "PER_DIMENSION_TCV_WITH_QUALIFICATION":
          case "TOTAL_TCV_WITH_QUALIFICATION":
            return [...prev.configurationRequest.discountStrategy.qualifications || []];
          default:
            return [];
        }
      })();
      qualifications.splice(qualificationIndex, 1);
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: {
            ...prev.configurationRequest.discountStrategy,
            qualifications
          }
        }
      };
    });
  };
  const handlePreviewQuestionnaire = async () => {
    setValidationErrors({});
    const validation = validateDiscountStrategyStep(artifact, t);
    const hasValidationErrors = !validation.isValid;
    const hasFieldErrors = Object.entries(validation.errorProps).some(([_key, value]) => {
      return value !== void 0 && value !== null && value !== "";
    });
    if (hasValidationErrors || hasFieldErrors) {
      Object.entries(validation.errorProps).forEach(([key, value]) => {
        if (value !== void 0 && value !== null && value !== "") {
          setFieldError(key, value);
        }
      });
    } else {
      clearFieldError("buyerProfileError");
      const allHaveQuestions = qualificationItems.every((qual) => qual.generatedQuestions && qual.generatedQuestions.length > 0);
      if (allHaveQuestions) {
        const questions = [];
        qualificationItems.forEach((qual) => {
          if (qual.generatedQuestions && Array.isArray(qual.generatedQuestions)) {
            qual.generatedQuestions.forEach((q) => {
              questions.push({
                question: q.question || q,
                qualifyingTheme: qual.qualifyingTheme || "",
                exampleResponse: q.exampleResponse
              });
            });
          }
        });
        setGeneratedQuestions(questions);
        setIsQuestionnaireModalVisible(true);
        return;
      }
      setIsGeneratingQuestions(true);
      try {
        const tokens = await MaxTokenData3.getInstance(logger).generateTokens([
          { action: GrantAction3.CreateExpressPrivateOfferConfiguration, requireUsagesRemaining: true }
        ]);
        const {
          hasValidationErrors: hasValidationErrors2,
          validationErrors: errors,
          result
        } = await generateAndUpdateBuyerProfileQuestions(writeableArtifact, tokens[0], flashbarManager, logger);
        if (hasValidationErrors2) {
          setValidationErrors(errors);
          setIsGeneratingQuestions(false);
          setFieldError("buyerProfileAIValidationError", "AI validation errors present");
        } else {
          setValidationErrors({});
          clearFieldError("buyerProfileAIValidationError");
          const questions = [];
          if (result && Array.isArray(result.qualifications)) {
            result.qualifications.forEach((qual) => {
              if (qual.buyerQuestions && Array.isArray(qual.buyerQuestions)) {
                qual.buyerQuestions.forEach((q) => {
                  questions.push({
                    question: q.question || q,
                    qualifyingTheme: qual.qualifyingTheme || "",
                    exampleResponse: q.exampleResponse
                  });
                });
              }
            });
          }
          setGeneratedQuestions(questions);
          setIsGeneratingQuestions(false);
          setIsQuestionnaireModalVisible(true);
        }
      } catch (error) {
        logger.error("Error in handlePreviewQuestionnaire", void 0, serializeError(error));
        setIsGeneratingQuestions(false);
      }
    }
  };
  return /* @__PURE__ */ jsxs15(
    Container11,
    {
      header: /* @__PURE__ */ jsx16(
        Header10,
        {
          variant: "h2",
          actions: /* @__PURE__ */ jsx16(
            Button9,
            {
              iconName: "gen-ai",
              onClick: () => {
                logger.biMetric({
                  metricName: "Click",
                  dimensions: {
                    ClickFeat: "buyer-profile-config",
                    ClickAct: "preview-questionnaire"
                  },
                  value: 1,
                  unit: "Count"
                });
                handlePreviewQuestionnaire();
              },
              loading: isGeneratingQuestions,
              disabled: isArtifactLocked,
              children: t("previewQuestionnaire")
            }
          ),
          description: t("buyerProfileDiscountStrategyDescription"),
          children: /* @__PURE__ */ jsxs15("span", { style: { display: "flex", alignItems: "center", gap: "8px" }, children: [
            t("buyerProfileBasedDiscountStrategy"),
            /* @__PURE__ */ jsx16(TextContent10, { children: /* @__PURE__ */ jsxs15("i", { style: { color: "#8456ce", display: "flex", alignItems: "center", gap: "4px" }, children: [
              /* @__PURE__ */ jsx16(Icon4, { name: "gen-ai", size: "small" }),
              /* @__PURE__ */ jsx16("span", { children: t("aiAssisted") })
            ] }) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ jsx16(SpaceBetween15, { direction: "vertical", size: "l", children: /* @__PURE__ */ jsxs15(SpaceBetween15, { size: "xl", children: [
          qualificationItems.map((qualification, qualificationIndex) => /* @__PURE__ */ jsxs15("div", { children: [
            qualificationIndex > 0 && /* @__PURE__ */ jsx16("hr", { style: { margin: "16px 0", border: "none", borderTop: "1px solid #e9ebed" } }),
            /* @__PURE__ */ jsxs15(SpaceBetween15, { direction: "vertical", size: "l", children: [
              /* @__PURE__ */ jsxs15(SpaceBetween15, { size: "xs", children: [
                /* @__PURE__ */ jsx16(
                  Header10,
                  {
                    variant: "h3",
                    actions: /* @__PURE__ */ jsx16(
                      Button9,
                      {
                        variant: "normal",
                        disabled: qualificationItems.length <= 1 || isArtifactLocked,
                        onClick: () => {
                          logger.biMetric({
                            metricName: "Click",
                            dimensions: {
                              ClickFeat: "buyer-profile-config",
                              ClickAct: "remove"
                            },
                            value: 1,
                            unit: "Count"
                          });
                          handleRemoveQualification(qualificationIndex);
                        },
                        children: t("remove")
                      }
                    ),
                    children: t("discountQualifier")
                  }
                ),
                /* @__PURE__ */ jsx16(Grid, { gridDefinition: [{ colspan: { default: 12, s: 10 } }], children: /* @__PURE__ */ jsx16(
                  FormField6,
                  {
                    label: t("qualifyingThemeLabel"),
                    description: t("qualifyingThemeDescription"),
                    stretch: true,
                    errorText: showFieldErrors && (!qualification.qualifyingTheme || qualification.qualifyingTheme.trim() === "") ? t("validationFieldRequired") : void 0,
                    children: /* @__PURE__ */ jsx16(
                      Select3,
                      {
                        "data-testid": "qualifying-theme-select",
                        selectedOption: qualification.qualifyingTheme ? { label: qualification.qualifyingTheme, value: qualification.qualifyingTheme } : null,
                        onChange: ({ detail }) => {
                          logger.biMetric({
                            metricName: "Click",
                            dimensions: {
                              ClickFeat: "buyer-profile-config",
                              ClickObj: "qualifying-theme-dropdown",
                              ClickAct: detail.selectedOption.value || ""
                            },
                            value: 1,
                            unit: "Count"
                          });
                          handleUpdateQualificationTheme(qualificationIndex, detail.selectedOption.value);
                        },
                        options: [
                          { label: t("companySizeOption"), value: "Company size" },
                          { label: t("industryOption"), value: "Industry" },
                          { label: t("useCaseOption"), value: "Use case" },
                          { label: t("otherOption"), value: "Other" }
                        ],
                        placeholder: t("chooseAnOption"),
                        invalid: showFieldErrors && (!qualification.qualifyingTheme || qualification.qualifyingTheme.trim() === ""),
                        disabled: isArtifactLocked
                      }
                    )
                  }
                ) })
              ] }),
              /* @__PURE__ */ jsxs15("div", { children: [
                /* @__PURE__ */ jsx16(TextContent10, { children: /* @__PURE__ */ jsx16("strong", { children: t("detailsLabel") }) }),
                /* @__PURE__ */ jsx16(Grid, { gridDefinition: [{ colspan: { default: 12, s: 10 } }], children: /* @__PURE__ */ jsx16(
                  FormField6,
                  {
                    stretch: true,
                    constraintText: t("qualificationDescriptionConstraint", { count: qualification.detail.length.toLocaleString() }),
                    errorText: qualification.detail.length > 1e3 ? t("qualificationDetailsTooManyCharacters", { count: qualification.detail.length.toLocaleString() }) : showFieldErrors && (!qualification.detail || qualification.detail.trim() === "") ? t("validationFieldRequired") : void 0,
                    children: /* @__PURE__ */ jsx16(
                      Textarea4,
                      {
                        "data-testid": "qualification-details-textarea",
                        value: qualification.detail,
                        onFocus: () => {
                          logger.biMetric({
                            metricName: "Click",
                            dimensions: {
                              ClickFeat: "buyer-profile-config",
                              ClickAct: "qualification-details"
                            },
                            value: 1,
                            unit: "Count"
                          });
                        },
                        onChange: ({ detail }) => {
                          handleUpdateQualificationDetail(qualificationIndex, detail.value);
                        },
                        placeholder: t("qualificationDetailsPlaceholder"),
                        rows: 4,
                        invalid: qualification.detail.length > 1e3 || showFieldErrors && (!qualification.detail || qualification.detail.trim() === ""),
                        disabled: isArtifactLocked
                      }
                    )
                  }
                ) })
              ] }),
              validationErrors[qualificationIndex] && /* @__PURE__ */ jsx16(
                Alert6,
                {
                  type: "error",
                  dismissible: true,
                  onDismiss: () => {
                    setValidationErrors((prev) => {
                      const updated = { ...prev };
                      delete updated[qualificationIndex];
                      if (Object.keys(updated).length === 0) {
                        clearFieldError("buyerProfileAIValidationError");
                      }
                      return updated;
                    });
                  },
                  children: validationErrors[qualificationIndex]
                }
              )
            ] })
          ] }, qualification.id)),
          /* @__PURE__ */ jsxs15("div", { children: [
            /* @__PURE__ */ jsx16(
              Button9,
              {
                variant: "normal",
                disabled: qualificationItems.length >= 5 || isArtifactLocked,
                onClick: () => {
                  logger.biMetric({
                    metricName: "Click",
                    dimensions: {
                      ClickFeat: "buyer-profile-config",
                      ClickAct: "add-new-qualifier"
                    },
                    value: 1,
                    unit: "Count"
                  });
                  handleAddQualification();
                },
                children: t("addNewQualifier")
              }
            ),
            /* @__PURE__ */ jsx16(TextContent10, { children: /* @__PURE__ */ jsx16("small", { children: qualificationItems.length >= 5 ? t("qualifiersLimitReached") : t("qualifiersAvailable", { count: 5 - qualificationItems.length }) }) })
          ] })
        ] }) }),
        /* @__PURE__ */ jsx16(
          QuestionnairePreviewModal,
          {
            visible: isQuestionnaireModalVisible,
            onDismiss: () => setIsQuestionnaireModalVisible(false),
            questions: generatedQuestions,
            logger,
            t
          }
        )
      ]
    }
  );
};

// src/aipo/CreateConfig/components/DiscountStrategyStep/DiscountStrategyStep.tsx
import { jsx as jsx17, jsxs as jsxs16 } from "react/jsx-runtime";
var DiscountStrategyStep = ({
  writeableArtifact,
  errors,
  clearFieldError,
  setFieldError,
  productDimensions = /* @__PURE__ */ new Map(),
  layoutComponents,
  isArtifactLocked = false,
  sendMessage,
  renderMessages,
  // openHelpPanel,
  logger,
  flashbarManager,
  t
}) => {
  const { artifact, setArtifact } = writeableArtifact;
  const [showAssistant, setShowAssistant] = React11.useState(false);
  const [panelSize, setPanelSize] = React11.useState(500);
  const { LayoutSplitPanel } = layoutComponents;
  React11.useEffect(() => {
    logger.updateContext({ PageType: "AWSMP-EPO-Create-Config" });
    logger.updateContext({ SubPageType: "AWSMP-Configure-Discount-Strategy" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, []);
  const discountStrategy = artifact?.configurationRequest.discountStrategy;
  const maxDiscountPercentage = artifact?.configurationRequest.maxDiscountPercentage?.toString() || "";
  const maxTotalContractValue = artifact?.configurationRequest.maxTotalContractValue?.toString() || "";
  const currentStrategy = discountStrategy?.strategy || null;
  const [perDimensionDiscounts, setPerDimensionDiscounts] = React11.useState(() => {
    return currentStrategy === "PER_DIMENSION_TCV" || currentStrategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION";
  });
  const [tcvDiscounts, setTcvDiscounts] = React11.useState(() => {
    return currentStrategy === "TOTAL_TCV" || currentStrategy === "TOTAL_TCV_WITH_QUALIFICATION";
  });
  const [buyerProfileDiscounts, setBuyerProfileDiscounts] = React11.useState(() => {
    return currentStrategy === "QUALIFICATION" || currentStrategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION" || currentStrategy === "TOTAL_TCV_WITH_QUALIFICATION";
  });
  const availableDimensions = React11.useMemo(() => {
    return artifact?.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates?.map((rate) => {
      const realDimension = productDimensions.get(rate.dimensionKey);
      return {
        key: rate.dimensionKey,
        name: realDimension?.dimension || rate.dimensionKey
      };
    }) || [];
  }, [artifact?.configurationRequest.configurableUpfrontDimensionRates, productDimensions]);
  const handleDiscountStrategyChange = (strategyType, checked) => {
    if (strategyType === "perDimension") {
      setPerDimensionDiscounts(checked);
    } else if (strategyType === "tcv") {
      setTcvDiscounts(checked);
    } else if (strategyType === "buyerProfile") {
      setBuyerProfileDiscounts(checked);
    }
    if (checked && errors.discountStrategyError) {
      clearFieldError("discountStrategyError");
    }
    if (!checked) {
      if (strategyType === "perDimension") {
        clearFieldError("perDimensionError");
      } else if (strategyType === "tcv") {
        clearFieldError("tcvDiscountsError");
      } else if (strategyType === "buyerProfile") {
        clearFieldError("buyerProfileError");
        clearFieldError("buyerProfileCharacterLimitError");
        clearFieldError("buyerProfileAIValidationError");
      }
    }
    setArtifact((prev) => {
      const currentStrategy2 = prev.configurationRequest.discountStrategy?.strategy;
      const hasQualifications = currentStrategy2 === "QUALIFICATION" || currentStrategy2 === "PER_DIMENSION_TCV_WITH_QUALIFICATION" || currentStrategy2 === "TOTAL_TCV_WITH_QUALIFICATION";
      let newStrategy = null;
      if (checked) {
        if (strategyType === "perDimension") {
          const initialTiers = {};
          availableDimensions.forEach((dimension, index) => {
            if (index === 0) {
              initialTiers[dimension.key] = [
                {
                  id: `${dimension.key}-0`,
                  minValue: null,
                  maxValue: null,
                  discountPercentage: null
                }
              ];
            } else {
              initialTiers[dimension.key] = [];
            }
          });
          if (hasQualifications) {
            const existingQualifications = prev.configurationRequest.discountStrategy && (prev.configurationRequest.discountStrategy.strategy === "QUALIFICATION" || prev.configurationRequest.discountStrategy.strategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION" || prev.configurationRequest.discountStrategy.strategy === "TOTAL_TCV_WITH_QUALIFICATION") ? prev.configurationRequest.discountStrategy.qualifications || [] : [];
            newStrategy = {
              strategy: "PER_DIMENSION_TCV_WITH_QUALIFICATION",
              perDimensionTcvTiers: initialTiers,
              qualifications: existingQualifications
            };
          } else {
            newStrategy = {
              strategy: "PER_DIMENSION_TCV",
              perDimensionTcvTiers: initialTiers
            };
          }
        } else if (strategyType === "tcv") {
          if (hasQualifications) {
            const existingQualifications = prev.configurationRequest.discountStrategy && (prev.configurationRequest.discountStrategy.strategy === "QUALIFICATION" || prev.configurationRequest.discountStrategy.strategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION" || prev.configurationRequest.discountStrategy.strategy === "TOTAL_TCV_WITH_QUALIFICATION") ? prev.configurationRequest.discountStrategy.qualifications || [] : [];
            newStrategy = {
              strategy: "TOTAL_TCV_WITH_QUALIFICATION",
              totalTcvTiers: [
                {
                  minValue: null,
                  maxValue: null,
                  discountPercentage: null
                }
              ],
              qualifications: existingQualifications
            };
          } else {
            newStrategy = {
              strategy: "TOTAL_TCV",
              totalTcvTiers: [
                {
                  minValue: null,
                  maxValue: null,
                  discountPercentage: null
                }
              ]
            };
          }
        } else if (strategyType === "buyerProfile") {
          const hasPerDimension = currentStrategy2 === "PER_DIMENSION_TCV" || currentStrategy2 === "PER_DIMENSION_TCV_WITH_QUALIFICATION";
          const hasTcv = currentStrategy2 === "TOTAL_TCV" || currentStrategy2 === "TOTAL_TCV_WITH_QUALIFICATION";
          if (hasPerDimension) {
            const existingTiers = prev.configurationRequest.discountStrategy && (prev.configurationRequest.discountStrategy.strategy === "PER_DIMENSION_TCV" || prev.configurationRequest.discountStrategy.strategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION") ? prev.configurationRequest.discountStrategy.perDimensionTcvTiers || {} : {};
            newStrategy = {
              strategy: "PER_DIMENSION_TCV_WITH_QUALIFICATION",
              perDimensionTcvTiers: existingTiers,
              qualifications: [
                {
                  qualifyingTheme: "",
                  detail: "",
                  buyerQuestions: []
                }
              ]
            };
          } else if (hasTcv) {
            const existingTiers = prev.configurationRequest.discountStrategy && (prev.configurationRequest.discountStrategy.strategy === "TOTAL_TCV" || prev.configurationRequest.discountStrategy.strategy === "TOTAL_TCV_WITH_QUALIFICATION") ? prev.configurationRequest.discountStrategy.totalTcvTiers || [] : [];
            newStrategy = {
              strategy: "TOTAL_TCV_WITH_QUALIFICATION",
              totalTcvTiers: existingTiers,
              qualifications: [
                {
                  qualifyingTheme: "",
                  detail: "",
                  buyerQuestions: []
                }
              ]
            };
          } else {
            newStrategy = {
              strategy: "QUALIFICATION",
              qualifications: [
                {
                  qualifyingTheme: "",
                  detail: "",
                  buyerQuestions: []
                }
              ]
            };
          }
        }
      } else {
        if (strategyType === "perDimension") {
          if (hasQualifications) {
            const existingQualifications = prev.configurationRequest.discountStrategy && (prev.configurationRequest.discountStrategy.strategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION" || prev.configurationRequest.discountStrategy.strategy === "TOTAL_TCV_WITH_QUALIFICATION" || prev.configurationRequest.discountStrategy.strategy === "QUALIFICATION") ? prev.configurationRequest.discountStrategy.qualifications || [] : [];
            newStrategy = {
              strategy: "QUALIFICATION",
              qualifications: existingQualifications
            };
          } else {
            newStrategy = null;
          }
        } else if (strategyType === "tcv") {
          if (hasQualifications) {
            const existingQualifications = prev.configurationRequest.discountStrategy && (prev.configurationRequest.discountStrategy.strategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION" || prev.configurationRequest.discountStrategy.strategy === "TOTAL_TCV_WITH_QUALIFICATION" || prev.configurationRequest.discountStrategy.strategy === "QUALIFICATION") ? prev.configurationRequest.discountStrategy.qualifications || [] : [];
            newStrategy = {
              strategy: "QUALIFICATION",
              qualifications: existingQualifications
            };
          } else {
            newStrategy = null;
          }
        } else if (strategyType === "buyerProfile") {
          const hasPerDimension = currentStrategy2 === "PER_DIMENSION_TCV_WITH_QUALIFICATION";
          const hasTcv = currentStrategy2 === "TOTAL_TCV_WITH_QUALIFICATION";
          if (hasPerDimension) {
            const existingTiers = prev.configurationRequest.discountStrategy && prev.configurationRequest.discountStrategy.strategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION" ? prev.configurationRequest.discountStrategy.perDimensionTcvTiers || {} : {};
            newStrategy = {
              strategy: "PER_DIMENSION_TCV",
              perDimensionTcvTiers: existingTiers
            };
          } else if (hasTcv) {
            const existingTiers = prev.configurationRequest.discountStrategy && prev.configurationRequest.discountStrategy.strategy === "TOTAL_TCV_WITH_QUALIFICATION" ? prev.configurationRequest.discountStrategy.totalTcvTiers || [] : [];
            newStrategy = {
              strategy: "TOTAL_TCV",
              totalTcvTiers: existingTiers
            };
          } else {
            newStrategy = null;
          }
        }
      }
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          discountStrategy: newStrategy
        }
      };
    });
  };
  const handleMaxDiscountChange = (value) => {
    if (errors.maxDiscountError) {
      clearFieldError("maxDiscountError");
    }
    if (errors.discountThresholdsError) {
      clearFieldError("discountThresholdsError");
    }
    const integerValue = parseIntegerValue(value);
    if (integerValue !== void 0 && (integerValue < 0 || integerValue >= 100)) {
      setFieldError("maxDiscountError", t("validationDiscountPercentageRange"));
    } else {
      setFieldError("maxDiscountError", void 0);
    }
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        maxDiscountPercentage: integerValue
      }
    }));
  };
  const handleMaxTCVChange = (value) => {
    if (errors.maxTcvError) {
      clearFieldError("maxTcvError");
    }
    if (errors.discountThresholdsError) {
      clearFieldError("discountThresholdsError");
    }
    const integerValue = parseIntegerValue(value);
    if (integerValue !== void 0 && integerValue <= 0) {
      setFieldError("maxTcvError", t("validationMaxTcvGreaterThanZero"));
    } else if (integerValue !== void 0 && integerValue >= 1e6) {
      setFieldError("maxTcvError", t("validationMaxTcvBelowLimit"));
    } else {
      setFieldError("maxTcvError", void 0);
    }
    setArtifact((prev) => ({
      ...prev,
      configurationRequest: {
        ...prev.configurationRequest,
        maxTotalContractValue: integerValue
      }
    }));
  };
  const showPerDimensionFieldErrors = errors.perDimensionError?.showFieldLevelErrors ?? false;
  const showTcvFieldErrors = errors.tcvDiscountsError?.showFieldLevelErrors ?? false;
  const showBuyerProfileFieldError = errors.buyerProfileError?.showFieldLevelErrors ?? false;
  const hasAnyStrategySelected = React11.useMemo(() => {
    return perDimensionDiscounts || tcvDiscounts || buyerProfileDiscounts;
  }, [perDimensionDiscounts, tcvDiscounts, buyerProfileDiscounts]);
  const isMaxDiscountZero = React11.useMemo(() => {
    const numValue = parseFloat(maxDiscountPercentage);
    return numValue === 0 || maxDiscountPercentage === "0";
  }, [maxDiscountPercentage]);
  const getDisabledStates = () => {
    if (isMaxDiscountZero && !hasAnyStrategySelected) {
      return {
        perDimensionDisabled: true,
        tcvDisabled: true,
        buyerProfileDisabled: true
      };
    }
    return {
      perDimensionDisabled: tcvDiscounts,
      tcvDisabled: perDimensionDiscounts,
      buyerProfileDisabled: false
    };
  };
  const { perDimensionDisabled, tcvDisabled, buyerProfileDisabled } = getDisabledStates();
  const allDisabledDueToMaxDiscount = isMaxDiscountZero && !hasAnyStrategySelected;
  const perDimensionPopoverText = allDisabledDueToMaxDiscount ? t("popoverPerDimensionMaxDiscount") : t("popoverPerDimensionMutuallyExclusive");
  const tcvPopoverText = allDisabledDueToMaxDiscount ? t("popoverTcvMaxDiscount") : t("popoverTcvMutuallyExclusive");
  const buyerProfilePopoverText = t("popoverBuyerProfileMaxDiscount");
  const specialMaxDiscountError = React11.useMemo(() => {
    if (isMaxDiscountZero && hasAnyStrategySelected) {
      return {
        body: t("errorDiscountMustBeGreaterThanZero"),
        header: void 0
      };
    }
    return null;
  }, [isMaxDiscountZero, hasAnyStrategySelected, t]);
  return /* @__PURE__ */ jsxs16(SpaceBetween16, { direction: "vertical", size: "l", children: [
    /* @__PURE__ */ jsx17(
      Container12,
      {
        header: /* @__PURE__ */ jsx17(Header11, { variant: "h2", description: t("discountThresholdsDescription"), children: t("discountThresholds") }),
        children: /* @__PURE__ */ jsxs16(SpaceBetween16, { direction: "vertical", size: "l", children: [
          /* @__PURE__ */ jsx17(
            KeyValuePairs4,
            {
              items: [
                {
                  label: t("currency"),
                  value: t("currencyUsd")
                }
              ]
            }
          ),
          /* @__PURE__ */ jsx17(
            FormField7,
            {
              label: t("maximumDiscountPercentage"),
              description: t("maximumDiscountPercentageDescription"),
              errorText: specialMaxDiscountError?.body || errors.maxDiscountError,
              children: /* @__PURE__ */ jsx17(
                Input6,
                {
                  "data-testid": "max-discount-percentage-input",
                  value: maxDiscountPercentage,
                  onFocus: () => {
                    logger.biMetric({
                      metricName: "Click",
                      dimensions: {
                        ClickFeat: "discount-thresholds",
                        ClickAct: "maximum-discount-percentage"
                      },
                      value: 1,
                      unit: "Count"
                    });
                  },
                  onChange: ({ detail }) => handleMaxDiscountChange(detail.value),
                  type: "number",
                  placeholder: t("enterANumber"),
                  invalid: !!(specialMaxDiscountError || errors.maxDiscountError),
                  disabled: isArtifactLocked
                }
              )
            }
          ),
          /* @__PURE__ */ jsx17(
            FormField7,
            {
              label: t("maximumTcvForEpo"),
              constraintText: t("maximumTcvConstraint"),
              description: t("maximumTcvDescription"),
              errorText: errors.maxTcvError,
              children: /* @__PURE__ */ jsx17(
                Input6,
                {
                  "data-testid": "max-tcv-input",
                  value: maxTotalContractValue,
                  onFocus: () => {
                    logger.biMetric({
                      metricName: "Click",
                      dimensions: {
                        ClickFeat: "discount-thresholds",
                        ClickAct: "maximum-total-contract-value"
                      },
                      value: 1,
                      unit: "Count"
                    });
                  },
                  onChange: ({ detail }) => handleMaxTCVChange(detail.value),
                  type: "number",
                  placeholder: t("enterANumber"),
                  invalid: !!errors.maxTcvError,
                  disabled: isArtifactLocked
                }
              )
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsx17(
      Container12,
      {
        header: /* @__PURE__ */ jsx17(Header11, { variant: "h2", description: t("discountStrategiesDescription"), children: t("discountStrategies") }),
        children: /* @__PURE__ */ jsxs16(SpaceBetween16, { direction: "vertical", size: "l", children: [
          /* @__PURE__ */ jsx17(Alert7, { type: "info", children: t("discountStrategiesCombinationAlert") }),
          /* @__PURE__ */ jsxs16(SpaceBetween16, { size: "xxs", children: [
            /* @__PURE__ */ jsx17(TextContent11, { children: /* @__PURE__ */ jsx17("strong", { children: t("discountStrategyOptions") }) }),
            /* @__PURE__ */ jsxs16(SpaceBetween16, { size: "xxxs", children: [
              (() => {
                const perDimensionCheckbox = /* @__PURE__ */ jsx17(
                  Checkbox2,
                  {
                    "data-testid": "per-dimension-checkbox",
                    checked: perDimensionDiscounts,
                    onChange: ({ detail }) => {
                      logger.biMetric({
                        metricName: "Click",
                        dimensions: {
                          ClickFeat: "strategy-selection",
                          ClickAct: "per-dimension-discounts"
                        },
                        value: 1,
                        unit: "Count"
                      });
                      handleDiscountStrategyChange("perDimension", detail.checked);
                    },
                    disabled: perDimensionDisabled || isArtifactLocked,
                    description: t("perDimensionDiscountsDescription"),
                    children: t("perDimensionDiscounts")
                  }
                );
                return perDimensionDisabled && !isArtifactLocked ? /* @__PURE__ */ jsx17(Popover2, { dismissButton: true, position: "left", size: "small", triggerType: "custom", content: perDimensionPopoverText, children: perDimensionCheckbox }) : perDimensionCheckbox;
              })(),
              (() => {
                const tcvCheckbox = /* @__PURE__ */ jsx17(
                  Checkbox2,
                  {
                    checked: tcvDiscounts,
                    onChange: ({ detail }) => {
                      logger.biMetric({
                        metricName: "Click",
                        dimensions: {
                          ClickFeat: "strategy-selection",
                          ClickAct: "tcv-discounts"
                        },
                        value: 1,
                        unit: "Count"
                      });
                      handleDiscountStrategyChange("tcv", detail.checked);
                    },
                    disabled: tcvDisabled || isArtifactLocked,
                    description: t("tcvBasedDiscountsDescription"),
                    children: t("tcvBasedDiscounts")
                  }
                );
                return tcvDisabled && !isArtifactLocked ? /* @__PURE__ */ jsx17(Popover2, { dismissButton: true, position: "left", size: "small", triggerType: "custom", content: tcvPopoverText, children: tcvCheckbox }) : tcvCheckbox;
              })(),
              (() => {
                const buyerProfileCheckbox = /* @__PURE__ */ jsx17(
                  Checkbox2,
                  {
                    "data-testid": "buyer-profile-checkbox",
                    checked: buyerProfileDiscounts,
                    onChange: ({ detail }) => {
                      logger.biMetric({
                        metricName: "Click",
                        dimensions: {
                          ClickFeat: "strategy-selection",
                          ClickAct: "buyer-profile-discounts"
                        },
                        value: 1,
                        unit: "Count"
                      });
                      handleDiscountStrategyChange("buyerProfile", detail.checked);
                    },
                    disabled: buyerProfileDisabled || isArtifactLocked,
                    description: t("buyerProfileBasedDiscountsDescription"),
                    children: /* @__PURE__ */ jsxs16("div", { className: DiscountStrategyStep_default.buyerProfileLabel, children: [
                      /* @__PURE__ */ jsx17("span", { children: t("buyerProfileBasedDiscounts") }),
                      /* @__PURE__ */ jsx17(TextContent11, { children: /* @__PURE__ */ jsxs16("i", { className: DiscountStrategyStep_default.aiIcon, style: { opacity: buyerProfileDisabled || isArtifactLocked ? 0.5 : 1 }, children: [
                        /* @__PURE__ */ jsx17(Icon5, { name: "gen-ai", size: "small" }),
                        /* @__PURE__ */ jsx17("span", { className: DiscountStrategyStep_default.aiAssisted, children: /* @__PURE__ */ jsx17("i", { children: t("aiAssisted") }) })
                      ] }) })
                    ] })
                  }
                );
                return buyerProfileDisabled && !isArtifactLocked ? /* @__PURE__ */ jsx17(Popover2, { dismissButton: true, position: "left", size: "small", triggerType: "custom", content: buyerProfilePopoverText, children: buyerProfileCheckbox }) : buyerProfileCheckbox;
              })()
            ] })
          ] })
        ] })
      }
    ),
    perDimensionDiscounts && /* @__PURE__ */ jsx17(
      PerDimensionDiscountEditor,
      {
        writeableArtifact,
        productDimensions,
        clearFieldError,
        showFieldErrors: showPerDimensionFieldErrors,
        logger,
        t
      }
    ),
    tcvDiscounts && /* @__PURE__ */ jsx17(
      TcvDiscountEditor,
      {
        writeableArtifact,
        clearFieldError,
        showFieldErrors: showTcvFieldErrors,
        logger,
        t
      }
    ),
    buyerProfileDiscounts && /* @__PURE__ */ jsx17(
      BuyerProfileEditor,
      {
        writeableArtifact,
        clearFieldError,
        setFieldError,
        showFieldErrors: showBuyerProfileFieldError,
        logger,
        flashbarManager,
        t
      }
    ),
    errors.discountStrategyError && /* @__PURE__ */ jsx17(
      Alert7,
      {
        dismissible: true,
        type: "error",
        onDismiss: () => clearFieldError("discountStrategyError"),
        header: errors.discountStrategyError.header,
        children: errors.discountStrategyError.body
      }
    ),
    errors.perDimensionError && !showPerDimensionFieldErrors && /* @__PURE__ */ jsx17(Alert7, { dismissible: true, type: "error", onDismiss: () => clearFieldError("perDimensionError"), header: errors.perDimensionError.header, children: errors.perDimensionError.body }),
    errors.tcvDiscountsError && !showTcvFieldErrors && /* @__PURE__ */ jsx17(Alert7, { dismissible: true, type: "error", onDismiss: () => clearFieldError("tcvDiscountsError"), header: errors.tcvDiscountsError.header, children: errors.tcvDiscountsError.body }),
    errors.buyerProfileError && !showBuyerProfileFieldError && /* @__PURE__ */ jsx17(Alert7, { dismissible: true, type: "error", onDismiss: () => clearFieldError("buyerProfileError"), header: errors.buyerProfileError.header, children: errors.buyerProfileError.body }),
    sendMessage && renderMessages && /* @__PURE__ */ jsx17(
      LayoutSplitPanel,
      {
        open: showAssistant,
        onToggle: (open) => setShowAssistant(open),
        onDismiss: () => setShowAssistant(false),
        onResize: (size) => setPanelSize(size),
        closeBehavior: "hide",
        header: t("advancedSettings"),
        size: panelSize,
        children: /* @__PURE__ */ jsx17(SpaceBetween16, { size: "l", children: /* @__PURE__ */ jsx17("div", { style: { maxHeight: "400px", overflowY: "auto" }, children: renderMessages() }) })
      }
    )
  ] });
};

// src/aipo/CreateConfig/components/ReviewAndCreate/ReviewAndCreateStep.tsx
import * as React12 from "react";
import Container13 from "@amzn/awsui-components-react/polaris/container";
import Header12 from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween17 from "@amzn/awsui-components-react/polaris/space-between";
import Box5 from "@amzn/awsui-components-react/polaris/box";
import Button10 from "@amzn/awsui-components-react/polaris/button";
import KeyValuePairs5 from "@amzn/awsui-components-react/polaris/key-value-pairs";
import Alert8 from "@amzn/awsui-components-react/polaris/alert";
import { ManagedTable as ManagedTable6 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";
import { jsx as jsx18, jsxs as jsxs17 } from "react/jsx-runtime";
var ReviewAndCreateStep = ({
  writeableArtifact,
  onEditStep,
  productDimensions = /* @__PURE__ */ new Map(),
  productName,
  logger,
  t
}) => {
  const { artifact, isArtifactLocked } = writeableArtifact;
  React12.useEffect(() => {
    logger.updateContext({ PageType: "AWSMP-EPO-Create-Config" });
    logger.updateContext({ SubPageType: "AWSMP-Review-And-Create" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, []);
  const selectedDimensions = artifact?.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates || [];
  const discountStrategy = artifact?.configurationRequest.discountStrategy;
  const iso8601ToMonths3 = (duration) => duration ? duration.slice(1, -1) : "";
  const iso8601ToDays2 = (duration) => duration ? duration.slice(1, -1) : "";
  const currentStrategy = discountStrategy?.strategy || null;
  const perDimensionDiscounts = currentStrategy === "PER_DIMENSION_TCV" || currentStrategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION";
  const tcvDiscounts = currentStrategy === "TOTAL_TCV" || currentStrategy === "TOTAL_TCV_WITH_QUALIFICATION";
  const hasQualifications = currentStrategy === "QUALIFICATION" || currentStrategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION" || currentStrategy === "TOTAL_TCV_WITH_QUALIFICATION";
  const perDimensionTiers = perDimensionDiscounts && discountStrategy && "perDimensionTcvTiers" in discountStrategy ? discountStrategy.perDimensionTcvTiers || {} : {};
  const tcvDiscountRanges = tcvDiscounts && discountStrategy && "totalTcvTiers" in discountStrategy ? discountStrategy.totalTcvTiers || [] : [];
  const buyerProfileQualifiers = hasQualifications && discountStrategy && "qualifications" in discountStrategy ? discountStrategy.qualifications || [] : [];
  const dimensionColumns = [
    {
      id: "dimension",
      header: t("dimensionName"),
      cell: (item) => {
        const matchingDimension = productDimensions.get(item.dimensionKey);
        return matchingDimension?.dimension || item.dimensionKey;
      },
      sortingField: "dimensionKey",
      minWidth: "113px"
    },
    {
      id: "apiIdentifier",
      header: t("apiIdentifier"),
      cell: (item) => item.dimensionKey,
      sortingField: "dimensionKey",
      minWidth: "133px"
    },
    {
      id: "description",
      header: t("description"),
      cell: (item) => {
        const matchingDimension = productDimensions.get(item.dimensionKey);
        return matchingDimension?.description || t("noDescriptionProvided");
      },
      sortingField: "description"
    }
  ];
  const priceColumns = [
    {
      id: "dimension",
      header: t("dimensionName"),
      cell: (item) => {
        const matchingDimension = productDimensions.get(item.dimensionKey);
        return matchingDimension?.dimension || item.dimensionKey;
      },
      sortingField: "dimensionKey",
      minWidth: "162px"
    },
    {
      id: "apiIdentifier",
      header: t("apiIdentifier"),
      cell: (item) => item.dimensionKey,
      sortingField: "dimensionKey",
      minWidth: "113px"
    },
    {
      id: "pricePerMonth",
      header: t("pricePerMonth"),
      cell: (item) => item.price !== null && item.price !== void 0 ? `$${item.price}` : "$0",
      sortingField: "price",
      minWidth: "146px"
    },
    {
      id: "expressPrivateOfferDescription",
      header: t("guidance"),
      cell: (item) => item.supplementaryDescription || t("noDescriptionProvided"),
      sortingField: "supplementaryDescription"
    }
  ];
  const perDimensionDiscountColumns = [
    {
      id: "minUnitQuantity",
      header: t("minimumUnitQuantity"),
      cell: (item) => item.minValue.toLocaleString(),
      sortingField: "minValue"
    },
    {
      id: "maxUnitQuantity",
      header: t("maximumUnitQuantity"),
      cell: (item) => item.maxValue.toLocaleString(),
      sortingField: "maxValue"
    },
    {
      id: "discountPercent",
      header: t("discountPercentage"),
      cell: (item) => `${item.discountPercentage}%`,
      sortingField: "discountPercentage"
    }
  ];
  const tcvDiscountColumns = [
    {
      id: "fromAmount",
      header: t("minimumValueUsd"),
      cell: (item) => `$${item.minValue}`,
      sortingField: "minValue"
    },
    {
      id: "toAmount",
      header: t("maximumValueUsd"),
      cell: (item) => `$${item.maxValue}`,
      sortingField: "maxValue"
    },
    {
      id: "discountPercent",
      header: t("discountPercentage"),
      cell: (item) => `${item.discountPercentage}%`,
      sortingField: "discountPercentage"
    }
  ];
  return /* @__PURE__ */ jsxs17(SpaceBetween17, { direction: "vertical", size: "xl", children: [
    /* @__PURE__ */ jsxs17(SpaceBetween17, { size: "l", children: [
      /* @__PURE__ */ jsx18(
        Header12,
        {
          variant: "h3",
          actions: /* @__PURE__ */ jsx18(
            Button10,
            {
              variant: "normal",
              onClick: () => {
                logger.biMetric({
                  metricName: "Click",
                  dimensions: {
                    ClickFeat: "review-actions",
                    ClickObj: "product-dimensions",
                    ClickAct: "edit"
                  },
                  value: 1,
                  unit: "Count"
                });
                onEditStep(0);
              },
              disabled: isArtifactLocked,
              children: "Edit"
            }
          ),
          children: t("reviewStepProductDimensions")
        }
      ),
      /* @__PURE__ */ jsx18(Container13, { header: /* @__PURE__ */ jsx18(Header12, { variant: "h3", children: t("selectedProduct") }), "data-testid": "review-product-container", children: /* @__PURE__ */ jsx18(
        KeyValuePairs5,
        {
          columns: 1,
          items: [
            {
              label: t("product"),
              value: productName && artifact?.configurationRequest.productId ? `${productName} (${artifact.configurationRequest.productId})` : artifact?.configurationRequest.productId || t("noProductSelected")
            }
          ]
        }
      ) }),
      /* @__PURE__ */ jsx18(
        ManagedTable6,
        {
          preferenceKey: "review-dimensions-table",
          hidePreferences: true,
          columnDefinitions: dimensionColumns,
          items: selectedDimensions,
          selectionType: void 0,
          ariaLabels: {
            allItemsSelectionLabel: () => t("allDimensions"),
            itemSelectionLabel: (_, item) => item.dimensionKey
          },
          trackBy: "dimensionKey",
          empty: /* @__PURE__ */ jsxs17(Box5, { textAlign: "center", color: "inherit", children: [
            /* @__PURE__ */ jsx18("b", { children: t("noDimensionsSelected") }),
            /* @__PURE__ */ jsx18(Box5, { padding: { bottom: "s" }, variant: "p", color: "inherit", children: t("noDimensionsSelectedDescription") })
          ] }),
          header: /* @__PURE__ */ jsx18(Header12, { counter: `(${selectedDimensions.length})`, children: t("includedDimensions") })
        }
      )
    ] }),
    /* @__PURE__ */ jsxs17(SpaceBetween17, { size: "l", children: [
      /* @__PURE__ */ jsx18(
        Header12,
        {
          variant: "h3",
          actions: /* @__PURE__ */ jsx18(
            Button10,
            {
              variant: "normal",
              onClick: () => {
                logger.biMetric({
                  metricName: "Click",
                  dimensions: {
                    ClickFeat: "review-actions",
                    ClickObj: "pricing-details",
                    ClickAct: "edit"
                  },
                  value: 1,
                  unit: "Count"
                });
                onEditStep(1);
              },
              disabled: isArtifactLocked,
              children: t("edit")
            }
          ),
          children: t("reviewStepPricingDetails")
        }
      ),
      /* @__PURE__ */ jsx18(
        ManagedTable6,
        {
          "data-testid": "review-prices-table",
          preferenceKey: "review-prices-table",
          hidePreferences: true,
          columnDefinitions: priceColumns,
          items: selectedDimensions,
          selectionType: void 0,
          ariaLabels: {
            allItemsSelectionLabel: () => t("allDimensionPrices"),
            itemSelectionLabel: (_, item) => item.dimensionKey
          },
          trackBy: "dimensionKey",
          empty: /* @__PURE__ */ jsxs17(Box5, { textAlign: "center", color: "inherit", children: [
            /* @__PURE__ */ jsx18("b", { children: t("noDimensionPricesConfigured") }),
            /* @__PURE__ */ jsx18(Box5, { padding: { bottom: "s" }, variant: "p", color: "inherit", children: t("noDimensionPricesConfiguredDescription") })
          ] }),
          header: /* @__PURE__ */ jsx18(Header12, { counter: `(${selectedDimensions.length})`, children: t("specifiedDimensions") })
        }
      )
    ] }),
    /* @__PURE__ */ jsxs17(SpaceBetween17, { size: "l", children: [
      /* @__PURE__ */ jsx18(
        Header12,
        {
          variant: "h3",
          actions: /* @__PURE__ */ jsx18(
            Button10,
            {
              variant: "normal",
              onClick: () => {
                logger.biMetric({
                  metricName: "Click",
                  dimensions: {
                    ClickFeat: "review-actions",
                    ClickObj: "offer-settings",
                    ClickAct: "edit"
                  },
                  value: 1,
                  unit: "Count"
                });
                onEditStep(2);
              },
              disabled: isArtifactLocked,
              children: t("edit")
            }
          ),
          children: t("reviewStepOfferSettings")
        }
      ),
      /* @__PURE__ */ jsx18(Container13, { header: /* @__PURE__ */ jsx18(Header12, { variant: "h3", children: t("contractDetailsAndEulaHeader") }), "data-testid": "review-offer-settings-container", children: /* @__PURE__ */ jsx18(
        KeyValuePairs5,
        {
          columns: 2,
          items: [
            {
              label: t("minimumOfferDurationInMonths"),
              value: iso8601ToMonths3(artifact?.configurationRequest.minOfferDuration || "") || t("notSet")
            },
            {
              label: t("maximumOfferDurationInMonths"),
              value: iso8601ToMonths3(artifact?.configurationRequest.maxOfferDuration || "") || t("notSet")
            },
            {
              label: t("endUserLicenseAgreement"),
              value: artifact?.configurationRequest.eulaType === "PUBLIC_OFFER_EULA" ? t("publicOfferEula") : t("standardContractForMarketplace")
            },
            {
              label: t("offerExpirationDurationInDays"),
              value: iso8601ToDays2(artifact?.configurationRequest.expiration || "") || t("notSet")
            },
            ...artifact?.configurationRequest.maxFutureStartDuration && artifact.configurationRequest.maxFutureStartDuration !== "P0D" ? [
              {
                label: t("fdaValidityRangeInDays"),
                value: iso8601ToDays2(artifact.configurationRequest.maxFutureStartDuration)
              }
            ] : []
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs17(SpaceBetween17, { size: "l", children: [
      /* @__PURE__ */ jsx18(
        Header12,
        {
          variant: "h3",
          actions: /* @__PURE__ */ jsx18(
            Button10,
            {
              variant: "normal",
              onClick: () => {
                logger.biMetric({
                  metricName: "Click",
                  dimensions: {
                    ClickFeat: "review-actions",
                    ClickObj: "discount-strategy",
                    ClickAct: "edit"
                  },
                  value: 1,
                  unit: "Count"
                });
                onEditStep(3);
              },
              disabled: isArtifactLocked,
              children: t("edit")
            }
          ),
          children: t("reviewStepDiscountStrategy")
        }
      ),
      /* @__PURE__ */ jsx18(Container13, { header: /* @__PURE__ */ jsx18(Header12, { variant: "h3", children: t("discountThresholds") }), "data-testid": "review-discount-thresholds-container", children: /* @__PURE__ */ jsxs17(SpaceBetween17, { direction: "vertical", size: "m", children: [
        /* @__PURE__ */ jsx18(
          KeyValuePairs5,
          {
            columns: 2,
            items: [
              {
                label: t("currency"),
                value: t("currencyUsd")
              },
              {
                label: t("maximumDiscountPercentage"),
                value: artifact?.configurationRequest.maxDiscountPercentage?.toString() || t("notSet")
              }
            ]
          }
        ),
        /* @__PURE__ */ jsx18(
          KeyValuePairs5,
          {
            columns: 1,
            items: [
              {
                label: t("maximumTcvForEpo"),
                value: artifact?.configurationRequest.maxTotalContractValue?.toString() || t("notSet")
              }
            ]
          }
        )
      ] }) }),
      perDimensionDiscounts && Object.keys(perDimensionTiers).length > 0 && /* @__PURE__ */ jsx18(Container13, { header: /* @__PURE__ */ jsx18(Header12, { variant: "h3", children: t("perDimensionDiscountStrategyHeader") }), children: /* @__PURE__ */ jsxs17(SpaceBetween17, { direction: "vertical", size: "xs", children: [
        /* @__PURE__ */ jsx18(Alert8, { type: "info", children: t("dimensionsWithoutRangesInfo") }),
        /* @__PURE__ */ jsx18(SpaceBetween17, { direction: "vertical", size: "l", children: Object.entries(perDimensionTiers).filter(([_, tiers]) => tiers && tiers.length > 0).map(([dimensionKey, tiers]) => {
          const matchingDimension = productDimensions.get(dimensionKey);
          const dimensionName = matchingDimension?.dimension || dimensionKey;
          return /* @__PURE__ */ jsx18(
            ManagedTable6,
            {
              variant: "embedded",
              preferenceKey: `review-per-dimension-${dimensionKey}-table`,
              hidePreferences: true,
              columnDefinitions: perDimensionDiscountColumns,
              items: tiers,
              selectionType: void 0,
              ariaLabels: {
                allItemsSelectionLabel: () => t("allDimensionDiscountRanges", { dimensionName }),
                itemSelectionLabel: (_, item) => t("rangeMinToMax", { minValue: item.minValue, maxValue: item.maxValue })
              },
              trackBy: "minValue",
              empty: /* @__PURE__ */ jsxs17(Box5, { textAlign: "center", color: "inherit", children: [
                /* @__PURE__ */ jsx18("b", { children: t("noDiscountRangesConfigured") }),
                /* @__PURE__ */ jsx18(Box5, { padding: { bottom: "s" }, variant: "p", color: "inherit", children: t("noDiscountRangesForDimension") })
              ] }),
              header: /* @__PURE__ */ jsx18(Header12, { counter: `(${tiers.length})`, children: dimensionName })
            },
            dimensionKey
          );
        }) })
      ] }) }),
      tcvDiscounts && /* @__PURE__ */ jsx18(
        ManagedTable6,
        {
          preferenceKey: "review-tcv-discounts-table",
          hidePreferences: true,
          columnDefinitions: tcvDiscountColumns,
          items: tcvDiscountRanges,
          selectionType: void 0,
          ariaLabels: {
            allItemsSelectionLabel: () => t("allTcvDiscountRanges"),
            itemSelectionLabel: (_, item) => t("rangeMinToMax", { minValue: item.minValue, maxValue: item.maxValue })
          },
          trackBy: "minValue",
          empty: /* @__PURE__ */ jsxs17(Box5, { textAlign: "center", color: "inherit", children: [
            /* @__PURE__ */ jsx18("b", { children: t("noTcvDiscountRangesConfigured") }),
            /* @__PURE__ */ jsx18(Box5, { padding: { bottom: "s" }, variant: "p", color: "inherit", children: t("noTcvDiscountRangesDescription") })
          ] }),
          header: /* @__PURE__ */ jsx18(Header12, { counter: `(${tcvDiscountRanges.length})`, children: t("totalContractValueDiscountStrategyHeader") })
        }
      ),
      buyerProfileQualifiers && buyerProfileQualifiers.length > 0 && /* @__PURE__ */ jsx18(Container13, { header: /* @__PURE__ */ jsx18(Header12, { variant: "h3", children: t("buyerProfileDiscountStrategyHeader") }), "data-testid": "review-buyer-profile-container", children: /* @__PURE__ */ jsx18(SpaceBetween17, { direction: "vertical", size: "m", children: buyerProfileQualifiers.map((qualifier, index) => /* @__PURE__ */ jsxs17("div", { "data-testid": `review-buyer-profile-qualifier-${index}`, children: [
        /* @__PURE__ */ jsxs17(SpaceBetween17, { direction: "vertical", size: "s", children: [
          /* @__PURE__ */ jsxs17(Box5, { children: [
            /* @__PURE__ */ jsx18(Box5, { fontWeight: "bold", display: "inline", children: t("qualifyingTheme") }),
            /* @__PURE__ */ jsx18(Box5, { margin: { top: "xs" }, children: qualifier.qualifyingTheme })
          ] }),
          /* @__PURE__ */ jsxs17(Box5, { children: [
            /* @__PURE__ */ jsx18(Box5, { fontWeight: "bold", display: "inline", children: t("details") }),
            /* @__PURE__ */ jsx18(Box5, { margin: { top: "xs" }, children: qualifier.detail })
          ] }),
          qualifier._validationError && /* @__PURE__ */ jsx18(Alert8, { type: "error", children: qualifier._validationError })
        ] }),
        index < buyerProfileQualifiers.length - 1 && /* @__PURE__ */ jsx18(Box5, { margin: { top: "m", bottom: "m" }, children: /* @__PURE__ */ jsx18("hr", { style: { border: "none", borderTop: "1px solid #e9ebed", margin: 0 } }) })
      ] }, index)) }) })
    ] })
  ] });
};

// src/aipo/CreateConfig/CreateConfig.tsx
import { FatalErrorPage as FatalErrorPage2 } from "@amzn/awsmp-max-ux-patterns/FatalErrorPage";
import { NotFoundPage } from "@amzn/awsmp-max-ux-patterns/NotFoundPage";

// src/aipo/CreateConfig/components/SelectProductDimensionsStep/SelectProductDimensionsStep.tsx
import * as React13 from "react";
import Container14 from "@amzn/awsui-components-react/polaris/container";
import Header13 from "@amzn/awsui-components-react/polaris/header";
import FormField8 from "@amzn/awsui-components-react/polaris/form-field";
import Select4 from "@amzn/awsui-components-react/polaris/select";
import SpaceBetween18 from "@amzn/awsui-components-react/polaris/space-between";
import Box6 from "@amzn/awsui-components-react/polaris/box";
import Button11 from "@amzn/awsui-components-react/polaris/button";
import Alert9 from "@amzn/awsui-components-react/polaris/alert";
import { ManagedTable as ManagedTable7 } from "@amzn/awsmp-max-ux-patterns/ManagedTable";
import { AppTrans as AppTrans2 } from "@amzn/awsmp-max-translations";
import TextContent12 from "@cloudscape-design/components/text-content";
import { jsx as jsx19, jsxs as jsxs18 } from "react/jsx-runtime";
var SelectProductDimensionsStep = ({
  availableProducts,
  writeableArtifact,
  errors,
  clearFieldError,
  productDimensions = /* @__PURE__ */ new Map(),
  isLoadingDimensions,
  isLoadingProducts,
  logger,
  t
}) => {
  const { artifact, setArtifact } = writeableArtifact;
  const selectedProductId = artifact?.configurationRequest.productId;
  const [selectedFromSelectedDimensions, setSelectedFromSelectedDimensions] = React13.useState([]);
  const [isAlertDismissed, setIsAlertDismissed] = React13.useState(false);
  React13.useEffect(() => {
    logger.updateContext({ PageType: "AWSMP-EPO-Create-Config" });
    logger.updateContext({ SubPageType: "AWSMP-Select-Product-Dimensions" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, []);
  const cleanupPerDimensionDiscountTiers = (discountStrategy, selectedDimensionKeys) => {
    if (!discountStrategy || discountStrategy.strategy !== "PER_DIMENSION_TCV" && discountStrategy.strategy !== "PER_DIMENSION_TCV_WITH_QUALIFICATION") {
      return discountStrategy;
    }
    const existingTiers = discountStrategy.perDimensionTcvTiers;
    const cleanedTiers = {};
    for (const [dimensionKey, tiers] of Object.entries(existingTiers)) {
      if (selectedDimensionKeys.has(dimensionKey)) {
        cleanedTiers[dimensionKey] = tiers;
      }
    }
    return {
      ...discountStrategy,
      perDimensionTcvTiers: cleanedTiers
    };
  };
  const productDimensionsArray = React13.useMemo(() => {
    return Array.from(productDimensions.values());
  }, [productDimensions]);
  const selectedDimensions = React13.useMemo(() => {
    if (!artifact?.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates) {
      return [];
    }
    return artifact.configurationRequest.configurableUpfrontDimensionRates.dimensionRates.reduce((acc, dimRate) => {
      const dimension = productDimensions.get(dimRate.dimensionKey);
      if (dimension)
        acc.push(dimension);
      return acc;
    }, []);
  }, [artifact?.configurationRequest.configurableUpfrontDimensionRates, productDimensions]);
  const handleSelectAll = () => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "product-dimensions-table",
        ClickAct: "select-all"
      },
      value: 1,
      unit: "Count"
    });
    setArtifact((prev) => {
      const existingRates = prev.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates || [];
      const existingRatesMap = new Map(existingRates.map((rate) => [rate.dimensionKey, rate]));
      const dimensionRates = Array.from(productDimensions.values()).map((dim) => {
        const existing = existingRatesMap.get(dim.apiIdentifier);
        return existing || {
          dimensionKey: dim.apiIdentifier,
          price: 0,
          supplementaryDescription: void 0
        };
      });
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          configurableUpfrontDimensionRates: {
            duration: "P1M",
            dimensionRates
          }
        }
      };
    });
  };
  const handleSelectAllSelected = () => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "selected-dimensions-table",
        ClickAct: "select-all"
      },
      value: 1,
      unit: "Count"
    });
    setSelectedFromSelectedDimensions([...selectedDimensions]);
  };
  const handleRemoveSelected = () => {
    logger.biMetric({
      metricName: "Click",
      dimensions: {
        ClickFeat: "selected-dimensions-table",
        ClickAct: "remove"
      },
      value: 1,
      unit: "Count"
    });
    const idsToRemove = selectedFromSelectedDimensions.map((item) => item.apiIdentifier);
    const remainingDimensionKeys = new Set(
      selectedDimensions.filter((item) => !idsToRemove.includes(item.apiIdentifier)).map((item) => item.apiIdentifier)
    );
    setArtifact((prev) => {
      const existingRates = prev.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates || [];
      const dimensionRates = existingRates.filter((rate) => remainingDimensionKeys.has(rate.dimensionKey));
      const discountStrategy = cleanupPerDimensionDiscountTiers(prev.configurationRequest.discountStrategy, remainingDimensionKeys);
      return {
        ...prev,
        configurationRequest: {
          ...prev.configurationRequest,
          configurableUpfrontDimensionRates: {
            duration: "P1M",
            dimensionRates
          },
          discountStrategy
        }
      };
    });
    setSelectedFromSelectedDimensions([]);
  };
  const productOptions = availableProducts.map((product) => ({
    label: `${product.name} (${product.id})`,
    value: product.id
  }));
  if (isLoadingProducts || productOptions.length > 0) {
    productOptions.unshift({ label: t("selectProductPlaceholder"), value: "" });
  }
  const dimensionColumns = [
    {
      id: "dimension",
      header: t("dimensionName"),
      cell: (item) => item.dimension,
      sortingField: "dimension",
      width: "200px"
    },
    {
      id: "apiIdentifier",
      header: t("apiIdentifier"),
      cell: (item) => item.apiIdentifier,
      sortingField: "apiIdentifier",
      width: "150px"
    },
    {
      id: "description",
      header: t("description"),
      cell: (item) => item.description,
      sortingField: "description"
    }
  ];
  const commonTableProps = {
    wrapLines: false,
    columnDefinitions: dimensionColumns,
    selectionType: "multi",
    variant: "embedded",
    trackBy: "apiIdentifier",
    sorting: { defaultState: { sortingColumn: { sortingField: "dimension" } } },
    pagination: {}
  };
  return /* @__PURE__ */ jsxs18(SpaceBetween18, { direction: "vertical", size: "l", children: [
    /* @__PURE__ */ jsx19(Container14, { header: /* @__PURE__ */ jsx19(Header13, { variant: "h2", children: t("productSelection") }), children: /* @__PURE__ */ jsx19(FormField8, { errorText: errors.productError, label: t("product"), description: t("productDescriptionEpo"), children: /* @__PURE__ */ jsx19(
      Select4,
      {
        "data-testid": "product-select",
        selectedOption: productOptions.find((option) => option.value === selectedProductId) || productOptions[0],
        empty: t("noEligibleProducts"),
        onChange: ({ detail }) => {
          logger.biMetric({
            metricName: "Click",
            dimensions: {
              ClickFeat: "product-container",
              ClickAct: "product-selection-dropdown"
            },
            value: 1,
            unit: "Count"
          });
          setArtifact((prev) => {
            const newArtifact = {
              ...prev,
              configurationRequest: {
                ...prev.configurationRequest,
                productId: detail.selectedOption.value ?? "",
                configurableUpfrontDimensionRates: void 0
              }
            };
            const discountStrategy = newArtifact.configurationRequest.discountStrategy;
            if (discountStrategy && (discountStrategy.strategy === "PER_DIMENSION_TCV" || discountStrategy.strategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION")) {
              newArtifact.configurationRequest.discountStrategy = void 0;
            }
            return newArtifact;
          });
          if (errors.productError) {
            clearFieldError("productError");
          }
        },
        options: isLoadingProducts ? [] : productOptions,
        placeholder: t("selectProductPlaceholder"),
        loadingText: t("loadingProducts"),
        statusType: isLoadingProducts ? "loading" : void 0
      }
    ) }) }),
    selectedProductId && /* @__PURE__ */ jsx19(Container14, { children: /* @__PURE__ */ jsxs18("div", { style: { display: "flex", flexDirection: "column", gap: "40px" }, children: [
      /* @__PURE__ */ jsx19(
        ManagedTable7,
        {
          ...commonTableProps,
          preferenceKey: "product-dimensions-table",
          hidePreferences: true,
          "data-testid": "product-dimensions-table",
          items: productDimensionsArray,
          selectedItems: selectedDimensions,
          onSelectionChange: ({ detail }) => {
            detail.selectedItems.forEach((item) => {
              logger.biMetric({
                metricName: "Click",
                dimensions: {
                  ClickFeat: "product-dimensions-table",
                  ClickObj: "product-dimension-row-select",
                  ClickAct: item.dimension
                },
                value: 1,
                unit: "Count"
              });
            });
            const selectedDimensionKeys = new Set(detail.selectedItems.map((item) => item.apiIdentifier));
            setArtifact((prev) => {
              const existingRates = prev.configurationRequest.configurableUpfrontDimensionRates?.dimensionRates || [];
              const existingRatesMap = new Map(existingRates.map((rate) => [rate.dimensionKey, rate]));
              const dimensionRates = detail.selectedItems.map((dim) => {
                const existing = existingRatesMap.get(dim.apiIdentifier);
                return existing || {
                  dimensionKey: dim.apiIdentifier,
                  price: 0,
                  supplementaryDescription: void 0
                };
              });
              const discountStrategy = cleanupPerDimensionDiscountTiers(prev.configurationRequest.discountStrategy, selectedDimensionKeys);
              return {
                ...prev,
                configurationRequest: {
                  ...prev.configurationRequest,
                  configurableUpfrontDimensionRates: {
                    duration: "P1M",
                    dimensionRates
                  },
                  discountStrategy
                }
              };
            });
            if (detail.selectedItems.length > 0 && errors.dimensionsError) {
              clearFieldError("dimensionsError");
            }
          },
          loading: isLoadingDimensions,
          ariaLabels: {
            selectionGroupLabel: t("productDimensionsSelection"),
            allItemsSelectionLabel: ({ selectedItems }) => `${selectedItems.length} ${selectedItems.length === 1 ? t("dimension") : t("dimensions")} selected`,
            itemSelectionLabel: ({ selectedItems }, item) => {
              const isItemSelected = selectedItems.filter((i) => i.apiIdentifier === item.apiIdentifier).length;
              return t(isItemSelected ? "isSelected" : "isNotSelected", { name: item.dimension });
            }
          },
          filtering: {
            filteringPlaceholder: t("findDimensions"),
            filteringAriaLabel: t("findDimensions")
          },
          header: /* @__PURE__ */ jsx19(
            Header13,
            {
              counter: selectedDimensions.length > 0 ? `(${selectedDimensions.length}/${productDimensions.size})` : `(${productDimensions.size})`,
              description: /* @__PURE__ */ jsxs18(SpaceBetween18, { direction: "vertical", size: "s", children: [
                /* @__PURE__ */ jsx19(Box6, { color: "text-body-secondary", children: t("productDimensionsStepDescription") }),
                !isAlertDismissed && /* @__PURE__ */ jsx19(
                  Alert9,
                  {
                    type: "info",
                    dismissible: true,
                    onDismiss: () => setIsAlertDismissed(true),
                    action: /* @__PURE__ */ jsx19(
                      Button11,
                      {
                        iconName: "external",
                        iconAlign: "right",
                        target: "_blank",
                        href: "https://docs.aws.amazon.com/marketplace/latest/userguide/express-private-offers-custom-dimensions.html",
                        children: t("viewDocumentation")
                      }
                    ),
                    children: /* @__PURE__ */ jsx19(TextContent12, { children: /* @__PURE__ */ jsx19(AppTrans2, { i18nKey: "dimensionsImportAlert", children: /* @__PURE__ */ jsx19("strong", {}) }) })
                  }
                )
              ] }),
              actions: /* @__PURE__ */ jsx19(Button11, { onClick: handleSelectAll, disabled: selectedDimensions.length === productDimensions.size, children: t("selectAll") }),
              children: t("productDimensions")
            }
          )
        }
      ),
      /* @__PURE__ */ jsx19(
        ManagedTable7,
        {
          ...commonTableProps,
          preferenceKey: "selected-dimensions-table",
          hidePreferences: true,
          items: selectedDimensions,
          selectedItems: selectedFromSelectedDimensions,
          onSelectionChange: ({ detail }) => {
            detail.selectedItems.forEach((item) => {
              logger.biMetric({
                metricName: "Click",
                dimensions: {
                  ClickFeat: "selected-dimensions-table",
                  ClickObj: "selected-dimensions-row-select",
                  ClickAct: item.dimension
                },
                value: 1,
                unit: "Count"
              });
            });
            setSelectedFromSelectedDimensions(detail.selectedItems);
          },
          ariaLabels: {
            selectionGroupLabel: t("selectedDimensionsSelection"),
            allItemsSelectionLabel: ({ selectedItems }) => `${selectedItems.length} ${selectedItems.length === 1 ? t("dimension") : t("dimensions")} ${t("selectedFromSelectedDimensions")}`,
            itemSelectionLabel: ({ selectedItems }, item) => {
              const isItemSelected = selectedItems.filter((i) => i.apiIdentifier === item.apiIdentifier).length;
              return t(isItemSelected ? "isSelected" : "isNotSelected", { name: item.dimension });
            }
          },
          filtering: {
            filteringPlaceholder: t("findSelectedDimensions"),
            filteringAriaLabel: t("findSelectedDimensions")
          },
          empty: /* @__PURE__ */ jsxs18(Box6, { textAlign: "center", color: "inherit", children: [
            /* @__PURE__ */ jsx19("b", { children: t("noDimensions") }),
            /* @__PURE__ */ jsx19(Box6, { padding: { bottom: "s" }, variant: "p", color: "inherit", children: t("noDimensionsToDisplay") })
          ] }),
          header: /* @__PURE__ */ jsx19(
            Header13,
            {
              counter: selectedFromSelectedDimensions.length > 0 ? `(${selectedFromSelectedDimensions.length}/${selectedDimensions.length})` : `(${selectedDimensions.length})`,
              actions: /* @__PURE__ */ jsxs18(SpaceBetween18, { direction: "horizontal", size: "xs", children: [
                /* @__PURE__ */ jsx19(
                  Button11,
                  {
                    onClick: handleSelectAllSelected,
                    disabled: selectedFromSelectedDimensions.length === selectedDimensions.length || selectedDimensions.length === 0,
                    children: t("selectAll")
                  }
                ),
                /* @__PURE__ */ jsx19(Button11, { onClick: handleRemoveSelected, disabled: selectedFromSelectedDimensions.length === 0, children: t("remove") })
              ] }),
              children: t("selectedDimensions")
            }
          )
        }
      ),
      errors.dimensionsError && /* @__PURE__ */ jsx19(Alert9, { type: "error", dismissible: true, onDismiss: () => clearFieldError("dimensionsError"), children: errors.dimensionsError }),
      errors.dimensionLimitError && /* @__PURE__ */ jsx19(
        Alert9,
        {
          type: "error",
          dismissible: true,
          onDismiss: () => clearFieldError("dimensionLimitError"),
          header: t("dimensionLimitExceededHeader"),
          children: errors.dimensionLimitError
        }
      )
    ] }) })
  ] });
};

// src/aipo/CreateConfig/CreateConfig.tsx
import Alert10 from "@amzn/awsui-components-react/polaris/alert";
import SpaceBetween19 from "@amzn/awsui-components-react/polaris/space-between";
import { Fragment as Fragment6, jsx as jsx20, jsxs as jsxs19 } from "react/jsx-runtime";
var CreateConfig = ({
  projectId,
  productId,
  writeableArtifact,
  t,
  layoutComponents,
  sendMessage,
  renderMessages,
  maxService,
  setBreadcrumbs,
  flashbarManager,
  logger
}) => {
  const navigate = useNavigate2();
  const [searchParams] = useSearchParams();
  const includeLimited = searchParams.get("includeLimited") === "true";
  const { artifact, isArtifactLocked } = writeableArtifact;
  const [availableProducts, setAvailableProducts] = useState9([]);
  const [isLoadingProducts, setIsLoadingProducts] = useState9(true);
  const [hasProductsError, setHasProductsError] = useState9(false);
  const [configuredProductIds, setConfiguredProductIds] = useState9(/* @__PURE__ */ new Set());
  const [invalidProductId, setInvalidProductId] = useState9(false);
  const [isProductNotFound, setIsProductNotFound] = useState9(false);
  const [hasAuthError, setHasAuthError] = useState9(false);
  const [productDimensions, setProductDimensions] = useState9(/* @__PURE__ */ new Map());
  const [isLoadingDimensions, setIsLoadingDimensions] = useState9(false);
  const [batchEntityDetails, setBatchEntityDetails] = useState9({});
  const [activeStepIndex, setActiveStepIndex] = useState9(0);
  const [stepErrors, setStepErrors] = useState9({});
  const [isSubmitting, setIsSubmitting] = useState9(false);
  const [submitError, setSubmitError] = useState9(null);
  const [fdaEnabled, setFdaEnabled] = useState9(false);
  React14.useEffect(() => {
    const unloadEvent = (event) => {
      event.preventDefault();
      event.returnValue = "";
      return t("unsavedChangesWarning");
    };
    window.addEventListener("beforeunload", unloadEvent);
    return () => {
      window.removeEventListener("beforeunload", unloadEvent);
    };
  }, []);
  const marketplaceApiService = new MarketplaceApiService(logger);
  const handleFetchError = (error) => {
    const statusCode = error?.statusCode || error?.$metadata?.httpStatusCode;
    const is4xxError = statusCode && Math.floor(statusCode / 100) === 4;
    if (is4xxError) {
      setIsProductNotFound(true);
    } else {
      setHasProductsError(true);
    }
    if (flashbarManager) {
      handleApiError(error, flashbarManager, t, logger);
    }
  };
  const fetchProductDimensions = (productId2) => {
    try {
      setIsLoadingDimensions(true);
      const dimensions = marketplaceApiService.extractProductDimensions(productId2, batchEntityDetails);
      setProductDimensions(dimensions);
    } catch (error) {
      setProductDimensions(/* @__PURE__ */ new Map());
      handleFetchError(error);
    } finally {
      setIsLoadingDimensions(false);
    }
  };
  const fetchMarketplaceProducts = async () => {
    try {
      setIsLoadingProducts(true);
      setHasProductsError(false);
      const { products, entityDetails } = await marketplaceApiService.fetchMarketplaceProducts(includeLimited);
      setBatchEntityDetails(entityDetails);
      setAvailableProducts(products);
    } catch (error) {
      setIsLoadingProducts(false);
      handleFetchError(error);
    }
  };
  React14.useEffect(() => {
    const fetchEpoConfigurations = async () => {
      if (!maxService?.directToolCallWithoutStreaming || !projectId || hasProductsError || isProductNotFound) {
        return;
      }
      try {
        const tokens = await MaxTokenData4.getInstance(logger).generateTokens([
          { action: GrantAction4.CreateExpressPrivateOfferConfiguration, requireUsagesRemaining: true },
          { action: GrantAction4.DeleteExpressPrivateOfferConfiguration, requireUsagesRemaining: true }
        ]);
        await writeableArtifact.shareProject(
          projectId,
          tokens[0]
          // targetWebIdentityToken (Create MAX token)
        );
        const result = await maxService.directToolCallWithoutStreaming({
          toolName: "listExpressPrivateOfferConfigurations",
          toolInput: {},
          webIdentityTokenOverride: tokens[0],
          // Use Create token
          agent: { agentId: "epo-seller-qualification" }
        });
        const summaries = result.aipoConfigurationSummaries || [];
        const configuredIds = new Set(summaries.map((s2) => s2.productId).filter(Boolean));
        setConfiguredProductIds(configuredIds);
      } catch (error) {
        if (isAuthenticationError(error)) {
          setHasAuthError(true);
          await epoSellerSignIn();
          return;
        }
        handleFetchError(error);
      } finally {
        setIsLoadingProducts(false);
      }
    };
    fetchEpoConfigurations();
  }, [maxService, projectId]);
  React14.useEffect(() => {
    setBreadcrumbs([
      { text: t("breadcrumbAwsMarketplace"), href: "https://aws.amazon.com/marketplace", isAbsoluteUrl: true },
      { text: t("breadcrumbEpoConfigurations"), href: "/epo" },
      { text: t("breadcrumbCreateConfiguration"), href: "/epo/create" }
    ]);
  }, [setBreadcrumbs]);
  React14.useEffect(() => {
    if (!hasProductsError && !isProductNotFound) {
      fetchMarketplaceProducts();
    }
  }, [hasProductsError, isProductNotFound]);
  React14.useEffect(() => {
    if (!productId) {
      return;
    }
    if (isLoadingProducts) {
      return;
    }
    const availableProductIds = availableProducts.filter((product) => !configuredProductIds.has(product.id)).map((product) => product.id);
    const isValidProduct = availableProductIds.includes(productId);
    if (!isValidProduct) {
      setInvalidProductId(true);
    }
  }, [productId, availableProducts, configuredProductIds, isLoadingProducts]);
  React14.useEffect(() => {
    if (hasProductsError || isProductNotFound) {
      return;
    }
    const selectedProductId = artifact?.configurationRequest.productId || "";
    if (selectedProductId && selectedProductId.length > 0) {
      if (Object.keys(batchEntityDetails).length > 0) {
        fetchProductDimensions(selectedProductId);
      }
    }
  }, [artifact?.configurationRequest.productId, batchEntityDetails, hasProductsError]);
  const clearStepErrors = () => {
    setStepErrors({});
  };
  const clearFieldError = (errorKey) => {
    setStepErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[errorKey];
      return newErrors;
    });
  };
  const setFieldError = (field, error) => {
    setStepErrors((prev) => {
      const newErrors = { ...prev };
      if (error) {
        newErrors[field] = error;
      } else {
        delete newErrors[field];
      }
      return newErrors;
    });
  };
  const stepValidations = [
    () => validateSelectProductDimensionsStep(artifact, t),
    () => validateAdditionalInformationStep(artifact, t),
    () => validateOfferSettingsStep(artifact, t, fdaEnabled),
    () => validateDiscountStrategyStep(artifact, t)
  ];
  if (!hasAuthError) {
    if (isProductNotFound) {
      return /* @__PURE__ */ jsx20(NotFoundPage, { logger });
    }
    if (hasProductsError) {
      return /* @__PURE__ */ jsx20(FatalErrorPage2, { logger });
    }
  }
  if (invalidProductId) {
    return /* @__PURE__ */ jsx20(NotFoundPage, { logger });
  }
  return /* @__PURE__ */ jsx20(Fragment6, { children: /* @__PURE__ */ jsx20(
    Wizard2,
    {
      activeStepIndex,
      submitButtonText: isSubmitting ? t("wizardSubmitButtonCreating") : t("wizardSubmitButton"),
      isLoadingNextStep: isSubmitting || isArtifactLocked,
      ...!isSubmitting && {
        onCancel: () => {
          navigate("/epo");
        }
      },
      onNavigate: ({ detail }) => {
        const { requestedStepIndex, reason } = detail;
        if (reason === "next" || reason === "step" && requestedStepIndex > activeStepIndex) {
          const startStep = activeStepIndex;
          const endStep = Math.min(requestedStepIndex - 1, stepValidations.length - 1);
          for (let stepIndex = startStep; stepIndex <= endStep; stepIndex++) {
            const validation = stepValidations[stepIndex]?.();
            if (stepIndex === activeStepIndex) {
              const constraintErrors = Object.entries(stepErrors).filter(([_key, value]) => {
                return value !== void 0 && value !== null && value !== "";
              });
              if (constraintErrors.length > 0) {
                return;
              }
            }
            if (validation && !validation.isValid) {
              setStepErrors(validation.errorProps);
              setActiveStepIndex(stepIndex);
              return;
            }
          }
          clearStepErrors();
        } else {
          clearStepErrors();
        }
        setActiveStepIndex(requestedStepIndex);
      },
      onSubmit: async () => {
        if (isSubmitting)
          return;
        setIsSubmitting(true);
        setSubmitError(null);
        try {
          const discountStrategy = artifact?.configurationRequest.discountStrategy;
          const hasQualifications = discountStrategy && (discountStrategy.strategy === "QUALIFICATION" || discountStrategy.strategy === "PER_DIMENSION_TCV_WITH_QUALIFICATION" || discountStrategy.strategy === "TOTAL_TCV_WITH_QUALIFICATION");
          if (hasQualifications && "qualifications" in discountStrategy) {
            const qualifications = discountStrategy.qualifications || [];
            const hasExistingValidationErrors = qualifications.some((qual) => qual._validationError);
            if (hasExistingValidationErrors) {
              setIsSubmitting(false);
              return;
            }
            const needsQuestionGeneration = qualifications.some((qual) => {
              return !qual.buyerQuestions || qual.buyerQuestions.length === 0;
            });
            if (needsQuestionGeneration) {
              const qualTokens = await MaxTokenData4.getInstance(logger).generateTokens([
                { action: GrantAction4.CreateExpressPrivateOfferConfiguration, requireUsagesRemaining: true }
              ]);
              const { hasValidationErrors, updatedArtifact } = await generateAndUpdateBuyerProfileQuestions(
                writeableArtifact,
                qualTokens[0],
                flashbarManager,
                logger
              );
              if (hasValidationErrors) {
                setIsSubmitting(false);
                return;
              }
              if (updatedArtifact) {
                const tokens2 = await MaxTokenData4.getInstance(logger).generateTokens([
                  { action: GrantAction4.CreateExpressPrivateOfferConfiguration, requireUsagesRemaining: true }
                ]);
                await writeableArtifact.callMcpTool("createExpressPrivateOfferConfiguration", {}, tokens2[0], updatedArtifact);
                const productId3 = updatedArtifact.configurationRequest.productId || "";
                const selectedProduct2 = availableProducts.find((p) => p.id === productId3);
                const productName2 = selectedProduct2?.name || productId3;
                navigate(`/epo?created=true&productId=${encodeURIComponent(productId3)}&productName=${encodeURIComponent(productName2)}`);
                return;
              }
            }
          }
          const tokens = await MaxTokenData4.getInstance(logger).generateTokens([
            { action: GrantAction4.CreateExpressPrivateOfferConfiguration, requireUsagesRemaining: true }
          ]);
          await writeableArtifact.callMcpTool("createExpressPrivateOfferConfiguration", {}, tokens[0]);
          const productId2 = artifact?.configurationRequest.productId || "";
          const selectedProduct = availableProducts.find((p) => p.id === productId2);
          const productName = selectedProduct?.name || productId2;
          navigate(`/epo?created=true&productId=${encodeURIComponent(productId2)}&productName=${encodeURIComponent(productName)}`);
        } catch (error) {
          const is400Error = error?.statusCode === 400;
          if (flashbarManager) {
            if (is400Error) {
              const errorMessage = error?.message || t("errorValidationOccurred");
              flashbarManager.addItem({
                type: "error",
                content: errorMessage,
                dismissible: true
              });
            } else {
              const statusCode = error?.statusCode || error?.$metadata?.httpStatusCode;
              if (statusCode !== 401 && statusCode !== 403) {
                logger.opsMetric({
                  metricName: CustomOpsMetricName.ClientSideNonFatalToolCallError,
                  unit: "Count",
                  value: 1
                });
              }
              flashbarManager.addItem({
                type: "error",
                header: t("errorSomethingWentWrongHeader"),
                content: t("errorInternalErrorMessage"),
                dismissible: true
              });
            }
          }
        } finally {
          setIsSubmitting(false);
        }
      },
      steps: [
        {
          title: t("wizardStepSelectProduct"),
          description: t("wizardStepSelectProductDesc"),
          content: /* @__PURE__ */ jsx20(
            SelectProductDimensionsStep,
            {
              availableProducts: availableProducts.filter((product) => !configuredProductIds.has(product.id)),
              writeableArtifact,
              errors: stepErrors,
              clearFieldError,
              productDimensions,
              isLoadingDimensions,
              isLoadingProducts,
              logger,
              t
            }
          )
        },
        {
          title: t("wizardStepPricing"),
          description: t("wizardStepPricingDesc"),
          content: /* @__PURE__ */ jsx20(
            AdditionalInformationStep,
            {
              writeableArtifact,
              errors: stepErrors,
              clearFieldError,
              layoutComponents,
              productDimensions,
              logger,
              t
            }
          )
        },
        {
          title: t("wizardStepOfferSettings"),
          content: /* @__PURE__ */ jsx20(
            OfferSettingsStep,
            {
              writeableArtifact,
              errors: stepErrors,
              clearFieldError,
              setFieldError,
              onFdaEnabledChange: setFdaEnabled,
              logger,
              t
            }
          )
        },
        {
          title: t("wizardStepDiscountStrategy"),
          description: /* @__PURE__ */ jsxs19(Fragment6, { children: [
            t("wizardStepDiscountStrategyDesc"),
            " ",
            /* @__PURE__ */ jsx20(
              Link6,
              {
                external: true,
                href: "https://docs.aws.amazon.com/marketplace/latest/userguide/express-private-offers-configuration.html#express-private-offers-configuration-rate-cards",
                variant: "primary",
                children: t("learnMore")
              }
            )
          ] }),
          content: /* @__PURE__ */ jsx20(
            DiscountStrategyStep,
            {
              writeableArtifact,
              errors: stepErrors,
              clearFieldError,
              setFieldError,
              productDimensions,
              layoutComponents,
              sendMessage,
              renderMessages,
              isArtifactLocked,
              maxService,
              logger,
              flashbarManager,
              t
            }
          )
        },
        {
          title: t("wizardStepReviewCreate"),
          content: /* @__PURE__ */ jsxs19(SpaceBetween19, { direction: "vertical", size: "l", children: [
            /* @__PURE__ */ jsx20(
              ReviewAndCreateStep,
              {
                writeableArtifact,
                onEditStep: setActiveStepIndex,
                productDimensions,
                productName: availableProducts.find((p) => p.id === artifact?.configurationRequest.productId)?.name,
                logger,
                t
              }
            ),
            submitError && /* @__PURE__ */ jsx20(Alert10, { type: "error", dismissible: true, onDismiss: () => setSubmitError(null), header: t("alertFailedToCreateHeader"), children: submitError })
          ] })
        }
      ]
    }
  ) });
};

// src/aipo/ViewConfig/ViewConfig.tsx
import * as React15 from "react";
import Button12 from "@cloudscape-design/components/button";
import Header14 from "@cloudscape-design/components/header";
import Tabs from "@cloudscape-design/components/tabs";
import Table from "@cloudscape-design/components/table";
import SpaceBetween20 from "@cloudscape-design/components/space-between";
import KeyValuePairs6 from "@cloudscape-design/components/key-value-pairs";
import Container15 from "@cloudscape-design/components/container";
import { MaxTokenData as MaxTokenData5, GrantAction as GrantAction5 } from "@amzn/awsmp-max-data";
import { LoadingSpinner as LoadingSpinner2 } from "@amzn/awsmp-max-ux-patterns/LoadingSpinner";
import { FatalErrorPage as FatalErrorPage3 } from "@amzn/awsmp-max-ux-patterns/FatalErrorPage";
import { NotFoundPage as NotFoundPage2 } from "@amzn/awsmp-max-ux-patterns/NotFoundPage";
import { useNavigate as useNavigate3 } from "react-router-dom";
import { jsx as jsx21, jsxs as jsxs20 } from "react/jsx-runtime";
var ViewConfig = ({ productId, t, maxService, setBreadcrumbs, flashbarManager, logger }) => {
  const navigate = useNavigate3();
  const [activeTabId, setActiveTabId] = React15.useState("dimensions");
  const [configuration, setConfiguration] = React15.useState(null);
  const [productName, setProductName] = React15.useState("");
  const [productCode, setProductCode] = React15.useState(void 0);
  const [dimensionNames, setDimensionNames] = React15.useState(/* @__PURE__ */ new Map());
  const [loading, setLoading] = React15.useState(true);
  const [error, setError] = React15.useState(null);
  const [hasFetchError, setHasFetchError] = React15.useState(false);
  const [isNotFound, setIsNotFound] = React15.useState(false);
  const [isDeleting, setIsDeleting] = React15.useState(false);
  const handleRemove = async () => {
    if (!productId || !maxService?.directToolCallWithoutStreaming) {
      return;
    }
    setIsDeleting(true);
    try {
      const tokens = await MaxTokenData5.getInstance(logger).generateTokens([
        { action: GrantAction5.DeleteExpressPrivateOfferConfiguration, requireUsagesRemaining: true }
      ]);
      await maxService.directToolCallWithoutStreaming({
        toolName: "deleteExpressPrivateOfferConfiguration",
        toolInput: { productId },
        webIdentityTokenOverride: tokens[0],
        agent: { agentId: "epo-seller-qualification" }
      });
      navigate({
        pathname: "/epo",
        search: `?deleted=true&productId=${encodeURIComponent(productId)}&productName=${encodeURIComponent(productName)}`
      });
    } catch (error2) {
      logger.error("Error deleting configuration:", void 0, serializeError(error2));
      setIsDeleting(false);
      handleApiError(error2, flashbarManager, t, logger);
    }
  };
  React15.useEffect(() => {
    const fetchData = async () => {
      if (!productId || !maxService || hasFetchError) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setError(null);
        const tokens = await MaxTokenData5.getInstance(logger).generateTokens([
          { action: GrantAction5.CreateExpressPrivateOfferConfiguration },
          { action: GrantAction5.DeleteExpressPrivateOfferConfiguration }
        ]);
        const config = await maxService.directToolCallWithoutStreaming({
          toolName: "getExpressPrivateOfferConfiguration",
          toolInput: { productId },
          webIdentityTokenOverride: tokens[0],
          agent: { agentId: "epo-seller-qualification" }
        });
        setConfiguration(config);
        try {
          const details = await new MarketplaceApiService(logger).fetchProductDetails(productId);
          setProductName(details.name);
          setProductCode(details.productCode);
          setDimensionNames(details.dimensions);
        } catch (nameError) {
          console.warn("Failed to fetch product details, using productId:", nameError);
          setProductName(productId);
          setProductCode(void 0);
          setDimensionNames(/* @__PURE__ */ new Map());
        }
      } catch (err) {
        logger.error("Error fetching data", void 0, serializeError(err));
        if (isAuthenticationError(err)) {
          await epoSellerSignIn();
          return;
        }
        setError(err.message || "Failed to load configuration");
        setHasFetchError(true);
        const statusCode = err?.statusCode || err?.$metadata?.httpStatusCode;
        const is4xxError = statusCode && Math.floor(statusCode / 100) === 4;
        if (is4xxError) {
          setIsNotFound(true);
        }
        handleApiError(err, flashbarManager, t, logger);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [productId, maxService]);
  React15.useEffect(() => {
    setBreadcrumbs([
      { text: t("awsMarketplace"), href: "https://aws.amazon.com/marketplace", isAbsoluteUrl: true },
      { text: t("expressPrivateOfferConfigurations"), href: "/epo" },
      { text: productName, href: `/epo/${productId}` }
    ]);
  }, [productName, setBreadcrumbs]);
  React15.useEffect(() => {
    logger.updateContext({ PageType: "AWSMP-EPO-View-Config" });
    logger.updateContext({ SubPageType: "AWSMP-Configuration-Details" });
    logger.biMetric({
      metricName: "PageHit",
      value: 1,
      unit: "Count"
    });
  }, [logger]);
  if (loading) {
    return /* @__PURE__ */ jsx21(LoadingSpinner2, {});
  }
  if (isNotFound) {
    return /* @__PURE__ */ jsx21(NotFoundPage2, { logger });
  }
  if (error || !productId || !configuration) {
    return /* @__PURE__ */ jsx21(FatalErrorPage3, { logger });
  }
  let sellerInstructions = null;
  try {
    sellerInstructions = configuration.sellerInstructions ? JSON.parse(configuration.sellerInstructions) : null;
  } catch (err) {
    logger.error("Failed to parse seller instructions", void 0, serializeError(err));
  }
  const formatDuration = (duration) => {
    const match2 = duration.match(/P(\d+)([YMD])/);
    if (!match2)
      return duration;
    const value = match2[1];
    const unit = match2[2];
    const unitMap = {
      Y: value === "1" ? t("year") : t("yearsLowercase"),
      M: value === "1" ? t("month") : t("monthsLowercase"),
      D: value === "1" ? t("day") : t("daysLowercase")
    };
    return `${value} ${unitMap[unit]}`;
  };
  const formatEulaType = (eulaType) => {
    if (eulaType === "PUBLIC_OFFER_EULA") {
      return t("publicOfferEula");
    } else if (eulaType === "STANDARD_CONTRACT_MARKETPLACE") {
      return t("standardContractForMarketplace");
    }
    return eulaType;
  };
  const dimensionsData = configuration.configurableUpfrontDimensionRates?.dimensionRates?.map((rate) => ({
    apiIdentifier: rate.dimensionKey,
    dimension: rate.dimensionKey,
    pricePerMonth: `$${rate.price}`,
    expressPrivateOfferDescription: rate.supplementaryDescription ?? "-"
  })) || [];
  const columnDefinitions = [
    {
      id: "apiIdentifier",
      header: t("apiIdentifier"),
      cell: (item) => item.apiIdentifier
    },
    {
      id: "dimension",
      header: t("dimension"),
      cell: (item) => dimensionNames.get(item.apiIdentifier) || item.dimension
    },
    {
      id: "pricePerMonth",
      header: t("pricePerMonth"),
      cell: (item) => item.pricePerMonth
    },
    {
      id: "expressPrivateOfferDescription",
      header: t("guidance"),
      cell: (item) => item.expressPrivateOfferDescription
    }
  ];
  const perDimensionTcvData = {};
  if (sellerInstructions?.perDimensionTcvTiers) {
    Object.entries(sellerInstructions.perDimensionTcvTiers).forEach(([dimensionKey, tiers]) => {
      perDimensionTcvData[dimensionKey] = tiers.map((tier) => ({
        fromValue: `${tier.minValue.toLocaleString()}`,
        toValue: `${tier.maxValue.toLocaleString()}`,
        discountPercent: `${tier.discountPercentage}%`
      }));
    });
  }
  const totalTcvDiscountData = [];
  if (sellerInstructions?.totalTcvTiers) {
    sellerInstructions.totalTcvTiers.forEach((tier) => {
      totalTcvDiscountData.push({
        fromValue: `$${tier.minValue.toLocaleString()}`,
        toValue: `$${tier.maxValue.toLocaleString()}`,
        discountPercent: `${tier.discountPercentage}%`
      });
    });
  }
  const tcvColumnDefinitions = [
    {
      id: "fromValue",
      header: t("minimumValue"),
      cell: (item) => item.fromValue
    },
    {
      id: "toValue",
      header: t("maximumValue"),
      cell: (item) => item.toValue
    },
    {
      id: "discountPercent",
      header: t("discountPercentage"),
      cell: (item) => item.discountPercent
    }
  ];
  const perDimensionColumnDefinitions = [
    {
      id: "fromValue",
      header: t("minimumUnitQuantity"),
      cell: (item) => item.fromValue
    },
    {
      id: "toValue",
      header: t("maximumUnitQuantity"),
      cell: (item) => item.toValue
    },
    {
      id: "discountPercent",
      header: t("discountPercentage"),
      cell: (item) => item.discountPercent
    }
  ];
  const qualifications = sellerInstructions?.qualifications || [];
  return /* @__PURE__ */ jsx21("div", { style: { marginTop: "12px" }, children: /* @__PURE__ */ jsxs20(SpaceBetween20, { size: "l", children: [
    /* @__PURE__ */ jsxs20(
      Header14,
      {
        variant: "h1",
        actions: /* @__PURE__ */ jsxs20(SpaceBetween20, { direction: "horizontal", size: "xs", children: [
          /* @__PURE__ */ jsx21(
            Button12,
            {
              variant: "normal",
              onClick: () => {
                logger.biMetric({
                  metricName: "Click",
                  dimensions: {
                    ClickFeat: "header-actions",
                    ClickAct: "remove-config"
                  },
                  value: 1,
                  unit: "Count"
                });
                handleRemove();
              },
              loading: isDeleting,
              disabled: isDeleting,
              children: t("remove")
            }
          ),
          /* @__PURE__ */ jsx21(
            Button12,
            {
              variant: "normal",
              href: productCode ? `https://aws.amazon.com/marketplace/pp?sku=${productCode}` : `https://aws.amazon.com/marketplace/management/products/${productId}/overview`,
              iconAlign: "right",
              iconName: "external",
              target: "_blank",
              onClick: () => {
                logger.biMetric({
                  metricName: "Click",
                  dimensions: {
                    ClickFeat: "header-actions",
                    ClickAct: "view-external-product"
                  },
                  value: 1,
                  unit: "Count"
                });
              },
              children: t("viewProductListing")
            }
          )
        ] }),
        children: [
          productName,
          " (",
          productId,
          ")"
        ]
      }
    ),
    /* @__PURE__ */ jsx21(
      Tabs,
      {
        "data-testid": "view-config-tabs",
        activeTabId,
        onChange: ({ detail }) => {
          const tabClickActions = {
            dimensions: "dimensions-tab",
            "discount-strategy": "discount-strategy-tab",
            "offer-settings": "offer-description-tab"
          };
          logger.biMetric({
            metricName: "Click",
            dimensions: {
              ClickFeat: "tab-navigation",
              ClickAct: tabClickActions[detail.activeTabId] || detail.activeTabId
            },
            value: 1,
            unit: "Count"
          });
          setActiveTabId(detail.activeTabId);
        },
        tabs: [
          {
            id: "dimensions",
            label: t("dimensions"),
            content: /* @__PURE__ */ jsx21(
              Table,
              {
                "data-testid": "view-dimensions-table",
                columnDefinitions,
                items: dimensionsData,
                header: /* @__PURE__ */ jsx21(Header14, { variant: "h3", children: t("specifiedDimensions") }),
                empty: t("noDimensionsFound")
              }
            )
          },
          {
            id: "discount-strategy",
            label: t("discountStrategy"),
            content: /* @__PURE__ */ jsxs20(SpaceBetween20, { size: "l", children: [
              Object.keys(perDimensionTcvData).length > 0 && /* @__PURE__ */ jsx21(Container15, { header: /* @__PURE__ */ jsx21(Header14, { variant: "h3", children: t("perDimensionDiscountStrategy") }), children: /* @__PURE__ */ jsx21(SpaceBetween20, { size: "l", children: Object.entries(perDimensionTcvData).map(([dimensionKey, tiers]) => /* @__PURE__ */ jsx21(
                Table,
                {
                  variant: "embedded",
                  columnDefinitions: perDimensionColumnDefinitions,
                  items: tiers,
                  header: /* @__PURE__ */ jsx21(Header14, { counter: `(${tiers.length})`, children: dimensionNames.get(dimensionKey) || dimensionKey }),
                  empty: t("noDiscountTiersFound")
                },
                dimensionKey
              )) }) }),
              totalTcvDiscountData.length > 0 && /* @__PURE__ */ jsx21(Container15, { header: /* @__PURE__ */ jsx21(Header14, { variant: "h3", children: t("totalContractValueDiscountStrategy") }), children: /* @__PURE__ */ jsx21(
                Table,
                {
                  variant: "embedded",
                  columnDefinitions: tcvColumnDefinitions,
                  items: totalTcvDiscountData,
                  empty: t("noDiscountTiersFound")
                }
              ) }),
              qualifications.length > 0 && /* @__PURE__ */ jsx21(Container15, { "data-testid": "view-buyer-profile-container", header: /* @__PURE__ */ jsx21(Header14, { variant: "h3", children: t("buyerProfileDiscountStrategy") }), children: /* @__PURE__ */ jsx21("div", { children: qualifications.map((qual, index) => /* @__PURE__ */ jsxs20(React15.Fragment, { children: [
                /* @__PURE__ */ jsx21(
                  KeyValuePairs6,
                  {
                    columns: 1,
                    items: [
                      {
                        label: t("qualifyingTheme"),
                        value: qual.qualifyingTheme || "-"
                      },
                      {
                        label: t("details"),
                        value: qual.detail || "-"
                      },
                      {
                        label: t("customerFacingQuestion"),
                        value: (qual.buyerQuestions || []).map((q) => q.question).join(" ") || "-"
                      }
                    ]
                  }
                ),
                index < qualifications.length - 1 && /* @__PURE__ */ jsx21("hr", { style: { margin: "16px 0", border: "none", borderTop: "1px solid #e9ebed" } })
              ] }, index)) }) }),
              /* @__PURE__ */ jsx21(Container15, { "data-testid": "view-discount-thresholds-container", header: /* @__PURE__ */ jsx21(Header14, { variant: "h3", children: t("discountThresholds") }), children: /* @__PURE__ */ jsx21(
                KeyValuePairs6,
                {
                  "data-testid": "view-discount-thresholds-keyvaluepairs",
                  columns: 2,
                  items: [
                    {
                      label: t("currency"),
                      // Only USD is supported currently
                      value: t("usd")
                    },
                    {
                      label: t("maximumDiscountPercentage"),
                      value: `${String(configuration.maxDiscountPercentage || 0)}%`
                    },
                    {
                      label: t("maximumTotalContractValue"),
                      value: `$${(configuration.maxTotalContractValue || 0).toLocaleString()}`
                    }
                  ]
                }
              ) })
            ] })
          },
          {
            id: "offer-settings",
            label: t("offerSettings"),
            content: /* @__PURE__ */ jsx21(Container15, { "data-testid": "view-offer-settings-container", header: /* @__PURE__ */ jsx21(Header14, { variant: "h3", children: t("contractDetailsAndEula") }), children: /* @__PURE__ */ jsx21(
              KeyValuePairs6,
              {
                "data-testid": "view-offer-settings-keyvaluepairs",
                columns: 2,
                items: [
                  {
                    label: t("minimumOfferDuration"),
                    value: configuration.minOfferDuration ? formatDuration(configuration.minOfferDuration) : t("notSet")
                  },
                  {
                    label: t("maximumOfferDuration"),
                    value: configuration.maxOfferDuration ? formatDuration(configuration.maxOfferDuration) : t("notSet")
                  },
                  {
                    label: t("endUserLicenseAgreement"),
                    value: configuration.eulaType ? formatEulaType(configuration.eulaType) : t("notSet")
                  },
                  {
                    label: t("offerExpirationDuration"),
                    value: configuration.expiration ? formatDuration(configuration.expiration) : t("notSet")
                  },
                  ...configuration.maxFutureStartDuration && configuration.maxFutureStartDuration !== "P0D" ? [
                    {
                      label: t("fdaValidityRange"),
                      value: formatDuration(configuration.maxFutureStartDuration)
                    }
                  ] : []
                ]
              }
            ) })
          }
        ]
      }
    )
  ] }) });
};

// src/aipo/Offer/Offer.tsx
import { jsx as jsx22, jsxs as jsxs21 } from "react/jsx-runtime";
var Offer = ({ onNavigateToProjects, onCreateProject }) => {
  return /* @__PURE__ */ jsxs21("div", { style: { padding: "20px" }, children: [
    /* @__PURE__ */ jsx22("h1", { children: "AIPO Buyer Flow" }),
    /* @__PURE__ */ jsx22("p", { children: "AI-Powered Offers entry point for buyers" }),
    /* @__PURE__ */ jsxs21("div", { style: { marginTop: "20px", padding: "15px", border: "1px solid #ccc", borderRadius: "5px" }, children: [
      /* @__PURE__ */ jsx22("h3", { children: "Coming Soon" }),
      /* @__PURE__ */ jsx22("p", { children: "This page will provide:" }),
      /* @__PURE__ */ jsxs21("ul", { children: [
        /* @__PURE__ */ jsx22("li", { children: "Browse available AI-powered offers" }),
        /* @__PURE__ */ jsx22("li", { children: "Filter and search functionality" }),
        /* @__PURE__ */ jsx22("li", { children: "View offer details and pricing" }),
        /* @__PURE__ */ jsx22("li", { children: "Request offers from sellers" })
      ] }),
      /* @__PURE__ */ jsxs21("p", { children: [
        /* @__PURE__ */ jsx22("strong", { children: "Note:" }),
        " Entry point for buyers to discover and request AIPO offers"
      ] })
    ] }),
    /* @__PURE__ */ jsxs21("div", { style: { marginTop: "20px", display: "flex", gap: "10px" }, children: [
      /* @__PURE__ */ jsx22(
        "button",
        {
          onClick: onNavigateToProjects,
          style: {
            padding: "10px 20px",
            backgroundColor: "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          },
          children: "View Projects"
        }
      ),
      /* @__PURE__ */ jsx22(
        "button",
        {
          onClick: onCreateProject,
          style: {
            padding: "10px 20px",
            backgroundColor: "#0073bb",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          },
          children: "Create New Project"
        }
      )
    ] }),
    /* @__PURE__ */ jsx22("div", { style: { marginTop: "20px", fontSize: "14px", color: "#666" }, children: /* @__PURE__ */ jsxs21("p", { children: [
      /* @__PURE__ */ jsx22("strong", { children: "Buyer Experience:" }),
      " Discover AI-powered offers from sellers, compare options, and initiate purchase requests through the marketplace."
    ] }) })
  ] });
};
export {
  CreateConfig,
  GetOffer,
  ListConfig,
  Offer,
  ViewConfig,
  mockQualificationResponses
};
//# sourceMappingURL=index.js.map
